// // // // // // // // // // // // // // // // // // // src/utils/generateResumeDoc.js
// // // // // // // // // // // // // // // // // // import { Document, Packer, Paragraph, TextRun, AlignmentType, BorderStyle } from "docx";
// // // // // // // // // // // // // // // // // // import jsPDF from "jspdf";

// // // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // // // TEMPLATE DEFINITIONS
// // // // // // // // // // // // // // // // // // // Add new templates here — must match ResumeGeneratorPage.jsx
// // // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // // const TEMPLATES = {
// // // // // // // // // // // // // // // // // //   classic: {
// // // // // // // // // // // // // // // // // //     name:       "Classic ATS",
// // // // // // // // // // // // // // // // // //     accentHex:  "2563eb",
// // // // // // // // // // // // // // // // // //     headerHex:  "1e293b",
// // // // // // // // // // // // // // // // // //     accentRgb:  [37, 99, 235],
// // // // // // // // // // // // // // // // // //     headerRgb:  [30, 41, 59],
// // // // // // // // // // // // // // // // // //     nameSize:   24,
// // // // // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // // //   modern: {
// // // // // // // // // // // // // // // // // //     name:       "Modern Pro",
// // // // // // // // // // // // // // // // // //     accentHex:  "7c3aed",
// // // // // // // // // // // // // // // // // //     headerHex:  "7c3aed",
// // // // // // // // // // // // // // // // // //     accentRgb:  [124, 58, 237],
// // // // // // // // // // // // // // // // // //     headerRgb:  [124, 58, 237],
// // // // // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // // //   executive: {
// // // // // // // // // // // // // // // // // //     name:       "Executive",
// // // // // // // // // // // // // // // // // //     accentHex:  "334155",
// // // // // // // // // // // // // // // // // //     headerHex:  "0f172a",
// // // // // // // // // // // // // // // // // //     accentRgb:  [51, 65, 85],
// // // // // // // // // // // // // // // // // //     headerRgb:  [15, 23, 42],
// // // // // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // // //   minimal: {
// // // // // // // // // // // // // // // // // //     name:       "Minimal Clean",
// // // // // // // // // // // // // // // // // //     accentHex:  "059669",
// // // // // // // // // // // // // // // // // //     headerHex:  "059669",
// // // // // // // // // // // // // // // // // //     accentRgb:  [5, 150, 105],
// // // // // // // // // // // // // // // // // //     headerRgb:  [5, 150, 105],
// // // // // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // // //   corporate: {
// // // // // // // // // // // // // // // // // //     name:       "Corporate",
// // // // // // // // // // // // // // // // // //     accentHex:  "0369a1",
// // // // // // // // // // // // // // // // // //     headerHex:  "0c4a6e",
// // // // // // // // // // // // // // // // // //     accentRgb:  [3, 105, 161],
// // // // // // // // // // // // // // // // // //     headerRgb:  [12, 74, 110],
// // // // // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // // //   creative: {
// // // // // // // // // // // // // // // // // //     name:       "Creative",
// // // // // // // // // // // // // // // // // //     accentHex:  "e11d48",
// // // // // // // // // // // // // // // // // //     headerHex:  "881337",
// // // // // // // // // // // // // // // // // //     accentRgb:  [225, 29, 72],
// // // // // // // // // // // // // // // // // //     headerRgb:  [136, 19, 55],
// // // // // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // // //   technical: {
// // // // // // // // // // // // // // // // // //     name:       "Technical",
// // // // // // // // // // // // // // // // // //     accentHex:  "0891b2",
// // // // // // // // // // // // // // // // // //     headerHex:  "164e63",
// // // // // // // // // // // // // // // // // //     accentRgb:  [8, 145, 178],
// // // // // // // // // // // // // // // // // //     headerRgb:  [22, 78, 99],
// // // // // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // // // };

// // // // // // // // // // // // // // // // // // function getTemplate(templateId) {
// // // // // // // // // // // // // // // // // //   return TEMPLATES[templateId] || TEMPLATES.classic;
// // // // // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // // // PDF DOWNLOAD — template-aware
// // // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // // export function downloadResumeAsPDF(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // // // // // //   const t = getTemplate(templateId);
// // // // // // // // // // // // // // // // // //   const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });

// // // // // // // // // // // // // // // // // //   const pageW    = 210;
// // // // // // // // // // // // // // // // // //   const margin   = 20;
// // // // // // // // // // // // // // // // // //   const cW       = pageW - margin * 2;
// // // // // // // // // // // // // // // // // //   let y          = 20;
// // // // // // // // // // // // // // // // // //   const dark     = [33, 37, 41];
// // // // // // // // // // // // // // // // // //   const gray     = [108, 117, 125];
// // // // // // // // // // // // // // // // // //   const lgray    = [220, 220, 220];

// // // // // // // // // // // // // // // // // //   function newPage() { pdf.addPage(); y = 20; }
// // // // // // // // // // // // // // // // // //   function check(h = 10) { if (y + h > 278) newPage(); }

// // // // // // // // // // // // // // // // // //   // ── Section heading ──
// // // // // // // // // // // // // // // // // //   function heading(text) {
// // // // // // // // // // // // // // // // // //     check(14);
// // // // // // // // // // // // // // // // // //     y += 5;

// // // // // // // // // // // // // // // // // //     if (t.style === "filled") {
// // // // // // // // // // // // // // // // // //       // Filled background + left bar
// // // // // // // // // // // // // // // // // //       pdf.setFillColor(t.accentRgb[0], t.accentRgb[1], t.accentRgb[2]);
// // // // // // // // // // // // // // // // // //       pdf.setGState(new pdf.GState({ opacity: 0.08 }));
// // // // // // // // // // // // // // // // // //       pdf.rect(margin - 2, y - 4, cW + 4, 7, "F");
// // // // // // // // // // // // // // // // // //       pdf.setGState(new pdf.GState({ opacity: 1 }));
// // // // // // // // // // // // // // // // // //       pdf.setFillColor(...t.accentRgb);
// // // // // // // // // // // // // // // // // //       pdf.rect(margin - 2, y - 4, 2.5, 7, "F");
// // // // // // // // // // // // // // // // // //       pdf.setFontSize(9.5);
// // // // // // // // // // // // // // // // // //       pdf.setFont("helvetica", "bold");
// // // // // // // // // // // // // // // // // //       pdf.setTextColor(...t.accentRgb);
// // // // // // // // // // // // // // // // // //       pdf.text(text.toUpperCase(), margin + 4, y);
// // // // // // // // // // // // // // // // // //     } else if (t.style === "thick") {
// // // // // // // // // // // // // // // // // //       // Double line underline (executive)
// // // // // // // // // // // // // // // // // //       pdf.setFontSize(9.5);
// // // // // // // // // // // // // // // // // //       pdf.setFont("helvetica", "bold");
// // // // // // // // // // // // // // // // // //       pdf.setTextColor(...t.headerRgb);
// // // // // // // // // // // // // // // // // //       pdf.text(text.toUpperCase(), margin, y);
// // // // // // // // // // // // // // // // // //       y += 2;
// // // // // // // // // // // // // // // // // //       pdf.setDrawColor(...t.headerRgb);
// // // // // // // // // // // // // // // // // //       pdf.setLineWidth(0.8);
// // // // // // // // // // // // // // // // // //       pdf.line(margin, y, margin + cW, y);
// // // // // // // // // // // // // // // // // //       y += 1;
// // // // // // // // // // // // // // // // // //       pdf.setLineWidth(0.2);
// // // // // // // // // // // // // // // // // //       pdf.line(margin, y, margin + cW, y);
// // // // // // // // // // // // // // // // // //     } else {
// // // // // // // // // // // // // // // // // //       // Standard thin underline (classic / minimal)
// // // // // // // // // // // // // // // // // //       pdf.setFontSize(9.5);
// // // // // // // // // // // // // // // // // //       pdf.setFont("helvetica", "bold");
// // // // // // // // // // // // // // // // // //       pdf.setTextColor(...t.accentRgb);
// // // // // // // // // // // // // // // // // //       pdf.text(text.toUpperCase(), margin, y);
// // // // // // // // // // // // // // // // // //       y += 2;
// // // // // // // // // // // // // // // // // //       pdf.setDrawColor(...t.accentRgb);
// // // // // // // // // // // // // // // // // //       pdf.setLineWidth(0.4);
// // // // // // // // // // // // // // // // // //       pdf.line(margin, y, margin + cW, y);
// // // // // // // // // // // // // // // // // //     }

// // // // // // // // // // // // // // // // // //     y += 5;
// // // // // // // // // // // // // // // // // //     pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   // ── HEADER ──
// // // // // // // // // // // // // // // // // //   if (t.style === "filled") {
// // // // // // // // // // // // // // // // // //     // Colored full-width header block
// // // // // // // // // // // // // // // // // //     pdf.setFillColor(...t.headerRgb);
// // // // // // // // // // // // // // // // // //     pdf.rect(0, 0, pageW, 34, "F");
// // // // // // // // // // // // // // // // // //     pdf.setFontSize(t.nameSize);
// // // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "bold");
// // // // // // // // // // // // // // // // // //     pdf.setTextColor(255, 255, 255);
// // // // // // // // // // // // // // // // // //     const nw = pdf.getTextWidth(resume.name || "");
// // // // // // // // // // // // // // // // // //     pdf.text(resume.name || "", (pageW - nw) / 2, 14);
// // // // // // // // // // // // // // // // // //     const contacts = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // // // //     pdf.setFontSize(8.5);
// // // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "normal");
// // // // // // // // // // // // // // // // // //     pdf.setTextColor(210, 210, 255);
// // // // // // // // // // // // // // // // // //     const ct = contacts.join("  |  ");
// // // // // // // // // // // // // // // // // //     pdf.text(ct, (pageW - pdf.getTextWidth(ct)) / 2, 24);
// // // // // // // // // // // // // // // // // //     y = 42;
// // // // // // // // // // // // // // // // // //   } else if (t.style === "thick") {
// // // // // // // // // // // // // // // // // //     // Executive: large uppercase name
// // // // // // // // // // // // // // // // // //     pdf.setFontSize(t.nameSize);
// // // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "bold");
// // // // // // // // // // // // // // // // // //     pdf.setTextColor(...t.headerRgb);
// // // // // // // // // // // // // // // // // //     const name = (resume.name || "").toUpperCase();
// // // // // // // // // // // // // // // // // //     pdf.text(name, (pageW - pdf.getTextWidth(name)) / 2, y);
// // // // // // // // // // // // // // // // // //     y += 3;
// // // // // // // // // // // // // // // // // //     pdf.setDrawColor(...t.headerRgb);
// // // // // // // // // // // // // // // // // //     pdf.setLineWidth(1.5);
// // // // // // // // // // // // // // // // // //     pdf.line(margin, y, margin + cW, y);
// // // // // // // // // // // // // // // // // //     y += 6;
// // // // // // // // // // // // // // // // // //     const contacts = [resume.email, resume.phone, resume.location].filter(Boolean);
// // // // // // // // // // // // // // // // // //     pdf.setFontSize(9);
// // // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "normal");
// // // // // // // // // // // // // // // // // //     pdf.setTextColor(...gray);
// // // // // // // // // // // // // // // // // //     const ct = contacts.join("   |   ");
// // // // // // // // // // // // // // // // // //     pdf.text(ct, (pageW - pdf.getTextWidth(ct)) / 2, y);
// // // // // // // // // // // // // // // // // //     y += 8;
// // // // // // // // // // // // // // // // // //   } else if (templateId === "minimal") {
// // // // // // // // // // // // // // // // // //     // Minimal: left-aligned light name + short accent bar
// // // // // // // // // // // // // // // // // //     pdf.setFontSize(t.nameSize);
// // // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "normal");
// // // // // // // // // // // // // // // // // //     pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // // //     pdf.text(resume.name || "", margin, y);
// // // // // // // // // // // // // // // // // //     y += 4;
// // // // // // // // // // // // // // // // // //     pdf.setFillColor(...t.accentRgb);
// // // // // // // // // // // // // // // // // //     pdf.rect(margin, y, 20, 1.5, "F");
// // // // // // // // // // // // // // // // // //     y += 6;
// // // // // // // // // // // // // // // // // //     const contacts = [resume.email, resume.phone, resume.location].filter(Boolean);
// // // // // // // // // // // // // // // // // //     pdf.setFontSize(9);
// // // // // // // // // // // // // // // // // //     pdf.setTextColor(...gray);
// // // // // // // // // // // // // // // // // //     pdf.text(contacts.join("   |   "), margin, y);
// // // // // // // // // // // // // // // // // //     y += 8;
// // // // // // // // // // // // // // // // // //   } else {
// // // // // // // // // // // // // // // // // //     // Classic: centered name + divider
// // // // // // // // // // // // // // // // // //     pdf.setFontSize(t.nameSize);
// // // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "bold");
// // // // // // // // // // // // // // // // // //     pdf.setTextColor(...t.headerRgb);
// // // // // // // // // // // // // // // // // //     const nw = pdf.getTextWidth(resume.name || "");
// // // // // // // // // // // // // // // // // //     pdf.text(resume.name || "", (pageW - nw) / 2, y);
// // // // // // // // // // // // // // // // // //     y += 8;
// // // // // // // // // // // // // // // // // //     const contacts = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // // // //     pdf.setFontSize(9);
// // // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "normal");
// // // // // // // // // // // // // // // // // //     pdf.setTextColor(...gray);
// // // // // // // // // // // // // // // // // //     const ct = contacts.join("  |  ");
// // // // // // // // // // // // // // // // // //     pdf.text(ct, (pageW - pdf.getTextWidth(ct)) / 2, y);
// // // // // // // // // // // // // // // // // //     y += 4;
// // // // // // // // // // // // // // // // // //     pdf.setDrawColor(...lgray);
// // // // // // // // // // // // // // // // // //     pdf.setLineWidth(0.3);
// // // // // // // // // // // // // // // // // //     pdf.line(margin, y, margin + cW, y);
// // // // // // // // // // // // // // // // // //     y += 6;
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   // ── SUMMARY ──
// // // // // // // // // // // // // // // // // //   if (resume.summary) {
// // // // // // // // // // // // // // // // // //     heading("Professional Summary");
// // // // // // // // // // // // // // // // // //     pdf.setFontSize(9); pdf.setFont("helvetica", "normal"); pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // // //     const lines = pdf.splitTextToSize(resume.summary, cW);
// // // // // // // // // // // // // // // // // //     check(lines.length * 4.5);
// // // // // // // // // // // // // // // // // //     pdf.text(lines, margin, y);
// // // // // // // // // // // // // // // // // //     y += lines.length * 4.5 + 4;
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   // ── EXPERIENCE ──
// // // // // // // // // // // // // // // // // //   if (resume.experience?.length > 0) {
// // // // // // // // // // // // // // // // // //     heading("Work Experience");
// // // // // // // // // // // // // // // // // //     resume.experience.forEach(exp => {
// // // // // // // // // // // // // // // // // //       check(16);
// // // // // // // // // // // // // // // // // //       pdf.setFontSize(10); pdf.setFont("helvetica", "bold"); pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // // //       pdf.text(exp.title, margin, y);
// // // // // // // // // // // // // // // // // //       pdf.setFont("helvetica", "normal"); pdf.setTextColor(...gray);
// // // // // // // // // // // // // // // // // //       const comp = ` — ${exp.company}${exp.location ? ` | ${exp.location}` : ""}`;
// // // // // // // // // // // // // // // // // //       pdf.text(comp, margin + pdf.getTextWidth(exp.title), y);
// // // // // // // // // // // // // // // // // //       const dt = `${exp.startDate} – ${exp.endDate}`;
// // // // // // // // // // // // // // // // // //       pdf.setFontSize(9);
// // // // // // // // // // // // // // // // // //       pdf.text(dt, margin + cW - pdf.getTextWidth(dt), y);
// // // // // // // // // // // // // // // // // //       y += 5;
// // // // // // // // // // // // // // // // // //       (exp.bullets || []).forEach(b => {
// // // // // // // // // // // // // // // // // //         check(8);
// // // // // // // // // // // // // // // // // //         pdf.setFontSize(9); pdf.setFont("helvetica", "normal"); pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // // //         const bl = pdf.splitTextToSize(`• ${b}`, cW - 5);
// // // // // // // // // // // // // // // // // //         pdf.text(bl, margin + 3, y);
// // // // // // // // // // // // // // // // // //         y += bl.length * 4.2 + 1;
// // // // // // // // // // // // // // // // // //       });
// // // // // // // // // // // // // // // // // //       y += 3;
// // // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   // ── EDUCATION ──
// // // // // // // // // // // // // // // // // //   if (resume.education?.length > 0) {
// // // // // // // // // // // // // // // // // //     heading("Education");
// // // // // // // // // // // // // // // // // //     resume.education.forEach(edu => {
// // // // // // // // // // // // // // // // // //       check(12);
// // // // // // // // // // // // // // // // // //       pdf.setFontSize(10); pdf.setFont("helvetica", "bold"); pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // // //       pdf.text(edu.degree, margin, y);
// // // // // // // // // // // // // // // // // //       pdf.setFont("helvetica", "normal"); pdf.setTextColor(...gray);
// // // // // // // // // // // // // // // // // //       pdf.text(` — ${edu.school}`, margin + pdf.getTextWidth(edu.degree), y);
// // // // // // // // // // // // // // // // // //       if (edu.year) { pdf.setFontSize(9); pdf.text(edu.year, margin + cW - pdf.getTextWidth(edu.year), y); }
// // // // // // // // // // // // // // // // // //       y += 5;
// // // // // // // // // // // // // // // // // //       if (edu.location || edu.gpa) {
// // // // // // // // // // // // // // // // // //         pdf.setFontSize(9); pdf.setTextColor(...gray);
// // // // // // // // // // // // // // // // // //         pdf.text([edu.location, edu.gpa ? `GPA: ${edu.gpa}` : ""].filter(Boolean).join("  |  "), margin, y);
// // // // // // // // // // // // // // // // // //         y += 4;
// // // // // // // // // // // // // // // // // //       }
// // // // // // // // // // // // // // // // // //       y += 2;
// // // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   // ── SKILLS ──
// // // // // // // // // // // // // // // // // //   if (resume.skills) {
// // // // // // // // // // // // // // // // // //     heading("Skills");
// // // // // // // // // // // // // // // // // //     pdf.setFontSize(9);
// // // // // // // // // // // // // // // // // //     [["Technical", "technical"], ["Tools", "tools"], ["Soft Skills", "soft"]].forEach(([label, key]) => {
// // // // // // // // // // // // // // // // // //       if (resume.skills[key]?.length > 0) {
// // // // // // // // // // // // // // // // // //         check(6);
// // // // // // // // // // // // // // // // // //         pdf.setFont("helvetica", "bold"); pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // // //         pdf.text(`${label}: `, margin, y);
// // // // // // // // // // // // // // // // // //         pdf.setFont("helvetica", "normal");
// // // // // // // // // // // // // // // // // //         const val = resume.skills[key].join(", ");
// // // // // // // // // // // // // // // // // //         const lw = pdf.getTextWidth(`${label}: `);
// // // // // // // // // // // // // // // // // //         const vl = pdf.splitTextToSize(val, cW - lw);
// // // // // // // // // // // // // // // // // //         pdf.text(vl, margin + lw, y);
// // // // // // // // // // // // // // // // // //         y += vl.length * 4.5 + 2;
// // // // // // // // // // // // // // // // // //       }
// // // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // // //     y += 2;
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   // ── CERTIFICATIONS ──
// // // // // // // // // // // // // // // // // //   if (resume.certifications?.length > 0) {
// // // // // // // // // // // // // // // // // //     heading("Certifications");
// // // // // // // // // // // // // // // // // //     resume.certifications.forEach(c => {
// // // // // // // // // // // // // // // // // //       check(6);
// // // // // // // // // // // // // // // // // //       pdf.setFontSize(9); pdf.setFont("helvetica", "normal"); pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // // //       const cl = pdf.splitTextToSize(`• ${c}`, cW - 3);
// // // // // // // // // // // // // // // // // //       pdf.text(cl, margin + 3, y);
// // // // // // // // // // // // // // // // // //       y += cl.length * 4.5 + 2;
// // // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   // ── FOOTER ──
// // // // // // // // // // // // // // // // // //   const pages = pdf.getNumberOfPages();
// // // // // // // // // // // // // // // // // //   for (let i = 1; i <= pages; i++) {
// // // // // // // // // // // // // // // // // //     pdf.setPage(i);
// // // // // // // // // // // // // // // // // //     pdf.setFontSize(7.5); pdf.setTextColor(...lgray);
// // // // // // // // // // // // // // // // // //     pdf.text(`Generated by ResumeScoreAI · ${t.name} Template`, margin, 291);
// // // // // // // // // // // // // // // // // //     pdf.text(`${i} / ${pages}`, pageW - margin - 6, 291);
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   pdf.save(fileName.replace(".html", ".pdf") || "ATS-Resume.pdf");
// // // // // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // // // WORD (.docx) DOWNLOAD — template-aware
// // // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // // export async function downloadResumeAsWord(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // // // // // //   const t = getTemplate(templateId);
// // // // // // // // // // // // // // // // // //   const dark = "212529";
// // // // // // // // // // // // // // // // // //   const gray = "6c757d";

// // // // // // // // // // // // // // // // // //   function heading(text) {
// // // // // // // // // // // // // // // // // //     if (t.style === "filled") {
// // // // // // // // // // // // // // // // // //       return new Paragraph({
// // // // // // // // // // // // // // // // // //         spacing: { before: 220, after: 80 },
// // // // // // // // // // // // // // // // // //         border: { left: { color: t.accentHex, space: 8, style: BorderStyle.SINGLE, size: 24 } },
// // // // // // // // // // // // // // // // // //         children: [new TextRun({ text: text.toUpperCase(), bold: true, size: 20, font: "Calibri", color: t.accentHex })],
// // // // // // // // // // // // // // // // // //       });
// // // // // // // // // // // // // // // // // //     }
// // // // // // // // // // // // // // // // // //     if (t.style === "thick") {
// // // // // // // // // // // // // // // // // //       return new Paragraph({
// // // // // // // // // // // // // // // // // //         spacing: { before: 220, after: 80 },
// // // // // // // // // // // // // // // // // //         border: { bottom: { color: t.headerHex, space: 4, style: BorderStyle.SINGLE, size: 18 } },
// // // // // // // // // // // // // // // // // //         children: [new TextRun({ text: text.toUpperCase(), bold: true, size: 22, font: "Calibri", color: t.headerHex })],
// // // // // // // // // // // // // // // // // //       });
// // // // // // // // // // // // // // // // // //     }
// // // // // // // // // // // // // // // // // //     return new Paragraph({
// // // // // // // // // // // // // // // // // //       spacing: { before: 220, after: 80 },
// // // // // // // // // // // // // // // // // //       border: { bottom: { color: t.accentHex, space: 4, style: BorderStyle.SINGLE, size: 10 } },
// // // // // // // // // // // // // // // // // //       children: [new TextRun({ text: text.toUpperCase(), bold: true, size: 22, font: "Calibri", color: t.accentHex })],
// // // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   function bullet(text) {
// // // // // // // // // // // // // // // // // //     return new Paragraph({
// // // // // // // // // // // // // // // // // //       text: `• ${text}`, spacing: { before: 40, after: 40 }, indent: { left: 360 },
// // // // // // // // // // // // // // // // // //       run: { size: 20, font: "Calibri", color: dark },
// // // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   const children = [];

// // // // // // // // // // // // // // // // // //   // ── Name ──
// // // // // // // // // // // // // // // // // //   children.push(new Paragraph({
// // // // // // // // // // // // // // // // // //     alignment: AlignmentType.CENTER,
// // // // // // // // // // // // // // // // // //     spacing: { after: 60 },
// // // // // // // // // // // // // // // // // //     children: [new TextRun({
// // // // // // // // // // // // // // // // // //       text: resume.name || "",
// // // // // // // // // // // // // // // // // //       bold: true,
// // // // // // // // // // // // // // // // // //       size: t.nameSize * 2,
// // // // // // // // // // // // // // // // // //       font: "Calibri",
// // // // // // // // // // // // // // // // // //       color: t.headerHex,
// // // // // // // // // // // // // // // // // //       allCaps: t.style === "thick",
// // // // // // // // // // // // // // // // // //     })],
// // // // // // // // // // // // // // // // // //   }));

// // // // // // // // // // // // // // // // // //   // ── Contact ──
// // // // // // // // // // // // // // // // // //   const contacts = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // // // //   if (contacts.length > 0) {
// // // // // // // // // // // // // // // // // //     children.push(new Paragraph({
// // // // // // // // // // // // // // // // // //       alignment: AlignmentType.CENTER,
// // // // // // // // // // // // // // // // // //       spacing: { after: 200 },
// // // // // // // // // // // // // // // // // //       children: contacts.map((c, i) => [
// // // // // // // // // // // // // // // // // //         new TextRun({ text: c, size: 18, font: "Calibri", color: gray }),
// // // // // // // // // // // // // // // // // //         i < contacts.length - 1 ? new TextRun({ text: "  |  ", size: 18, font: "Calibri", color: "BBBBBB" }) : null,
// // // // // // // // // // // // // // // // // //       ]).flat().filter(Boolean),
// // // // // // // // // // // // // // // // // //     }));
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   // ── Summary ──
// // // // // // // // // // // // // // // // // //   if (resume.summary) {
// // // // // // // // // // // // // // // // // //     children.push(heading("Professional Summary"));
// // // // // // // // // // // // // // // // // //     children.push(new Paragraph({ text: resume.summary, spacing: { before: 60, after: 120 }, run: { size: 20, font: "Calibri", color: dark } }));
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   // ── Experience ──
// // // // // // // // // // // // // // // // // //   if (resume.experience?.length > 0) {
// // // // // // // // // // // // // // // // // //     children.push(heading("Work Experience"));
// // // // // // // // // // // // // // // // // //     resume.experience.forEach(exp => {
// // // // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // // // //         spacing: { before: 120, after: 40 },
// // // // // // // // // // // // // // // // // //         children: [
// // // // // // // // // // // // // // // // // //           new TextRun({ text: exp.title, bold: true, size: 22, font: "Calibri", color: dark }),
// // // // // // // // // // // // // // // // // //           new TextRun({ text: ` — ${exp.company}`, size: 22, font: "Calibri", color: gray }),
// // // // // // // // // // // // // // // // // //         ],
// // // // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // // // //         spacing: { before: 0, after: 60 },
// // // // // // // // // // // // // // // // // //         children: [
// // // // // // // // // // // // // // // // // //           new TextRun({ text: `${exp.startDate} – ${exp.endDate}`, size: 18, font: "Calibri", color: gray, italics: true }),
// // // // // // // // // // // // // // // // // //           exp.location ? new TextRun({ text: `  |  ${exp.location}`, size: 18, font: "Calibri", color: "AAAAAA" }) : null,
// // // // // // // // // // // // // // // // // //         ].filter(Boolean),
// // // // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // // // //       (exp.bullets || []).forEach(b => children.push(bullet(b)));
// // // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   // ── Education ──
// // // // // // // // // // // // // // // // // //   if (resume.education?.length > 0) {
// // // // // // // // // // // // // // // // // //     children.push(heading("Education"));
// // // // // // // // // // // // // // // // // //     resume.education.forEach(edu => {
// // // // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // // // //         spacing: { before: 100, after: 40 },
// // // // // // // // // // // // // // // // // //         children: [
// // // // // // // // // // // // // // // // // //           new TextRun({ text: edu.degree, bold: true, size: 22, font: "Calibri", color: dark }),
// // // // // // // // // // // // // // // // // //           new TextRun({ text: ` — ${edu.school}`, size: 22, font: "Calibri", color: gray }),
// // // // // // // // // // // // // // // // // //         ],
// // // // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // // // //         spacing: { before: 0, after: 80 },
// // // // // // // // // // // // // // // // // //         children: [
// // // // // // // // // // // // // // // // // //           new TextRun({ text: edu.year || "", size: 18, font: "Calibri", color: gray, italics: true }),
// // // // // // // // // // // // // // // // // //           edu.location ? new TextRun({ text: `  |  ${edu.location}`, size: 18, font: "Calibri", color: "AAAAAA" }) : null,
// // // // // // // // // // // // // // // // // //           edu.gpa ? new TextRun({ text: `  |  GPA: ${edu.gpa}`, size: 18, font: "Calibri", color: "AAAAAA" }) : null,
// // // // // // // // // // // // // // // // // //         ].filter(Boolean),
// // // // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   // ── Skills ──
// // // // // // // // // // // // // // // // // //   if (resume.skills) {
// // // // // // // // // // // // // // // // // //     children.push(heading("Skills"));
// // // // // // // // // // // // // // // // // //     [["Technical", "technical"], ["Tools", "tools"], ["Soft Skills", "soft"]].forEach(([label, key]) => {
// // // // // // // // // // // // // // // // // //       if (resume.skills[key]?.length > 0) {
// // // // // // // // // // // // // // // // // //         children.push(new Paragraph({
// // // // // // // // // // // // // // // // // //           spacing: { before: 40, after: 40 },
// // // // // // // // // // // // // // // // // //           children: [
// // // // // // // // // // // // // // // // // //             new TextRun({ text: `${label}: `, bold: true, size: 20, font: "Calibri", color: dark }),
// // // // // // // // // // // // // // // // // //             new TextRun({ text: resume.skills[key].join(", "), size: 20, font: "Calibri", color: dark }),
// // // // // // // // // // // // // // // // // //           ],
// // // // // // // // // // // // // // // // // //         }));
// // // // // // // // // // // // // // // // // //       }
// // // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   // ── Certifications ──
// // // // // // // // // // // // // // // // // //   if (resume.certifications?.length > 0) {
// // // // // // // // // // // // // // // // // //     children.push(heading("Certifications"));
// // // // // // // // // // // // // // // // // //     resume.certifications.forEach(c => children.push(bullet(c)));
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   const doc = new Document({
// // // // // // // // // // // // // // // // // //     sections: [{
// // // // // // // // // // // // // // // // // //       properties: { page: { margin: { top: 720, right: 720, bottom: 720, left: 720 } } },
// // // // // // // // // // // // // // // // // //       children,
// // // // // // // // // // // // // // // // // //     }],
// // // // // // // // // // // // // // // // // //   });

// // // // // // // // // // // // // // // // // //   const blob = await Packer.toBlob(doc);
// // // // // // // // // // // // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // // // // // // // // // // // //   const a = document.createElement("a");
// // // // // // // // // // // // // // // // // //   a.href = url;
// // // // // // // // // // // // // // // // // //   a.download = fileName.replace(".html", ".docx") || "ATS-Resume.docx";
// // // // // // // // // // // // // // // // // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // // // // // // // // // // // // // // //   URL.revokeObjectURL(url);
// // // // // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // // // HTML DOWNLOAD — template-aware
// // // // // // // // // // // // // // // // // // // Matches landing page ResumeCard previews exactly
// // // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // // export function downloadATSResume(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // // // // // //   const t      = getTemplate(templateId);
// // // // // // // // // // // // // // // // // //   const accent = "#" + t.accentHex;
// // // // // // // // // // // // // // // // // //   const header = "#" + t.headerHex;
// // // // // // // // // // // // // // // // // //   const name   = resume.name || "";

// // // // // // // // // // // // // // // // // //   // ── CSS builder — string concat avoids template-literal-in-object issues ──
// // // // // // // // // // // // // // // // // //   function buildCSS(id, ac, hd) {
// // // // // // // // // // // // // // // // // //     const ul  = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";border-bottom:1.5px solid " + ac + ";padding-bottom:4px;margin-bottom:12px;}";
// // // // // // // // // // // // // // // // // //     const fil = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;border-radius:0 6px 6px 0;}";
// // // // // // // // // // // // // // // // // //     const mon = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.12em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;border-radius:0 6px 6px 0;font-family:'Courier New',monospace;}";
// // // // // // // // // // // // // // // // // //     if (id==="classic")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:26px;font-weight:700;color:#0f172a;text-align:center;}.contact{font-size:13px;color:#475569;display:flex;justify-content:center;flex-wrap:wrap;gap:16px;}.header-wrap{text-align:center;border-bottom:2px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // // // //     if (id==="modern")    return "body{font-family:Arial,Helvetica,sans-serif;}.page{display:flex;max-width:800px;margin:0 auto;}.sidebar{width:200px;background:"+hd+";padding:28px 18px;flex-shrink:0;}.main-col{flex:1;padding:28px 24px;}.name{font-size:14px;font-weight:800;color:#fff;}.contact{font-size:10px;color:rgba(255,255,255,0.7);}"+fil;
// // // // // // // // // // // // // // // // // //     if (id==="executive") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:28px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.06em;}.contact{font-size:12px;color:rgba(255,255,255,0.6);display:flex;flex-wrap:wrap;gap:20px;}.header-wrap{background:"+hd+";padding:28px 32px 24px;}.body-wrap{padding:24px 32px;}"+ul;
// // // // // // // // // // // // // // // // // //     if (id==="minimal")   return "body,.page{font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;}.name{font-size:28px;font-weight:300;color:#0f172a;letter-spacing:-0.02em;}.accent-bar{width:32px;height:3px;background:"+ac+";border-radius:2px;margin:6px 0 10px;}.contact{font-size:13px;color:#64748b;display:flex;flex-wrap:wrap;gap:18px;}.header-wrap{border-bottom:2.5px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // // // //     if (id==="corporate") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:24px;font-weight:700;color:#fff;}.contact{font-size:12px;color:rgba(200,225,255,0.85);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+","+ac+");padding:24px 28px 22px;}.body-wrap{padding:22px 28px;}"+fil;
// // // // // // // // // // // // // // // // // //     if (id==="creative")  return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:30px;font-weight:800;color:#fff;letter-spacing:-0.02em;}.contact{font-size:11px;color:rgba(255,210,220,0.85);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+","+ac+");padding:28px 28px 52px;clip-path:polygon(0 0,100% 0,100% 80%,0 100%);margin-bottom:-8px;}.body-wrap{padding:16px 28px 24px;}"+ul;
// // // // // // // // // // // // // // // // // //     if (id==="technical")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:'Courier New',Courier,monospace;font-size:22px;font-weight:700;color:#fff;letter-spacing:0.02em;}.contact{font-family:'Courier New',Courier,monospace;font-size:10px;color:rgba(180,230,240,0.75);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+",#0e7490);padding:20px 24px 18px;border-bottom:3px solid "+ac+";}.body-wrap{padding:22px 24px;}"+mon;
// // // // // // // // // // // // // // // // // //     if (id==="elegant")     return "body,.page{font-family:Georgia,'Times New Roman',serif;}.accent-strip{width:6px;background:linear-gradient(180deg,"+ac+","+hd+");flex-shrink:0;}.name{font-size:26px;font-weight:700;color:"+hd+";letter-spacing:0.01em;}.role{font-size:11px;color:"+ac+";font-weight:600;letter-spacing:0.1em;text-transform:uppercase;margin:4px 0 10px;}.contact{display:flex;flex-wrap:wrap;gap:16px;font-size:11px;color:#78716c;}.header-wrap{display:flex;border-bottom:1px solid #e7e5e4;}.header-inner{flex:1;padding:26px 26px 18px;}.body-wrap{padding:18px 26px 22px 32px;}"+ul;
// // // // // // // // // // // // // // // // // //     if (id==="bold")        return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:34px;font-weight:900;color:#fff;letter-spacing:-0.03em;line-height:1;}.accent-bar{width:52px;height:4px;background:"+ac+";border-radius:2px;margin:10px 0 12px;}.role{font-size:12px;color:rgba(255,255,255,0.75);text-transform:uppercase;letter-spacing:0.1em;margin-bottom:10px;}.contact{display:flex;flex-wrap:wrap;gap:16px;font-size:11px;color:rgba(255,255,255,0.55);}.header-wrap{background:"+hd+";padding:26px 26px 20px;}.body-wrap{padding:20px 26px;}"+fil;
// // // // // // // // // // // // // // // // // //     if (id==="sidebarlight")return "body{font-family:Arial,Helvetica,sans-serif;}.page{display:flex;}.sidebar{width:200px;background:"+hd+";padding:26px 16px;flex-shrink:0;border-right:3px solid "+ac+";}.avatar{width:58px;height:58px;border-radius:50%;background:"+ac+"25;border:2.5px solid "+ac+";display:flex;align-items:center;justify-content:center;margin-bottom:14px;font-size:22px;font-weight:700;color:"+ac+";}.name{font-size:13px;font-weight:800;color:#0f172a;margin-bottom:2px;}.role{font-size:10px;color:"+ac+";font-weight:600;margin-bottom:14px;}.main-col{flex:1;padding:22px 20px;}"+ul;
// // // // // // // // // // // // // // // // // //     if (id==="academic")    return "body,.page{font-family:Georgia,'Times New Roman',serif;}.name{font-size:24px;font-weight:700;color:#fff;text-align:center;}.role{font-size:11px;color:"+ac+"cc;font-style:italic;text-align:center;margin:4px 0 10px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:16px;font-size:10px;color:rgba(255,255,255,0.5);}.header-wrap{background:"+hd+";padding:22px 30px 18px;text-align:center;}.double-rule-top{height:3px;background:"+ac+";}.double-rule-bot{height:1px;background:"+ac+"40;}.body-wrap{padding:20px 30px;}"+ul;
// // // // // // // // // // // // // // // // // //     return "";
// // // // // // // // // // // // // // // // // //   }
// // // // // // // // // // // // // // // // // //   const css = buildCSS(templateId, accent, header);

// // // // // // // // // // // // // // // // // //   // ── Contact list ──
// // // // // // // // // // // // // // // // // //   const contacts = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // // // //   const contactSpans = contacts.map(c => `<span>${c}</span>`).join("");
// // // // // // // // // // // // // // // // // //   const contactDivs  = contacts.map(c => `<div>${c}</div>`).join("");

// // // // // // // // // // // // // // // // // //   // ── Header HTML per template ──
// // // // // // // // // // // // // // // // // //   function buildHeader(id) {
// // // // // // // // // // // // // // // // // //     if (id==="classic") return `<div class="header-wrap"><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // // // //     if (id==="modern")  return `<div class="sidebar"><div style="width:64px;height:64px;border-radius:50%;background:rgba(255,255,255,0.15);margin-bottom:16px;"></div><div class="name">${name}</div><div style="font-size:10px;color:${accent}cc;background:rgba(255,255,255,0.08);padding:2px 8px;border-radius:4px;display:inline-block;margin:4px 0 16px;font-weight:600;">${(resume.experience||[])[0]?.title||"Professional"}</div><hr style="border:none;border-top:1px solid rgba(255,255,255,0.15);margin:0 0 12px;"/><div style="font-size:10px;font-weight:700;color:rgba(255,255,255,0.5);text-transform:uppercase;letter-spacing:0.1em;margin-bottom:8px;">Contact</div><div style="display:flex;flex-direction:column;gap:5px;font-size:10px;color:rgba(255,255,255,0.7);">${contactDivs}</div></div><div class="main-col">`;
// // // // // // // // // // // // // // // // // //     if (id==="executive") return `<div class="header-wrap"><div class="name">${name.toUpperCase()}</div><hr style="border:none;border-top:2px solid rgba(255,255,255,0.3);margin:8px 0 4px;"/><hr style="border:none;border-top:0.5px solid rgba(255,255,255,0.1);margin:0 0 12px;"/><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // // // //     if (id==="minimal") return `<div class="header-wrap"><div class="name">${name}</div><div class="accent-bar"></div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // // // //     if (id==="corporate") return `<div class="header-wrap"><div class="name">${name}</div><div style="font-size:12px;color:rgba(200,225,255,0.7);font-style:italic;margin:4px 0 10px;">${(resume.experience||[])[0]?.title||"Professional Resume"}</div><hr style="border:none;border-top:1px solid rgba(255,255,255,0.2);margin:0 0 10px;"/><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // // // //     if (id==="creative") return `<div class="header-wrap"><div class="name">${name}</div><div style="font-size:12px;color:rgba(255,210,220,0.85);text-transform:uppercase;letter-spacing:0.08em;margin:6px 0 12px;">Resume</div><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // // // //     if (id==="technical") return `<div class="header-wrap"><div style="font-size:10px;color:${accent}cc;font-family:'Courier New',monospace;margin-bottom:6px;letter-spacing:0.04em;">// resume.json</div><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // // // //     return `<div class="header-wrap"><div class="name">${name}</div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // // // //   }
// // // // // // // // // // // // // // // // // //   // closing tags for templates that open extra divs
// // // // // // // // // // // // // // // // // //   function closeHeader(id) {
// // // // // // // // // // // // // // // // // //     if (["modern","executive","corporate","creative","technical","elegant","bold","sidebarlight","academic"].includes(id)) return "</div>";
// // // // // // // // // // // // // // // // // //     return "";
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   const headerHtml = buildHeader(templateId);
// // // // // // // // // // // // // // // // // //   const headerClose = closeHeader(templateId);

// // // // // // // // // // // // // // // // // //   // ── Body sections ──
// // // // // // // // // // // // // // // // // //   const expHtml = (resume.experience || []).map(exp => `
// // // // // // // // // // // // // // // // // //     <div style="margin-bottom:14px;">
// // // // // // // // // // // // // // // // // //       <div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:4px;">
// // // // // // // // // // // // // // // // // //         <div>
// // // // // // // // // // // // // // // // // //           <strong style="font-size:14px;color:#0f172a;">${exp.title}</strong>
// // // // // // // // // // // // // // // // // //           <span style="color:#475569;"> — ${exp.company}</span>
// // // // // // // // // // // // // // // // // //           ${exp.location ? `<span style="color:#94a3b8;font-size:12px;"> | ${exp.location}</span>` : ""}
// // // // // // // // // // // // // // // // // //         </div>
// // // // // // // // // // // // // // // // // //         <span style="color:#64748b;font-size:12px;font-style:italic;white-space:nowrap;">${exp.startDate} – ${exp.endDate}</span>
// // // // // // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // // // // // //       <ul style="margin:5px 0 0 20px;padding:0;">
// // // // // // // // // // // // // // // // // //         ${(exp.bullets || []).map(b => `<li style="font-size:13px;color:#374151;margin-bottom:4px;line-height:1.6;">${b}</li>`).join("")}
// // // // // // // // // // // // // // // // // //       </ul>
// // // // // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // // // // //   const eduHtml = (resume.education || []).map(edu => `
// // // // // // // // // // // // // // // // // //     <div style="display:flex;justify-content:space-between;margin-bottom:8px;flex-wrap:wrap;gap:4px;">
// // // // // // // // // // // // // // // // // //       <div>
// // // // // // // // // // // // // // // // // //         <strong style="font-size:14px;color:#0f172a;">${edu.degree}</strong>
// // // // // // // // // // // // // // // // // //         <span style="color:#475569;"> — ${edu.school}</span>
// // // // // // // // // // // // // // // // // //         ${edu.location ? `<span style="color:#94a3b8;font-size:12px;"> | ${edu.location}</span>` : ""}
// // // // // // // // // // // // // // // // // //         ${edu.gpa ? `<span style="color:#94a3b8;font-size:12px;"> | GPA: ${edu.gpa}</span>` : ""}
// // // // // // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // // // // // //       <span style="color:#64748b;font-size:12px;font-style:italic;">${edu.year || ""}</span>
// // // // // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // // // // //   const skillsHtml = resume.skills ? [
// // // // // // // // // // // // // // // // // //     resume.skills.technical?.length > 0 ? `<p style="margin:4px 0;font-size:13px;"><strong>Technical:</strong> ${resume.skills.technical.join(", ")}</p>` : "",
// // // // // // // // // // // // // // // // // //     resume.skills.tools?.length > 0     ? `<p style="margin:4px 0;font-size:13px;"><strong>Tools:</strong> ${resume.skills.tools.join(", ")}</p>` : "",
// // // // // // // // // // // // // // // // // //     resume.skills.soft?.length > 0      ? `<p style="margin:4px 0;font-size:13px;"><strong>Soft Skills:</strong> ${resume.skills.soft.join(", ")}</p>` : "",
// // // // // // // // // // // // // // // // // //   ].join("") : "";

// // // // // // // // // // // // // // // // // //   const certHtml = resume.certifications?.length > 0
// // // // // // // // // // // // // // // // // //     ? `<ul style="margin:4px 0 0 20px;padding:0;">${resume.certifications.map(c => `<li style="font-size:13px;color:#374151;margin-bottom:4px;">${c}</li>`).join("")}</ul>`
// // // // // // // // // // // // // // // // // //     : "";

// // // // // // // // // // // // // // // // // //   function section(title, body) {
// // // // // // // // // // // // // // // // // //     if (!body) return "";
// // // // // // // // // // // // // // // // // //     return `<div style="margin-bottom:20px;"><div class="section-title">${title}</div>${body}</div>`;
// // // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // // //   const pageOpen  = templateId === "modern" ? `<div class="page">` : `<div class="page" style="max-width:800px;margin:0 auto;padding:36px 40px;">`;

// // // // // // // // // // // // // // // // // //   const html = `<!DOCTYPE html>
// // // // // // // // // // // // // // // // // // <html lang="en">
// // // // // // // // // // // // // // // // // // <head>
// // // // // // // // // // // // // // // // // //   <meta charset="utf-8"/>
// // // // // // // // // // // // // // // // // //   <title>${name} — ${t.name}</title>
// // // // // // // // // // // // // // // // // //   <style>
// // // // // // // // // // // // // // // // // //     *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
// // // // // // // // // // // // // // // // // //     body{color:#212529;background:#fff;font-size:14px;line-height:1.55;}
// // // // // // // // // // // // // // // // // //     ${css}
// // // // // // // // // // // // // // // // // //     @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}.page{padding:20px;}.no-print{display:none!important;}}
// // // // // // // // // // // // // // // // // //   </style>
// // // // // // // // // // // // // // // // // // </head>
// // // // // // // // // // // // // // // // // // <body>
// // // // // // // // // // // // // // // // // // ${pageOpen}
// // // // // // // // // // // // // // // // // //   <div class="no-print" style="background:#eff6ff;border:1px solid #bfdbfe;border-radius:8px;padding:10px 16px;margin-bottom:20px;font-size:13px;color:#2563eb;">
// // // // // // // // // // // // // // // // // //     <strong>To save as PDF:</strong> Press Ctrl+P (or Cmd+P) &rarr; Select "Save as PDF" &rarr; Click Save
// // // // // // // // // // // // // // // // // //   </div>
// // // // // // // // // // // // // // // // // //   ${headerHtml}
// // // // // // // // // // // // // // // // // //   ${section("Professional Summary", resume.summary ? `<p style="font-size:13px;line-height:1.75;color:#374151;">${resume.summary}</p>` : "")}
// // // // // // // // // // // // // // // // // //   ${section("Work Experience", expHtml)}
// // // // // // // // // // // // // // // // // //   ${section("Education", eduHtml)}
// // // // // // // // // // // // // // // // // //   ${section("Skills", skillsHtml)}
// // // // // // // // // // // // // // // // // //   ${resume.certifications?.length > 0 ? section("Certifications", certHtml) : ""}
// // // // // // // // // // // // // // // // // //   ${headerClose}
// // // // // // // // // // // // // // // // // // </div>
// // // // // // // // // // // // // // // // // // </body>
// // // // // // // // // // // // // // // // // // </html>`;

// // // // // // // // // // // // // // // // // //   const blob = new Blob([html], { type: "text/html;charset=utf-8" });
// // // // // // // // // // // // // // // // // //   const url  = URL.createObjectURL(blob);
// // // // // // // // // // // // // // // // // //   const a    = document.createElement("a");
// // // // // // // // // // // // // // // // // //   a.href = url;
// // // // // // // // // // // // // // // // // //   a.download = fileName || "ATS-Resume.html";
// // // // // // // // // // // // // // // // // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // // // // // // // // // // // // // // //   URL.revokeObjectURL(url);
// // // // // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // // // src/utils/generateResumeDoc.js
// // // // // // // // // // // // // // // // // // eslint-disable-next-line no-unused-vars
// // // // // // // // // // // // // // // // // import { Document, Packer, Paragraph, TextRun, HeadingLevel, AlignmentType, BorderStyle } from "docx";
// // // // // // // // // // // // // // // // // import jsPDF from "jspdf";

// // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // // TEMPLATE DEFINITIONS
// // // // // // // // // // // // // // // // // // Add new templates here — must match ResumeGeneratorPage.jsx
// // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // const TEMPLATES = {
// // // // // // // // // // // // // // // // //   classic: {
// // // // // // // // // // // // // // // // //     name:       "Classic ATS",
// // // // // // // // // // // // // // // // //     accentHex:  "2563eb",
// // // // // // // // // // // // // // // // //     headerHex:  "1e293b",
// // // // // // // // // // // // // // // // //     accentRgb:  [37, 99, 235],
// // // // // // // // // // // // // // // // //     headerRgb:  [30, 41, 59],
// // // // // // // // // // // // // // // // //     nameSize:   24,
// // // // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // //   modern: {
// // // // // // // // // // // // // // // // //     name:       "Modern Pro",
// // // // // // // // // // // // // // // // //     accentHex:  "7c3aed",
// // // // // // // // // // // // // // // // //     headerHex:  "7c3aed",
// // // // // // // // // // // // // // // // //     accentRgb:  [124, 58, 237],
// // // // // // // // // // // // // // // // //     headerRgb:  [124, 58, 237],
// // // // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // //   executive: {
// // // // // // // // // // // // // // // // //     name:       "Executive",
// // // // // // // // // // // // // // // // //     accentHex:  "334155",
// // // // // // // // // // // // // // // // //     headerHex:  "0f172a",
// // // // // // // // // // // // // // // // //     accentRgb:  [51, 65, 85],
// // // // // // // // // // // // // // // // //     headerRgb:  [15, 23, 42],
// // // // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // //   minimal: {
// // // // // // // // // // // // // // // // //     name:       "Minimal Clean",
// // // // // // // // // // // // // // // // //     accentHex:  "059669",
// // // // // // // // // // // // // // // // //     headerHex:  "059669",
// // // // // // // // // // // // // // // // //     accentRgb:  [5, 150, 105],
// // // // // // // // // // // // // // // // //     headerRgb:  [5, 150, 105],
// // // // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // //   corporate: {
// // // // // // // // // // // // // // // // //     name:       "Corporate",
// // // // // // // // // // // // // // // // //     accentHex:  "0369a1",
// // // // // // // // // // // // // // // // //     headerHex:  "0c4a6e",
// // // // // // // // // // // // // // // // //     accentRgb:  [3, 105, 161],
// // // // // // // // // // // // // // // // //     headerRgb:  [12, 74, 110],
// // // // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // //   creative: {
// // // // // // // // // // // // // // // // //     name:       "Creative",
// // // // // // // // // // // // // // // // //     accentHex:  "e11d48",
// // // // // // // // // // // // // // // // //     headerHex:  "881337",
// // // // // // // // // // // // // // // // //     accentRgb:  [225, 29, 72],
// // // // // // // // // // // // // // // // //     headerRgb:  [136, 19, 55],
// // // // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // //   technical: {
// // // // // // // // // // // // // // // // //     name:       "Technical",
// // // // // // // // // // // // // // // // //     accentHex:  "0891b2",
// // // // // // // // // // // // // // // // //     headerHex:  "164e63",
// // // // // // // // // // // // // // // // //     accentRgb:  [8, 145, 178],
// // // // // // // // // // // // // // // // //     headerRgb:  [22, 78, 99],
// // // // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // // };

// // // // // // // // // // // // // // // // // function getTemplate(templateId) {
// // // // // // // // // // // // // // // // //   return TEMPLATES[templateId] || TEMPLATES.classic;
// // // // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // // PDF DOWNLOAD — template-aware
// // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // export function downloadResumeAsPDF(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // // // // //   const t = getTemplate(templateId);
// // // // // // // // // // // // // // // // //   const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });

// // // // // // // // // // // // // // // // //   const pageW    = 210;
// // // // // // // // // // // // // // // // //   const margin   = 20;
// // // // // // // // // // // // // // // // //   const cW       = pageW - margin * 2;
// // // // // // // // // // // // // // // // //   let y          = 20;
// // // // // // // // // // // // // // // // //   const dark     = [33, 37, 41];
// // // // // // // // // // // // // // // // //   const gray     = [108, 117, 125];
// // // // // // // // // // // // // // // // //   const lgray    = [220, 220, 220];

// // // // // // // // // // // // // // // // //   function newPage() { pdf.addPage(); y = 20; }
// // // // // // // // // // // // // // // // //   function check(h = 10) { if (y + h > 278) newPage(); }

// // // // // // // // // // // // // // // // //   // ── Section heading ──
// // // // // // // // // // // // // // // // //   function heading(text) {
// // // // // // // // // // // // // // // // //     check(14);
// // // // // // // // // // // // // // // // //     y += 5;

// // // // // // // // // // // // // // // // //     if (t.style === "filled") {
// // // // // // // // // // // // // // // // //       // Filled background + left bar
// // // // // // // // // // // // // // // // //       pdf.setFillColor(t.accentRgb[0], t.accentRgb[1], t.accentRgb[2]);
// // // // // // // // // // // // // // // // //       pdf.setGState(new pdf.GState({ opacity: 0.08 }));
// // // // // // // // // // // // // // // // //       pdf.rect(margin - 2, y - 4, cW + 4, 7, "F");
// // // // // // // // // // // // // // // // //       pdf.setGState(new pdf.GState({ opacity: 1 }));
// // // // // // // // // // // // // // // // //       pdf.setFillColor(...t.accentRgb);
// // // // // // // // // // // // // // // // //       pdf.rect(margin - 2, y - 4, 2.5, 7, "F");
// // // // // // // // // // // // // // // // //       pdf.setFontSize(9.5);
// // // // // // // // // // // // // // // // //       pdf.setFont("helvetica", "bold");
// // // // // // // // // // // // // // // // //       pdf.setTextColor(...t.accentRgb);
// // // // // // // // // // // // // // // // //       pdf.text(text.toUpperCase(), margin + 4, y);
// // // // // // // // // // // // // // // // //     } else if (t.style === "thick") {
// // // // // // // // // // // // // // // // //       // Double line underline (executive)
// // // // // // // // // // // // // // // // //       pdf.setFontSize(9.5);
// // // // // // // // // // // // // // // // //       pdf.setFont("helvetica", "bold");
// // // // // // // // // // // // // // // // //       pdf.setTextColor(...t.headerRgb);
// // // // // // // // // // // // // // // // //       pdf.text(text.toUpperCase(), margin, y);
// // // // // // // // // // // // // // // // //       y += 2;
// // // // // // // // // // // // // // // // //       pdf.setDrawColor(...t.headerRgb);
// // // // // // // // // // // // // // // // //       pdf.setLineWidth(0.8);
// // // // // // // // // // // // // // // // //       pdf.line(margin, y, margin + cW, y);
// // // // // // // // // // // // // // // // //       y += 1;
// // // // // // // // // // // // // // // // //       pdf.setLineWidth(0.2);
// // // // // // // // // // // // // // // // //       pdf.line(margin, y, margin + cW, y);
// // // // // // // // // // // // // // // // //     } else {
// // // // // // // // // // // // // // // // //       // Standard thin underline (classic / minimal)
// // // // // // // // // // // // // // // // //       pdf.setFontSize(9.5);
// // // // // // // // // // // // // // // // //       pdf.setFont("helvetica", "bold");
// // // // // // // // // // // // // // // // //       pdf.setTextColor(...t.accentRgb);
// // // // // // // // // // // // // // // // //       pdf.text(text.toUpperCase(), margin, y);
// // // // // // // // // // // // // // // // //       y += 2;
// // // // // // // // // // // // // // // // //       pdf.setDrawColor(...t.accentRgb);
// // // // // // // // // // // // // // // // //       pdf.setLineWidth(0.4);
// // // // // // // // // // // // // // // // //       pdf.line(margin, y, margin + cW, y);
// // // // // // // // // // // // // // // // //     }

// // // // // // // // // // // // // // // // //     y += 5;
// // // // // // // // // // // // // // // // //     pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   // ── HEADER ──
// // // // // // // // // // // // // // // // //   if (t.style === "filled") {
// // // // // // // // // // // // // // // // //     // Colored full-width header block
// // // // // // // // // // // // // // // // //     pdf.setFillColor(...t.headerRgb);
// // // // // // // // // // // // // // // // //     pdf.rect(0, 0, pageW, 34, "F");
// // // // // // // // // // // // // // // // //     pdf.setFontSize(t.nameSize);
// // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "bold");
// // // // // // // // // // // // // // // // //     pdf.setTextColor(255, 255, 255);
// // // // // // // // // // // // // // // // //     const nw = pdf.getTextWidth(resume.name || "");
// // // // // // // // // // // // // // // // //     pdf.text(resume.name || "", (pageW - nw) / 2, 14);
// // // // // // // // // // // // // // // // //     const contacts = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // // //     pdf.setFontSize(8.5);
// // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "normal");
// // // // // // // // // // // // // // // // //     pdf.setTextColor(210, 210, 255);
// // // // // // // // // // // // // // // // //     const ct = contacts.join("  |  ");
// // // // // // // // // // // // // // // // //     pdf.text(ct, (pageW - pdf.getTextWidth(ct)) / 2, 24);
// // // // // // // // // // // // // // // // //     y = 42;
// // // // // // // // // // // // // // // // //   } else if (t.style === "thick") {
// // // // // // // // // // // // // // // // //     // Executive: large uppercase name
// // // // // // // // // // // // // // // // //     pdf.setFontSize(t.nameSize);
// // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "bold");
// // // // // // // // // // // // // // // // //     pdf.setTextColor(...t.headerRgb);
// // // // // // // // // // // // // // // // //     const name = (resume.name || "").toUpperCase();
// // // // // // // // // // // // // // // // //     pdf.text(name, (pageW - pdf.getTextWidth(name)) / 2, y);
// // // // // // // // // // // // // // // // //     y += 3;
// // // // // // // // // // // // // // // // //     pdf.setDrawColor(...t.headerRgb);
// // // // // // // // // // // // // // // // //     pdf.setLineWidth(1.5);
// // // // // // // // // // // // // // // // //     pdf.line(margin, y, margin + cW, y);
// // // // // // // // // // // // // // // // //     y += 6;
// // // // // // // // // // // // // // // // //     const contacts = [resume.email, resume.phone, resume.location].filter(Boolean);
// // // // // // // // // // // // // // // // //     pdf.setFontSize(9);
// // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "normal");
// // // // // // // // // // // // // // // // //     pdf.setTextColor(...gray);
// // // // // // // // // // // // // // // // //     const ct = contacts.join("   |   ");
// // // // // // // // // // // // // // // // //     pdf.text(ct, (pageW - pdf.getTextWidth(ct)) / 2, y);
// // // // // // // // // // // // // // // // //     y += 8;
// // // // // // // // // // // // // // // // //   } else if (templateId === "minimal") {
// // // // // // // // // // // // // // // // //     // Minimal: left-aligned light name + short accent bar
// // // // // // // // // // // // // // // // //     pdf.setFontSize(t.nameSize);
// // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "normal");
// // // // // // // // // // // // // // // // //     pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // //     pdf.text(resume.name || "", margin, y);
// // // // // // // // // // // // // // // // //     y += 4;
// // // // // // // // // // // // // // // // //     pdf.setFillColor(...t.accentRgb);
// // // // // // // // // // // // // // // // //     pdf.rect(margin, y, 20, 1.5, "F");
// // // // // // // // // // // // // // // // //     y += 6;
// // // // // // // // // // // // // // // // //     const contacts = [resume.email, resume.phone, resume.location].filter(Boolean);
// // // // // // // // // // // // // // // // //     pdf.setFontSize(9);
// // // // // // // // // // // // // // // // //     pdf.setTextColor(...gray);
// // // // // // // // // // // // // // // // //     pdf.text(contacts.join("   |   "), margin, y);
// // // // // // // // // // // // // // // // //     y += 8;
// // // // // // // // // // // // // // // // //   } else {
// // // // // // // // // // // // // // // // //     // Classic: centered name + divider
// // // // // // // // // // // // // // // // //     pdf.setFontSize(t.nameSize);
// // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "bold");
// // // // // // // // // // // // // // // // //     pdf.setTextColor(...t.headerRgb);
// // // // // // // // // // // // // // // // //     const nw = pdf.getTextWidth(resume.name || "");
// // // // // // // // // // // // // // // // //     pdf.text(resume.name || "", (pageW - nw) / 2, y);
// // // // // // // // // // // // // // // // //     y += 8;
// // // // // // // // // // // // // // // // //     const contacts = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // // //     pdf.setFontSize(9);
// // // // // // // // // // // // // // // // //     pdf.setFont("helvetica", "normal");
// // // // // // // // // // // // // // // // //     pdf.setTextColor(...gray);
// // // // // // // // // // // // // // // // //     const ct = contacts.join("  |  ");
// // // // // // // // // // // // // // // // //     pdf.text(ct, (pageW - pdf.getTextWidth(ct)) / 2, y);
// // // // // // // // // // // // // // // // //     y += 4;
// // // // // // // // // // // // // // // // //     pdf.setDrawColor(...lgray);
// // // // // // // // // // // // // // // // //     pdf.setLineWidth(0.3);
// // // // // // // // // // // // // // // // //     pdf.line(margin, y, margin + cW, y);
// // // // // // // // // // // // // // // // //     y += 6;
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   // ── SUMMARY ──
// // // // // // // // // // // // // // // // //   if (resume.summary) {
// // // // // // // // // // // // // // // // //     heading("Professional Summary");
// // // // // // // // // // // // // // // // //     pdf.setFontSize(9); pdf.setFont("helvetica", "normal"); pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // //     const lines = pdf.splitTextToSize(resume.summary, cW);
// // // // // // // // // // // // // // // // //     check(lines.length * 4.5);
// // // // // // // // // // // // // // // // //     pdf.text(lines, margin, y);
// // // // // // // // // // // // // // // // //     y += lines.length * 4.5 + 4;
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   // ── EXPERIENCE ──
// // // // // // // // // // // // // // // // //   if (resume.experience?.length > 0) {
// // // // // // // // // // // // // // // // //     heading("Work Experience");
// // // // // // // // // // // // // // // // //     resume.experience.forEach(exp => {
// // // // // // // // // // // // // // // // //       check(16);
// // // // // // // // // // // // // // // // //       pdf.setFontSize(10); pdf.setFont("helvetica", "bold"); pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // //       pdf.text(exp.title, margin, y);
// // // // // // // // // // // // // // // // //       pdf.setFont("helvetica", "normal"); pdf.setTextColor(...gray);
// // // // // // // // // // // // // // // // //       const comp = ` — ${exp.company}${exp.location ? ` | ${exp.location}` : ""}`;
// // // // // // // // // // // // // // // // //       pdf.text(comp, margin + pdf.getTextWidth(exp.title), y);
// // // // // // // // // // // // // // // // //       const dt = `${exp.startDate} – ${exp.endDate}`;
// // // // // // // // // // // // // // // // //       pdf.setFontSize(9);
// // // // // // // // // // // // // // // // //       pdf.text(dt, margin + cW - pdf.getTextWidth(dt), y);
// // // // // // // // // // // // // // // // //       y += 5;
// // // // // // // // // // // // // // // // //       (exp.bullets || []).forEach(b => {
// // // // // // // // // // // // // // // // //         check(8);
// // // // // // // // // // // // // // // // //         pdf.setFontSize(9); pdf.setFont("helvetica", "normal"); pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // //         const bl = pdf.splitTextToSize(`• ${b}`, cW - 5);
// // // // // // // // // // // // // // // // //         pdf.text(bl, margin + 3, y);
// // // // // // // // // // // // // // // // //         y += bl.length * 4.2 + 1;
// // // // // // // // // // // // // // // // //       });
// // // // // // // // // // // // // // // // //       y += 3;
// // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   // ── EDUCATION ──
// // // // // // // // // // // // // // // // //   if (resume.education?.length > 0) {
// // // // // // // // // // // // // // // // //     heading("Education");
// // // // // // // // // // // // // // // // //     resume.education.forEach(edu => {
// // // // // // // // // // // // // // // // //       check(12);
// // // // // // // // // // // // // // // // //       pdf.setFontSize(10); pdf.setFont("helvetica", "bold"); pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // //       pdf.text(edu.degree, margin, y);
// // // // // // // // // // // // // // // // //       pdf.setFont("helvetica", "normal"); pdf.setTextColor(...gray);
// // // // // // // // // // // // // // // // //       pdf.text(` — ${edu.school}`, margin + pdf.getTextWidth(edu.degree), y);
// // // // // // // // // // // // // // // // //       if (edu.year) { pdf.setFontSize(9); pdf.text(edu.year, margin + cW - pdf.getTextWidth(edu.year), y); }
// // // // // // // // // // // // // // // // //       y += 5;
// // // // // // // // // // // // // // // // //       if (edu.location || edu.gpa) {
// // // // // // // // // // // // // // // // //         pdf.setFontSize(9); pdf.setTextColor(...gray);
// // // // // // // // // // // // // // // // //         pdf.text([edu.location, edu.gpa ? `GPA: ${edu.gpa}` : ""].filter(Boolean).join("  |  "), margin, y);
// // // // // // // // // // // // // // // // //         y += 4;
// // // // // // // // // // // // // // // // //       }
// // // // // // // // // // // // // // // // //       y += 2;
// // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   // ── SKILLS ──
// // // // // // // // // // // // // // // // //   if (resume.skills) {
// // // // // // // // // // // // // // // // //     heading("Skills");
// // // // // // // // // // // // // // // // //     pdf.setFontSize(9);
// // // // // // // // // // // // // // // // //     [["Technical", "technical"], ["Tools", "tools"], ["Soft Skills", "soft"]].forEach(([label, key]) => {
// // // // // // // // // // // // // // // // //       if (resume.skills[key]?.length > 0) {
// // // // // // // // // // // // // // // // //         check(6);
// // // // // // // // // // // // // // // // //         pdf.setFont("helvetica", "bold"); pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // //         pdf.text(`${label}: `, margin, y);
// // // // // // // // // // // // // // // // //         pdf.setFont("helvetica", "normal");
// // // // // // // // // // // // // // // // //         const val = resume.skills[key].join(", ");
// // // // // // // // // // // // // // // // //         const lw = pdf.getTextWidth(`${label}: `);
// // // // // // // // // // // // // // // // //         const vl = pdf.splitTextToSize(val, cW - lw);
// // // // // // // // // // // // // // // // //         pdf.text(vl, margin + lw, y);
// // // // // // // // // // // // // // // // //         y += vl.length * 4.5 + 2;
// // // // // // // // // // // // // // // // //       }
// // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // //     y += 2;
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   // ── CERTIFICATIONS ──
// // // // // // // // // // // // // // // // //   if (resume.certifications?.length > 0) {
// // // // // // // // // // // // // // // // //     heading("Certifications");
// // // // // // // // // // // // // // // // //     resume.certifications.forEach(c => {
// // // // // // // // // // // // // // // // //       check(6);
// // // // // // // // // // // // // // // // //       pdf.setFontSize(9); pdf.setFont("helvetica", "normal"); pdf.setTextColor(...dark);
// // // // // // // // // // // // // // // // //       const cl = pdf.splitTextToSize(`• ${c}`, cW - 3);
// // // // // // // // // // // // // // // // //       pdf.text(cl, margin + 3, y);
// // // // // // // // // // // // // // // // //       y += cl.length * 4.5 + 2;
// // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   // ── FOOTER ──
// // // // // // // // // // // // // // // // //   const pages = pdf.getNumberOfPages();
// // // // // // // // // // // // // // // // //   for (let i = 1; i <= pages; i++) {
// // // // // // // // // // // // // // // // //     pdf.setPage(i);
// // // // // // // // // // // // // // // // //     pdf.setFontSize(7.5); pdf.setTextColor(...lgray);
// // // // // // // // // // // // // // // // //     pdf.text(`Generated by ResumeScoreAI · ${t.name} Template`, margin, 291);
// // // // // // // // // // // // // // // // //     pdf.text(`${i} / ${pages}`, pageW - margin - 6, 291);
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   pdf.save(fileName.replace(".html", ".pdf") || "ATS-Resume.pdf");
// // // // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // // WORD (.docx) DOWNLOAD — template-aware
// // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // export async function downloadResumeAsWord(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // // // // //   const t = getTemplate(templateId);
// // // // // // // // // // // // // // // // //   const dark = "212529";
// // // // // // // // // // // // // // // // //   const gray = "6c757d";

// // // // // // // // // // // // // // // // //   function heading(text) {
// // // // // // // // // // // // // // // // //     if (t.style === "filled") {
// // // // // // // // // // // // // // // // //       return new Paragraph({
// // // // // // // // // // // // // // // // //         spacing: { before: 220, after: 80 },
// // // // // // // // // // // // // // // // //         border: { left: { color: t.accentHex, space: 8, style: BorderStyle.SINGLE, size: 24 } },
// // // // // // // // // // // // // // // // //         children: [new TextRun({ text: text.toUpperCase(), bold: true, size: 20, font: "Calibri", color: t.accentHex })],
// // // // // // // // // // // // // // // // //       });
// // // // // // // // // // // // // // // // //     }
// // // // // // // // // // // // // // // // //     if (t.style === "thick") {
// // // // // // // // // // // // // // // // //       return new Paragraph({
// // // // // // // // // // // // // // // // //         spacing: { before: 220, after: 80 },
// // // // // // // // // // // // // // // // //         border: { bottom: { color: t.headerHex, space: 4, style: BorderStyle.SINGLE, size: 18 } },
// // // // // // // // // // // // // // // // //         children: [new TextRun({ text: text.toUpperCase(), bold: true, size: 22, font: "Calibri", color: t.headerHex })],
// // // // // // // // // // // // // // // // //       });
// // // // // // // // // // // // // // // // //     }
// // // // // // // // // // // // // // // // //     return new Paragraph({
// // // // // // // // // // // // // // // // //       spacing: { before: 220, after: 80 },
// // // // // // // // // // // // // // // // //       border: { bottom: { color: t.accentHex, space: 4, style: BorderStyle.SINGLE, size: 10 } },
// // // // // // // // // // // // // // // // //       children: [new TextRun({ text: text.toUpperCase(), bold: true, size: 22, font: "Calibri", color: t.accentHex })],
// // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   function bullet(text) {
// // // // // // // // // // // // // // // // //     return new Paragraph({
// // // // // // // // // // // // // // // // //       text: `• ${text}`, spacing: { before: 40, after: 40 }, indent: { left: 360 },
// // // // // // // // // // // // // // // // //       run: { size: 20, font: "Calibri", color: dark },
// // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   const children = [];

// // // // // // // // // // // // // // // // //   // ── Name ──
// // // // // // // // // // // // // // // // //   children.push(new Paragraph({
// // // // // // // // // // // // // // // // //     alignment: AlignmentType.CENTER,
// // // // // // // // // // // // // // // // //     spacing: { after: 60 },
// // // // // // // // // // // // // // // // //     children: [new TextRun({
// // // // // // // // // // // // // // // // //       text: resume.name || "",
// // // // // // // // // // // // // // // // //       bold: true,
// // // // // // // // // // // // // // // // //       size: t.nameSize * 2,
// // // // // // // // // // // // // // // // //       font: "Calibri",
// // // // // // // // // // // // // // // // //       color: t.headerHex,
// // // // // // // // // // // // // // // // //       allCaps: t.style === "thick",
// // // // // // // // // // // // // // // // //     })],
// // // // // // // // // // // // // // // // //   }));

// // // // // // // // // // // // // // // // //   // ── Contact ──
// // // // // // // // // // // // // // // // //   const contacts = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // // //   if (contacts.length > 0) {
// // // // // // // // // // // // // // // // //     children.push(new Paragraph({
// // // // // // // // // // // // // // // // //       alignment: AlignmentType.CENTER,
// // // // // // // // // // // // // // // // //       spacing: { after: 200 },
// // // // // // // // // // // // // // // // //       children: contacts.map((c, i) => [
// // // // // // // // // // // // // // // // //         new TextRun({ text: c, size: 18, font: "Calibri", color: gray }),
// // // // // // // // // // // // // // // // //         i < contacts.length - 1 ? new TextRun({ text: "  |  ", size: 18, font: "Calibri", color: "BBBBBB" }) : null,
// // // // // // // // // // // // // // // // //       ]).flat().filter(Boolean),
// // // // // // // // // // // // // // // // //     }));
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   // ── Summary ──
// // // // // // // // // // // // // // // // //   if (resume.summary) {
// // // // // // // // // // // // // // // // //     children.push(heading("Professional Summary"));
// // // // // // // // // // // // // // // // //     children.push(new Paragraph({ text: resume.summary, spacing: { before: 60, after: 120 }, run: { size: 20, font: "Calibri", color: dark } }));
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   // ── Experience ──
// // // // // // // // // // // // // // // // //   if (resume.experience?.length > 0) {
// // // // // // // // // // // // // // // // //     children.push(heading("Work Experience"));
// // // // // // // // // // // // // // // // //     resume.experience.forEach(exp => {
// // // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // // //         spacing: { before: 120, after: 40 },
// // // // // // // // // // // // // // // // //         children: [
// // // // // // // // // // // // // // // // //           new TextRun({ text: exp.title, bold: true, size: 22, font: "Calibri", color: dark }),
// // // // // // // // // // // // // // // // //           new TextRun({ text: ` — ${exp.company}`, size: 22, font: "Calibri", color: gray }),
// // // // // // // // // // // // // // // // //         ],
// // // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // // //         spacing: { before: 0, after: 60 },
// // // // // // // // // // // // // // // // //         children: [
// // // // // // // // // // // // // // // // //           new TextRun({ text: `${exp.startDate} – ${exp.endDate}`, size: 18, font: "Calibri", color: gray, italics: true }),
// // // // // // // // // // // // // // // // //           exp.location ? new TextRun({ text: `  |  ${exp.location}`, size: 18, font: "Calibri", color: "AAAAAA" }) : null,
// // // // // // // // // // // // // // // // //         ].filter(Boolean),
// // // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // // //       (exp.bullets || []).forEach(b => children.push(bullet(b)));
// // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   // ── Education ──
// // // // // // // // // // // // // // // // //   if (resume.education?.length > 0) {
// // // // // // // // // // // // // // // // //     children.push(heading("Education"));
// // // // // // // // // // // // // // // // //     resume.education.forEach(edu => {
// // // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // // //         spacing: { before: 100, after: 40 },
// // // // // // // // // // // // // // // // //         children: [
// // // // // // // // // // // // // // // // //           new TextRun({ text: edu.degree, bold: true, size: 22, font: "Calibri", color: dark }),
// // // // // // // // // // // // // // // // //           new TextRun({ text: ` — ${edu.school}`, size: 22, font: "Calibri", color: gray }),
// // // // // // // // // // // // // // // // //         ],
// // // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // // //         spacing: { before: 0, after: 80 },
// // // // // // // // // // // // // // // // //         children: [
// // // // // // // // // // // // // // // // //           new TextRun({ text: edu.year || "", size: 18, font: "Calibri", color: gray, italics: true }),
// // // // // // // // // // // // // // // // //           edu.location ? new TextRun({ text: `  |  ${edu.location}`, size: 18, font: "Calibri", color: "AAAAAA" }) : null,
// // // // // // // // // // // // // // // // //           edu.gpa ? new TextRun({ text: `  |  GPA: ${edu.gpa}`, size: 18, font: "Calibri", color: "AAAAAA" }) : null,
// // // // // // // // // // // // // // // // //         ].filter(Boolean),
// // // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   // ── Skills ──
// // // // // // // // // // // // // // // // //   if (resume.skills) {
// // // // // // // // // // // // // // // // //     children.push(heading("Skills"));
// // // // // // // // // // // // // // // // //     [["Technical", "technical"], ["Tools", "tools"], ["Soft Skills", "soft"]].forEach(([label, key]) => {
// // // // // // // // // // // // // // // // //       if (resume.skills[key]?.length > 0) {
// // // // // // // // // // // // // // // // //         children.push(new Paragraph({
// // // // // // // // // // // // // // // // //           spacing: { before: 40, after: 40 },
// // // // // // // // // // // // // // // // //           children: [
// // // // // // // // // // // // // // // // //             new TextRun({ text: `${label}: `, bold: true, size: 20, font: "Calibri", color: dark }),
// // // // // // // // // // // // // // // // //             new TextRun({ text: resume.skills[key].join(", "), size: 20, font: "Calibri", color: dark }),
// // // // // // // // // // // // // // // // //           ],
// // // // // // // // // // // // // // // // //         }));
// // // // // // // // // // // // // // // // //       }
// // // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   // ── Certifications ──
// // // // // // // // // // // // // // // // //   if (resume.certifications?.length > 0) {
// // // // // // // // // // // // // // // // //     children.push(heading("Certifications"));
// // // // // // // // // // // // // // // // //     resume.certifications.forEach(c => children.push(bullet(c)));
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   const doc = new Document({
// // // // // // // // // // // // // // // // //     sections: [{
// // // // // // // // // // // // // // // // //       properties: { page: { margin: { top: 720, right: 720, bottom: 720, left: 720 } } },
// // // // // // // // // // // // // // // // //       children,
// // // // // // // // // // // // // // // // //     }],
// // // // // // // // // // // // // // // // //   });

// // // // // // // // // // // // // // // // //   const blob = await Packer.toBlob(doc);
// // // // // // // // // // // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // // // // // // // // // // //   const a = document.createElement("a");
// // // // // // // // // // // // // // // // //   a.href = url;
// // // // // // // // // // // // // // // // //   a.download = fileName.replace(".html", ".docx") || "ATS-Resume.docx";
// // // // // // // // // // // // // // // // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // // // // // // // // // // // // // //   URL.revokeObjectURL(url);
// // // // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // // HTML DOWNLOAD — template-aware
// // // // // // // // // // // // // // // // // // Matches landing page ResumeCard previews exactly
// // // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // export function downloadATSResume(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // // // // //   const t      = getTemplate(templateId);
// // // // // // // // // // // // // // // // //   const accent = "#" + t.accentHex;
// // // // // // // // // // // // // // // // //   const header = "#" + t.headerHex;
// // // // // // // // // // // // // // // // //   const name   = resume.name || "";

// // // // // // // // // // // // // // // // //   // ── CSS builder — string concat avoids template-literal-in-object issues ──
// // // // // // // // // // // // // // // // //   function buildCSS(id, ac, hd) {
// // // // // // // // // // // // // // // // //     const ul  = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";border-bottom:1.5px solid " + ac + ";padding-bottom:4px;margin-bottom:12px;}";
// // // // // // // // // // // // // // // // //     const fil = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;border-radius:0 6px 6px 0;}";
// // // // // // // // // // // // // // // // //     const mon = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.12em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;border-radius:0 6px 6px 0;font-family:'Courier New',monospace;}";
// // // // // // // // // // // // // // // // //     if (id==="classic")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:26px;font-weight:700;color:#0f172a;text-align:center;}.contact{font-size:13px;color:#475569;display:flex;justify-content:center;flex-wrap:wrap;gap:16px;}.header-wrap{text-align:center;border-bottom:2px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // // //     if (id==="modern")    return "body{font-family:Arial,Helvetica,sans-serif;}.page{display:flex;max-width:800px;margin:0 auto;}.sidebar{width:200px;background:"+hd+";padding:28px 18px;flex-shrink:0;}.main-col{flex:1;padding:28px 24px;}.name{font-size:14px;font-weight:800;color:#fff;}.contact{font-size:10px;color:rgba(255,255,255,0.7);}"+fil;
// // // // // // // // // // // // // // // // //     if (id==="executive") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:28px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.06em;}.contact{font-size:12px;color:rgba(255,255,255,0.6);display:flex;flex-wrap:wrap;gap:20px;}.header-wrap{background:"+hd+";padding:28px 32px 24px;}.body-wrap{padding:24px 32px;}"+ul;
// // // // // // // // // // // // // // // // //     if (id==="minimal")   return "body,.page{font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;}.name{font-size:28px;font-weight:300;color:#0f172a;letter-spacing:-0.02em;}.accent-bar{width:32px;height:3px;background:"+ac+";border-radius:2px;margin:6px 0 10px;}.contact{font-size:13px;color:#64748b;display:flex;flex-wrap:wrap;gap:18px;}.header-wrap{border-bottom:2.5px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // // //     if (id==="corporate") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:24px;font-weight:700;color:#fff;}.contact{font-size:12px;color:rgba(200,225,255,0.85);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+","+ac+");padding:24px 28px 22px;}.body-wrap{padding:22px 28px;}"+fil;
// // // // // // // // // // // // // // // // //     if (id==="creative")  return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:30px;font-weight:800;color:#fff;letter-spacing:-0.02em;}.contact{font-size:11px;color:rgba(255,210,220,0.85);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+","+ac+");padding:28px 28px 52px;clip-path:polygon(0 0,100% 0,100% 80%,0 100%);margin-bottom:-8px;}.body-wrap{padding:16px 28px 24px;}"+ul;
// // // // // // // // // // // // // // // // //     if (id==="technical")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:'Courier New',Courier,monospace;font-size:22px;font-weight:700;color:#fff;letter-spacing:0.02em;}.contact{font-family:'Courier New',Courier,monospace;font-size:10px;color:rgba(180,230,240,0.75);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+",#0e7490);padding:20px 24px 18px;border-bottom:3px solid "+ac+";}.body-wrap{padding:22px 24px;}"+mon;
// // // // // // // // // // // // // // // // //     if (id==="elegant")     return "body,.page{font-family:Georgia,'Times New Roman',serif;}.accent-strip{width:6px;background:linear-gradient(180deg,"+ac+","+hd+");flex-shrink:0;}.name{font-size:26px;font-weight:700;color:"+hd+";letter-spacing:0.01em;}.role{font-size:11px;color:"+ac+";font-weight:600;letter-spacing:0.1em;text-transform:uppercase;margin:4px 0 10px;}.contact{display:flex;flex-wrap:wrap;gap:16px;font-size:11px;color:#78716c;}.header-wrap{display:flex;border-bottom:1px solid #e7e5e4;}.header-inner{flex:1;padding:26px 26px 18px;}.body-wrap{padding:18px 26px 22px 32px;}"+ul;
// // // // // // // // // // // // // // // // //     if (id==="bold")        return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:34px;font-weight:900;color:#fff;letter-spacing:-0.03em;line-height:1;}.accent-bar{width:52px;height:4px;background:"+ac+";border-radius:2px;margin:10px 0 12px;}.role{font-size:12px;color:rgba(255,255,255,0.75);text-transform:uppercase;letter-spacing:0.1em;margin-bottom:10px;}.contact{display:flex;flex-wrap:wrap;gap:16px;font-size:11px;color:rgba(255,255,255,0.55);}.header-wrap{background:"+hd+";padding:26px 26px 20px;}.body-wrap{padding:20px 26px;}"+fil;
// // // // // // // // // // // // // // // // //     if (id==="sidebarlight")return "body{font-family:Arial,Helvetica,sans-serif;}.page{display:flex;}.sidebar{width:200px;background:"+hd+";padding:26px 16px;flex-shrink:0;border-right:3px solid "+ac+";}.avatar{width:58px;height:58px;border-radius:50%;background:"+ac+"25;border:2.5px solid "+ac+";display:flex;align-items:center;justify-content:center;margin-bottom:14px;font-size:22px;font-weight:700;color:"+ac+";}.name{font-size:13px;font-weight:800;color:#0f172a;margin-bottom:2px;}.role{font-size:10px;color:"+ac+";font-weight:600;margin-bottom:14px;}.main-col{flex:1;padding:22px 20px;}"+ul;
// // // // // // // // // // // // // // // // //     if (id==="academic")    return "body,.page{font-family:Georgia,'Times New Roman',serif;}.name{font-size:24px;font-weight:700;color:#fff;text-align:center;}.role{font-size:11px;color:"+ac+"cc;font-style:italic;text-align:center;margin:4px 0 10px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:16px;font-size:10px;color:rgba(255,255,255,0.5);}.header-wrap{background:"+hd+";padding:22px 30px 18px;text-align:center;}.double-rule-top{height:3px;background:"+ac+";}.double-rule-bot{height:1px;background:"+ac+"40;}.body-wrap{padding:20px 30px;}"+ul;
// // // // // // // // // // // // // // // // //     if (id==="professional") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:28px;font-weight:700;color:#fff;}.role{font-size:12px;color:"+ac+"bb;text-transform:uppercase;letter-spacing:0.1em;}.contact{font-size:11px;color:rgba(255,255,255,0.6);}.header-inner{display:flex;justify-content:space-between;align-items:flex-end;flex-wrap:wrap;gap:12px;}.accent-line{height:2px;background:"+ac+";border-radius:1px;margin-top:16px;}.header-wrap{background:"+hd+";padding:26px 32px 20px;}.body-wrap{padding:20px 32px;}"+ul;
// // // // // // // // // // // // // // // // //     if (id==="compact")      return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:22px;font-weight:700;color:#fff;}.role{font-size:11px;color:rgba(255,255,255,0.65);}.contact{display:flex;flex-wrap:wrap;gap:10px;}.contact span{font-size:10px;color:rgba(255,255,255,0.5);background:rgba(255,255,255,0.08);padding:2px 8px;border-radius:4px;}.header-wrap{background:"+hd+";padding:14px 24px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:10px;}.body-wrap{padding:14px 24px;}"+ul;
// // // // // // // // // // // // // // // // //     if (id==="cleanserif")   return "body,.page{font-family:Georgia,'Times New Roman',serif;padding:28px 32px;}.name{font-size:28px;font-weight:700;color:#1a0a0a;letter-spacing:0.02em;text-align:center;}.role{font-size:12px;color:"+ac+";font-weight:600;letter-spacing:0.12em;text-transform:uppercase;text-align:center;margin:4px 0 10px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:18px;font-size:11px;color:#6b7280;}.header-wrap{text-align:center;border-bottom:3px double "+ac+";padding-bottom:16px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // // //     if (id==="government")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:22px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.08em;}.contact{display:flex;flex-wrap:wrap;gap:18px;font-size:11px;color:rgba(255,255,255,0.6);margin-top:8px;}.position-bar{background:"+ac+"12;padding:6px 28px;border-bottom:1px solid "+ac+"25;font-size:11px;color:#374151;}.position-label{font-weight:700;color:"+ac+";text-transform:uppercase;letter-spacing:0.06em;}.header-wrap{background:"+hd+";padding:18px 28px 16px;border-bottom:4px solid "+ac+";}.body-wrap{padding:18px 28px;}"+fil;
// // // // // // // // // // // // // // // // //     if (id==="classic_bw")  return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:26px;font-weight:700;color:#000;text-align:center;letter-spacing:0.02em;}.role{font-size:12px;color:#333;text-align:center;margin:4px 0 8px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:18px;font-size:12px;color:#555;}.header-wrap{text-align:center;border-bottom:2px solid #000;padding-bottom:16px;margin-bottom:20px;}.section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:#000;border-bottom:1.5px solid #000;padding-bottom:4px;margin-bottom:12px;}";
// // // // // // // // // // // // // // // // //     if (id==="traditional") return "body,.page{font-family:Georgia,'Times New Roman',serif;padding:28px 32px;}.name{font-size:26px;font-weight:700;color:#000;text-align:center;font-family:Georgia,serif;letter-spacing:0.01em;}.role{font-size:12px;color:#444;text-align:center;margin:4px 0 8px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:18px;font-size:12px;color:#555;}.header-wrap{text-align:center;border-bottom:1.5px solid #1a1a1a;padding-bottom:16px;margin-bottom:20px;}.section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:#1a1a1a;border-bottom:1.5px solid #1a1a1a;padding-bottom:4px;margin-bottom:12px;}";
// // // // // // // // // // // // // // // // //     return "";
// // // // // // // // // // // // // // // // //   }
// // // // // // // // // // // // // // // // //   const css = buildCSS(templateId, accent, header);

// // // // // // // // // // // // // // // // //   // ── Contact list ──
// // // // // // // // // // // // // // // // //   const contacts = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // // //   const contactSpans = contacts.map(c => `<span>${c}</span>`).join("");
// // // // // // // // // // // // // // // // //   const contactDivs  = contacts.map(c => `<div>${c}</div>`).join("");

// // // // // // // // // // // // // // // // //   // ── Header HTML per template ──
// // // // // // // // // // // // // // // // //   function buildHeader(id) {
// // // // // // // // // // // // // // // // //     if (id==="classic") return `<div class="header-wrap"><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // // //     if (id==="modern")  return `<div class="sidebar"><div style="width:64px;height:64px;border-radius:50%;background:rgba(255,255,255,0.15);margin-bottom:16px;"></div><div class="name">${name}</div><div style="font-size:10px;color:${accent}cc;background:rgba(255,255,255,0.08);padding:2px 8px;border-radius:4px;display:inline-block;margin:4px 0 16px;font-weight:600;">${(resume.experience||[])[0]?.title||"Professional"}</div><hr style="border:none;border-top:1px solid rgba(255,255,255,0.15);margin:0 0 12px;"/><div style="font-size:10px;font-weight:700;color:rgba(255,255,255,0.5);text-transform:uppercase;letter-spacing:0.1em;margin-bottom:8px;">Contact</div><div style="display:flex;flex-direction:column;gap:5px;font-size:10px;color:rgba(255,255,255,0.7);">${contactDivs}</div></div><div class="main-col">`;
// // // // // // // // // // // // // // // // //     if (id==="executive") return `<div class="header-wrap"><div class="name">${name.toUpperCase()}</div><hr style="border:none;border-top:2px solid rgba(255,255,255,0.3);margin:8px 0 4px;"/><hr style="border:none;border-top:0.5px solid rgba(255,255,255,0.1);margin:0 0 12px;"/><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // // //     if (id==="minimal") return `<div class="header-wrap"><div class="name">${name}</div><div class="accent-bar"></div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // // //     if (id==="corporate") return `<div class="header-wrap"><div class="name">${name}</div><div style="font-size:12px;color:rgba(200,225,255,0.7);font-style:italic;margin:4px 0 10px;">${(resume.experience||[])[0]?.title||"Professional Resume"}</div><hr style="border:none;border-top:1px solid rgba(255,255,255,0.2);margin:0 0 10px;"/><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // // //     if (id==="creative") return `<div class="header-wrap"><div class="name">${name}</div><div style="font-size:12px;color:rgba(255,210,220,0.85);text-transform:uppercase;letter-spacing:0.08em;margin:6px 0 12px;">Resume</div><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // // //     if (id==="technical") return `<div class="header-wrap"><div style="font-size:10px;color:${accent}cc;font-family:'Courier New',monospace;margin-bottom:6px;letter-spacing:0.04em;">// resume.json</div><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // // //     if (id==="professional") return `<div class="header-wrap"><div class="header-inner"><div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div></div><div style="text-align:right">${contacts.slice(0,2).map(c=>`<div style="font-size:11px;color:rgba(255,255,255,0.6);margin-bottom:3px;">${c}</div>`).join("")}</div></div><div class="accent-line"></div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // // //     if (id==="compact")      return `<div class="header-wrap"><div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div></div><div class="contact">${contacts.map(c=>`<span>${c}</span>`).join("")}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // // //     if (id==="cleanserif")   return `<div class="header-wrap"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // // //     if (id==="government")   return `<div class="header-wrap"><div class="name">${name}</div><div class="contact">${contactSpans}</div></div><div class="position-bar"><span class="position-label">Position Applied For: </span>${(resume.experience||[])[0]?.title||"Professional"}</div><div class="body-wrap">`;
// // // // // // // // // // // // // // // // //     if (id==="classic_bw")  return `<div class="header-wrap"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // // //     if (id==="traditional") return `<div class="header-wrap"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // // //     return `<div class="header-wrap"><div class="name">${name}</div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // // //   }
// // // // // // // // // // // // // // // // //   // closing tags for templates that open extra divs
// // // // // // // // // // // // // // // // //   function closeHeader(id) {
// // // // // // // // // // // // // // // // //     if (["modern","executive","corporate","creative","technical","elegant","bold","sidebarlight","academic","professional","compact","government"].includes(id)) return "</div>";
// // // // // // // // // // // // // // // // //     return "";
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   const headerHtml = buildHeader(templateId);
// // // // // // // // // // // // // // // // //   const headerClose = closeHeader(templateId);

// // // // // // // // // // // // // // // // //   // ── Body sections ──
// // // // // // // // // // // // // // // // //   const expHtml = (resume.experience || []).map(exp => `
// // // // // // // // // // // // // // // // //     <div style="margin-bottom:14px;">
// // // // // // // // // // // // // // // // //       <div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:4px;">
// // // // // // // // // // // // // // // // //         <div>
// // // // // // // // // // // // // // // // //           <strong style="font-size:14px;color:#0f172a;">${exp.title}</strong>
// // // // // // // // // // // // // // // // //           <span style="color:#475569;"> — ${exp.company}</span>
// // // // // // // // // // // // // // // // //           ${exp.location ? `<span style="color:#94a3b8;font-size:12px;"> | ${exp.location}</span>` : ""}
// // // // // // // // // // // // // // // // //         </div>
// // // // // // // // // // // // // // // // //         <span style="color:#64748b;font-size:12px;font-style:italic;white-space:nowrap;">${exp.startDate} – ${exp.endDate}</span>
// // // // // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // // // // //       <ul style="margin:5px 0 0 20px;padding:0;">
// // // // // // // // // // // // // // // // //         ${(exp.bullets || []).map(b => `<li style="font-size:13px;color:#374151;margin-bottom:4px;line-height:1.6;">${b}</li>`).join("")}
// // // // // // // // // // // // // // // // //       </ul>
// // // // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // // // //   const eduHtml = (resume.education || []).map(edu => `
// // // // // // // // // // // // // // // // //     <div style="display:flex;justify-content:space-between;margin-bottom:8px;flex-wrap:wrap;gap:4px;">
// // // // // // // // // // // // // // // // //       <div>
// // // // // // // // // // // // // // // // //         <strong style="font-size:14px;color:#0f172a;">${edu.degree}</strong>
// // // // // // // // // // // // // // // // //         <span style="color:#475569;"> — ${edu.school}</span>
// // // // // // // // // // // // // // // // //         ${edu.location ? `<span style="color:#94a3b8;font-size:12px;"> | ${edu.location}</span>` : ""}
// // // // // // // // // // // // // // // // //         ${edu.gpa ? `<span style="color:#94a3b8;font-size:12px;"> | GPA: ${edu.gpa}</span>` : ""}
// // // // // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // // // // //       <span style="color:#64748b;font-size:12px;font-style:italic;">${edu.year || ""}</span>
// // // // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // // // //   const skillsHtml = resume.skills ? [
// // // // // // // // // // // // // // // // //     resume.skills.technical?.length > 0 ? `<p style="margin:4px 0;font-size:13px;"><strong>Technical:</strong> ${resume.skills.technical.join(", ")}</p>` : "",
// // // // // // // // // // // // // // // // //     resume.skills.tools?.length > 0     ? `<p style="margin:4px 0;font-size:13px;"><strong>Tools:</strong> ${resume.skills.tools.join(", ")}</p>` : "",
// // // // // // // // // // // // // // // // //     resume.skills.soft?.length > 0      ? `<p style="margin:4px 0;font-size:13px;"><strong>Soft Skills:</strong> ${resume.skills.soft.join(", ")}</p>` : "",
// // // // // // // // // // // // // // // // //   ].join("") : "";

// // // // // // // // // // // // // // // // //   const certHtml = resume.certifications?.length > 0
// // // // // // // // // // // // // // // // //     ? `<ul style="margin:4px 0 0 20px;padding:0;">${resume.certifications.map(c => `<li style="font-size:13px;color:#374151;margin-bottom:4px;">${c}</li>`).join("")}</ul>`
// // // // // // // // // // // // // // // // //     : "";

// // // // // // // // // // // // // // // // //   function section(title, body) {
// // // // // // // // // // // // // // // // //     if (!body) return "";
// // // // // // // // // // // // // // // // //     return `<div style="margin-bottom:20px;"><div class="section-title">${title}</div>${body}</div>`;
// // // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // // //   const pageOpen  = templateId === "modern" ? `<div class="page">` : `<div class="page" style="max-width:800px;margin:0 auto;padding:36px 40px;">`;

// // // // // // // // // // // // // // // // //   const html = `<!DOCTYPE html>
// // // // // // // // // // // // // // // // // <html lang="en">
// // // // // // // // // // // // // // // // // <head>
// // // // // // // // // // // // // // // // //   <meta charset="utf-8"/>
// // // // // // // // // // // // // // // // //   <title>${name} — ${t.name}</title>
// // // // // // // // // // // // // // // // //   <style>
// // // // // // // // // // // // // // // // //     *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
// // // // // // // // // // // // // // // // //     body{color:#212529;background:#fff;font-size:14px;line-height:1.55;}
// // // // // // // // // // // // // // // // //     ${css}
// // // // // // // // // // // // // // // // //     @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}.page{padding:20px;}.no-print{display:none!important;}}
// // // // // // // // // // // // // // // // //   </style>
// // // // // // // // // // // // // // // // // </head>
// // // // // // // // // // // // // // // // // <body>
// // // // // // // // // // // // // // // // // ${pageOpen}
// // // // // // // // // // // // // // // // //   <div class="no-print" style="background:#eff6ff;border:1px solid #bfdbfe;border-radius:8px;padding:10px 16px;margin-bottom:20px;font-size:13px;color:#2563eb;">
// // // // // // // // // // // // // // // // //     <strong>To save as PDF:</strong> Press Ctrl+P (or Cmd+P) &rarr; Select "Save as PDF" &rarr; Click Save
// // // // // // // // // // // // // // // // //   </div>
// // // // // // // // // // // // // // // // //   ${headerHtml}
// // // // // // // // // // // // // // // // //   ${section("Professional Summary", resume.summary ? `<p style="font-size:13px;line-height:1.75;color:#374151;">${resume.summary}</p>` : "")}
// // // // // // // // // // // // // // // // //   ${section("Work Experience", expHtml)}
// // // // // // // // // // // // // // // // //   ${section("Education", eduHtml)}
// // // // // // // // // // // // // // // // //   ${section("Skills", skillsHtml)}
// // // // // // // // // // // // // // // // //   ${resume.certifications?.length > 0 ? section("Certifications", certHtml) : ""}
// // // // // // // // // // // // // // // // //   ${headerClose}
// // // // // // // // // // // // // // // // // </div>
// // // // // // // // // // // // // // // // // </body>
// // // // // // // // // // // // // // // // // </html>`;

// // // // // // // // // // // // // // // // //   const blob = new Blob([html], { type: "text/html;charset=utf-8" });
// // // // // // // // // // // // // // // // //   const url  = URL.createObjectURL(blob);
// // // // // // // // // // // // // // // // //   const a    = document.createElement("a");
// // // // // // // // // // // // // // // // //   a.href = url;
// // // // // // // // // // // // // // // // //   a.download = fileName || "ATS-Resume.html";
// // // // // // // // // // // // // // // // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // // // // // // // // // // // // // //   URL.revokeObjectURL(url);
// // // // // // // // // // // // // // // // // }


// // // // // // // // // // // // // // // // // src/utils/generateResumeDoc.js
// // // // // // // // // // // // // // // // import { Document, Packer, Paragraph, TextRun, HeadingLevel, AlignmentType, BorderStyle } from "docx";

// // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // TEMPLATE DEFINITIONS
// // // // // // // // // // // // // // // // // Add new templates here — must match ResumeGeneratorPage.jsx
// // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // const TEMPLATES = {
// // // // // // // // // // // // // // // //   classic: {
// // // // // // // // // // // // // // // //     name:       "Classic ATS",
// // // // // // // // // // // // // // // //     accentHex:  "2563eb",
// // // // // // // // // // // // // // // //     headerHex:  "1e293b",
// // // // // // // // // // // // // // // //     accentRgb:  [37, 99, 235],
// // // // // // // // // // // // // // // //     headerRgb:  [30, 41, 59],
// // // // // // // // // // // // // // // //     nameSize:   24,
// // // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   modern: {
// // // // // // // // // // // // // // // //     name:       "Modern Pro",
// // // // // // // // // // // // // // // //     accentHex:  "7c3aed",
// // // // // // // // // // // // // // // //     headerHex:  "7c3aed",
// // // // // // // // // // // // // // // //     accentRgb:  [124, 58, 237],
// // // // // // // // // // // // // // // //     headerRgb:  [124, 58, 237],
// // // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   executive: {
// // // // // // // // // // // // // // // //     name:       "Executive",
// // // // // // // // // // // // // // // //     accentHex:  "334155",
// // // // // // // // // // // // // // // //     headerHex:  "0f172a",
// // // // // // // // // // // // // // // //     accentRgb:  [51, 65, 85],
// // // // // // // // // // // // // // // //     headerRgb:  [15, 23, 42],
// // // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   minimal: {
// // // // // // // // // // // // // // // //     name:       "Minimal Clean",
// // // // // // // // // // // // // // // //     accentHex:  "059669",
// // // // // // // // // // // // // // // //     headerHex:  "059669",
// // // // // // // // // // // // // // // //     accentRgb:  [5, 150, 105],
// // // // // // // // // // // // // // // //     headerRgb:  [5, 150, 105],
// // // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   corporate: {
// // // // // // // // // // // // // // // //     name:       "Corporate",
// // // // // // // // // // // // // // // //     accentHex:  "0369a1",
// // // // // // // // // // // // // // // //     headerHex:  "0c4a6e",
// // // // // // // // // // // // // // // //     accentRgb:  [3, 105, 161],
// // // // // // // // // // // // // // // //     headerRgb:  [12, 74, 110],
// // // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   creative: {
// // // // // // // // // // // // // // // //     name:       "Creative",
// // // // // // // // // // // // // // // //     accentHex:  "e11d48",
// // // // // // // // // // // // // // // //     headerHex:  "881337",
// // // // // // // // // // // // // // // //     accentRgb:  [225, 29, 72],
// // // // // // // // // // // // // // // //     headerRgb:  [136, 19, 55],
// // // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   technical: {
// // // // // // // // // // // // // // // //     name:       "Technical",
// // // // // // // // // // // // // // // //     accentHex:  "0891b2",
// // // // // // // // // // // // // // // //     headerHex:  "164e63",
// // // // // // // // // // // // // // // //     accentRgb:  [8, 145, 178],
// // // // // // // // // // // // // // // //     headerRgb:  [22, 78, 99],
// // // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   bold: {
// // // // // // // // // // // // // // // //     name:       "Bold Impact",
// // // // // // // // // // // // // // // //     accentHex:  "2563eb",
// // // // // // // // // // // // // // // //     headerHex:  "1e3a8a",
// // // // // // // // // // // // // // // //     accentRgb:  [37, 99, 235],
// // // // // // // // // // // // // // // //     headerRgb:  [30, 58, 138],
// // // // // // // // // // // // // // // //     nameSize:   28,
// // // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   elegant: {
// // // // // // // // // // // // // // // //     name:       "Elegant",
// // // // // // // // // // // // // // // //     accentHex:  "b45309",
// // // // // // // // // // // // // // // //     headerHex:  "78350f",
// // // // // // // // // // // // // // // //     accentRgb:  [180, 83, 9],
// // // // // // // // // // // // // // // //     headerRgb:  [120, 53, 15],
// // // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   academic: {
// // // // // // // // // // // // // // // //     name:       "Academic",
// // // // // // // // // // // // // // // //     accentHex:  "1e40af",
// // // // // // // // // // // // // // // //     headerHex:  "1e3a8a",
// // // // // // // // // // // // // // // //     accentRgb:  [30, 64, 175],
// // // // // // // // // // // // // // // //     headerRgb:  [30, 58, 138],
// // // // // // // // // // // // // // // //     nameSize:   24,
// // // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   professional: {
// // // // // // // // // // // // // // // //     name:       "Professional",
// // // // // // // // // // // // // // // //     accentHex:  "0f172a",
// // // // // // // // // // // // // // // //     headerHex:  "0f172a",
// // // // // // // // // // // // // // // //     accentRgb:  [15, 23, 42],
// // // // // // // // // // // // // // // //     headerRgb:  [15, 23, 42],
// // // // // // // // // // // // // // // //     nameSize:   24,
// // // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   compact: {
// // // // // // // // // // // // // // // //     name:       "Compact",
// // // // // // // // // // // // // // // //     accentHex:  "374151",
// // // // // // // // // // // // // // // //     headerHex:  "111827",
// // // // // // // // // // // // // // // //     accentRgb:  [55, 65, 81],
// // // // // // // // // // // // // // // //     headerRgb:  [17, 24, 39],
// // // // // // // // // // // // // // // //     nameSize:   20,
// // // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   cleanserif: {
// // // // // // // // // // // // // // // //     name:       "Clean Serif",
// // // // // // // // // // // // // // // //     accentHex:  "7c2d12",
// // // // // // // // // // // // // // // //     headerHex:  "1a0a0a",
// // // // // // // // // // // // // // // //     accentRgb:  [124, 45, 18],
// // // // // // // // // // // // // // // //     headerRgb:  [26, 10, 10],
// // // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   government: {
// // // // // // // // // // // // // // // //     name:       "Government",
// // // // // // // // // // // // // // // //     accentHex:  "1e3a5f",
// // // // // // // // // // // // // // // //     headerHex:  "0f2540",
// // // // // // // // // // // // // // // //     accentRgb:  [30, 58, 95],
// // // // // // // // // // // // // // // //     headerRgb:  [15, 37, 64],
// // // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   sidebarlight: {
// // // // // // // // // // // // // // // //     name:       "Sidebar Light",
// // // // // // // // // // // // // // // //     accentHex:  "0369a1",
// // // // // // // // // // // // // // // //     headerHex:  "0c4a6e",
// // // // // // // // // // // // // // // //     accentRgb:  [3, 105, 161],
// // // // // // // // // // // // // // // //     headerRgb:  [12, 74, 110],
// // // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   classic_bw: {
// // // // // // // // // // // // // // // //     name:       "Classic B&W",
// // // // // // // // // // // // // // // //     accentHex:  "000000",
// // // // // // // // // // // // // // // //     headerHex:  "000000",
// // // // // // // // // // // // // // // //     accentRgb:  [0, 0, 0],
// // // // // // // // // // // // // // // //     headerRgb:  [0, 0, 0],
// // // // // // // // // // // // // // // //     nameSize:   24,
// // // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // //   traditional: {
// // // // // // // // // // // // // // // //     name:       "Traditional",
// // // // // // // // // // // // // // // //     accentHex:  "1a1a1a",
// // // // // // // // // // // // // // // //     headerHex:  "1a1a1a",
// // // // // // // // // // // // // // // //     accentRgb:  [26, 26, 26],
// // // // // // // // // // // // // // // //     headerRgb:  [26, 26, 26],
// // // // // // // // // // // // // // // //     nameSize:   24,
// // // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // // };

// // // // // // // // // // // // // // // // function getTemplate(templateId) {
// // // // // // // // // // // // // // // //   return TEMPLATES[templateId] || TEMPLATES.classic;
// // // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // PDF DOWNLOAD — renders HTML then opens print dialog
// // // // // // // // // // // // // // // // // This produces pixel-perfect output matching the template preview
// // // // // // // // // // // // // // // // // because it uses the same CSS as the screen render
// // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // export function downloadResumeAsPDF(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // // // //   // Build the full HTML using downloadATSResume's HTML generator then open print dialog
// // // // // // // // // // // // // // // //   const t      = getTemplate(templateId);
// // // // // // // // // // // // // // // //   const accent = "#" + t.accentHex;
// // // // // // // // // // // // // // // //   const header = "#" + t.headerHex;
// // // // // // // // // // // // // // // //   const name   = resume.name || "";

// // // // // // // // // // // // // // // //   function buildCSS(id, ac, hd) {
// // // // // // // // // // // // // // // //     const ul  = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";border-bottom:1.5px solid " + ac + ";padding-bottom:4px;margin-bottom:12px;}";
// // // // // // // // // // // // // // // //     const fil = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;border-radius:0 6px 6px 0;}";
// // // // // // // // // // // // // // // //     const mon = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.12em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;border-radius:0 6px 6px 0;font-family:'Courier New',monospace;}";
// // // // // // // // // // // // // // // //     if (id==="classic")      return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:26px;font-weight:700;color:#0f172a;text-align:center;}.contact{font-size:13px;color:#475569;display:flex;justify-content:center;flex-wrap:wrap;gap:16px;}.header-wrap{text-align:center;border-bottom:2px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="modern")       return "body{font-family:Arial,Helvetica,sans-serif;}.page{display:flex;max-width:800px;margin:0 auto;}.sidebar{width:200px;background:"+hd+";padding:28px 18px;flex-shrink:0;}.main-col{flex:1;padding:28px 24px;}.name{font-size:14px;font-weight:800;color:#fff;}.contact{font-size:10px;color:rgba(255,255,255,0.7);}"+fil;
// // // // // // // // // // // // // // // //     if (id==="executive")    return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:28px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.06em;}.contact{font-size:12px;color:rgba(255,255,255,0.6);display:flex;flex-wrap:wrap;gap:20px;}.header-wrap{background:"+hd+";padding:28px 32px 24px;}.body-wrap{padding:24px 32px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="minimal")      return "body,.page{font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;}.name{font-size:28px;font-weight:300;color:#0f172a;letter-spacing:-0.02em;}.accent-bar{width:32px;height:3px;background:"+ac+";border-radius:2px;margin:6px 0 10px;}.contact{font-size:13px;color:#64748b;display:flex;flex-wrap:wrap;gap:18px;}.header-wrap{border-bottom:2.5px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="corporate")    return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:24px;font-weight:700;color:#fff;}.contact{font-size:12px;color:rgba(200,225,255,0.85);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+","+ac+");padding:24px 28px 22px;}.body-wrap{padding:22px 28px;}"+fil;
// // // // // // // // // // // // // // // //     if (id==="creative")     return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:30px;font-weight:800;color:#fff;letter-spacing:-0.02em;}.contact{font-size:11px;color:rgba(255,210,220,0.85);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+","+ac+");padding:28px 28px 52px;clip-path:polygon(0 0,100% 0,100% 80%,0 100%);margin-bottom:-8px;}.body-wrap{padding:16px 28px 24px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="technical")    return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:'Courier New',Courier,monospace;font-size:22px;font-weight:700;color:#fff;letter-spacing:0.02em;}.contact{font-family:'Courier New',Courier,monospace;font-size:10px;color:rgba(180,230,240,0.75);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+",#0e7490);padding:20px 24px 18px;border-bottom:3px solid "+ac+";}.body-wrap{padding:22px 24px;}"+mon;
// // // // // // // // // // // // // // // //     if (id==="elegant")      return "body,.page{font-family:Georgia,'Times New Roman',serif;}.accent-strip{width:6px;background:linear-gradient(180deg,"+ac+","+hd+");flex-shrink:0;}.name{font-size:26px;font-weight:700;color:"+hd+";letter-spacing:0.01em;}.role{font-size:11px;color:"+ac+";font-weight:600;letter-spacing:0.1em;text-transform:uppercase;margin:4px 0 10px;}.contact{display:flex;flex-wrap:wrap;gap:16px;font-size:11px;color:#78716c;}.header-wrap{display:flex;border-bottom:1px solid #e7e5e4;}.header-inner{flex:1;padding:26px 26px 18px;}.body-wrap{padding:18px 26px 22px 32px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="bold")         return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:34px;font-weight:900;color:#fff;letter-spacing:-0.03em;line-height:1;}.accent-bar{width:52px;height:4px;background:"+ac+";border-radius:2px;margin:10px 0 12px;}.role{font-size:12px;color:rgba(255,255,255,0.75);text-transform:uppercase;letter-spacing:0.1em;margin-bottom:10px;}.contact{display:flex;flex-wrap:wrap;gap:16px;font-size:11px;color:rgba(255,255,255,0.55);}.header-wrap{background:"+hd+";padding:26px 26px 20px;}.body-wrap{padding:20px 26px;}"+fil;
// // // // // // // // // // // // // // // //     if (id==="sidebarlight") return "body{font-family:Arial,Helvetica,sans-serif;}.page{display:flex;}.sidebar{width:200px;background:"+hd+";padding:26px 16px;flex-shrink:0;border-right:3px solid "+ac+";}.avatar{width:58px;height:58px;border-radius:50%;background:"+ac+"25;border:2.5px solid "+ac+";display:flex;align-items:center;justify-content:center;margin-bottom:14px;font-size:22px;font-weight:700;color:"+ac+";}.name{font-size:13px;font-weight:800;color:#0f172a;margin-bottom:2px;}.role{font-size:10px;color:"+ac+";font-weight:600;margin-bottom:14px;}.main-col{flex:1;padding:22px 20px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="academic")     return "body,.page{font-family:Georgia,'Times New Roman',serif;}.name{font-size:24px;font-weight:700;color:#fff;text-align:center;}.role{font-size:11px;color:"+ac+"cc;font-style:italic;text-align:center;margin:4px 0 10px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:16px;font-size:10px;color:rgba(255,255,255,0.5);}.header-wrap{background:"+hd+";padding:22px 30px 18px;text-align:center;}.double-rule-top{height:3px;background:"+ac+";}.double-rule-bot{height:1px;background:"+ac+"40;}.body-wrap{padding:20px 30px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="professional") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:28px;font-weight:700;color:#fff;}.role{font-size:12px;color:"+ac+"bb;text-transform:uppercase;letter-spacing:0.1em;}.contact{font-size:11px;color:rgba(255,255,255,0.6);}.header-inner{display:flex;justify-content:space-between;align-items:flex-end;flex-wrap:wrap;gap:12px;}.accent-line{height:2px;background:"+ac+";border-radius:1px;margin-top:16px;}.header-wrap{background:"+hd+";padding:26px 32px 20px;}.body-wrap{padding:20px 32px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="compact")      return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:22px;font-weight:700;color:#fff;}.role{font-size:11px;color:rgba(255,255,255,0.65);}.contact{display:flex;flex-wrap:wrap;gap:10px;}.contact span{font-size:10px;color:rgba(255,255,255,0.5);background:rgba(255,255,255,0.08);padding:2px 8px;border-radius:4px;}.header-wrap{background:"+hd+";padding:14px 24px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:10px;}.body-wrap{padding:14px 24px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="cleanserif")   return "body,.page{font-family:Georgia,'Times New Roman',serif;padding:28px 32px;}.name{font-size:28px;font-weight:700;color:#1a0a0a;letter-spacing:0.02em;text-align:center;}.role{font-size:12px;color:"+ac+";font-weight:600;letter-spacing:0.12em;text-transform:uppercase;text-align:center;margin:4px 0 10px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:18px;font-size:11px;color:#6b7280;}.header-wrap{text-align:center;border-bottom:3px double "+ac+";padding-bottom:16px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="government")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:22px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.08em;}.contact{display:flex;flex-wrap:wrap;gap:18px;font-size:11px;color:rgba(255,255,255,0.6);margin-top:8px;}.position-bar{background:"+ac+"12;padding:6px 28px;border-bottom:1px solid "+ac+"25;font-size:11px;color:#374151;}.position-label{font-weight:700;color:"+ac+";text-transform:uppercase;letter-spacing:0.06em;}.header-wrap{background:"+hd+";padding:18px 28px 16px;border-bottom:4px solid "+ac+";}.body-wrap{padding:18px 28px;}"+fil;
// // // // // // // // // // // // // // // //     if (id==="classic_bw")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:26px;font-weight:700;color:#000;text-align:center;}.contact{font-size:13px;color:#374151;display:flex;justify-content:center;flex-wrap:wrap;gap:16px;}.header-wrap{text-align:center;border-bottom:2px solid #000;padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="traditional")  return "body,.page{font-family:Georgia,'Times New Roman',serif;padding:28px 32px;}.name{font-size:26px;font-weight:700;color:#000;text-align:center;}.contact{font-size:13px;color:#374151;display:flex;justify-content:center;flex-wrap:wrap;gap:16px;}.header-wrap{text-align:center;border-bottom:1.5px solid #1a1a1a;padding-bottom:16px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // //     return "body,.page{font-family:Arial,Helvetica,sans-serif;}"+ul;
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   function buildHeader(id) {
// // // // // // // // // // // // // // // //     const contacts    = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // //     const contactSpans= contacts.map(c => `<span>${c}</span>`).join("");
// // // // // // // // // // // // // // // //     const contactDivs = contacts.map(c => `<div>${c}</div>`).join("");
// // // // // // // // // // // // // // // //     if (id==="classic"||id==="classic_bw") return `<div class="header-wrap"><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // //     if (id==="modern")       return `<div class="sidebar"><div style="width:64px;height:64px;border-radius:50%;background:rgba(255,255,255,0.15);margin-bottom:16px;"></div><div class="name">${name}</div><div style="font-size:10px;color:${accent}cc;background:rgba(255,255,255,0.08);padding:2px 8px;border-radius:4px;display:inline-block;margin:4px 0 16px;font-weight:600;">${(resume.experience||[])[0]?.title||""}</div><hr style="border:none;border-top:1px solid rgba(255,255,255,0.15);margin:0 0 12px;"/><div style="display:flex;flex-direction:column;gap:5px;font-size:10px;color:rgba(255,255,255,0.7);">${contactDivs}</div></div><div class="main-col">`;
// // // // // // // // // // // // // // // //     if (id==="executive")    return `<div class="header-wrap"><div class="name">${name.toUpperCase()}</div><hr style="border:none;border-top:2px solid rgba(255,255,255,0.3);margin:8px 0;"/><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="minimal")      return `<div class="header-wrap"><div class="name">${name}</div><div class="accent-bar"></div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // //     if (id==="corporate")    return `<div class="header-wrap"><div class="name">${name}</div><div style="font-size:12px;color:rgba(200,225,255,0.7);font-style:italic;margin:4px 0 10px;">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="creative")     return `<div class="header-wrap"><div class="name">${name}</div><div class="contact" style="margin-top:10px;">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="technical")    return `<div class="header-wrap"><div style="font-size:10px;color:${accent}cc;font-family:'Courier New',monospace;margin-bottom:6px;">// resume.json</div><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="elegant")      return `<div class="header-wrap"><div class="accent-strip"></div><div class="header-inner"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="bold")         return `<div class="header-wrap"><div class="name">${name}</div><div class="accent-bar"></div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="sidebarlight") return `<div class="sidebar"><div class="avatar">${(name||"?")[0]}</div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><hr style="border:none;border-top:1px solid rgba(0,0,0,0.1);margin:0 0 12px;"/><div style="display:flex;flex-direction:column;gap:5px;font-size:10px;color:#374151;">${contactDivs}</div></div><div class="main-col">`;
// // // // // // // // // // // // // // // //     if (id==="academic")     return `<div class="double-rule-top"></div><div class="header-wrap"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div><div class="double-rule-bot"></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="professional") return `<div class="header-wrap"><div class="header-inner"><div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div></div><div style="text-align:right">${contacts.slice(0,2).map(c=>`<div style="font-size:11px;color:rgba(255,255,255,0.6);margin-bottom:3px;">${c}</div>`).join("")}</div></div><div class="accent-line"></div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="compact")      return `<div class="header-wrap"><div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div></div><div class="contact">${contacts.map(c=>`<span>${c}</span>`).join("")}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="cleanserif")   return `<div class="header-wrap"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // //     if (id==="government")   return `<div class="header-wrap"><div class="name">${name}</div><div class="contact">${contactSpans}</div></div><div class="position-bar"><span class="position-label">Position: </span>${(resume.experience||[])[0]?.title||""}</div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="traditional")  return `<div class="header-wrap"><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // //     return `<div class="header-wrap"><div class="name">${name}</div><div style="margin-top:8px;">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   function closeHeader(id) {
// // // // // // // // // // // // // // // //     if (["modern","executive","corporate","creative","technical","elegant","bold","sidebarlight","academic","professional","compact","government"].includes(id)) return "</div>";
// // // // // // // // // // // // // // // //     return "";
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   const css        = buildCSS(templateId, accent, header);
// // // // // // // // // // // // // // // //   const contacts   = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // //   const headerHtml = buildHeader(templateId);
// // // // // // // // // // // // // // // //   const headerClose= closeHeader(templateId);
// // // // // // // // // // // // // // // //   const pageOpen   = ["modern","sidebarlight"].includes(templateId) ? `<div class="page">` : `<div class="page" style="max-width:800px;margin:0 auto;padding:${["cleanserif","traditional"].includes(templateId)?"0":"36px 40px"};">`;

// // // // // // // // // // // // // // // //   const expHtml = (resume.experience||[]).map(exp => `
// // // // // // // // // // // // // // // //     <div style="margin-bottom:16px;">
// // // // // // // // // // // // // // // //       <div style="display:flex;justify-content:space-between;align-items:baseline;flex-wrap:wrap;gap:4px;margin-bottom:3px;">
// // // // // // // // // // // // // // // //         <span style="font-weight:700;font-size:14px;">${exp.title||""}</span>
// // // // // // // // // // // // // // // //         <span style="font-size:12px;color:#64748b;font-style:italic;">${exp.startDate||""} – ${exp.endDate||""}</span>
// // // // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // // // //       <div style="font-size:13px;color:#475569;margin-bottom:6px;">${exp.company||""}${exp.location?` | ${exp.location}`:""}</div>
// // // // // // // // // // // // // // // //       <ul style="margin:0 0 0 18px;padding:0;">${(exp.bullets||[]).map(b=>`<li style="font-size:13px;color:#374151;margin-bottom:3px;line-height:1.5;">${b}</li>`).join("")}</ul>
// // // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // // //   const eduHtml = (resume.education||[]).map(edu => `
// // // // // // // // // // // // // // // //     <div style="margin-bottom:12px;">
// // // // // // // // // // // // // // // //       <div style="font-weight:700;font-size:14px;">${edu.degree||""} — ${edu.school||""}</div>
// // // // // // // // // // // // // // // //       <div style="font-size:12px;color:#64748b;margin-top:2px;">${edu.year||""}${edu.location?` | ${edu.location}`:""}${edu.gpa?` | GPA: ${edu.gpa}`:""}</div>
// // // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // // //   const skillsHtml = resume.skills ? [
// // // // // // // // // // // // // // // //     resume.skills.technical?.length > 0 ? `<p style="margin:4px 0;font-size:13px;"><strong>Technical:</strong> ${resume.skills.technical.join(", ")}</p>` : "",
// // // // // // // // // // // // // // // //     resume.skills.tools?.length > 0     ? `<p style="margin:4px 0;font-size:13px;"><strong>Tools:</strong> ${resume.skills.tools.join(", ")}</p>` : "",
// // // // // // // // // // // // // // // //     resume.skills.soft?.length > 0      ? `<p style="margin:4px 0;font-size:13px;"><strong>Soft Skills:</strong> ${resume.skills.soft.join(", ")}</p>` : "",
// // // // // // // // // // // // // // // //   ].join("") : "";

// // // // // // // // // // // // // // // //   const certHtml = (resume.certifications||[]).length > 0
// // // // // // // // // // // // // // // //     ? `<ul style="margin:4px 0 0 18px;padding:0;">${resume.certifications.map(c=>`<li style="font-size:13px;color:#374151;margin-bottom:4px;">${c}</li>`).join("")}</ul>`
// // // // // // // // // // // // // // // //     : "";

// // // // // // // // // // // // // // // //   function section(title, body) {
// // // // // // // // // // // // // // // //     if (!body?.trim()) return "";
// // // // // // // // // // // // // // // //     return `<div style="margin-bottom:20px;"><div class="section-title">${title}</div>${body}</div>`;
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   const html = `<!DOCTYPE html>
// // // // // // // // // // // // // // // // <html lang="en">
// // // // // // // // // // // // // // // // <head>
// // // // // // // // // // // // // // // //   <meta charset="utf-8"/>
// // // // // // // // // // // // // // // //   <title>${name} — ${t.name} Resume</title>
// // // // // // // // // // // // // // // //   <style>
// // // // // // // // // // // // // // // //     *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
// // // // // // // // // // // // // // // //     body{color:#212529;background:#fff;font-size:14px;line-height:1.55;}
// // // // // // // // // // // // // // // //     ${css}
// // // // // // // // // // // // // // // //     @media print{
// // // // // // // // // // // // // // // //       body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}
// // // // // // // // // // // // // // // //       .no-print{display:none!important;}
// // // // // // // // // // // // // // // //       @page{margin:0;size:A4;}
// // // // // // // // // // // // // // // //     }
// // // // // // // // // // // // // // // //   </style>
// // // // // // // // // // // // // // // // </head>
// // // // // // // // // // // // // // // // <body>
// // // // // // // // // // // // // // // // ${pageOpen}
// // // // // // // // // // // // // // // //   ${headerHtml}
// // // // // // // // // // // // // // // //   ${section("Professional Summary", resume.summary ? `<p style="font-size:13px;line-height:1.75;color:#374151;">${resume.summary}</p>` : "")}
// // // // // // // // // // // // // // // //   ${section("Work Experience", expHtml)}
// // // // // // // // // // // // // // // //   ${section("Education", eduHtml)}
// // // // // // // // // // // // // // // //   ${section("Skills", skillsHtml)}
// // // // // // // // // // // // // // // //   ${certHtml ? section("Certifications", certHtml) : ""}
// // // // // // // // // // // // // // // //   ${headerClose}
// // // // // // // // // // // // // // // // </div>
// // // // // // // // // // // // // // // // </body>
// // // // // // // // // // // // // // // // </html>`;

// // // // // // // // // // // // // // // //   // Open in new tab and trigger print dialog
// // // // // // // // // // // // // // // //   const newTab = window.open("", "_blank");
// // // // // // // // // // // // // // // //   if (!newTab) {
// // // // // // // // // // // // // // // //     // Popup blocked — fall back to HTML download
// // // // // // // // // // // // // // // //     const blob = new Blob([html], { type: "text/html;charset=utf-8" });
// // // // // // // // // // // // // // // //     const url  = URL.createObjectURL(blob);
// // // // // // // // // // // // // // // //     const a    = Object.assign(document.createElement("a"), { href: url, download: fileName?.replace(".pdf", ".html") || "Resume.html" });
// // // // // // // // // // // // // // // //     document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // // // // // // // // // // // // //     URL.revokeObjectURL(url);
// // // // // // // // // // // // // // // //     return;
// // // // // // // // // // // // // // // //   }
// // // // // // // // // // // // // // // //   newTab.document.write(html);
// // // // // // // // // // // // // // // //   newTab.document.close();
// // // // // // // // // // // // // // // //   setTimeout(() => {
// // // // // // // // // // // // // // // //     newTab.focus();
// // // // // // // // // // // // // // // //     newTab.print();
// // // // // // // // // // // // // // // //   }, 800);
// // // // // // // // // // // // // // // // }


// // // // // // // // // // // // // // // // export async function downloadResumeAsWord(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // // // //   const t    = getTemplate(templateId);
// // // // // // // // // // // // // // // //   const dark = "212529";
// // // // // // // // // // // // // // // //   const gray = "6c757d";

// // // // // // // // // // // // // // // //   // ── Header style: does this template have a dark/colored header background? ──
// // // // // // // // // // // // // // // //   const hasDarkHeader = ["bold","modern","corporate","sidebarlight","professional","compact","government","technical","elegant"].includes(templateId);
// // // // // // // // // // // // // // // //   const headerBg      = t.headerHex || t.accentHex || "1e293b";
// // // // // // // // // // // // // // // //   const headerTextCol = hasDarkHeader ? "FFFFFF" : t.headerHex;
// // // // // // // // // // // // // // // //   const nameColor     = hasDarkHeader ? "FFFFFF" : t.headerHex;

// // // // // // // // // // // // // // // //   // ── Section heading style ──
// // // // // // // // // // // // // // // //   function heading(text) {
// // // // // // // // // // // // // // // //     if (t.style === "filled") {
// // // // // // // // // // // // // // // //       return new Paragraph({
// // // // // // // // // // // // // // // //         spacing: { before: 260, after: 100 },
// // // // // // // // // // // // // // // //         shading: { type: "clear", fill: t.accentHex + "15" },
// // // // // // // // // // // // // // // //         border: { left: { color: t.accentHex, space: 6, style: BorderStyle.SINGLE, size: 28 } },
// // // // // // // // // // // // // // // //         children: [new TextRun({ text: text.toUpperCase(), bold: true, size: 20, font: "Calibri", color: t.accentHex })],
// // // // // // // // // // // // // // // //       });
// // // // // // // // // // // // // // // //     }
// // // // // // // // // // // // // // // //     if (t.style === "thick") {
// // // // // // // // // // // // // // // //       return new Paragraph({
// // // // // // // // // // // // // // // //         spacing: { before: 260, after: 100 },
// // // // // // // // // // // // // // // //         border: { bottom: { color: t.headerHex, space: 4, style: BorderStyle.THICK, size: 18 } },
// // // // // // // // // // // // // // // //         children: [new TextRun({ text: text.toUpperCase(), bold: true, size: 22, font: "Calibri", color: t.headerHex })],
// // // // // // // // // // // // // // // //       });
// // // // // // // // // // // // // // // //     }
// // // // // // // // // // // // // // // //     // underline style (default)
// // // // // // // // // // // // // // // //     return new Paragraph({
// // // // // // // // // // // // // // // //       spacing: { before: 260, after: 100 },
// // // // // // // // // // // // // // // //       border: { bottom: { color: t.accentHex, space: 4, style: BorderStyle.SINGLE, size: 10 } },
// // // // // // // // // // // // // // // //       children: [new TextRun({ text: text.toUpperCase(), bold: true, size: 22, font: "Calibri", color: t.accentHex })],
// // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   function bullet(text) {
// // // // // // // // // // // // // // // //     if (!text) return null;
// // // // // // // // // // // // // // // //     return new Paragraph({
// // // // // // // // // // // // // // // //       spacing: { before: 40, after: 40 },
// // // // // // // // // // // // // // // //       indent: { left: 360 },
// // // // // // // // // // // // // // // //       children: [new TextRun({ text: `• ${text}`, size: 20, font: "Calibri", color: dark })],
// // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   const children = [];

// // // // // // // // // // // // // // // //   // ── HEADER — shaded background for dark-header templates ──
// // // // // // // // // // // // // // // //   if (hasDarkHeader) {
// // // // // // // // // // // // // // // //     // Name row with background shading
// // // // // // // // // // // // // // // //     children.push(new Paragraph({
// // // // // // // // // // // // // // // //       alignment: AlignmentType.CENTER,
// // // // // // // // // // // // // // // //       spacing: { before: 0, after: 40 },
// // // // // // // // // // // // // // // //       shading: { type: "clear", fill: headerBg },
// // // // // // // // // // // // // // // //       children: [new TextRun({
// // // // // // // // // // // // // // // //         text: (resume.name || "").toUpperCase(),
// // // // // // // // // // // // // // // //         bold: true,
// // // // // // // // // // // // // // // //         size: t.nameSize * 2,
// // // // // // // // // // // // // // // //         font: "Calibri",
// // // // // // // // // // // // // // // //         color: "FFFFFF",
// // // // // // // // // // // // // // // //       })],
// // // // // // // // // // // // // // // //     }));
// // // // // // // // // // // // // // // //     // Role/title row
// // // // // // // // // // // // // // // //     const role = resume.experience?.[0]?.title || "";
// // // // // // // // // // // // // // // //     if (role) {
// // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // //         alignment: AlignmentType.CENTER,
// // // // // // // // // // // // // // // //         spacing: { before: 0, after: 40 },
// // // // // // // // // // // // // // // //         shading: { type: "clear", fill: headerBg },
// // // // // // // // // // // // // // // //         children: [new TextRun({ text: role.toUpperCase(), size: 20, font: "Calibri", color: "DDDDDD", characterSpacing: 40 })],
// // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // //     }
// // // // // // // // // // // // // // // //     // Contact row
// // // // // // // // // // // // // // // //     const contacts = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // //     if (contacts.length > 0) {
// // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // //         alignment: AlignmentType.CENTER,
// // // // // // // // // // // // // // // //         spacing: { before: 0, after: 200 },
// // // // // // // // // // // // // // // //         shading: { type: "clear", fill: headerBg },
// // // // // // // // // // // // // // // //         children: contacts.map((c, i) => [
// // // // // // // // // // // // // // // //           new TextRun({ text: c, size: 18, font: "Calibri", color: "AAAACC" }),
// // // // // // // // // // // // // // // //           i < contacts.length - 1 ? new TextRun({ text: "   |   ", size: 18, font: "Calibri", color: "666688" }) : null,
// // // // // // // // // // // // // // // //         ]).flat().filter(Boolean),
// // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // //     }
// // // // // // // // // // // // // // // //   } else {
// // // // // // // // // // // // // // // //     // Light header — name centered, accent color
// // // // // // // // // // // // // // // //     children.push(new Paragraph({
// // // // // // // // // // // // // // // //       alignment: AlignmentType.CENTER,
// // // // // // // // // // // // // // // //       spacing: { after: 60 },
// // // // // // // // // // // // // // // //       children: [new TextRun({
// // // // // // // // // // // // // // // //         text: resume.name || "",
// // // // // // // // // // // // // // // //         bold: true,
// // // // // // // // // // // // // // // //         size: t.nameSize * 2,
// // // // // // // // // // // // // // // //         font: "Calibri",
// // // // // // // // // // // // // // // //         color: nameColor,
// // // // // // // // // // // // // // // //         allCaps: t.style === "thick",
// // // // // // // // // // // // // // // //       })],
// // // // // // // // // // // // // // // //     }));
// // // // // // // // // // // // // // // //     const contacts = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // //     if (contacts.length > 0) {
// // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // //         alignment: AlignmentType.CENTER,
// // // // // // // // // // // // // // // //         spacing: { after: 200 },
// // // // // // // // // // // // // // // //         children: contacts.map((c, i) => [
// // // // // // // // // // // // // // // //           new TextRun({ text: c, size: 18, font: "Calibri", color: gray }),
// // // // // // // // // // // // // // // //           i < contacts.length - 1 ? new TextRun({ text: "  |  ", size: 18, font: "Calibri", color: "BBBBBB" }) : null,
// // // // // // // // // // // // // // // //         ]).flat().filter(Boolean),
// // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // //     }
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   // ── Summary ──
// // // // // // // // // // // // // // // //   if (resume.summary) {
// // // // // // // // // // // // // // // //     children.push(heading("Professional Summary"));
// // // // // // // // // // // // // // // //     children.push(new Paragraph({
// // // // // // // // // // // // // // // //       spacing: { before: 60, after: 120 },
// // // // // // // // // // // // // // // //       children: [new TextRun({ text: resume.summary, size: 20, font: "Calibri", color: dark })],
// // // // // // // // // // // // // // // //     }));
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   // ── Experience ──
// // // // // // // // // // // // // // // //   if (resume.experience?.length > 0) {
// // // // // // // // // // // // // // // //     children.push(heading("Work Experience"));
// // // // // // // // // // // // // // // //     resume.experience.forEach(exp => {
// // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // //         spacing: { before: 120, after: 40 },
// // // // // // // // // // // // // // // //         children: [
// // // // // // // // // // // // // // // //           new TextRun({ text: exp.title || "", bold: true, size: 22, font: "Calibri", color: dark }),
// // // // // // // // // // // // // // // //           new TextRun({ text: ` — ${exp.company || ""}`, size: 22, font: "Calibri", color: gray }),
// // // // // // // // // // // // // // // //         ],
// // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // //         spacing: { before: 0, after: 60 },
// // // // // // // // // // // // // // // //         children: [
// // // // // // // // // // // // // // // //           new TextRun({ text: `${exp.startDate || ""} – ${exp.endDate || ""}`, size: 18, font: "Calibri", color: gray, italics: true }),
// // // // // // // // // // // // // // // //           exp.location ? new TextRun({ text: `  |  ${exp.location}`, size: 18, font: "Calibri", color: "AAAAAA" }) : null,
// // // // // // // // // // // // // // // //         ].filter(Boolean),
// // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // //       (exp.bullets || []).forEach(b => { const p = bullet(b); if (p) children.push(p); });
// // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   // ── Education ──
// // // // // // // // // // // // // // // //   if (resume.education?.length > 0) {
// // // // // // // // // // // // // // // //     children.push(heading("Education"));
// // // // // // // // // // // // // // // //     resume.education.forEach(edu => {
// // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // //         spacing: { before: 100, after: 40 },
// // // // // // // // // // // // // // // //         children: [
// // // // // // // // // // // // // // // //           new TextRun({ text: edu.degree || "", bold: true, size: 22, font: "Calibri", color: dark }),
// // // // // // // // // // // // // // // //           new TextRun({ text: ` — ${edu.school || ""}`, size: 22, font: "Calibri", color: gray }),
// // // // // // // // // // // // // // // //         ],
// // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // //         spacing: { before: 0, after: 80 },
// // // // // // // // // // // // // // // //         children: [
// // // // // // // // // // // // // // // //           new TextRun({ text: edu.year || "", size: 18, font: "Calibri", color: gray, italics: true }),
// // // // // // // // // // // // // // // //           edu.location ? new TextRun({ text: `  |  ${edu.location}`, size: 18, font: "Calibri", color: "AAAAAA" }) : null,
// // // // // // // // // // // // // // // //           edu.gpa     ? new TextRun({ text: `  |  GPA: ${edu.gpa}`,  size: 18, font: "Calibri", color: "AAAAAA" }) : null,
// // // // // // // // // // // // // // // //         ].filter(Boolean),
// // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   // ── Skills ──
// // // // // // // // // // // // // // // //   if (resume.skills) {
// // // // // // // // // // // // // // // //     children.push(heading("Skills"));
// // // // // // // // // // // // // // // //     [["Technical", "technical"], ["Tools", "tools"], ["Soft Skills", "soft"]].forEach(([label, key]) => {
// // // // // // // // // // // // // // // //       if (resume.skills[key]?.length > 0) {
// // // // // // // // // // // // // // // //         children.push(new Paragraph({
// // // // // // // // // // // // // // // //           spacing: { before: 40, after: 40 },
// // // // // // // // // // // // // // // //           children: [
// // // // // // // // // // // // // // // //             new TextRun({ text: `${label}: `, bold: true, size: 20, font: "Calibri", color: dark }),
// // // // // // // // // // // // // // // //             new TextRun({ text: resume.skills[key].join(", "), size: 20, font: "Calibri", color: dark }),
// // // // // // // // // // // // // // // //           ],
// // // // // // // // // // // // // // // //         }));
// // // // // // // // // // // // // // // //       }
// // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   // ── Certifications ──
// // // // // // // // // // // // // // // //   if (resume.certifications?.length > 0) {
// // // // // // // // // // // // // // // //     children.push(heading("Certifications"));
// // // // // // // // // // // // // // // //     resume.certifications.forEach(c => { const p = bullet(c); if (p) children.push(p); });
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   // ── Projects ──
// // // // // // // // // // // // // // // //   if (resume.projects?.length > 0) {
// // // // // // // // // // // // // // // //     children.push(heading("Projects"));
// // // // // // // // // // // // // // // //     resume.projects.forEach(proj => {
// // // // // // // // // // // // // // // //       children.push(new Paragraph({
// // // // // // // // // // // // // // // //         spacing: { before: 100, after: 40 },
// // // // // // // // // // // // // // // //         children: [new TextRun({ text: proj.name || "", bold: true, size: 22, font: "Calibri", color: dark })],
// // // // // // // // // // // // // // // //       }));
// // // // // // // // // // // // // // // //       if (proj.description) {
// // // // // // // // // // // // // // // //         children.push(new Paragraph({
// // // // // // // // // // // // // // // //           spacing: { before: 0, after: 60 },
// // // // // // // // // // // // // // // //           children: [new TextRun({ text: proj.description, size: 20, font: "Calibri", color: dark })],
// // // // // // // // // // // // // // // //         }));
// // // // // // // // // // // // // // // //       }
// // // // // // // // // // // // // // // //     });
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   const doc = new Document({
// // // // // // // // // // // // // // // //     sections: [{
// // // // // // // // // // // // // // // //       properties: { page: { margin: { top: 720, right: 720, bottom: 720, left: 720 } } },
// // // // // // // // // // // // // // // //       children,
// // // // // // // // // // // // // // // //     }],
// // // // // // // // // // // // // // // //   });

// // // // // // // // // // // // // // // //   const blob = await Packer.toBlob(doc);
// // // // // // // // // // // // // // // //   const url  = URL.createObjectURL(blob);
// // // // // // // // // // // // // // // //   const a    = Object.assign(document.createElement("a"), { href: url, download: fileName || "Resume.docx" });
// // // // // // // // // // // // // // // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // // // // // // // // // // // // //   URL.revokeObjectURL(url);
// // // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // // HTML DOWNLOAD — template-aware
// // // // // // // // // // // // // // // // // Matches landing page ResumeCard previews exactly
// // // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // export function downloadATSResume(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // // // //   const t      = getTemplate(templateId);
// // // // // // // // // // // // // // // //   const accent = "#" + t.accentHex;
// // // // // // // // // // // // // // // //   const header = "#" + t.headerHex;
// // // // // // // // // // // // // // // //   const name   = resume.name || "";

// // // // // // // // // // // // // // // //   // ── CSS builder — string concat avoids template-literal-in-object issues ──
// // // // // // // // // // // // // // // //   function buildCSS(id, ac, hd) {
// // // // // // // // // // // // // // // //     const ul  = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";border-bottom:1.5px solid " + ac + ";padding-bottom:4px;margin-bottom:12px;}";
// // // // // // // // // // // // // // // //     const fil = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;border-radius:0 6px 6px 0;}";
// // // // // // // // // // // // // // // //     const mon = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.12em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;border-radius:0 6px 6px 0;font-family:'Courier New',monospace;}";
// // // // // // // // // // // // // // // //     if (id==="classic")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:26px;font-weight:700;color:#0f172a;text-align:center;}.contact{font-size:13px;color:#475569;display:flex;justify-content:center;flex-wrap:wrap;gap:16px;}.header-wrap{text-align:center;border-bottom:2px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="modern")    return "body{font-family:Arial,Helvetica,sans-serif;}.page{display:flex;max-width:800px;margin:0 auto;}.sidebar{width:200px;background:"+hd+";padding:28px 18px;flex-shrink:0;}.main-col{flex:1;padding:28px 24px;}.name{font-size:14px;font-weight:800;color:#fff;}.contact{font-size:10px;color:rgba(255,255,255,0.7);}"+fil;
// // // // // // // // // // // // // // // //     if (id==="executive") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:28px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.06em;}.contact{font-size:12px;color:rgba(255,255,255,0.6);display:flex;flex-wrap:wrap;gap:20px;}.header-wrap{background:"+hd+";padding:28px 32px 24px;}.body-wrap{padding:24px 32px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="minimal")   return "body,.page{font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;}.name{font-size:28px;font-weight:300;color:#0f172a;letter-spacing:-0.02em;}.accent-bar{width:32px;height:3px;background:"+ac+";border-radius:2px;margin:6px 0 10px;}.contact{font-size:13px;color:#64748b;display:flex;flex-wrap:wrap;gap:18px;}.header-wrap{border-bottom:2.5px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="corporate") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:24px;font-weight:700;color:#fff;}.contact{font-size:12px;color:rgba(200,225,255,0.85);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+","+ac+");padding:24px 28px 22px;}.body-wrap{padding:22px 28px;}"+fil;
// // // // // // // // // // // // // // // //     if (id==="creative")  return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:30px;font-weight:800;color:#fff;letter-spacing:-0.02em;}.contact{font-size:11px;color:rgba(255,210,220,0.85);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+","+ac+");padding:28px 28px 52px;clip-path:polygon(0 0,100% 0,100% 80%,0 100%);margin-bottom:-8px;}.body-wrap{padding:16px 28px 24px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="technical")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:'Courier New',Courier,monospace;font-size:22px;font-weight:700;color:#fff;letter-spacing:0.02em;}.contact{font-family:'Courier New',Courier,monospace;font-size:10px;color:rgba(180,230,240,0.75);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+",#0e7490);padding:20px 24px 18px;border-bottom:3px solid "+ac+";}.body-wrap{padding:22px 24px;}"+mon;
// // // // // // // // // // // // // // // //     if (id==="elegant")     return "body,.page{font-family:Georgia,'Times New Roman',serif;}.accent-strip{width:6px;background:linear-gradient(180deg,"+ac+","+hd+");flex-shrink:0;}.name{font-size:26px;font-weight:700;color:"+hd+";letter-spacing:0.01em;}.role{font-size:11px;color:"+ac+";font-weight:600;letter-spacing:0.1em;text-transform:uppercase;margin:4px 0 10px;}.contact{display:flex;flex-wrap:wrap;gap:16px;font-size:11px;color:#78716c;}.header-wrap{display:flex;border-bottom:1px solid #e7e5e4;}.header-inner{flex:1;padding:26px 26px 18px;}.body-wrap{padding:18px 26px 22px 32px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="bold")        return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:34px;font-weight:900;color:#fff;letter-spacing:-0.03em;line-height:1;}.accent-bar{width:52px;height:4px;background:"+ac+";border-radius:2px;margin:10px 0 12px;}.role{font-size:12px;color:rgba(255,255,255,0.75);text-transform:uppercase;letter-spacing:0.1em;margin-bottom:10px;}.contact{display:flex;flex-wrap:wrap;gap:16px;font-size:11px;color:rgba(255,255,255,0.55);}.header-wrap{background:"+hd+";padding:26px 26px 20px;}.body-wrap{padding:20px 26px;}"+fil;
// // // // // // // // // // // // // // // //     if (id==="sidebarlight")return "body{font-family:Arial,Helvetica,sans-serif;}.page{display:flex;}.sidebar{width:200px;background:"+hd+";padding:26px 16px;flex-shrink:0;border-right:3px solid "+ac+";}.avatar{width:58px;height:58px;border-radius:50%;background:"+ac+"25;border:2.5px solid "+ac+";display:flex;align-items:center;justify-content:center;margin-bottom:14px;font-size:22px;font-weight:700;color:"+ac+";}.name{font-size:13px;font-weight:800;color:#0f172a;margin-bottom:2px;}.role{font-size:10px;color:"+ac+";font-weight:600;margin-bottom:14px;}.main-col{flex:1;padding:22px 20px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="academic")    return "body,.page{font-family:Georgia,'Times New Roman',serif;}.name{font-size:24px;font-weight:700;color:#fff;text-align:center;}.role{font-size:11px;color:"+ac+"cc;font-style:italic;text-align:center;margin:4px 0 10px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:16px;font-size:10px;color:rgba(255,255,255,0.5);}.header-wrap{background:"+hd+";padding:22px 30px 18px;text-align:center;}.double-rule-top{height:3px;background:"+ac+";}.double-rule-bot{height:1px;background:"+ac+"40;}.body-wrap{padding:20px 30px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="professional") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:28px;font-weight:700;color:#fff;}.role{font-size:12px;color:"+ac+"bb;text-transform:uppercase;letter-spacing:0.1em;}.contact{font-size:11px;color:rgba(255,255,255,0.6);}.header-inner{display:flex;justify-content:space-between;align-items:flex-end;flex-wrap:wrap;gap:12px;}.accent-line{height:2px;background:"+ac+";border-radius:1px;margin-top:16px;}.header-wrap{background:"+hd+";padding:26px 32px 20px;}.body-wrap{padding:20px 32px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="compact")      return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:22px;font-weight:700;color:#fff;}.role{font-size:11px;color:rgba(255,255,255,0.65);}.contact{display:flex;flex-wrap:wrap;gap:10px;}.contact span{font-size:10px;color:rgba(255,255,255,0.5);background:rgba(255,255,255,0.08);padding:2px 8px;border-radius:4px;}.header-wrap{background:"+hd+";padding:14px 24px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:10px;}.body-wrap{padding:14px 24px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="cleanserif")   return "body,.page{font-family:Georgia,'Times New Roman',serif;padding:28px 32px;}.name{font-size:28px;font-weight:700;color:#1a0a0a;letter-spacing:0.02em;text-align:center;}.role{font-size:12px;color:"+ac+";font-weight:600;letter-spacing:0.12em;text-transform:uppercase;text-align:center;margin:4px 0 10px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:18px;font-size:11px;color:#6b7280;}.header-wrap{text-align:center;border-bottom:3px double "+ac+";padding-bottom:16px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // // //     if (id==="government")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:22px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.08em;}.contact{display:flex;flex-wrap:wrap;gap:18px;font-size:11px;color:rgba(255,255,255,0.6);margin-top:8px;}.position-bar{background:"+ac+"12;padding:6px 28px;border-bottom:1px solid "+ac+"25;font-size:11px;color:#374151;}.position-label{font-weight:700;color:"+ac+";text-transform:uppercase;letter-spacing:0.06em;}.header-wrap{background:"+hd+";padding:18px 28px 16px;border-bottom:4px solid "+ac+";}.body-wrap{padding:18px 28px;}"+fil;
// // // // // // // // // // // // // // // //     return "";
// // // // // // // // // // // // // // // //   }
// // // // // // // // // // // // // // // //   const css = buildCSS(templateId, accent, header);

// // // // // // // // // // // // // // // //   // ── Contact list ──
// // // // // // // // // // // // // // // //   const contacts = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // // //   const contactSpans = contacts.map(c => `<span>${c}</span>`).join("");
// // // // // // // // // // // // // // // //   const contactDivs  = contacts.map(c => `<div>${c}</div>`).join("");

// // // // // // // // // // // // // // // //   // ── Header HTML per template ──
// // // // // // // // // // // // // // // //   function buildHeader(id) {
// // // // // // // // // // // // // // // //     if (id==="classic") return `<div class="header-wrap"><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // //     if (id==="modern")  return `<div class="sidebar"><div style="width:64px;height:64px;border-radius:50%;background:rgba(255,255,255,0.15);margin-bottom:16px;"></div><div class="name">${name}</div><div style="font-size:10px;color:${accent}cc;background:rgba(255,255,255,0.08);padding:2px 8px;border-radius:4px;display:inline-block;margin:4px 0 16px;font-weight:600;">${(resume.experience||[])[0]?.title||"Professional"}</div><hr style="border:none;border-top:1px solid rgba(255,255,255,0.15);margin:0 0 12px;"/><div style="font-size:10px;font-weight:700;color:rgba(255,255,255,0.5);text-transform:uppercase;letter-spacing:0.1em;margin-bottom:8px;">Contact</div><div style="display:flex;flex-direction:column;gap:5px;font-size:10px;color:rgba(255,255,255,0.7);">${contactDivs}</div></div><div class="main-col">`;
// // // // // // // // // // // // // // // //     if (id==="executive") return `<div class="header-wrap"><div class="name">${name.toUpperCase()}</div><hr style="border:none;border-top:2px solid rgba(255,255,255,0.3);margin:8px 0 4px;"/><hr style="border:none;border-top:0.5px solid rgba(255,255,255,0.1);margin:0 0 12px;"/><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="minimal") return `<div class="header-wrap"><div class="name">${name}</div><div class="accent-bar"></div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // //     if (id==="corporate") return `<div class="header-wrap"><div class="name">${name}</div><div style="font-size:12px;color:rgba(200,225,255,0.7);font-style:italic;margin:4px 0 10px;">${(resume.experience||[])[0]?.title||"Professional Resume"}</div><hr style="border:none;border-top:1px solid rgba(255,255,255,0.2);margin:0 0 10px;"/><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="creative") return `<div class="header-wrap"><div class="name">${name}</div><div style="font-size:12px;color:rgba(255,210,220,0.85);text-transform:uppercase;letter-spacing:0.08em;margin:6px 0 12px;">Resume</div><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="technical") return `<div class="header-wrap"><div style="font-size:10px;color:${accent}cc;font-family:'Courier New',monospace;margin-bottom:6px;letter-spacing:0.04em;">// resume.json</div><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="professional") return `<div class="header-wrap"><div class="header-inner"><div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div></div><div style="text-align:right">${contacts.slice(0,2).map(c=>`<div style="font-size:11px;color:rgba(255,255,255,0.6);margin-bottom:3px;">${c}</div>`).join("")}</div></div><div class="accent-line"></div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="compact")      return `<div class="header-wrap"><div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div></div><div class="contact">${contacts.map(c=>`<span>${c}</span>`).join("")}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     if (id==="cleanserif")   return `<div class="header-wrap"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // //     if (id==="government")   return `<div class="header-wrap"><div class="name">${name}</div><div class="contact">${contactSpans}</div></div><div class="position-bar"><span class="position-label">Position Applied For: </span>${(resume.experience||[])[0]?.title||"Professional"}</div><div class="body-wrap">`;
// // // // // // // // // // // // // // // //     return `<div class="header-wrap"><div class="name">${name}</div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // // //   }
// // // // // // // // // // // // // // // //   // closing tags for templates that open extra divs
// // // // // // // // // // // // // // // //   function closeHeader(id) {
// // // // // // // // // // // // // // // //     if (["modern","executive","corporate","creative","technical","elegant","bold","sidebarlight","academic","professional","compact","government"].includes(id)) return "</div>";
// // // // // // // // // // // // // // // //     return "";
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   const headerHtml = buildHeader(templateId);
// // // // // // // // // // // // // // // //   const headerClose = closeHeader(templateId);

// // // // // // // // // // // // // // // //   // ── Body sections ──
// // // // // // // // // // // // // // // //   const expHtml = (resume.experience || []).map(exp => `
// // // // // // // // // // // // // // // //     <div style="margin-bottom:14px;">
// // // // // // // // // // // // // // // //       <div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:4px;">
// // // // // // // // // // // // // // // //         <div>
// // // // // // // // // // // // // // // //           <strong style="font-size:14px;color:#0f172a;">${exp.title}</strong>
// // // // // // // // // // // // // // // //           <span style="color:#475569;"> — ${exp.company}</span>
// // // // // // // // // // // // // // // //           ${exp.location ? `<span style="color:#94a3b8;font-size:12px;"> | ${exp.location}</span>` : ""}
// // // // // // // // // // // // // // // //         </div>
// // // // // // // // // // // // // // // //         <span style="color:#64748b;font-size:12px;font-style:italic;white-space:nowrap;">${exp.startDate} – ${exp.endDate}</span>
// // // // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // // // //       <ul style="margin:5px 0 0 20px;padding:0;">
// // // // // // // // // // // // // // // //         ${(exp.bullets || []).map(b => `<li style="font-size:13px;color:#374151;margin-bottom:4px;line-height:1.6;">${b}</li>`).join("")}
// // // // // // // // // // // // // // // //       </ul>
// // // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // // //   const eduHtml = (resume.education || []).map(edu => `
// // // // // // // // // // // // // // // //     <div style="display:flex;justify-content:space-between;margin-bottom:8px;flex-wrap:wrap;gap:4px;">
// // // // // // // // // // // // // // // //       <div>
// // // // // // // // // // // // // // // //         <strong style="font-size:14px;color:#0f172a;">${edu.degree}</strong>
// // // // // // // // // // // // // // // //         <span style="color:#475569;"> — ${edu.school}</span>
// // // // // // // // // // // // // // // //         ${edu.location ? `<span style="color:#94a3b8;font-size:12px;"> | ${edu.location}</span>` : ""}
// // // // // // // // // // // // // // // //         ${edu.gpa ? `<span style="color:#94a3b8;font-size:12px;"> | GPA: ${edu.gpa}</span>` : ""}
// // // // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // // // //       <span style="color:#64748b;font-size:12px;font-style:italic;">${edu.year || ""}</span>
// // // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // // //   const skillsHtml = resume.skills ? [
// // // // // // // // // // // // // // // //     resume.skills.technical?.length > 0 ? `<p style="margin:4px 0;font-size:13px;"><strong>Technical:</strong> ${resume.skills.technical.join(", ")}</p>` : "",
// // // // // // // // // // // // // // // //     resume.skills.tools?.length > 0     ? `<p style="margin:4px 0;font-size:13px;"><strong>Tools:</strong> ${resume.skills.tools.join(", ")}</p>` : "",
// // // // // // // // // // // // // // // //     resume.skills.soft?.length > 0      ? `<p style="margin:4px 0;font-size:13px;"><strong>Soft Skills:</strong> ${resume.skills.soft.join(", ")}</p>` : "",
// // // // // // // // // // // // // // // //   ].join("") : "";

// // // // // // // // // // // // // // // //   const certHtml = resume.certifications?.length > 0
// // // // // // // // // // // // // // // //     ? `<ul style="margin:4px 0 0 20px;padding:0;">${resume.certifications.map(c => `<li style="font-size:13px;color:#374151;margin-bottom:4px;">${c}</li>`).join("")}</ul>`
// // // // // // // // // // // // // // // //     : "";

// // // // // // // // // // // // // // // //   function section(title, body) {
// // // // // // // // // // // // // // // //     if (!body) return "";
// // // // // // // // // // // // // // // //     return `<div style="margin-bottom:20px;"><div class="section-title">${title}</div>${body}</div>`;
// // // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // // //   const pageOpen  = templateId === "modern" ? `<div class="page">` : `<div class="page" style="max-width:800px;margin:0 auto;padding:36px 40px;">`;

// // // // // // // // // // // // // // // //   const html = `<!DOCTYPE html>
// // // // // // // // // // // // // // // // <html lang="en">
// // // // // // // // // // // // // // // // <head>
// // // // // // // // // // // // // // // //   <meta charset="utf-8"/>
// // // // // // // // // // // // // // // //   <title>${name} — ${t.name}</title>
// // // // // // // // // // // // // // // //   <style>
// // // // // // // // // // // // // // // //     *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
// // // // // // // // // // // // // // // //     body{color:#212529;background:#fff;font-size:14px;line-height:1.55;}
// // // // // // // // // // // // // // // //     ${css}
// // // // // // // // // // // // // // // //     @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}.page{padding:20px;}.no-print{display:none!important;}}
// // // // // // // // // // // // // // // //   </style>
// // // // // // // // // // // // // // // // </head>
// // // // // // // // // // // // // // // // <body>
// // // // // // // // // // // // // // // // ${pageOpen}
// // // // // // // // // // // // // // // //   <div class="no-print" style="background:#eff6ff;border:1px solid #bfdbfe;border-radius:8px;padding:10px 16px;margin-bottom:20px;font-size:13px;color:#2563eb;">
// // // // // // // // // // // // // // // //     <strong>To save as PDF:</strong> Press Ctrl+P (or Cmd+P) &rarr; Select "Save as PDF" &rarr; Click Save
// // // // // // // // // // // // // // // //   </div>
// // // // // // // // // // // // // // // //   ${headerHtml}
// // // // // // // // // // // // // // // //   ${section("Professional Summary", resume.summary ? `<p style="font-size:13px;line-height:1.75;color:#374151;">${resume.summary}</p>` : "")}
// // // // // // // // // // // // // // // //   ${section("Work Experience", expHtml)}
// // // // // // // // // // // // // // // //   ${section("Education", eduHtml)}
// // // // // // // // // // // // // // // //   ${section("Skills", skillsHtml)}
// // // // // // // // // // // // // // // //   ${resume.certifications?.length > 0 ? section("Certifications", certHtml) : ""}
// // // // // // // // // // // // // // // //   ${headerClose}
// // // // // // // // // // // // // // // // </div>
// // // // // // // // // // // // // // // // </body>
// // // // // // // // // // // // // // // // </html>`;

// // // // // // // // // // // // // // // //   const blob = new Blob([html], { type: "text/html;charset=utf-8" });
// // // // // // // // // // // // // // // //   const url  = URL.createObjectURL(blob);
// // // // // // // // // // // // // // // //   const a    = document.createElement("a");
// // // // // // // // // // // // // // // //   a.href = url;
// // // // // // // // // // // // // // // //   a.download = fileName || "ATS-Resume.html";
// // // // // // // // // // // // // // // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // // // // // // // // // // // // //   URL.revokeObjectURL(url);
// // // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // src/utils/generateResumeDoc.js

// // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // TEMPLATE DEFINITIONS
// // // // // // // // // // // // // // // // Add new templates here — must match ResumeGeneratorPage.jsx
// // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // const TEMPLATES = {
// // // // // // // // // // // // // // //   classic: {
// // // // // // // // // // // // // // //     name:       "Classic ATS",
// // // // // // // // // // // // // // //     accentHex:  "2563eb",
// // // // // // // // // // // // // // //     headerHex:  "1e293b",
// // // // // // // // // // // // // // //     accentRgb:  [37, 99, 235],
// // // // // // // // // // // // // // //     headerRgb:  [30, 41, 59],
// // // // // // // // // // // // // // //     nameSize:   24,
// // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   modern: {
// // // // // // // // // // // // // // //     name:       "Modern Pro",
// // // // // // // // // // // // // // //     accentHex:  "7c3aed",
// // // // // // // // // // // // // // //     headerHex:  "7c3aed",
// // // // // // // // // // // // // // //     accentRgb:  [124, 58, 237],
// // // // // // // // // // // // // // //     headerRgb:  [124, 58, 237],
// // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   executive: {
// // // // // // // // // // // // // // //     name:       "Executive",
// // // // // // // // // // // // // // //     accentHex:  "334155",
// // // // // // // // // // // // // // //     headerHex:  "0f172a",
// // // // // // // // // // // // // // //     accentRgb:  [51, 65, 85],
// // // // // // // // // // // // // // //     headerRgb:  [15, 23, 42],
// // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   minimal: {
// // // // // // // // // // // // // // //     name:       "Minimal Clean",
// // // // // // // // // // // // // // //     accentHex:  "059669",
// // // // // // // // // // // // // // //     headerHex:  "059669",
// // // // // // // // // // // // // // //     accentRgb:  [5, 150, 105],
// // // // // // // // // // // // // // //     headerRgb:  [5, 150, 105],
// // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   corporate: {
// // // // // // // // // // // // // // //     name:       "Corporate",
// // // // // // // // // // // // // // //     accentHex:  "0369a1",
// // // // // // // // // // // // // // //     headerHex:  "0c4a6e",
// // // // // // // // // // // // // // //     accentRgb:  [3, 105, 161],
// // // // // // // // // // // // // // //     headerRgb:  [12, 74, 110],
// // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   creative: {
// // // // // // // // // // // // // // //     name:       "Creative",
// // // // // // // // // // // // // // //     accentHex:  "e11d48",
// // // // // // // // // // // // // // //     headerHex:  "881337",
// // // // // // // // // // // // // // //     accentRgb:  [225, 29, 72],
// // // // // // // // // // // // // // //     headerRgb:  [136, 19, 55],
// // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   technical: {
// // // // // // // // // // // // // // //     name:       "Technical",
// // // // // // // // // // // // // // //     accentHex:  "0891b2",
// // // // // // // // // // // // // // //     headerHex:  "164e63",
// // // // // // // // // // // // // // //     accentRgb:  [8, 145, 178],
// // // // // // // // // // // // // // //     headerRgb:  [22, 78, 99],
// // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   bold: {
// // // // // // // // // // // // // // //     name:       "Bold Impact",
// // // // // // // // // // // // // // //     accentHex:  "2563eb",
// // // // // // // // // // // // // // //     headerHex:  "1e3a8a",
// // // // // // // // // // // // // // //     accentRgb:  [37, 99, 235],
// // // // // // // // // // // // // // //     headerRgb:  [30, 58, 138],
// // // // // // // // // // // // // // //     nameSize:   28,
// // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   elegant: {
// // // // // // // // // // // // // // //     name:       "Elegant",
// // // // // // // // // // // // // // //     accentHex:  "b45309",
// // // // // // // // // // // // // // //     headerHex:  "78350f",
// // // // // // // // // // // // // // //     accentRgb:  [180, 83, 9],
// // // // // // // // // // // // // // //     headerRgb:  [120, 53, 15],
// // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   academic: {
// // // // // // // // // // // // // // //     name:       "Academic",
// // // // // // // // // // // // // // //     accentHex:  "1e40af",
// // // // // // // // // // // // // // //     headerHex:  "1e3a8a",
// // // // // // // // // // // // // // //     accentRgb:  [30, 64, 175],
// // // // // // // // // // // // // // //     headerRgb:  [30, 58, 138],
// // // // // // // // // // // // // // //     nameSize:   24,
// // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   professional: {
// // // // // // // // // // // // // // //     name:       "Professional",
// // // // // // // // // // // // // // //     accentHex:  "0f172a",
// // // // // // // // // // // // // // //     headerHex:  "0f172a",
// // // // // // // // // // // // // // //     accentRgb:  [15, 23, 42],
// // // // // // // // // // // // // // //     headerRgb:  [15, 23, 42],
// // // // // // // // // // // // // // //     nameSize:   24,
// // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   compact: {
// // // // // // // // // // // // // // //     name:       "Compact",
// // // // // // // // // // // // // // //     accentHex:  "374151",
// // // // // // // // // // // // // // //     headerHex:  "111827",
// // // // // // // // // // // // // // //     accentRgb:  [55, 65, 81],
// // // // // // // // // // // // // // //     headerRgb:  [17, 24, 39],
// // // // // // // // // // // // // // //     nameSize:   20,
// // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   cleanserif: {
// // // // // // // // // // // // // // //     name:       "Clean Serif",
// // // // // // // // // // // // // // //     accentHex:  "7c2d12",
// // // // // // // // // // // // // // //     headerHex:  "1a0a0a",
// // // // // // // // // // // // // // //     accentRgb:  [124, 45, 18],
// // // // // // // // // // // // // // //     headerRgb:  [26, 10, 10],
// // // // // // // // // // // // // // //     nameSize:   26,
// // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   government: {
// // // // // // // // // // // // // // //     name:       "Government",
// // // // // // // // // // // // // // //     accentHex:  "1e3a5f",
// // // // // // // // // // // // // // //     headerHex:  "0f2540",
// // // // // // // // // // // // // // //     accentRgb:  [30, 58, 95],
// // // // // // // // // // // // // // //     headerRgb:  [15, 37, 64],
// // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   sidebarlight: {
// // // // // // // // // // // // // // //     name:       "Sidebar Light",
// // // // // // // // // // // // // // //     accentHex:  "0369a1",
// // // // // // // // // // // // // // //     headerHex:  "0c4a6e",
// // // // // // // // // // // // // // //     accentRgb:  [3, 105, 161],
// // // // // // // // // // // // // // //     headerRgb:  [12, 74, 110],
// // // // // // // // // // // // // // //     nameSize:   22,
// // // // // // // // // // // // // // //     style:      "filled",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   classic_bw: {
// // // // // // // // // // // // // // //     name:       "Classic B&W",
// // // // // // // // // // // // // // //     accentHex:  "000000",
// // // // // // // // // // // // // // //     headerHex:  "000000",
// // // // // // // // // // // // // // //     accentRgb:  [0, 0, 0],
// // // // // // // // // // // // // // //     headerRgb:  [0, 0, 0],
// // // // // // // // // // // // // // //     nameSize:   24,
// // // // // // // // // // // // // // //     style:      "underline",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   traditional: {
// // // // // // // // // // // // // // //     name:       "Traditional",
// // // // // // // // // // // // // // //     accentHex:  "1a1a1a",
// // // // // // // // // // // // // // //     headerHex:  "1a1a1a",
// // // // // // // // // // // // // // //     accentRgb:  [26, 26, 26],
// // // // // // // // // // // // // // //     headerRgb:  [26, 26, 26],
// // // // // // // // // // // // // // //     nameSize:   24,
// // // // // // // // // // // // // // //     style:      "thick",
// // // // // // // // // // // // // // //     font:       "helvetica",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // };

// // // // // // // // // // // // // // // function getTemplate(templateId) {
// // // // // // // // // // // // // // //   return TEMPLATES[templateId] || TEMPLATES.classic;
// // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // PDF DOWNLOAD — renders HTML then opens print dialog
// // // // // // // // // // // // // // // // This produces pixel-perfect output matching the template preview
// // // // // // // // // // // // // // // // because it uses the same CSS as the screen render
// // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // export function downloadResumeAsPDF(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // // //   // Build the full HTML using downloadATSResume's HTML generator then open print dialog
// // // // // // // // // // // // // // //   const t      = getTemplate(templateId);
// // // // // // // // // // // // // // //   const accent = "#" + t.accentHex;
// // // // // // // // // // // // // // //   const header = "#" + t.headerHex;
// // // // // // // // // // // // // // //   const name   = resume.name || "";

// // // // // // // // // // // // // // //   function buildCSS(id, ac, hd) {
// // // // // // // // // // // // // // //     const ul  = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";border-bottom:1.5px solid " + ac + ";padding-bottom:4px;margin-bottom:12px;}";
// // // // // // // // // // // // // // //     const fil = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;border-radius:0 6px 6px 0;}";
// // // // // // // // // // // // // // //     const mon = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.12em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;border-radius:0 6px 6px 0;font-family:'Courier New',monospace;}";
// // // // // // // // // // // // // // //     if (id==="classic")      return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:26px;font-weight:700;color:#0f172a;text-align:center;}.contact{font-size:13px;color:#475569;display:flex;justify-content:center;flex-wrap:wrap;gap:16px;}.header-wrap{text-align:center;border-bottom:2px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="modern")       return "body{font-family:Arial,Helvetica,sans-serif;}.page{display:flex;max-width:800px;margin:0 auto;}.sidebar{width:200px;background:"+hd+";padding:28px 18px;flex-shrink:0;}.main-col{flex:1;padding:28px 24px;}.name{font-size:14px;font-weight:800;color:#fff;}.contact{font-size:10px;color:rgba(255,255,255,0.7);}"+fil;
// // // // // // // // // // // // // // //     if (id==="executive")    return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:28px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.06em;}.contact{font-size:12px;color:rgba(255,255,255,0.6);display:flex;flex-wrap:wrap;gap:20px;}.header-wrap{background:"+hd+";padding:28px 32px 24px;}.body-wrap{padding:24px 32px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="minimal")      return "body,.page{font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;}.name{font-size:28px;font-weight:300;color:#0f172a;letter-spacing:-0.02em;}.accent-bar{width:32px;height:3px;background:"+ac+";border-radius:2px;margin:6px 0 10px;}.contact{font-size:13px;color:#64748b;display:flex;flex-wrap:wrap;gap:18px;}.header-wrap{border-bottom:2.5px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="corporate")    return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:24px;font-weight:700;color:#fff;}.contact{font-size:12px;color:rgba(200,225,255,0.85);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+","+ac+");padding:24px 28px 22px;}.body-wrap{padding:22px 28px;}"+fil;
// // // // // // // // // // // // // // //     if (id==="creative")     return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:30px;font-weight:800;color:#fff;letter-spacing:-0.02em;}.contact{font-size:11px;color:rgba(255,210,220,0.85);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+","+ac+");padding:28px 28px 52px;clip-path:polygon(0 0,100% 0,100% 80%,0 100%);margin-bottom:-8px;}.body-wrap{padding:16px 28px 24px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="technical")    return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:'Courier New',Courier,monospace;font-size:22px;font-weight:700;color:#fff;letter-spacing:0.02em;}.contact{font-family:'Courier New',Courier,monospace;font-size:10px;color:rgba(180,230,240,0.75);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+",#0e7490);padding:20px 24px 18px;border-bottom:3px solid "+ac+";}.body-wrap{padding:22px 24px;}"+mon;
// // // // // // // // // // // // // // //     if (id==="elegant")      return "body,.page{font-family:Georgia,'Times New Roman',serif;}.accent-strip{width:6px;background:linear-gradient(180deg,"+ac+","+hd+");flex-shrink:0;}.name{font-size:26px;font-weight:700;color:"+hd+";letter-spacing:0.01em;}.role{font-size:11px;color:"+ac+";font-weight:600;letter-spacing:0.1em;text-transform:uppercase;margin:4px 0 10px;}.contact{display:flex;flex-wrap:wrap;gap:16px;font-size:11px;color:#78716c;}.header-wrap{display:flex;border-bottom:1px solid #e7e5e4;}.header-inner{flex:1;padding:26px 26px 18px;}.body-wrap{padding:18px 26px 22px 32px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="bold")         return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:34px;font-weight:900;color:#fff;letter-spacing:-0.03em;line-height:1;}.accent-bar{width:52px;height:4px;background:"+ac+";border-radius:2px;margin:10px 0 12px;}.role{font-size:12px;color:rgba(255,255,255,0.75);text-transform:uppercase;letter-spacing:0.1em;margin-bottom:10px;}.contact{display:flex;flex-wrap:wrap;gap:16px;font-size:11px;color:rgba(255,255,255,0.55);}.header-wrap{background:"+hd+";padding:26px 26px 20px;}.body-wrap{padding:20px 26px;}"+fil;
// // // // // // // // // // // // // // //     if (id==="sidebarlight") return "body{font-family:Arial,Helvetica,sans-serif;}.page{display:flex;}.sidebar{width:200px;background:"+hd+";padding:26px 16px;flex-shrink:0;border-right:3px solid "+ac+";}.avatar{width:58px;height:58px;border-radius:50%;background:"+ac+"25;border:2.5px solid "+ac+";display:flex;align-items:center;justify-content:center;margin-bottom:14px;font-size:22px;font-weight:700;color:"+ac+";}.name{font-size:13px;font-weight:800;color:#0f172a;margin-bottom:2px;}.role{font-size:10px;color:"+ac+";font-weight:600;margin-bottom:14px;}.main-col{flex:1;padding:22px 20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="academic")     return "body,.page{font-family:Georgia,'Times New Roman',serif;}.name{font-size:24px;font-weight:700;color:#fff;text-align:center;}.role{font-size:11px;color:"+ac+"cc;font-style:italic;text-align:center;margin:4px 0 10px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:16px;font-size:10px;color:rgba(255,255,255,0.5);}.header-wrap{background:"+hd+";padding:22px 30px 18px;text-align:center;}.double-rule-top{height:3px;background:"+ac+";}.double-rule-bot{height:1px;background:"+ac+"40;}.body-wrap{padding:20px 30px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="professional") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:28px;font-weight:700;color:#fff;}.role{font-size:12px;color:"+ac+"bb;text-transform:uppercase;letter-spacing:0.1em;}.contact{font-size:11px;color:rgba(255,255,255,0.6);}.header-inner{display:flex;justify-content:space-between;align-items:flex-end;flex-wrap:wrap;gap:12px;}.accent-line{height:2px;background:"+ac+";border-radius:1px;margin-top:16px;}.header-wrap{background:"+hd+";padding:26px 32px 20px;}.body-wrap{padding:20px 32px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="compact")      return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:22px;font-weight:700;color:#fff;}.role{font-size:11px;color:rgba(255,255,255,0.65);}.contact{display:flex;flex-wrap:wrap;gap:10px;}.contact span{font-size:10px;color:rgba(255,255,255,0.5);background:rgba(255,255,255,0.08);padding:2px 8px;border-radius:4px;}.header-wrap{background:"+hd+";padding:14px 24px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:10px;}.body-wrap{padding:14px 24px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="cleanserif")   return "body,.page{font-family:Georgia,'Times New Roman',serif;padding:28px 32px;}.name{font-size:28px;font-weight:700;color:#1a0a0a;letter-spacing:0.02em;text-align:center;}.role{font-size:12px;color:"+ac+";font-weight:600;letter-spacing:0.12em;text-transform:uppercase;text-align:center;margin:4px 0 10px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:18px;font-size:11px;color:#6b7280;}.header-wrap{text-align:center;border-bottom:3px double "+ac+";padding-bottom:16px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="government")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:22px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.08em;}.contact{display:flex;flex-wrap:wrap;gap:18px;font-size:11px;color:rgba(255,255,255,0.6);margin-top:8px;}.position-bar{background:"+ac+"12;padding:6px 28px;border-bottom:1px solid "+ac+"25;font-size:11px;color:#374151;}.position-label{font-weight:700;color:"+ac+";text-transform:uppercase;letter-spacing:0.06em;}.header-wrap{background:"+hd+";padding:18px 28px 16px;border-bottom:4px solid "+ac+";}.body-wrap{padding:18px 28px;}"+fil;
// // // // // // // // // // // // // // //     if (id==="classic_bw")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:26px;font-weight:700;color:#000;text-align:center;}.contact{font-size:13px;color:#374151;display:flex;justify-content:center;flex-wrap:wrap;gap:16px;}.header-wrap{text-align:center;border-bottom:2px solid #000;padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="traditional")  return "body,.page{font-family:Georgia,'Times New Roman',serif;padding:28px 32px;}.name{font-size:26px;font-weight:700;color:#000;text-align:center;}.contact{font-size:13px;color:#374151;display:flex;justify-content:center;flex-wrap:wrap;gap:16px;}.header-wrap{text-align:center;border-bottom:1.5px solid #1a1a1a;padding-bottom:16px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     return "body,.page{font-family:Arial,Helvetica,sans-serif;}"+ul;
// // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // //   function buildHeader(id) {
// // // // // // // // // // // // // // //     const contacts    = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // //     const contactSpans= contacts.map(c => `<span>${c}</span>`).join("");
// // // // // // // // // // // // // // //     const contactDivs = contacts.map(c => `<div>${c}</div>`).join("");
// // // // // // // // // // // // // // //     if (id==="classic"||id==="classic_bw") return `<div class="header-wrap"><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // //     if (id==="modern")       return `<div class="sidebar"><div style="width:64px;height:64px;border-radius:50%;background:rgba(255,255,255,0.15);margin-bottom:16px;"></div><div class="name">${name}</div><div style="font-size:10px;color:${accent}cc;background:rgba(255,255,255,0.08);padding:2px 8px;border-radius:4px;display:inline-block;margin:4px 0 16px;font-weight:600;">${(resume.experience||[])[0]?.title||""}</div><hr style="border:none;border-top:1px solid rgba(255,255,255,0.15);margin:0 0 12px;"/><div style="display:flex;flex-direction:column;gap:5px;font-size:10px;color:rgba(255,255,255,0.7);">${contactDivs}</div></div><div class="main-col">`;
// // // // // // // // // // // // // // //     if (id==="executive")    return `<div class="header-wrap"><div class="name">${name.toUpperCase()}</div><hr style="border:none;border-top:2px solid rgba(255,255,255,0.3);margin:8px 0;"/><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="minimal")      return `<div class="header-wrap"><div class="name">${name}</div><div class="accent-bar"></div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // //     if (id==="corporate")    return `<div class="header-wrap"><div class="name">${name}</div><div style="font-size:12px;color:rgba(200,225,255,0.7);font-style:italic;margin:4px 0 10px;">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="creative")     return `<div class="header-wrap"><div class="name">${name}</div><div class="contact" style="margin-top:10px;">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="technical")    return `<div class="header-wrap"><div style="font-size:10px;color:${accent}cc;font-family:'Courier New',monospace;margin-bottom:6px;">// resume.json</div><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="elegant")      return `<div class="header-wrap"><div class="accent-strip"></div><div class="header-inner"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="bold")         return `<div class="header-wrap"><div class="name">${name}</div><div class="accent-bar"></div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="sidebarlight") return `<div class="sidebar"><div class="avatar">${(name||"?")[0]}</div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><hr style="border:none;border-top:1px solid rgba(0,0,0,0.1);margin:0 0 12px;"/><div style="display:flex;flex-direction:column;gap:5px;font-size:10px;color:#374151;">${contactDivs}</div></div><div class="main-col">`;
// // // // // // // // // // // // // // //     if (id==="academic")     return `<div class="double-rule-top"></div><div class="header-wrap"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div><div class="double-rule-bot"></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="professional") return `<div class="header-wrap"><div class="header-inner"><div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div></div><div style="text-align:right">${contacts.slice(0,2).map(c=>`<div style="font-size:11px;color:rgba(255,255,255,0.6);margin-bottom:3px;">${c}</div>`).join("")}</div></div><div class="accent-line"></div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="compact")      return `<div class="header-wrap"><div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div></div><div class="contact">${contacts.map(c=>`<span>${c}</span>`).join("")}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="cleanserif")   return `<div class="header-wrap"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // //     if (id==="government")   return `<div class="header-wrap"><div class="name">${name}</div><div class="contact">${contactSpans}</div></div><div class="position-bar"><span class="position-label">Position: </span>${(resume.experience||[])[0]?.title||""}</div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="traditional")  return `<div class="header-wrap"><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // //     return `<div class="header-wrap"><div class="name">${name}</div><div style="margin-top:8px;">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // //   function closeHeader(id) {
// // // // // // // // // // // // // // //     if (["modern","executive","corporate","creative","technical","elegant","bold","sidebarlight","academic","professional","compact","government"].includes(id)) return "</div>";
// // // // // // // // // // // // // // //     return "";
// // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // //   const css        = buildCSS(templateId, accent, header);
// // // // // // // // // // // // // // //   const contacts   = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // //   const headerHtml = buildHeader(templateId);
// // // // // // // // // // // // // // //   const headerClose= closeHeader(templateId);
// // // // // // // // // // // // // // //   const pageOpen   = ["modern","sidebarlight"].includes(templateId) ? `<div class="page">` : `<div class="page" style="max-width:800px;margin:0 auto;padding:${["cleanserif","traditional"].includes(templateId)?"0":"36px 40px"};">`;

// // // // // // // // // // // // // // //   const expHtml = (resume.experience||[]).map(exp => `
// // // // // // // // // // // // // // //     <div style="margin-bottom:16px;">
// // // // // // // // // // // // // // //       <div style="display:flex;justify-content:space-between;align-items:baseline;flex-wrap:wrap;gap:4px;margin-bottom:3px;">
// // // // // // // // // // // // // // //         <span style="font-weight:700;font-size:14px;">${exp.title||""}</span>
// // // // // // // // // // // // // // //         <span style="font-size:12px;color:#64748b;font-style:italic;">${exp.startDate||""} – ${exp.endDate||""}</span>
// // // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // // //       <div style="font-size:13px;color:#475569;margin-bottom:6px;">${exp.company||""}${exp.location?` | ${exp.location}`:""}</div>
// // // // // // // // // // // // // // //       <ul style="margin:0 0 0 18px;padding:0;">${(exp.bullets||[]).map(b=>`<li style="font-size:13px;color:#374151;margin-bottom:3px;line-height:1.5;">${b}</li>`).join("")}</ul>
// // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // //   const eduHtml = (resume.education||[]).map(edu => `
// // // // // // // // // // // // // // //     <div style="margin-bottom:12px;">
// // // // // // // // // // // // // // //       <div style="font-weight:700;font-size:14px;">${edu.degree||""} — ${edu.school||""}</div>
// // // // // // // // // // // // // // //       <div style="font-size:12px;color:#64748b;margin-top:2px;">${edu.year||""}${edu.location?` | ${edu.location}`:""}${edu.gpa?` | GPA: ${edu.gpa}`:""}</div>
// // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // //   const skillsHtml = resume.skills ? [
// // // // // // // // // // // // // // //     resume.skills.technical?.length > 0 ? `<p style="margin:4px 0;font-size:13px;"><strong>Technical:</strong> ${resume.skills.technical.join(", ")}</p>` : "",
// // // // // // // // // // // // // // //     resume.skills.tools?.length > 0     ? `<p style="margin:4px 0;font-size:13px;"><strong>Tools:</strong> ${resume.skills.tools.join(", ")}</p>` : "",
// // // // // // // // // // // // // // //     resume.skills.soft?.length > 0      ? `<p style="margin:4px 0;font-size:13px;"><strong>Soft Skills:</strong> ${resume.skills.soft.join(", ")}</p>` : "",
// // // // // // // // // // // // // // //   ].join("") : "";

// // // // // // // // // // // // // // //   const certHtml = (resume.certifications||[]).length > 0
// // // // // // // // // // // // // // //     ? `<ul style="margin:4px 0 0 18px;padding:0;">${resume.certifications.map(c=>`<li style="font-size:13px;color:#374151;margin-bottom:4px;">${c}</li>`).join("")}</ul>`
// // // // // // // // // // // // // // //     : "";

// // // // // // // // // // // // // // //   function section(title, body) {
// // // // // // // // // // // // // // //     if (!body?.trim()) return "";
// // // // // // // // // // // // // // //     return `<div style="margin-bottom:20px;"><div class="section-title">${title}</div>${body}</div>`;
// // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // //   const html = `<!DOCTYPE html>
// // // // // // // // // // // // // // // <html lang="en">
// // // // // // // // // // // // // // // <head>
// // // // // // // // // // // // // // //   <meta charset="utf-8"/>
// // // // // // // // // // // // // // //   <title>${name} — ${t.name} Resume</title>
// // // // // // // // // // // // // // //   <style>
// // // // // // // // // // // // // // //     *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
// // // // // // // // // // // // // // //     body{color:#212529;background:#fff;font-size:14px;line-height:1.55;}
// // // // // // // // // // // // // // //     ${css}
// // // // // // // // // // // // // // //     @media print{
// // // // // // // // // // // // // // //       body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}
// // // // // // // // // // // // // // //       .no-print{display:none!important;}
// // // // // // // // // // // // // // //       @page{margin:0;size:A4;}
// // // // // // // // // // // // // // //     }
// // // // // // // // // // // // // // //   </style>
// // // // // // // // // // // // // // // </head>
// // // // // // // // // // // // // // // <body>
// // // // // // // // // // // // // // // ${pageOpen}
// // // // // // // // // // // // // // //   ${headerHtml}
// // // // // // // // // // // // // // //   ${section("Professional Summary", resume.summary ? `<p style="font-size:13px;line-height:1.75;color:#374151;">${resume.summary}</p>` : "")}
// // // // // // // // // // // // // // //   ${section("Work Experience", expHtml)}
// // // // // // // // // // // // // // //   ${section("Education", eduHtml)}
// // // // // // // // // // // // // // //   ${section("Skills", skillsHtml)}
// // // // // // // // // // // // // // //   ${certHtml ? section("Certifications", certHtml) : ""}
// // // // // // // // // // // // // // //   ${headerClose}
// // // // // // // // // // // // // // // </div>
// // // // // // // // // // // // // // // </body>
// // // // // // // // // // // // // // // </html>`;

// // // // // // // // // // // // // // //   // Open in new tab and trigger print dialog
// // // // // // // // // // // // // // //   const newTab = window.open("", "_blank");
// // // // // // // // // // // // // // //   if (!newTab) {
// // // // // // // // // // // // // // //     // Popup blocked — fall back to HTML download
// // // // // // // // // // // // // // //     const blob = new Blob([html], { type: "text/html;charset=utf-8" });
// // // // // // // // // // // // // // //     const url  = URL.createObjectURL(blob);
// // // // // // // // // // // // // // //     const a    = Object.assign(document.createElement("a"), { href: url, download: fileName?.replace(".pdf", ".html") || "Resume.html" });
// // // // // // // // // // // // // // //     document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // // // // // // // // // // // //     URL.revokeObjectURL(url);
// // // // // // // // // // // // // // //     return;
// // // // // // // // // // // // // // //   }
// // // // // // // // // // // // // // //   newTab.document.write(html);
// // // // // // // // // // // // // // //   newTab.document.close();
// // // // // // // // // // // // // // //   setTimeout(() => {
// // // // // // // // // // // // // // //     newTab.focus();
// // // // // // // // // // // // // // //     newTab.print();
// // // // // // // // // // // // // // //   }, 800);
// // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // WORD DOWNLOAD — template-aware
// // // // // // // // // // // // // // // // Saves as .doc which Word opens natively
// // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // export async function downloadResumeAsWord(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // // //   const t      = getTemplate(templateId);
// // // // // // // // // // // // // // //   const accent = "#" + t.accentHex;
// // // // // // // // // // // // // // //   const header = "#" + t.headerHex;
// // // // // // // // // // // // // // //   const name   = resume.name || "";

// // // // // // // // // // // // // // //   function buildCSS(id, ac, hd) {
// // // // // // // // // // // // // // //     const ul  = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";border-bottom:1.5px solid " + ac + ";padding-bottom:4px;margin-bottom:12px;}";
// // // // // // // // // // // // // // //     const fil = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;}";
// // // // // // // // // // // // // // //     if (id==="classic"||id==="classic_bw") return "body{font-family:Arial,Helvetica,sans-serif;max-width:800px;margin:0 auto;padding:36px 40px;}.name{font-family:Georgia,serif;font-size:26px;font-weight:700;color:#0f172a;text-align:center;}.contact{font-size:13px;color:#475569;text-align:center;}.header-wrap{text-align:center;border-bottom:2px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="modern")       return "body{font-family:Arial,Helvetica,sans-serif;max-width:800px;margin:0 auto;}.sidebar{display:inline-block;width:200px;background:"+hd+";padding:28px 18px;vertical-align:top;}.main-col{display:inline-block;padding:28px 24px;vertical-align:top;width:calc(100% - 260px);}.name{font-size:14px;font-weight:800;color:#fff;}.contact{font-size:10px;color:rgba(255,255,255,0.7);}"+fil;
// // // // // // // // // // // // // // //     if (id==="executive")    return "body{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:28px;font-weight:700;color:#fff;text-transform:uppercase;}.contact{font-size:12px;color:rgba(255,255,255,0.6);}.header-wrap{background:"+hd+";padding:28px 32px 24px;}.body-wrap{padding:24px 32px 24px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="minimal")      return "body{font-family:Helvetica,Arial,sans-serif;max-width:800px;margin:0 auto;padding:36px 40px;}.name{font-size:28px;font-weight:300;color:#0f172a;}.accent-bar{width:32px;height:3px;background:"+ac+";margin:6px 0 10px;}.contact{font-size:13px;color:#64748b;}.header-wrap{border-bottom:2.5px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="corporate")    return "body{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:24px;font-weight:700;color:#fff;}.contact{font-size:12px;color:rgba(200,225,255,0.85);}.header-wrap{background:"+hd+";padding:24px 28px 22px;}.body-wrap{padding:22px 28px;}"+fil;
// // // // // // // // // // // // // // //     if (id==="creative")     return "body{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:30px;font-weight:800;color:#fff;}.contact{font-size:11px;color:rgba(255,210,220,0.85);}.header-wrap{background:"+hd+";padding:28px 28px 24px;}.body-wrap{padding:16px 28px 24px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="technical")    return "body{font-family:Arial,Helvetica,sans-serif;}.name{font-family:'Courier New',monospace;font-size:22px;font-weight:700;color:#fff;}.contact{font-family:'Courier New',monospace;font-size:10px;color:rgba(180,230,240,0.75);}.header-wrap{background:"+hd+";padding:20px 24px 18px;border-bottom:3px solid "+ac+";}.body-wrap{padding:22px 24px;}"+fil;
// // // // // // // // // // // // // // //     if (id==="elegant")      return "body{font-family:Georgia,'Times New Roman',serif;max-width:800px;margin:0 auto;padding:36px 40px;}.name{font-size:26px;font-weight:700;color:"+hd+";}.role{font-size:11px;color:"+ac+";font-weight:600;text-transform:uppercase;letter-spacing:0.1em;margin:4px 0 10px;}.contact{font-size:11px;color:#78716c;}.header-wrap{border-bottom:1px solid #e7e5e4;padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="bold")         return "body{font-family:Arial,Helvetica,sans-serif;}.name{font-size:34px;font-weight:900;color:#fff;letter-spacing:-0.03em;}.accent-bar{width:52px;height:4px;background:"+ac+";margin:10px 0 12px;}.role{font-size:12px;color:rgba(255,255,255,0.75);text-transform:uppercase;letter-spacing:0.1em;margin-bottom:10px;}.contact{font-size:11px;color:rgba(255,255,255,0.55);}.header-wrap{background:"+hd+";padding:26px 26px 20px;}.body-wrap{padding:20px 26px;}"+fil;
// // // // // // // // // // // // // // //     if (id==="sidebarlight") return "body{font-family:Arial,Helvetica,sans-serif;max-width:800px;margin:0 auto;}.sidebar{display:inline-block;width:200px;background:"+hd+";padding:26px 16px;border-right:3px solid "+ac+";vertical-align:top;}.main-col{display:inline-block;padding:22px 20px;vertical-align:top;width:calc(100% - 260px);}.name{font-size:13px;font-weight:800;color:#0f172a;}.role{font-size:10px;color:"+ac+";font-weight:600;}"+ul;
// // // // // // // // // // // // // // //     if (id==="academic")     return "body{font-family:Georgia,'Times New Roman',serif;}.name{font-size:24px;font-weight:700;color:#fff;text-align:center;}.role{font-size:11px;color:"+ac+"cc;font-style:italic;text-align:center;margin:4px 0 10px;}.contact{text-align:center;font-size:10px;color:rgba(255,255,255,0.5);}.header-wrap{background:"+hd+";padding:22px 30px 18px;}.body-wrap{padding:20px 30px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="professional") return "body{font-family:Arial,Helvetica,sans-serif;}.name{font-size:28px;font-weight:700;color:#fff;}.role{font-size:12px;color:"+ac+"bb;text-transform:uppercase;letter-spacing:0.1em;}.contact{font-size:11px;color:rgba(255,255,255,0.6);}.header-wrap{background:"+hd+";padding:26px 32px 20px;}.body-wrap{padding:20px 32px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="compact")      return "body{font-family:Arial,Helvetica,sans-serif;}.name{font-size:22px;font-weight:700;color:#fff;}.role{font-size:11px;color:rgba(255,255,255,0.65);}.contact{font-size:10px;color:rgba(255,255,255,0.5);}.header-wrap{background:"+hd+";padding:14px 24px;}.body-wrap{padding:14px 24px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="cleanserif")   return "body{font-family:Georgia,'Times New Roman',serif;max-width:800px;margin:0 auto;padding:28px 32px;}.name{font-size:28px;font-weight:700;color:#1a0a0a;text-align:center;}.role{font-size:12px;color:"+ac+";font-weight:600;text-transform:uppercase;text-align:center;margin:4px 0 10px;}.contact{text-align:center;font-size:11px;color:#6b7280;}.header-wrap{text-align:center;border-bottom:3px double "+ac+";padding-bottom:16px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="government")   return "body{font-family:Arial,Helvetica,sans-serif;}.name{font-size:22px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.08em;}.contact{font-size:11px;color:rgba(255,255,255,0.6);margin-top:8px;}.header-wrap{background:"+hd+";padding:18px 28px 16px;border-bottom:4px solid "+ac+";}.body-wrap{padding:18px 28px;}"+fil;
// // // // // // // // // // // // // // //     if (id==="traditional")  return "body{font-family:Georgia,'Times New Roman',serif;max-width:800px;margin:0 auto;padding:28px 32px;}.name{font-size:26px;font-weight:700;color:#000;text-align:center;}.contact{text-align:center;font-size:13px;color:#374151;}.header-wrap{text-align:center;border-bottom:1.5px solid #1a1a1a;padding-bottom:16px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     return "body{font-family:Arial,Helvetica,sans-serif;max-width:800px;margin:0 auto;padding:36px 40px;}"+ul;
// // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // //   function buildHeader(id) {
// // // // // // // // // // // // // // //     const contacts    = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // //     const contactStr  = contacts.join("  |  ");
// // // // // // // // // // // // // // //     const contactList = contacts.map(c=>`<div>${c}</div>`).join("");
// // // // // // // // // // // // // // //     const role        = (resume.experience||[])[0]?.title || "";
// // // // // // // // // // // // // // //     if (id==="classic"||id==="classic_bw"||id==="traditional") return `<div class="header-wrap"><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactStr}</div></div>`;
// // // // // // // // // // // // // // //     if (id==="modern")       return `<div class="sidebar"><div class="name">${name}</div><div style="font-size:10px;color:${accent}cc;margin:4px 0 16px;font-weight:600;">${role}</div><div style="font-size:9px;color:rgba(255,255,255,0.5);text-transform:uppercase;letter-spacing:0.1em;margin-bottom:8px;">Contact</div>${contactList}</div><div class="main-col">`;
// // // // // // // // // // // // // // //     if (id==="executive")    return `<div class="header-wrap"><div class="name">${name.toUpperCase()}</div><hr style="border:none;border-top:2px solid rgba(255,255,255,0.3);margin:8px 0;"/><div class="contact">${contactStr}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="minimal")      return `<div class="header-wrap"><div class="name">${name}</div><div class="accent-bar"></div><div class="contact">${contactStr}</div></div>`;
// // // // // // // // // // // // // // //     if (id==="corporate"||id==="creative"||id==="academic") return `<div class="header-wrap"><div class="name">${name}</div><div class="role">${role}</div><div class="contact">${contactStr}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="technical")    return `<div class="header-wrap"><div style="font-size:10px;color:${accent}cc;font-family:'Courier New',monospace;margin-bottom:6px;">// resume.json</div><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactStr}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="elegant")      return `<div class="header-wrap"><div class="name">${name}</div><div class="role">${role}</div><div class="contact">${contactStr}</div></div>`;
// // // // // // // // // // // // // // //     if (id==="bold")         return `<div class="header-wrap"><div class="name">${name}</div><div class="accent-bar"></div><div class="role">${role}</div><div class="contact">${contactStr}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="sidebarlight") return `<div class="sidebar"><div class="name">${name}</div><div class="role">${role}</div><hr style="border:none;border-top:1px solid rgba(0,0,0,0.1);margin:10px 0;"/>${contactList}</div><div class="main-col">`;
// // // // // // // // // // // // // // //     if (id==="professional") return `<div class="header-wrap"><div class="name">${name}</div><div class="role">${role}</div><div class="contact" style="margin-top:8px;">${contactStr}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="compact")      return `<div class="header-wrap"><div class="name">${name}</div><div class="role">${role}</div><div class="contact" style="margin-top:6px;">${contactStr}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="cleanserif")   return `<div class="header-wrap"><div class="name">${name}</div><div class="role">${role}</div><div class="contact">${contactStr}</div></div>`;
// // // // // // // // // // // // // // //     if (id==="government")   return `<div class="header-wrap"><div class="name">${name}</div><div class="contact">${contactStr}</div></div><div style="background:${accent}12;padding:6px 28px;border-bottom:1px solid ${accent}25;font-size:11px;"><strong style="color:${accent}">POSITION:</strong> ${role}</div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     return `<div class="header-wrap"><div class="name">${name}</div><div style="margin-top:8px;font-size:13px;color:#475569;">${contactStr}</div></div>`;
// // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // //   function closeHeader(id) {
// // // // // // // // // // // // // // //     if (["modern","sidebarlight","executive","corporate","creative","technical","bold","academic","professional","compact","government"].includes(id)) return "</div>";
// // // // // // // // // // // // // // //     return "";
// // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // //   const css        = buildCSS(templateId, accent, header);
// // // // // // // // // // // // // // //   const headerHtml = buildHeader(templateId);
// // // // // // // // // // // // // // //   const headerClose= closeHeader(templateId);

// // // // // // // // // // // // // // //   const expHtml = (resume.experience||[]).map(exp => `
// // // // // // // // // // // // // // //     <div style="margin-bottom:16px;">
// // // // // // // // // // // // // // //       <div style="display:flex;justify-content:space-between;margin-bottom:3px;">
// // // // // // // // // // // // // // //         <strong style="font-size:14px;">${exp.title||""}</strong>
// // // // // // // // // // // // // // //         <span style="font-size:12px;color:#64748b;font-style:italic;">${exp.startDate||""} – ${exp.endDate||""}</span>
// // // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // // //       <div style="font-size:13px;color:#475569;margin-bottom:6px;">${exp.company||""}${exp.location ? ` | ${exp.location}`:""}</div>
// // // // // // // // // // // // // // //       <ul style="margin:0 0 0 18px;padding:0;">${(exp.bullets||[]).map(b=>`<li style="font-size:13px;color:#374151;margin-bottom:3px;line-height:1.5;">${b}</li>`).join("")}</ul>
// // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // //   const eduHtml = (resume.education||[]).map(edu => `
// // // // // // // // // // // // // // //     <div style="margin-bottom:12px;">
// // // // // // // // // // // // // // //       <strong style="font-size:14px;">${edu.degree||""} — ${edu.school||""}</strong>
// // // // // // // // // // // // // // //       <div style="font-size:12px;color:#64748b;margin-top:2px;">${edu.year||""}${edu.location?` | ${edu.location}`:""}${edu.gpa?` | GPA: ${edu.gpa}`:""}</div>
// // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // //   const skillsHtml = resume.skills ? [
// // // // // // // // // // // // // // //     resume.skills.technical?.length > 0 ? `<p style="margin:4px 0;font-size:13px;"><strong>Technical:</strong> ${resume.skills.technical.join(", ")}</p>`:"",
// // // // // // // // // // // // // // //     resume.skills.tools?.length > 0     ? `<p style="margin:4px 0;font-size:13px;"><strong>Tools:</strong> ${resume.skills.tools.join(", ")}</p>`:"",
// // // // // // // // // // // // // // //     resume.skills.soft?.length > 0      ? `<p style="margin:4px 0;font-size:13px;"><strong>Soft Skills:</strong> ${resume.skills.soft.join(", ")}</p>`:"",
// // // // // // // // // // // // // // //   ].join("") : "";

// // // // // // // // // // // // // // //   const certHtml = (resume.certifications||[]).length > 0
// // // // // // // // // // // // // // //     ? `<ul style="margin:4px 0 0 18px;padding:0;">${resume.certifications.map(c=>`<li style="font-size:13px;color:#374151;margin-bottom:4px;">${c}</li>`).join("")}</ul>`
// // // // // // // // // // // // // // //     : "";

// // // // // // // // // // // // // // //   function section(title, body) {
// // // // // // // // // // // // // // //     if (!body?.trim()) return "";
// // // // // // // // // // // // // // //     return `<div style="margin-bottom:20px;"><div class="section-title">${title}</div>${body}</div>`;
// // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // //   const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
// // // // // // // // // // // // // // // xmlns:w="urn:schemas-microsoft-com:office:word"
// // // // // // // // // // // // // // // xmlns="http://www.w3.org/TR/REC-html40">
// // // // // // // // // // // // // // // <head>
// // // // // // // // // // // // // // // <meta charset="utf-8"/>
// // // // // // // // // // // // // // // <meta name="ProgId" content="Word.Document"/>
// // // // // // // // // // // // // // // <meta name="Generator" content="Microsoft Word 15"/>
// // // // // // // // // // // // // // // <!--[if gte mso 9]>
// // // // // // // // // // // // // // // <xml><w:WordDocument><w:View>Print</w:View><w:Zoom>100</w:Zoom></w:WordDocument></xml>
// // // // // // // // // // // // // // // <![endif]-->
// // // // // // // // // // // // // // // <style>
// // // // // // // // // // // // // // //   @page { size:A4; margin:1in; }
// // // // // // // // // // // // // // //   body { font-family: Arial, sans-serif; font-size: 14px; line-height: 1.55; color: #212529; }
// // // // // // // // // // // // // // //   ${css}
// // // // // // // // // // // // // // //   ul { margin: 4px 0 4px 18px; padding: 0; }
// // // // // // // // // // // // // // //   li { margin-bottom: 3px; line-height: 1.5; }
// // // // // // // // // // // // // // //   p  { margin: 4px 0; }
// // // // // // // // // // // // // // // </style>
// // // // // // // // // // // // // // // </head>
// // // // // // // // // // // // // // // <body>
// // // // // // // // // // // // // // // ${headerHtml}
// // // // // // // // // // // // // // // ${section("Professional Summary", resume.summary ? `<p style="font-size:13px;line-height:1.75;color:#374151;">${resume.summary}</p>` : "")}
// // // // // // // // // // // // // // // ${section("Work Experience", expHtml)}
// // // // // // // // // // // // // // // ${section("Education", eduHtml)}
// // // // // // // // // // // // // // // ${section("Skills", skillsHtml)}
// // // // // // // // // // // // // // // ${certHtml ? section("Certifications", certHtml) : ""}
// // // // // // // // // // // // // // // ${headerClose}
// // // // // // // // // // // // // // // </body>
// // // // // // // // // // // // // // // </html>`;

// // // // // // // // // // // // // // //   const blob = new Blob(["\ufeff", html], {
// // // // // // // // // // // // // // //     type: "application/msword;charset=utf-8",
// // // // // // // // // // // // // // //   });
// // // // // // // // // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // // // // // // // // //   const a   = Object.assign(document.createElement("a"), {
// // // // // // // // // // // // // // //     href:     url,
// // // // // // // // // // // // // // //     download: (fileName || "Resume").replace(/\.(docx?|html?)$/i, "") + ".doc",
// // // // // // // // // // // // // // //   });
// // // // // // // // // // // // // // //   document.body.appendChild(a);
// // // // // // // // // // // // // // //   a.click();
// // // // // // // // // // // // // // //   document.body.removeChild(a);
// // // // // // // // // // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 1000);
// // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // // HTML DOWNLOAD — template-aware
// // // // // // // // // // // // // // // // Matches landing page ResumeCard previews exactly
// // // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // export function downloadATSResume(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // // //   const t      = getTemplate(templateId);
// // // // // // // // // // // // // // //   const accent = "#" + t.accentHex;
// // // // // // // // // // // // // // //   const header = "#" + t.headerHex;
// // // // // // // // // // // // // // //   const name   = resume.name || "";

// // // // // // // // // // // // // // //   function buildCSS(id, ac, hd) {
// // // // // // // // // // // // // // //     const ul  = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";border-bottom:1.5px solid " + ac + ";padding-bottom:4px;margin-bottom:12px;}";
// // // // // // // // // // // // // // //     const fil = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.1em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;border-radius:0 6px 6px 0;}";
// // // // // // // // // // // // // // //     const mon = ".section-title{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.12em;color:" + ac + ";background:" + ac + "18;border-left:3px solid " + ac + ";padding:5px 10px;margin-bottom:12px;border-radius:0 6px 6px 0;font-family:'Courier New',monospace;}";
// // // // // // // // // // // // // // //     if (id==="classic")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:26px;font-weight:700;color:#0f172a;text-align:center;}.contact{font-size:13px;color:#475569;display:flex;justify-content:center;flex-wrap:wrap;gap:16px;}.header-wrap{text-align:center;border-bottom:2px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="modern")    return "body{font-family:Arial,Helvetica,sans-serif;}.page{display:flex;max-width:800px;margin:0 auto;}.sidebar{width:200px;background:"+hd+";padding:28px 18px;flex-shrink:0;}.main-col{flex:1;padding:28px 24px;}.name{font-size:14px;font-weight:800;color:#fff;}.contact{font-size:10px;color:rgba(255,255,255,0.7);}"+fil;
// // // // // // // // // // // // // // //     if (id==="executive") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:28px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.06em;}.contact{font-size:12px;color:rgba(255,255,255,0.6);display:flex;flex-wrap:wrap;gap:20px;}.header-wrap{background:"+hd+";padding:28px 32px 24px;}.body-wrap{padding:24px 32px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="minimal")   return "body,.page{font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;}.name{font-size:28px;font-weight:300;color:#0f172a;letter-spacing:-0.02em;}.accent-bar{width:32px;height:3px;background:"+ac+";border-radius:2px;margin:6px 0 10px;}.contact{font-size:13px;color:#64748b;display:flex;flex-wrap:wrap;gap:18px;}.header-wrap{border-bottom:2.5px solid "+ac+";padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="corporate") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:24px;font-weight:700;color:#fff;}.contact{font-size:12px;color:rgba(200,225,255,0.85);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+","+ac+");padding:24px 28px 22px;}.body-wrap{padding:22px 28px;}"+fil;
// // // // // // // // // // // // // // //     if (id==="creative")  return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:Georgia,serif;font-size:30px;font-weight:800;color:#fff;letter-spacing:-0.02em;}.contact{font-size:11px;color:rgba(255,210,220,0.85);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+","+ac+");padding:28px 28px 52px;clip-path:polygon(0 0,100% 0,100% 80%,0 100%);margin-bottom:-8px;}.body-wrap{padding:16px 28px 24px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="technical")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-family:'Courier New',Courier,monospace;font-size:22px;font-weight:700;color:#fff;letter-spacing:0.02em;}.contact{font-family:'Courier New',Courier,monospace;font-size:10px;color:rgba(180,230,240,0.75);display:flex;flex-wrap:wrap;gap:16px;}.header-wrap{background:linear-gradient(135deg,"+hd+",#0e7490);padding:20px 24px 18px;border-bottom:3px solid "+ac+";}.body-wrap{padding:22px 24px;}"+mon;
// // // // // // // // // // // // // // //     if (id==="elegant")     return "body,.page{font-family:Georgia,'Times New Roman',serif;}.accent-strip{width:6px;background:linear-gradient(180deg,"+ac+","+hd+");flex-shrink:0;}.name{font-size:26px;font-weight:700;color:"+hd+";letter-spacing:0.01em;}.role{font-size:11px;color:"+ac+";font-weight:600;letter-spacing:0.1em;text-transform:uppercase;margin:4px 0 10px;}.contact{display:flex;flex-wrap:wrap;gap:16px;font-size:11px;color:#78716c;}.header-wrap{display:flex;border-bottom:1px solid #e7e5e4;}.header-inner{flex:1;padding:26px 26px 18px;}.body-wrap{padding:18px 26px 22px 32px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="bold")        return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:34px;font-weight:900;color:#fff;letter-spacing:-0.03em;line-height:1;}.accent-bar{width:52px;height:4px;background:"+ac+";border-radius:2px;margin:10px 0 12px;}.role{font-size:12px;color:rgba(255,255,255,0.75);text-transform:uppercase;letter-spacing:0.1em;margin-bottom:10px;}.contact{display:flex;flex-wrap:wrap;gap:16px;font-size:11px;color:rgba(255,255,255,0.55);}.header-wrap{background:"+hd+";padding:26px 26px 20px;}.body-wrap{padding:20px 26px;}"+fil;
// // // // // // // // // // // // // // //     if (id==="sidebarlight")return "body{font-family:Arial,Helvetica,sans-serif;}.page{display:flex;}.sidebar{width:200px;background:"+hd+";padding:26px 16px;flex-shrink:0;border-right:3px solid "+ac+";}.avatar{width:58px;height:58px;border-radius:50%;background:"+ac+"25;border:2.5px solid "+ac+";display:flex;align-items:center;justify-content:center;margin-bottom:14px;font-size:22px;font-weight:700;color:"+ac+";}.name{font-size:13px;font-weight:800;color:#0f172a;margin-bottom:2px;}.role{font-size:10px;color:"+ac+";font-weight:600;margin-bottom:14px;}.main-col{flex:1;padding:22px 20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="academic")    return "body,.page{font-family:Georgia,'Times New Roman',serif;}.name{font-size:24px;font-weight:700;color:#fff;text-align:center;}.role{font-size:11px;color:"+ac+"cc;font-style:italic;text-align:center;margin:4px 0 10px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:16px;font-size:10px;color:rgba(255,255,255,0.5);}.header-wrap{background:"+hd+";padding:22px 30px 18px;text-align:center;}.double-rule-top{height:3px;background:"+ac+";}.double-rule-bot{height:1px;background:"+ac+"40;}.body-wrap{padding:20px 30px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="professional") return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:28px;font-weight:700;color:#fff;}.role{font-size:12px;color:"+ac+"bb;text-transform:uppercase;letter-spacing:0.1em;}.contact{font-size:11px;color:rgba(255,255,255,0.6);}.header-inner{display:flex;justify-content:space-between;align-items:flex-end;flex-wrap:wrap;gap:12px;}.accent-line{height:2px;background:"+ac+";border-radius:1px;margin-top:16px;}.header-wrap{background:"+hd+";padding:26px 32px 20px;}.body-wrap{padding:20px 32px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="compact")      return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:22px;font-weight:700;color:#fff;}.role{font-size:11px;color:rgba(255,255,255,0.65);}.contact{display:flex;flex-wrap:wrap;gap:10px;}.contact span{font-size:10px;color:rgba(255,255,255,0.5);background:rgba(255,255,255,0.08);padding:2px 8px;border-radius:4px;}.header-wrap{background:"+hd+";padding:14px 24px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:10px;}.body-wrap{padding:14px 24px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="cleanserif")   return "body,.page{font-family:Georgia,'Times New Roman',serif;padding:28px 32px;}.name{font-size:28px;font-weight:700;color:#1a0a0a;letter-spacing:0.02em;text-align:center;}.role{font-size:12px;color:"+ac+";font-weight:600;letter-spacing:0.12em;text-transform:uppercase;text-align:center;margin:4px 0 10px;}.contact{display:flex;justify-content:center;flex-wrap:wrap;gap:18px;font-size:11px;color:#6b7280;}.header-wrap{text-align:center;border-bottom:3px double "+ac+";padding-bottom:16px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="government")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:22px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:0.08em;}.contact{display:flex;flex-wrap:wrap;gap:18px;font-size:11px;color:rgba(255,255,255,0.6);margin-top:8px;}.position-bar{background:"+ac+"12;padding:6px 28px;border-bottom:1px solid "+ac+"25;font-size:11px;color:#374151;}.position-label{font-weight:700;color:"+ac+";text-transform:uppercase;letter-spacing:0.06em;}.header-wrap{background:"+hd+";padding:18px 28px 16px;border-bottom:4px solid "+ac+";}.body-wrap{padding:18px 28px;}"+fil;
// // // // // // // // // // // // // // //     if (id==="classic_bw")   return "body,.page{font-family:Arial,Helvetica,sans-serif;}.name{font-size:26px;font-weight:700;color:#000;text-align:center;}.contact{font-size:13px;color:#374151;display:flex;justify-content:center;flex-wrap:wrap;gap:16px;}.header-wrap{text-align:center;border-bottom:2px solid #000;padding-bottom:18px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     if (id==="traditional")  return "body,.page{font-family:Georgia,'Times New Roman',serif;padding:28px 32px;}.name{font-size:26px;font-weight:700;color:#000;text-align:center;}.contact{font-size:13px;color:#374151;display:flex;justify-content:center;flex-wrap:wrap;gap:16px;}.header-wrap{text-align:center;border-bottom:1.5px solid #1a1a1a;padding-bottom:16px;margin-bottom:20px;}"+ul;
// // // // // // // // // // // // // // //     return "";
// // // // // // // // // // // // // // //   }
// // // // // // // // // // // // // // //   const css = buildCSS(templateId, accent, header);

// // // // // // // // // // // // // // //   const contacts = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean);
// // // // // // // // // // // // // // //   const contactSpans = contacts.map(c => `<span>${c}</span>`).join("");
// // // // // // // // // // // // // // //   const contactDivs  = contacts.map(c => `<div>${c}</div>`).join("");

// // // // // // // // // // // // // // //   function buildHeader(id) {
// // // // // // // // // // // // // // //     if (id==="classic"||id==="classic_bw") return `<div class="header-wrap"><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // //     if (id==="modern")  return `<div class="sidebar"><div style="width:64px;height:64px;border-radius:50%;background:rgba(255,255,255,0.15);margin-bottom:16px;"></div><div class="name">${name}</div><div style="font-size:10px;color:${accent}cc;background:rgba(255,255,255,0.08);padding:2px 8px;border-radius:4px;display:inline-block;margin:4px 0 16px;font-weight:600;">${(resume.experience||[])[0]?.title||"Professional"}</div><hr style="border:none;border-top:1px solid rgba(255,255,255,0.15);margin:0 0 12px;"/><div style="font-size:10px;font-weight:700;color:rgba(255,255,255,0.5);text-transform:uppercase;letter-spacing:0.1em;margin-bottom:8px;">Contact</div><div style="display:flex;flex-direction:column;gap:5px;font-size:10px;color:rgba(255,255,255,0.7);">${contactDivs}</div></div><div class="main-col">`;
// // // // // // // // // // // // // // //     if (id==="executive") return `<div class="header-wrap"><div class="name">${name.toUpperCase()}</div><hr style="border:none;border-top:2px solid rgba(255,255,255,0.3);margin:8px 0 4px;"/><hr style="border:none;border-top:0.5px solid rgba(255,255,255,0.1);margin:0 0 12px;"/><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="minimal") return `<div class="header-wrap"><div class="name">${name}</div><div class="accent-bar"></div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // //     if (id==="corporate") return `<div class="header-wrap"><div class="name">${name}</div><div style="font-size:12px;color:rgba(200,225,255,0.7);font-style:italic;margin:4px 0 10px;">${(resume.experience||[])[0]?.title||"Professional Resume"}</div><hr style="border:none;border-top:1px solid rgba(255,255,255,0.2);margin:0 0 10px;"/><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="creative") return `<div class="header-wrap"><div class="name">${name}</div><div style="font-size:12px;color:rgba(255,210,220,0.85);text-transform:uppercase;letter-spacing:0.08em;margin:6px 0 12px;">Resume</div><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="technical") return `<div class="header-wrap"><div style="font-size:10px;color:${accent}cc;font-family:'Courier New',monospace;margin-bottom:6px;letter-spacing:0.04em;">// resume.json</div><div class="name">${name}</div><div class="contact" style="margin-top:8px;">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="professional") return `<div class="header-wrap"><div class="header-inner"><div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div></div><div style="text-align:right">${contacts.slice(0,2).map(c=>`<div style="font-size:11px;color:rgba(255,255,255,0.6);margin-bottom:3px;">${c}</div>`).join("")}</div></div><div class="accent-line"></div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="compact")      return `<div class="header-wrap"><div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div></div><div class="contact">${contacts.map(c=>`<span>${c}</span>`).join("")}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="cleanserif")   return `<div class="header-wrap"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // //     if (id==="government")   return `<div class="header-wrap"><div class="name">${name}</div><div class="contact">${contactSpans}</div></div><div class="position-bar"><span class="position-label">Position Applied For: </span>${(resume.experience||[])[0]?.title||"Professional"}</div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="elegant")      return `<div class="header-wrap"><div class="accent-strip"></div><div class="header-inner"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="bold")         return `<div class="header-wrap"><div class="name">${name}</div><div class="accent-bar"></div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     if (id==="sidebarlight") return `<div class="sidebar"><div class="avatar">${(name||"?")[0]}</div><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><hr style="border:none;border-top:1px solid rgba(0,0,0,0.1);margin:0 0 12px;"/><div style="display:flex;flex-direction:column;gap:5px;font-size:10px;color:#374151;">${contactDivs}</div></div><div class="main-col">`;
// // // // // // // // // // // // // // //     if (id==="academic")     return `<div class="double-rule-top"></div><div class="header-wrap"><div class="name">${name}</div><div class="role">${(resume.experience||[])[0]?.title||""}</div><div class="contact">${contactSpans}</div></div><div class="double-rule-bot"></div><div class="body-wrap">`;
// // // // // // // // // // // // // // //     return `<div class="header-wrap"><div class="name">${name}</div><div class="contact">${contactSpans}</div></div>`;
// // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // //   function closeHeader(id) {
// // // // // // // // // // // // // // //     if (["modern","executive","corporate","creative","technical","elegant","bold","sidebarlight","academic","professional","compact","government"].includes(id)) return "</div>";
// // // // // // // // // // // // // // //     return "";
// // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // //   const headerHtml = buildHeader(templateId);
// // // // // // // // // // // // // // //   const headerClose = closeHeader(templateId);

// // // // // // // // // // // // // // //   const expHtml = (resume.experience || []).map(exp => `
// // // // // // // // // // // // // // //     <div style="margin-bottom:14px;">
// // // // // // // // // // // // // // //       <div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:4px;">
// // // // // // // // // // // // // // //         <div>
// // // // // // // // // // // // // // //           <strong style="font-size:14px;color:#0f172a;">${exp.title}</strong>
// // // // // // // // // // // // // // //           <span style="color:#475569;"> — ${exp.company}</span>
// // // // // // // // // // // // // // //           ${exp.location ? `<span style="color:#94a3b8;font-size:12px;"> | ${exp.location}</span>` : ""}
// // // // // // // // // // // // // // //         </div>
// // // // // // // // // // // // // // //         <span style="color:#64748b;font-size:12px;font-style:italic;white-space:nowrap;">${exp.startDate} – ${exp.endDate}</span>
// // // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // // //       <ul style="margin:5px 0 0 20px;padding:0;">
// // // // // // // // // // // // // // //         ${(exp.bullets || []).map(b => `<li style="font-size:13px;color:#374151;margin-bottom:4px;line-height:1.6;">${b}</li>`).join("")}
// // // // // // // // // // // // // // //       </ul>
// // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // //   const eduHtml = (resume.education || []).map(edu => `
// // // // // // // // // // // // // // //     <div style="display:flex;justify-content:space-between;margin-bottom:8px;flex-wrap:wrap;gap:4px;">
// // // // // // // // // // // // // // //       <div>
// // // // // // // // // // // // // // //         <strong style="font-size:14px;color:#0f172a;">${edu.degree}</strong>
// // // // // // // // // // // // // // //         <span style="color:#475569;"> — ${edu.school}</span>
// // // // // // // // // // // // // // //         ${edu.location ? `<span style="color:#94a3b8;font-size:12px;"> | ${edu.location}</span>` : ""}
// // // // // // // // // // // // // // //         ${edu.gpa ? `<span style="color:#94a3b8;font-size:12px;"> | GPA: ${edu.gpa}</span>` : ""}
// // // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // // //       <span style="color:#64748b;font-size:12px;font-style:italic;">${edu.year || ""}</span>
// // // // // // // // // // // // // // //     </div>`).join("");

// // // // // // // // // // // // // // //   const skillsHtml = resume.skills ? [
// // // // // // // // // // // // // // //     resume.skills.technical?.length > 0 ? `<p style="margin:4px 0;font-size:13px;"><strong>Technical:</strong> ${resume.skills.technical.join(", ")}</p>` : "",
// // // // // // // // // // // // // // //     resume.skills.tools?.length > 0     ? `<p style="margin:4px 0;font-size:13px;"><strong>Tools:</strong> ${resume.skills.tools.join(", ")}</p>` : "",
// // // // // // // // // // // // // // //     resume.skills.soft?.length > 0      ? `<p style="margin:4px 0;font-size:13px;"><strong>Soft Skills:</strong> ${resume.skills.soft.join(", ")}</p>` : "",
// // // // // // // // // // // // // // //   ].join("") : "";

// // // // // // // // // // // // // // //   const certHtml = resume.certifications?.length > 0
// // // // // // // // // // // // // // //     ? `<ul style="margin:4px 0 0 20px;padding:0;">${resume.certifications.map(c => `<li style="font-size:13px;color:#374151;margin-bottom:4px;">${c}</li>`).join("")}</ul>`
// // // // // // // // // // // // // // //     : "";

// // // // // // // // // // // // // // //   function section(title, body) {
// // // // // // // // // // // // // // //     if (!body) return "";
// // // // // // // // // // // // // // //     return `<div style="margin-bottom:20px;"><div class="section-title">${title}</div>${body}</div>`;
// // // // // // // // // // // // // // //   }

// // // // // // // // // // // // // // //   const pageOpen  = templateId === "modern" ? `<div class="page">` : `<div class="page" style="max-width:800px;margin:0 auto;padding:36px 40px;">`;

// // // // // // // // // // // // // // //   const html = `<!DOCTYPE html>
// // // // // // // // // // // // // // // <html lang="en">
// // // // // // // // // // // // // // // <head>
// // // // // // // // // // // // // // //   <meta charset="utf-8"/>
// // // // // // // // // // // // // // //   <title>${name} — ${t.name}</title>
// // // // // // // // // // // // // // //   <style>
// // // // // // // // // // // // // // //     *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
// // // // // // // // // // // // // // //     body{color:#212529;background:#fff;font-size:14px;line-height:1.55;}
// // // // // // // // // // // // // // //     ${css}
// // // // // // // // // // // // // // //     @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}.page{padding:20px;}.no-print{display:none!important;}}
// // // // // // // // // // // // // // //   </style>
// // // // // // // // // // // // // // // </head>
// // // // // // // // // // // // // // // <body>
// // // // // // // // // // // // // // // ${pageOpen}
// // // // // // // // // // // // // // //   <div class="no-print" style="background:#eff6ff;border:1px solid #bfdbfe;border-radius:8px;padding:10px 16px;margin-bottom:20px;font-size:13px;color:#2563eb;">
// // // // // // // // // // // // // // //     <strong>To save as PDF:</strong> Press Ctrl+P (or Cmd+P) &rarr; Select "Save as PDF" &rarr; Click Save
// // // // // // // // // // // // // // //   </div>
// // // // // // // // // // // // // // //   ${headerHtml}
// // // // // // // // // // // // // // //   ${section("Professional Summary", resume.summary ? `<p style="font-size:13px;line-height:1.75;color:#374151;">${resume.summary}</p>` : "")}
// // // // // // // // // // // // // // //   ${section("Work Experience", expHtml)}
// // // // // // // // // // // // // // //   ${section("Education", eduHtml)}
// // // // // // // // // // // // // // //   ${section("Skills", skillsHtml)}
// // // // // // // // // // // // // // //   ${resume.certifications?.length > 0 ? section("Certifications", certHtml) : ""}
// // // // // // // // // // // // // // //   ${headerClose}
// // // // // // // // // // // // // // // </div>
// // // // // // // // // // // // // // // </body>
// // // // // // // // // // // // // // // </html>`;

// // // // // // // // // // // // // // //   const blob = new Blob([html], { type: "text/html;charset=utf-8" });
// // // // // // // // // // // // // // //   const url  = URL.createObjectURL(blob);
// // // // // // // // // // // // // // //   const a    = document.createElement("a");
// // // // // // // // // // // // // // //   a.href = url;
// // // // // // // // // // // // // // //   a.download = fileName || "ATS-Resume.html";
// // // // // // // // // // // // // // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // // // // // // // // // // // //   URL.revokeObjectURL(url);
// // // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // Above is corrected code------------------


// // // // // // // // // // // // // // // src/utils/generateResumeDoc.js

// // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // TEMPLATE DEFINITIONS
// // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // const TEMPLATES = {
// // // // // // // // // // // // // //   classic: { name: "Classic ATS", accentHex: "2563eb", headerHex: "1e293b" },
// // // // // // // // // // // // // //   modern: { name: "Modern Pro", accentHex: "7c3aed", headerHex: "7c3aed" },
// // // // // // // // // // // // // //   executive: { name: "Executive", accentHex: "334155", headerHex: "0f172a" },
// // // // // // // // // // // // // //   minimal: { name: "Minimal Clean", accentHex: "059669", headerHex: "059669" },
// // // // // // // // // // // // // //   corporate: { name: "Corporate", accentHex: "0369a1", headerHex: "0c4a6e" },
// // // // // // // // // // // // // //   creative: { name: "Creative", accentHex: "e11d48", headerHex: "881337" },
// // // // // // // // // // // // // //   technical: { name: "Technical", accentHex: "0891b2", headerHex: "164e63" },
// // // // // // // // // // // // // //   bold: { name: "Bold Impact", accentHex: "2563eb", headerHex: "1e3a8a" },
// // // // // // // // // // // // // //   elegant: { name: "Elegant", accentHex: "b45309", headerHex: "78350f" },
// // // // // // // // // // // // // //   academic: { name: "Academic", accentHex: "1e40af", headerHex: "1e3a8a" },
// // // // // // // // // // // // // //   professional: { name: "Professional", accentHex: "0f172a", headerHex: "0f172a" },
// // // // // // // // // // // // // //   compact: { name: "Compact", accentHex: "374151", headerHex: "111827" },
// // // // // // // // // // // // // //   cleanserif: { name: "Clean Serif", accentHex: "7c2d12", headerHex: "1a0a0a" },
// // // // // // // // // // // // // //   government: { name: "Government", accentHex: "1e3a5f", headerHex: "0f2540" },
// // // // // // // // // // // // // //   sidebarlight: { name: "Sidebar Light", accentHex: "0369a1", headerHex: "0c4a6e" },
// // // // // // // // // // // // // //   classic_bw: { name: "Classic B&W", accentHex: "000000", headerHex: "000000" },
// // // // // // // // // // // // // //   traditional: { name: "Traditional", accentHex: "1a1a1a", headerHex: "1a1a1a" },
// // // // // // // // // // // // // // };

// // // // // // // // // // // // // // function getTemplate(templateId) {
// // // // // // // // // // // // // //   return TEMPLATES[templateId] || TEMPLATES.classic;
// // // // // // // // // // // // // // }

// // // // // // // // // // // // // // function formatDateRange(startDate, endDate) {
// // // // // // // // // // // // // //   if (!startDate && !endDate) return "";
// // // // // // // // // // // // // //   if (startDate && !endDate) return startDate;
// // // // // // // // // // // // // //   if (!startDate && endDate) return endDate;
// // // // // // // // // // // // // //   return `${startDate} – ${endDate}`;
// // // // // // // // // // // // // // }

// // // // // // // // // // // // // // function escapeHtml(text) {
// // // // // // // // // // // // // //   if (!text) return "";
// // // // // // // // // // // // // //   return String(text)
// // // // // // // // // // // // // //     .replace(/&/g, "&amp;")
// // // // // // // // // // // // // //     .replace(/</g, "&lt;")
// // // // // // // // // // // // // //     .replace(/>/g, "&gt;")
// // // // // // // // // // // // // //     .replace(/"/g, "&quot;")
// // // // // // // // // // // // // //     .replace(/'/g, "&#39;");
// // // // // // // // // // // // // // }

// // // // // // // // // // // // // // function cleanResumeData(resume) {
// // // // // // // // // // // // // //   if (!resume || typeof resume !== 'object') {
// // // // // // // // // // // // // //     return {
// // // // // // // // // // // // // //       name: "", email: "", phone: "", location: "", linkedin: "", title: "",
// // // // // // // // // // // // // //       summary: "", experience: [], education: [], skills: { technical: [], tools: [], soft: [] }, certifications: []
// // // // // // // // // // // // // //     };
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   return {
// // // // // // // // // // // // // //     name: resume.name || resume.userName || "",
// // // // // // // // // // // // // //     email: resume.email || resume.userEmail || "",
// // // // // // // // // // // // // //     phone: resume.phone || resume.userPhone || "",
// // // // // // // // // // // // // //     location: resume.location || resume.userLocation || "",
// // // // // // // // // // // // // //     linkedin: resume.linkedin || "",
// // // // // // // // // // // // // //     title: resume.title || resume.currentRole || (resume.experience && resume.experience[0] && resume.experience[0].title) || "",
// // // // // // // // // // // // // //     summary: (resume.summary && typeof resume.summary === 'string') ? resume.summary : "",
// // // // // // // // // // // // // //     experience: (resume.experience && Array.isArray(resume.experience)) ? resume.experience : [],
// // // // // // // // // // // // // //     education: (resume.education && Array.isArray(resume.education)) ? resume.education : [],
// // // // // // // // // // // // // //     skills: (resume.skills && typeof resume.skills === 'object') ? {
// // // // // // // // // // // // // //       technical: resume.skills.technical || [],
// // // // // // // // // // // // // //       tools: resume.skills.tools || [],
// // // // // // // // // // // // // //       soft: resume.skills.soft || []
// // // // // // // // // // // // // //     } : { technical: [], tools: [], soft: [] },
// // // // // // // // // // // // // //     certifications: (resume.certifications && Array.isArray(resume.certifications)) ? resume.certifications : []
// // // // // // // // // // // // // //   };
// // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // BROWSER HTML GENERATOR (For PDF and HTML download)
// // // // // // // // // // // // // // // Uses modern CSS - works in browsers
// // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // function generateBrowserHTML(resumeData, templateId) {
// // // // // // // // // // // // // //   const resume = cleanResumeData(resumeData);
// // // // // // // // // // // // // //   const t = getTemplate(templateId);
// // // // // // // // // // // // // //   const accentColor = t.accentHex;
// // // // // // // // // // // // // //   const headerBg = t.headerHex;
  
// // // // // // // // // // // // // //   const name = escapeHtml(resume.name) || "Your Name";
// // // // // // // // // // // // // //   const title = escapeHtml(resume.title);
  
// // // // // // // // // // // // // //   const contacts = [];
// // // // // // // // // // // // // //   if (resume.email) contacts.push(escapeHtml(resume.email));
// // // // // // // // // // // // // //   if (resume.phone) contacts.push(escapeHtml(resume.phone));
// // // // // // // // // // // // // //   if (resume.location) contacts.push(escapeHtml(resume.location));
// // // // // // // // // // // // // //   if (resume.linkedin) contacts.push(escapeHtml(resume.linkedin));
  
// // // // // // // // // // // // // //   const summary = escapeHtml(resume.summary);
  
// // // // // // // // // // // // // //   // Experience
// // // // // // // // // // // // // //   let experienceHtml = "";
// // // // // // // // // // // // // //   if (resume.experience.length > 0) {
// // // // // // // // // // // // // //     resume.experience.forEach(exp => {
// // // // // // // // // // // // // //       if (exp && exp.title) {
// // // // // // // // // // // // // //         experienceHtml += `
// // // // // // // // // // // // // //           <div class="exp-item">
// // // // // // // // // // // // // //             <div class="exp-header">
// // // // // // // // // // // // // //               <strong>${escapeHtml(exp.title)}</strong>
// // // // // // // // // // // // // //               <span class="exp-date">${formatDateRange(exp.startDate, exp.endDate)}</span>
// // // // // // // // // // // // // //             </div>
// // // // // // // // // // // // // //             <div class="exp-company">${escapeHtml(exp.company || "")}${exp.location ? ` | ${escapeHtml(exp.location)}` : ""}</div>
// // // // // // // // // // // // // //             <ul class="exp-bullets">
// // // // // // // // // // // // // //               ${(exp.bullets || []).map(b => `<li>${escapeHtml(b)}</li>`).join("")}
// // // // // // // // // // // // // //             </ul>
// // // // // // // // // // // // // //           </div>
// // // // // // // // // // // // // //         `;
// // // // // // // // // // // // // //       }
// // // // // // // // // // // // // //     });
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   // Education
// // // // // // // // // // // // // //   let educationHtml = "";
// // // // // // // // // // // // // //   if (resume.education.length > 0) {
// // // // // // // // // // // // // //     resume.education.forEach(edu => {
// // // // // // // // // // // // // //       if (edu && edu.degree) {
// // // // // // // // // // // // // //         educationHtml += `
// // // // // // // // // // // // // //           <div class="edu-item">
// // // // // // // // // // // // // //             <div class="edu-header">
// // // // // // // // // // // // // //               <strong>${escapeHtml(edu.degree)}</strong>
// // // // // // // // // // // // // //               <span class="edu-year">${escapeHtml(edu.year || "")}</span>
// // // // // // // // // // // // // //             </div>
// // // // // // // // // // // // // //             <div class="edu-school">${escapeHtml(edu.school || "")}${edu.location ? `, ${escapeHtml(edu.location)}` : ""}</div>
// // // // // // // // // // // // // //             ${edu.gpa ? `<div class="edu-gpa">GPA: ${escapeHtml(edu.gpa)}</div>` : ""}
// // // // // // // // // // // // // //           </div>
// // // // // // // // // // // // // //         `;
// // // // // // // // // // // // // //       }
// // // // // // // // // // // // // //     });
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   // Skills
// // // // // // // // // // // // // //   let skillsHtml = "";
// // // // // // // // // // // // // //   const skills = resume.skills;
// // // // // // // // // // // // // //   if (skills.technical && skills.technical.length) {
// // // // // // // // // // // // // //     skillsHtml += `<p><strong>Technical:</strong> ${skills.technical.map(s => escapeHtml(s)).join(", ")}</p>`;
// // // // // // // // // // // // // //   }
// // // // // // // // // // // // // //   if (skills.tools && skills.tools.length) {
// // // // // // // // // // // // // //     skillsHtml += `<p><strong>Tools:</strong> ${skills.tools.map(s => escapeHtml(s)).join(", ")}</p>`;
// // // // // // // // // // // // // //   }
// // // // // // // // // // // // // //   if (skills.soft && skills.soft.length) {
// // // // // // // // // // // // // //     skillsHtml += `<p><strong>Soft Skills:</strong> ${skills.soft.map(s => escapeHtml(s)).join(", ")}</p>`;
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   // Certifications
// // // // // // // // // // // // // //   let certHtml = "";
// // // // // // // // // // // // // //   if (resume.certifications.length > 0) {
// // // // // // // // // // // // // //     certHtml = `<ul class="cert-list">${resume.certifications.map(c => `<li>${escapeHtml(c)}</li>`).join("")}</ul>`;
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   const isTwoColumn = templateId === "modern" || templateId === "sidebarlight";
// // // // // // // // // // // // // //   const isDarkHeader = ["bold", "executive", "corporate", "professional", "government", "academic"].includes(templateId);
// // // // // // // // // // // // // //   const isMinimal = templateId === "minimal";
// // // // // // // // // // // // // //   const isBold = templateId === "bold";
// // // // // // // // // // // // // //   // eslint-disable-next-line no-unused-vars
// // // // // // // // // // // // // //   const isExecutive = templateId === "executive";
  
// // // // // // // // // // // // // //   const sectionClass = (isBold || templateId === "modern") ? "section-filled" : "section-underlined";
  
// // // // // // // // // // // // // //   // Build header
// // // // // // // // // // // // // //   let headerHtml = "";
// // // // // // // // // // // // // //   let mainClose = "";
  
// // // // // // // // // // // // // //   if (isTwoColumn) {
// // // // // // // // // // // // // //     const initial = name.charAt(0).toUpperCase();
// // // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // // //       <div class="two-column">
// // // // // // // // // // // // // //         <div class="sidebar" style="background: #${headerBg};">
// // // // // // // // // // // // // //           <div class="avatar">${initial}</div>
// // // // // // // // // // // // // //           <div class="sidebar-name">${name}</div>
// // // // // // // // // // // // // //           ${title ? `<div class="sidebar-title">${title}</div>` : ""}
// // // // // // // // // // // // // //           <div class="sidebar-contact">${contacts.map(c => `<div>${c}</div>`).join("")}</div>
// // // // // // // // // // // // // //         </div>
// // // // // // // // // // // // // //         <div class="main-content">
// // // // // // // // // // // // // //     `;
// // // // // // // // // // // // // //     mainClose = `</div></div>`;
// // // // // // // // // // // // // //   } else if (isDarkHeader) {
// // // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // // //       <div class="dark-header" style="background: #${headerBg};">
// // // // // // // // // // // // // //         <div class="dark-name">${name}</div>
// // // // // // // // // // // // // //         ${title ? `<div class="dark-title">${title}</div>` : ""}
// // // // // // // // // // // // // //         <div class="dark-contact">${contacts.map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // //       <div class="dark-body">
// // // // // // // // // // // // // //     `;
// // // // // // // // // // // // // //     mainClose = `</div>`;
// // // // // // // // // // // // // //   } else {
// // // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // // //       <div class="standard-header" style="border-bottom-color: #${accentColor};">
// // // // // // // // // // // // // //         <div class="standard-name">${name}</div>
// // // // // // // // // // // // // //         ${title && !isMinimal ? `<div class="standard-title">${title}</div>` : ""}
// // // // // // // // // // // // // //         ${isMinimal ? `<div class="minimal-bar" style="background: #${accentColor};"></div>` : ""}
// // // // // // // // // // // // // //         <div class="standard-contact">${contacts.map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // //     `;
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   function renderSection(sectionTitle, content) {
// // // // // // // // // // // // // //     if (!content || content === "") return "";
// // // // // // // // // // // // // //     return `
// // // // // // // // // // // // // //       <div class="section">
// // // // // // // // // // // // // //         <div class="${sectionClass}" style="color: #${accentColor}; border-bottom-color: #${accentColor}; border-left-color: #${accentColor}; background: #${accentColor}18;">${sectionTitle}</div>
// // // // // // // // // // // // // //         <div class="section-content">${content}</div>
// // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // //     `;
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   return `<!DOCTYPE html>
// // // // // // // // // // // // // // <html>
// // // // // // // // // // // // // // <head>
// // // // // // // // // // // // // //   <meta charset="UTF-8">
// // // // // // // // // // // // // //   <title>${name} - Resume</title>
// // // // // // // // // // // // // //   <style>
// // // // // // // // // // // // // //     * { margin: 0; padding: 0; box-sizing: border-box; }
// // // // // // // // // // // // // //     body {
// // // // // // // // // // // // // //       font-family: 'Helvetica Neue', Helvetica, Arial, 'Segoe UI', sans-serif;
// // // // // // // // // // // // // //       font-size: 14px;
// // // // // // // // // // // // // //       line-height: 1.5;
// // // // // // // // // // // // // //       color: #1a202c;
// // // // // // // // // // // // // //       background: #e8e8e8;
// // // // // // // // // // // // // //     }
// // // // // // // // // // // // // //     .resume {
// // // // // // // // // // // // // //       max-width: 850px;
// // // // // // // // // // // // // //       margin: 20px auto;
// // // // // // // // // // // // // //       background: white;
// // // // // // // // // // // // // //       box-shadow: 0 4px 12px rgba(0,0,0,0.1);
// // // // // // // // // // // // // //     }
// // // // // // // // // // // // // //     .section {
// // // // // // // // // // // // // //       margin-bottom: 24px;
// // // // // // // // // // // // // //       padding: 0 40px;
// // // // // // // // // // // // // //     }
// // // // // // // // // // // // // //     .section-underlined {
// // // // // // // // // // // // // //       font-size: 11px;
// // // // // // // // // // // // // //       font-weight: 800;
// // // // // // // // // // // // // //       text-transform: uppercase;
// // // // // // // // // // // // // //       letter-spacing: 0.1em;
// // // // // // // // // // // // // //       border-bottom: 1.5px solid;
// // // // // // // // // // // // // //       padding-bottom: 4px;
// // // // // // // // // // // // // //       margin-bottom: 12px;
// // // // // // // // // // // // // //     }
// // // // // // // // // // // // // //     .section-filled {
// // // // // // // // // // // // // //       font-size: 11px;
// // // // // // // // // // // // // //       font-weight: 800;
// // // // // // // // // // // // // //       text-transform: uppercase;
// // // // // // // // // // // // // //       letter-spacing: 0.1em;
// // // // // // // // // // // // // //       border-left: 3px solid;
// // // // // // // // // // // // // //       padding: 6px 12px;
// // // // // // // // // // // // // //       margin-bottom: 12px;
// // // // // // // // // // // // // //       border-radius: 0 6px 6px 0;
// // // // // // // // // // // // // //     }
// // // // // // // // // // // // // //     .section-content { margin-top: 12px; }
// // // // // // // // // // // // // //     .standard-header {
// // // // // // // // // // // // // //       border-bottom: 2px solid;
// // // // // // // // // // // // // //       padding: 30px 40px 20px;
// // // // // // // // // // // // // //       margin-bottom: 24px;
// // // // // // // // // // // // // //       text-align: center;
// // // // // // // // // // // // // //     }
// // // // // // // // // // // // // //     .standard-name { font-size: 28px; font-weight: 700; margin-bottom: 5px; }
// // // // // // // // // // // // // //     .standard-title { font-size: 14px; color: #4a5568; margin-bottom: 10px; }
// // // // // // // // // // // // // //     .minimal-bar { width: 40px; height: 3px; margin: 10px auto 12px; }
// // // // // // // // // // // // // //     .standard-contact { display: flex; flex-wrap: wrap; justify-content: center; gap: 16px; font-size: 12px; color: #718096; margin-top: 12px; }
// // // // // // // // // // // // // //     .dark-header { padding: 30px 40px; color: #fff; }
// // // // // // // // // // // // // //     .dark-name { font-size: 36px; font-weight: 900; letter-spacing: -1px; margin-bottom: 8px; }
// // // // // // // // // // // // // //     .dark-title { font-size: 14px; opacity: 0.8; margin-bottom: 15px; }
// // // // // // // // // // // // // //     .dark-contact { display: flex; flex-wrap: wrap; gap: 20px; font-size: 12px; opacity: 0.7; }
// // // // // // // // // // // // // //     .dark-body { padding: 30px 40px; background: #fff; }
// // // // // // // // // // // // // //     .two-column { display: flex; }
// // // // // // // // // // // // // //     .sidebar { width: 30%; padding: 30px 20px; color: #fff; }
// // // // // // // // // // // // // //     .avatar { width: 70px; height: 70px; border-radius: 50%; background: rgba(255,255,255,0.15); display: flex; align-items: center; justify-content: center; margin-bottom: 20px; font-size: 28px; font-weight: bold; }
// // // // // // // // // // // // // //     .sidebar-name { font-size: 18px; font-weight: 800; margin-bottom: 8px; }
// // // // // // // // // // // // // //     .sidebar-title { font-size: 11px; opacity: 0.8; margin-bottom: 25px; }
// // // // // // // // // // // // // //     .sidebar-contact { font-size: 10px; opacity: 0.7; }
// // // // // // // // // // // // // //     .sidebar-contact div { margin-bottom: 6px; }
// // // // // // // // // // // // // //     .main-content { width: 70%; padding: 30px 25px; background: #fff; }
// // // // // // // // // // // // // //     .exp-item { margin-bottom: 20px; }
// // // // // // // // // // // // // //     .exp-header { display: flex; justify-content: space-between; flex-wrap: wrap; margin-bottom: 5px; }
// // // // // // // // // // // // // //     .exp-date { font-size: 12px; color: #666; }
// // // // // // // // // // // // // //     .exp-company { font-size: 12px; color: #555; margin-bottom: 8px; }
// // // // // // // // // // // // // //     .exp-bullets { margin: 0 0 0 20px; padding: 0; }
// // // // // // // // // // // // // //     .exp-bullets li { margin-bottom: 5px; font-size: 13px; line-height: 1.5; }
// // // // // // // // // // // // // //     .edu-item { margin-bottom: 15px; }
// // // // // // // // // // // // // //     .edu-header { display: flex; justify-content: space-between; flex-wrap: wrap; }
// // // // // // // // // // // // // //     .edu-year { font-size: 12px; color: #666; }
// // // // // // // // // // // // // //     .edu-school { font-size: 13px; color: #555; }
// // // // // // // // // // // // // //     .edu-gpa { font-size: 12px; color: #666; }
// // // // // // // // // // // // // //     p { margin: 0 0 8px 0; }
// // // // // // // // // // // // // //     .cert-list { margin: 0 0 0 20px; padding: 0; }
// // // // // // // // // // // // // //     .cert-list li { margin-bottom: 5px; }
// // // // // // // // // // // // // //     @media print {
// // // // // // // // // // // // // //       body { background: white; padding: 0; margin: 0; }
// // // // // // // // // // // // // //       .resume { margin: 0; box-shadow: none; }
// // // // // // // // // // // // // //       .dark-header, .sidebar { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
// // // // // // // // // // // // // //       @page { size: A4; margin: 0.5in; }
// // // // // // // // // // // // // //     }
// // // // // // // // // // // // // //   </style>
// // // // // // // // // // // // // // </head>
// // // // // // // // // // // // // // <body>
// // // // // // // // // // // // // // <div class="resume">
// // // // // // // // // // // // // //   ${headerHtml}
// // // // // // // // // // // // // //   ${summary ? renderSection("PROFESSIONAL SUMMARY", `<p>${summary}</p>`) : ""}
// // // // // // // // // // // // // //   ${experienceHtml ? renderSection("WORK EXPERIENCE", experienceHtml) : ""}
// // // // // // // // // // // // // //   ${educationHtml ? renderSection("EDUCATION", educationHtml) : ""}
// // // // // // // // // // // // // //   ${skillsHtml ? renderSection("SKILLS", skillsHtml) : ""}
// // // // // // // // // // // // // //   ${certHtml ? renderSection("CERTIFICATIONS", certHtml) : ""}
// // // // // // // // // // // // // //   ${mainClose}
// // // // // // // // // // // // // // </div>
// // // // // // // // // // // // // // </body>
// // // // // // // // // // // // // // </html>`;
// // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // WORD-SPECIFIC GENERATOR (Uses tables, no flexbox)
// // // // // // // // // // // // // // // Word renders this perfectly
// // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // function generateWordHTML(resumeData, templateId) {
// // // // // // // // // // // // // //   const resume = cleanResumeData(resumeData);
// // // // // // // // // // // // // //   const t = getTemplate(templateId);
// // // // // // // // // // // // // //   const accentColor = t.accentHex;
// // // // // // // // // // // // // //   const headerBg = t.headerHex;
  
// // // // // // // // // // // // // //   const name = escapeHtml(resume.name) || "Your Name";
// // // // // // // // // // // // // //   const title = escapeHtml(resume.title);
  
// // // // // // // // // // // // // //   const contacts = [];
// // // // // // // // // // // // // //   if (resume.email) contacts.push(escapeHtml(resume.email));
// // // // // // // // // // // // // //   if (resume.phone) contacts.push(escapeHtml(resume.phone));
// // // // // // // // // // // // // //   if (resume.location) contacts.push(escapeHtml(resume.location));
// // // // // // // // // // // // // //   if (resume.linkedin) contacts.push(escapeHtml(resume.linkedin));
  
// // // // // // // // // // // // // //   const summary = escapeHtml(resume.summary);
  
// // // // // // // // // // // // // //   // Experience - Word compatible (no flexbox)
// // // // // // // // // // // // // //   let experienceHtml = "";
// // // // // // // // // // // // // //   if (resume.experience.length > 0) {
// // // // // // // // // // // // // //     resume.experience.forEach(exp => {
// // // // // // // // // // // // // //       if (exp && exp.title) {
// // // // // // // // // // // // // //         experienceHtml += `
// // // // // // // // // // // // // //           <div style="margin-bottom: 16px;">
// // // // // // // // // // // // // //             <table width="100%" cellpadding="0" cellspacing="0" style="margin-bottom: 4px;">
// // // // // // // // // // // // // //               <tr>
// // // // // // // // // // // // // //                 <td align="left"><strong>${escapeHtml(exp.title)}</strong></td>
// // // // // // // // // // // // // //                 <td align="right" style="color: #666; font-size: 12px;">${formatDateRange(exp.startDate, exp.endDate)}</td>
// // // // // // // // // // // // // //               </tr>
// // // // // // // // // // // // // //             </table>
// // // // // // // // // // // // // //             <div style="font-size: 12px; color: #555; margin-bottom: 8px;">${escapeHtml(exp.company || "")}${exp.location ? ` | ${escapeHtml(exp.location)}` : ""}</div>
// // // // // // // // // // // // // //             <ul style="margin: 0 0 0 20px;">
// // // // // // // // // // // // // //               ${(exp.bullets || []).map(b => `<li style="margin-bottom: 4px; font-size: 13px;">${escapeHtml(b)}</li>`).join("")}
// // // // // // // // // // // // // //             </ul>
// // // // // // // // // // // // // //           </div>
// // // // // // // // // // // // // //         `;
// // // // // // // // // // // // // //       }
// // // // // // // // // // // // // //     });
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   // Education
// // // // // // // // // // // // // //   let educationHtml = "";
// // // // // // // // // // // // // //   if (resume.education.length > 0) {
// // // // // // // // // // // // // //     resume.education.forEach(edu => {
// // // // // // // // // // // // // //       if (edu && edu.degree) {
// // // // // // // // // // // // // //         educationHtml += `
// // // // // // // // // // // // // //           <div style="margin-bottom: 12px;">
// // // // // // // // // // // // // //             <table width="100%" cellpadding="0" cellspacing="0">
// // // // // // // // // // // // // //               <tr>
// // // // // // // // // // // // // //                 <td align="left"><strong>${escapeHtml(edu.degree)}</strong></td>
// // // // // // // // // // // // // //                 <td align="right" style="color: #666; font-size: 12px;">${escapeHtml(edu.year || "")}</td>
// // // // // // // // // // // // // //               </tr>
// // // // // // // // // // // // // //             </table>
// // // // // // // // // // // // // //             <div style="font-size: 13px; color: #555;">${escapeHtml(edu.school || "")}${edu.location ? `, ${escapeHtml(edu.location)}` : ""}</div>
// // // // // // // // // // // // // //             ${edu.gpa ? `<div style="font-size: 12px; color: #666; margin-top: 2px;">GPA: ${escapeHtml(edu.gpa)}</div>` : ""}
// // // // // // // // // // // // // //           </div>
// // // // // // // // // // // // // //         `;
// // // // // // // // // // // // // //       }
// // // // // // // // // // // // // //     });
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   // Skills
// // // // // // // // // // // // // //   let skillsHtml = "";
// // // // // // // // // // // // // //   const skills = resume.skills;
// // // // // // // // // // // // // //   if (skills.technical && skills.technical.length) {
// // // // // // // // // // // // // //     skillsHtml += `<p style="margin: 0 0 8px 0;"><strong>Technical:</strong> ${skills.technical.map(s => escapeHtml(s)).join(", ")}</p>`;
// // // // // // // // // // // // // //   }
// // // // // // // // // // // // // //   if (skills.tools && skills.tools.length) {
// // // // // // // // // // // // // //     skillsHtml += `<p style="margin: 0 0 8px 0;"><strong>Tools:</strong> ${skills.tools.map(s => escapeHtml(s)).join(", ")}</p>`;
// // // // // // // // // // // // // //   }
// // // // // // // // // // // // // //   if (skills.soft && skills.soft.length) {
// // // // // // // // // // // // // //     skillsHtml += `<p style="margin: 0 0 8px 0;"><strong>Soft Skills:</strong> ${skills.soft.map(s => escapeHtml(s)).join(", ")}</p>`;
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   // Certifications
// // // // // // // // // // // // // //   let certHtml = "";
// // // // // // // // // // // // // //   if (resume.certifications.length > 0) {
// // // // // // // // // // // // // //     certHtml = `<ul style="margin: 0 0 0 20px;">${resume.certifications.map(c => `<li>${escapeHtml(c)}</li>`).join("")}</ul>`;
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   const isTwoColumn = templateId === "modern" || templateId === "sidebarlight";
// // // // // // // // // // // // // //   const isDarkHeader = ["bold", "executive", "corporate", "professional", "government", "academic"].includes(templateId);
// // // // // // // // // // // // // //   const isMinimal = templateId === "minimal";
  
// // // // // // // // // // // // // //   // Section title style for Word (simple)
// // // // // // // // // // // // // //   const sectionTitleStyle = `font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em; color: #${accentColor}; border-bottom: 1px solid #${accentColor}; padding-bottom: 4px; margin: 0 0 12px 0;`;
  
// // // // // // // // // // // // // //   function renderSection(titleText, content) {
// // // // // // // // // // // // // //     if (!content || content === "") return "";
// // // // // // // // // // // // // //     return `<div style="margin-bottom: 20px;"><div style="${sectionTitleStyle}">${titleText}</div><div style="margin-top: 10px;">${content}</div></div>`;
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   // Header for Word (tables, no flexbox)
// // // // // // // // // // // // // //   let headerHtml = "";
  
// // // // // // // // // // // // // //   if (isTwoColumn) {
// // // // // // // // // // // // // //     const initial = name.charAt(0).toUpperCase();
// // // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // // //       <table width="100%" cellpadding="0" cellspacing="0" style="background: #${headerBg}; color: #fff;">
// // // // // // // // // // // // // //         <tr>
// // // // // // // // // // // // // //           <td width="30%" valign="top" style="padding: 30px 20px;">
// // // // // // // // // // // // // //             <div style="width: 70px; height: 70px; background: rgba(255,255,255,0.15); border-radius: 50%; margin-bottom: 20px; text-align: center; line-height: 70px; font-size: 28px; font-weight: bold;">${initial}</div>
// // // // // // // // // // // // // //             <div style="font-size: 18px; font-weight: 800; margin-bottom: 8px;">${name}</div>
// // // // // // // // // // // // // //             ${title ? `<div style="font-size: 11px; opacity: 0.8; margin-bottom: 25px;">${title}</div>` : ""}
// // // // // // // // // // // // // //             <div style="font-size: 10px; opacity: 0.7;">
// // // // // // // // // // // // // //               ${contacts.map(c => `<div style="margin-bottom: 6px;">${c}</div>`).join("")}
// // // // // // // // // // // // // //             </div>
// // // // // // // // // // // // // //           </td>
// // // // // // // // // // // // // //           <td width="70%" valign="top" style="padding: 30px 25px; background: #fff;">
// // // // // // // // // // // // // //     `;
// // // // // // // // // // // // // //     headerHtml += `</td></tr></table>`;
// // // // // // // // // // // // // //   } else if (isDarkHeader) {
// // // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // // //       <div style="background: #${headerBg}; padding: 30px 40px; color: #fff;">
// // // // // // // // // // // // // //         <div style="font-size: 36px; font-weight: 900; letter-spacing: -1px; margin-bottom: 8px;">${name}</div>
// // // // // // // // // // // // // //         ${title ? `<div style="font-size: 14px; opacity: 0.8; margin-bottom: 15px;">${title}</div>` : ""}
// // // // // // // // // // // // // //         <div style="font-size: 12px; opacity: 0.7;">${contacts.join(" | ")}</div>
// // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // //       <div style="padding: 30px 40px; background: #fff;">
// // // // // // // // // // // // // //     `;
// // // // // // // // // // // // // //     headerHtml += `</div>`;
// // // // // // // // // // // // // //   } else {
// // // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // // //       <div style="border-bottom: 2px solid #${accentColor}; padding-bottom: 20px; margin-bottom: 24px; text-align: center;">
// // // // // // // // // // // // // //         <div style="font-size: 28px; font-weight: 700; margin-bottom: 5px;">${name}</div>
// // // // // // // // // // // // // //         ${title && !isMinimal ? `<div style="font-size: 14px; color: #4a5568; margin-bottom: 10px;">${title}</div>` : ""}
// // // // // // // // // // // // // //         ${isMinimal ? `<div style="width: 40px; height: 3px; background: #${accentColor}; margin: 10px auto 12px;"></div>` : ""}
// // // // // // // // // // // // // //         <div style="font-size: 12px; color: #718096;">${contacts.join(" | ")}</div>
// // // // // // // // // // // // // //       </div>
// // // // // // // // // // // // // //     `;
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   return `<!DOCTYPE html>
// // // // // // // // // // // // // // <html>
// // // // // // // // // // // // // // <head>
// // // // // // // // // // // // // //   <meta charset="UTF-8">
// // // // // // // // // // // // // //   <meta name="ProgId" content="Word.Document">
// // // // // // // // // // // // // //   <meta name="Generator" content="Microsoft Word 15">
// // // // // // // // // // // // // //   <title>${name} - Resume</title>
// // // // // // // // // // // // // //   <style>
// // // // // // // // // // // // // //     body {
// // // // // // // // // // // // // //       font-family: 'Calibri', 'Arial', sans-serif;
// // // // // // // // // // // // // //       font-size: 12pt;
// // // // // // // // // // // // // //       line-height: 1.4;
// // // // // // // // // // // // // //       margin: 1in auto;
// // // // // // // // // // // // // //       max-width: 8.5in;
// // // // // // // // // // // // // //     }
// // // // // // // // // // // // // //     table {
// // // // // // // // // // // // // //       border-collapse: collapse;
// // // // // // // // // // // // // //     }
// // // // // // // // // // // // // //     ul, ol {
// // // // // // // // // // // // // //       margin: 4px 0 4px 20px;
// // // // // // // // // // // // // //       padding: 0;
// // // // // // // // // // // // // //     }
// // // // // // // // // // // // // //     li {
// // // // // // // // // // // // // //       margin-bottom: 4px;
// // // // // // // // // // // // // //     }
// // // // // // // // // // // // // //   </style>
// // // // // // // // // // // // // // </head>
// // // // // // // // // // // // // // <body>
// // // // // // // // // // // // // // ${headerHtml}
// // // // // // // // // // // // // // ${summary ? renderSection("PROFESSIONAL SUMMARY", `<p>${summary}</p>`) : ""}
// // // // // // // // // // // // // // ${experienceHtml ? renderSection("WORK EXPERIENCE", experienceHtml) : ""}
// // // // // // // // // // // // // // ${educationHtml ? renderSection("EDUCATION", educationHtml) : ""}
// // // // // // // // // // // // // // ${skillsHtml ? renderSection("SKILLS", skillsHtml) : ""}
// // // // // // // // // // // // // // ${certHtml ? renderSection("CERTIFICATIONS", certHtml) : ""}
// // // // // // // // // // // // // // </body>
// // // // // // // // // // // // // // </html>`;
// // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // PDF DOWNLOAD - Uses browser HTML
// // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // export function downloadResumeAsPDF(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // //   const html = generateBrowserHTML(resume, templateId);
// // // // // // // // // // // // // //   const blob = new Blob([html], { type: "text/html" });
// // // // // // // // // // // // // //   const url = URL.createObjectURL(blob);
  
// // // // // // // // // // // // // //   const printWindow = window.open(url, "_blank");
// // // // // // // // // // // // // //   if (!printWindow) {
// // // // // // // // // // // // // //     const a = document.createElement("a");
// // // // // // // // // // // // // //     a.href = url;
// // // // // // // // // // // // // //     a.download = (fileName || "resume").replace(/\.pdf$/i, "") + ".html";
// // // // // // // // // // // // // //     document.body.appendChild(a);
// // // // // // // // // // // // // //     a.click();
// // // // // // // // // // // // // //     document.body.removeChild(a);
// // // // // // // // // // // // // //     URL.revokeObjectURL(url);
// // // // // // // // // // // // // //     return;
// // // // // // // // // // // // // //   }
  
// // // // // // // // // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 1000);
// // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // WORD DOWNLOAD - Uses Word-specific HTML
// // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // export function downloadResumeAsWord(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // //   const html = generateWordHTML(resume, templateId);
  
// // // // // // // // // // // // // //   const blob = new Blob([html], { type: "application/msword" });
// // // // // // // // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // // // // // // // //   const a = document.createElement("a");
// // // // // // // // // // // // // //   a.href = url;
// // // // // // // // // // // // // //   a.download = (fileName || "resume").replace(/\.(doc|docx)$/i, "") + ".doc";
// // // // // // // // // // // // // //   document.body.appendChild(a);
// // // // // // // // // // // // // //   a.click();
// // // // // // // // // // // // // //   document.body.removeChild(a);
// // // // // // // // // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 100);
// // // // // // // // // // // // // // }

// // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // // HTML DOWNLOAD - Uses browser HTML
// // // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // export function downloadATSResume(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // // //   const html = generateBrowserHTML(resume, templateId);
// // // // // // // // // // // // // //   const blob = new Blob([html], { type: "text/html" });
// // // // // // // // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // // // // // // // //   const a = document.createElement("a");
// // // // // // // // // // // // // //   a.href = url;
// // // // // // // // // // // // // //   a.download = (fileName || "resume").replace(/\.html$/i, "") + ".html";
// // // // // // // // // // // // // //   document.body.appendChild(a);
// // // // // // // // // // // // // //   a.click();
// // // // // // // // // // // // // //   document.body.removeChild(a);
// // // // // // // // // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 100);
// // // // // // // // // // // // // // }


// // // // // // // // // // // // // //---------- below code is new updated

// // // // // // // // // // // // // // src/utils/generateResumeDoc.js

// // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // TEMPLATE DEFINITIONS
// // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // const TEMPLATES = {
// // // // // // // // // // // // //   // Existing templates
// // // // // // // // // // // // //   classic: { name: "Classic ATS", accentHex: "2563eb", headerHex: "1e293b", style: "underline", category: "professional" },
// // // // // // // // // // // // //   modern: { name: "Modern Pro", accentHex: "7c3aed", headerHex: "7c3aed", style: "filled", category: "modern" },
// // // // // // // // // // // // //   executive: { name: "Executive", accentHex: "334155", headerHex: "0f172a", style: "thick", category: "executive" },
// // // // // // // // // // // // //   minimal: { name: "Minimal Clean", accentHex: "059669", headerHex: "059669", style: "underline", category: "clean" },
// // // // // // // // // // // // //   corporate: { name: "Corporate", accentHex: "0369a1", headerHex: "0c4a6e", style: "filled", category: "corporate" },
// // // // // // // // // // // // //   creative: { name: "Creative", accentHex: "e11d48", headerHex: "881337", style: "thick", category: "creative" },
// // // // // // // // // // // // //   technical: { name: "Technical", accentHex: "0891b2", headerHex: "164e63", style: "underline", category: "technical" },
// // // // // // // // // // // // //   bold: { name: "Bold Impact", accentHex: "2563eb", headerHex: "1e3a8a", style: "filled", category: "bold" },
// // // // // // // // // // // // //   elegant: { name: "Elegant", accentHex: "b45309", headerHex: "78350f", style: "thick", category: "elegant" },
// // // // // // // // // // // // //   academic: { name: "Academic", accentHex: "1e40af", headerHex: "1e3a8a", style: "thick", category: "academic" },
// // // // // // // // // // // // //   professional: { name: "Professional", accentHex: "0f172a", headerHex: "0f172a", style: "filled", category: "professional" },
// // // // // // // // // // // // //   compact: { name: "Compact", accentHex: "374151", headerHex: "111827", style: "filled", category: "compact" },
// // // // // // // // // // // // //   cleanserif: { name: "Clean Serif", accentHex: "7c2d12", headerHex: "1a0a0a", style: "thick", category: "serif" },
// // // // // // // // // // // // //   government: { name: "Government", accentHex: "1e3a5f", headerHex: "0f2540", style: "filled", category: "formal" },
// // // // // // // // // // // // //   sidebarlight: { name: "Sidebar Light", accentHex: "0369a1", headerHex: "0c4a6e", style: "filled", category: "sidebar" },
// // // // // // // // // // // // //   classic_bw: { name: "Classic B&W", accentHex: "000000", headerHex: "000000", style: "underline", category: "blackwhite" },
// // // // // // // // // // // // //   traditional: { name: "Traditional", accentHex: "1a1a1a", headerHex: "1a1a1a", style: "thick", category: "traditional" },
// // // // // // // // // // // // //   // New templates
// // // // // // // // // // // // //   ats_optimized: { name: "ATS Optimized", accentHex: "2d3748", headerHex: "1a202c", style: "simple", category: "ats" },
// // // // // // // // // // // // //   horizontal: { name: "Horizontal Header", accentHex: "2563eb", headerHex: "ffffff", style: "horizontal", category: "modern" },
// // // // // // // // // // // // //   border_accent: { name: "Border Accent", accentHex: "2563eb", headerHex: "f8fafc", style: "border", category: "clean" },
// // // // // // // // // // // // //   timeline: { name: "Timeline", accentHex: "0f172a", headerHex: "f1f5f9", style: "timeline", category: "modern" },
// // // // // // // // // // // // //   dual_accent: { name: "Dual Accent", accentHex: "2563eb", accentSecondaryHex: "64748b", headerHex: "ffffff", style: "dual", category: "professional" },
// // // // // // // // // // // // //   minimal_luxe: { name: "Minimal Luxe", accentHex: "8b5cf6", headerHex: "faf5ff", style: "minimal", category: "premium" },
// // // // // // // // // // // // //   focus_grid: { name: "Focus Grid", accentHex: "0891b2", headerHex: "164e63", style: "grid", category: "skills" },
// // // // // // // // // // // // //   elevated_classic: { name: "Elevated Classic", accentHex: "0369a1", headerHex: "0c4a6e", style: "elevated", category: "classic" },
// // // // // // // // // // // // //   spaced_clean: { name: "Spaced Clean", accentHex: "4f46e5", headerHex: "eef2ff", style: "spaced", category: "clean" },
// // // // // // // // // // // // //   focused: { name: "Focused", accentHex: "dc2626", headerHex: "fef2f2", style: "focused", category: "bold" },
// // // // // // // // // // // // // };

// // // // // // // // // // // // // function getTemplate(templateId) {
// // // // // // // // // // // // //   return TEMPLATES[templateId] || TEMPLATES.classic;
// // // // // // // // // // // // // }

// // // // // // // // // // // // // function formatDateRange(startDate, endDate) {
// // // // // // // // // // // // //   if (!startDate && !endDate) return "";
// // // // // // // // // // // // //   if (startDate && !endDate) return startDate;
// // // // // // // // // // // // //   if (!startDate && endDate) return endDate;
// // // // // // // // // // // // //   return `${startDate} – ${endDate}`;
// // // // // // // // // // // // // }

// // // // // // // // // // // // // function escapeHtml(text) {
// // // // // // // // // // // // //   if (!text) return "";
// // // // // // // // // // // // //   return String(text)
// // // // // // // // // // // // //     .replace(/&/g, "&amp;")
// // // // // // // // // // // // //     .replace(/</g, "&lt;")
// // // // // // // // // // // // //     .replace(/>/g, "&gt;")
// // // // // // // // // // // // //     .replace(/"/g, "&quot;")
// // // // // // // // // // // // //     .replace(/'/g, "&#39;");
// // // // // // // // // // // // // }

// // // // // // // // // // // // // function cleanResumeData(resume) {
// // // // // // // // // // // // //   if (!resume || typeof resume !== 'object') {
// // // // // // // // // // // // //     return {
// // // // // // // // // // // // //       name: "", email: "", phone: "", location: "", linkedin: "", title: "",
// // // // // // // // // // // // //       summary: "", experience: [], education: [], skills: { technical: [], tools: [], soft: [] }, certifications: []
// // // // // // // // // // // // //     };
// // // // // // // // // // // // //   }
// // // // // // // // // // // // //   return {
// // // // // // // // // // // // //     name: resume.name || resume.userName || "",
// // // // // // // // // // // // //     email: resume.email || resume.userEmail || "",
// // // // // // // // // // // // //     phone: resume.phone || resume.userPhone || "",
// // // // // // // // // // // // //     location: resume.location || resume.userLocation || "",
// // // // // // // // // // // // //     linkedin: resume.linkedin || "",
// // // // // // // // // // // // //     title: resume.title || resume.currentRole || (resume.experience && resume.experience[0] && resume.experience[0].title) || "",
// // // // // // // // // // // // //     summary: (resume.summary && typeof resume.summary === 'string') ? resume.summary : "",
// // // // // // // // // // // // //     experience: (resume.experience && Array.isArray(resume.experience)) ? resume.experience : [],
// // // // // // // // // // // // //     education: (resume.education && Array.isArray(resume.education)) ? resume.education : [],
// // // // // // // // // // // // //     skills: (resume.skills && typeof resume.skills === 'object') ? {
// // // // // // // // // // // // //       technical: resume.skills.technical || [],
// // // // // // // // // // // // //       tools: resume.skills.tools || [],
// // // // // // // // // // // // //       soft: resume.skills.soft || []
// // // // // // // // // // // // //     } : { technical: [], tools: [], soft: [] },
// // // // // // // // // // // // //     certifications: (resume.certifications && Array.isArray(resume.certifications)) ? resume.certifications : []
// // // // // // // // // // // // //   };
// // // // // // // // // // // // // }

// // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // // MAIN RESUME HTML GENERATOR
// // // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // function generateResumeHTML(resumeData, templateId) {
// // // // // // // // // // // // //   const resume = cleanResumeData(resumeData);
// // // // // // // // // // // // //   const t = getTemplate(templateId);
// // // // // // // // // // // // //   const accentColor = t.accentHex;
// // // // // // // // // // // // //   const headerBg = t.headerHex;
  
// // // // // // // // // // // // //   const name = escapeHtml(resume.name) || "Your Name";
// // // // // // // // // // // // //   const title = escapeHtml(resume.title);
  
// // // // // // // // // // // // //   const contacts = [];
// // // // // // // // // // // // //   if (resume.email) contacts.push(escapeHtml(resume.email));
// // // // // // // // // // // // //   if (resume.phone) contacts.push(escapeHtml(resume.phone));
// // // // // // // // // // // // //   if (resume.location) contacts.push(escapeHtml(resume.location));
// // // // // // // // // // // // //   if (resume.linkedin) contacts.push(escapeHtml(resume.linkedin));
  
// // // // // // // // // // // // //   const summary = escapeHtml(resume.summary);
  
// // // // // // // // // // // // //   // Experience HTML
// // // // // // // // // // // // //   let experienceHtml = "";
// // // // // // // // // // // // //   if (resume.experience.length > 0) {
// // // // // // // // // // // // //     resume.experience.forEach(exp => {
// // // // // // // // // // // // //       if (exp && exp.title) {
// // // // // // // // // // // // //         experienceHtml += `
// // // // // // // // // // // // //           <div class="exp-item">
// // // // // // // // // // // // //             <div class="exp-header">
// // // // // // // // // // // // //               <strong class="exp-title">${escapeHtml(exp.title)}</strong>
// // // // // // // // // // // // //               <span class="exp-date">${formatDateRange(exp.startDate, exp.endDate)}</span>
// // // // // // // // // // // // //             </div>
// // // // // // // // // // // // //             <div class="exp-company">${escapeHtml(exp.company || "")}${exp.location ? ` | ${escapeHtml(exp.location)}` : ""}</div>
// // // // // // // // // // // // //             <ul class="exp-bullets">
// // // // // // // // // // // // //               ${(exp.bullets || []).map(b => `<li>${escapeHtml(b)}</li>`).join("")}
// // // // // // // // // // // // //             </ul>
// // // // // // // // // // // // //           </div>
// // // // // // // // // // // // //         `;
// // // // // // // // // // // // //       }
// // // // // // // // // // // // //     });
// // // // // // // // // // // // //   }
  
// // // // // // // // // // // // //   // Education HTML
// // // // // // // // // // // // //   let educationHtml = "";
// // // // // // // // // // // // //   if (resume.education.length > 0) {
// // // // // // // // // // // // //     resume.education.forEach(edu => {
// // // // // // // // // // // // //       if (edu && edu.degree) {
// // // // // // // // // // // // //         educationHtml += `
// // // // // // // // // // // // //           <div class="edu-item">
// // // // // // // // // // // // //             <div class="edu-header">
// // // // // // // // // // // // //               <strong class="edu-degree">${escapeHtml(edu.degree)}</strong>
// // // // // // // // // // // // //               <span class="edu-year">${escapeHtml(edu.year || "")}</span>
// // // // // // // // // // // // //             </div>
// // // // // // // // // // // // //             <div class="edu-school">${escapeHtml(edu.school || "")}${edu.location ? `, ${escapeHtml(edu.location)}` : ""}</div>
// // // // // // // // // // // // //             ${edu.gpa ? `<div class="edu-gpa">GPA: ${escapeHtml(edu.gpa)}</div>` : ""}
// // // // // // // // // // // // //           </div>
// // // // // // // // // // // // //         `;
// // // // // // // // // // // // //       }
// // // // // // // // // // // // //     });
// // // // // // // // // // // // //   }
  
// // // // // // // // // // // // //   // Skills HTML
// // // // // // // // // // // // //   let skillsHtml = "";
// // // // // // // // // // // // //   const skills = resume.skills;
// // // // // // // // // // // // //   if (skills.technical && skills.technical.length) {
// // // // // // // // // // // // //     skillsHtml += `<p><strong>Technical:</strong> ${skills.technical.map(s => escapeHtml(s)).join(", ")}</p>`;
// // // // // // // // // // // // //   }
// // // // // // // // // // // // //   if (skills.tools && skills.tools.length) {
// // // // // // // // // // // // //     skillsHtml += `<p><strong>Tools:</strong> ${skills.tools.map(s => escapeHtml(s)).join(", ")}</p>`;
// // // // // // // // // // // // //   }
// // // // // // // // // // // // //   if (skills.soft && skills.soft.length) {
// // // // // // // // // // // // //     skillsHtml += `<p><strong>Soft Skills:</strong> ${skills.soft.map(s => escapeHtml(s)).join(", ")}</p>`;
// // // // // // // // // // // // //   }
  
// // // // // // // // // // // // //   // Certifications HTML
// // // // // // // // // // // // //   let certHtml = "";
// // // // // // // // // // // // //   if (resume.certifications.length > 0) {
// // // // // // // // // // // // //     certHtml = `<ul class="cert-list">${resume.certifications.map(c => `<li>${escapeHtml(c)}</li>`).join("")}</ul>`;
// // // // // // // // // // // // //   }
  
// // // // // // // // // // // // //   // Template-specific rendering
// // // // // // // // // // // // //   const isTwoColumn = templateId === "modern" || templateId === "sidebarlight" || templateId === "focus_grid";
// // // // // // // // // // // // //   const isDarkHeader = ["bold", "executive", "corporate", "professional", "government", "academic", "focused"].includes(templateId);
// // // // // // // // // // // // //   const isMinimal = templateId === "minimal";
// // // // // // // // // // // // //   const isBold = templateId === "bold";
// // // // // // // // // // // // //   const isExecutive = templateId === "executive";
  
// // // // // // // // // // // // //   // Section title style class
// // // // // // // // // // // // //   let sectionClass = "section-underlined";
// // // // // // // // // // // // //   if (isBold || templateId === "modern" || templateId === "corporate" || templateId === "government") {
// // // // // // // // // // // // //     sectionClass = "section-filled";
// // // // // // // // // // // // //   } else if (templateId === "technical") {
// // // // // // // // // // // // //     sectionClass = "section-mono";
// // // // // // // // // // // // //   } else if (templateId === "ats_optimized") {
// // // // // // // // // // // // //     sectionClass = "section-simple";
// // // // // // // // // // // // //   } else if (templateId === "horizontal") {
// // // // // // // // // // // // //     sectionClass = "section-horizontal";
// // // // // // // // // // // // //   } else if (templateId === "border_accent") {
// // // // // // // // // // // // //     sectionClass = "section-border";
// // // // // // // // // // // // //   } else if (templateId === "timeline") {
// // // // // // // // // // // // //     sectionClass = "section-timeline";
// // // // // // // // // // // // //   } else if (templateId === "dual_accent") {
// // // // // // // // // // // // //     sectionClass = "section-dual";
// // // // // // // // // // // // //   } else if (templateId === "minimal_luxe") {
// // // // // // // // // // // // //     sectionClass = "section-minimal";
// // // // // // // // // // // // //   } else if (templateId === "focus_grid") {
// // // // // // // // // // // // //     sectionClass = "section-grid";
// // // // // // // // // // // // //   } else if (templateId === "elevated_classic") {
// // // // // // // // // // // // //     sectionClass = "section-elevated";
// // // // // // // // // // // // //   } else if (templateId === "spaced_clean") {
// // // // // // // // // // // // //     sectionClass = "section-spaced";
// // // // // // // // // // // // //   } else if (templateId === "focused") {
// // // // // // // // // // // // //     sectionClass = "section-focused";
// // // // // // // // // // // // //   }
  
// // // // // // // // // // // // //   // Build header based on template
// // // // // // // // // // // // //   let headerHtml = "";
// // // // // // // // // // // // //   let mainClose = "";
  
// // // // // // // // // // // // //   if (templateId === "focus_grid") {
// // // // // // // // // // // // //     // Two-column grid layout
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="grid-container">
// // // // // // // // // // // // //         <div class="grid-sidebar">
// // // // // // // // // // // // //           <div class="grid-contact">
// // // // // // // // // // // // //             <div class="grid-section-title">Contact</div>
// // // // // // // // // // // // //             ${contacts.map(c => `<div class="grid-contact-item">${c}</div>`).join("")}
// // // // // // // // // // // // //           </div>
// // // // // // // // // // // // //           <div class="grid-skills">
// // // // // // // // // // // // //             <div class="grid-section-title">Skills</div>
// // // // // // // // // // // // //             <div class="grid-skills-list">
// // // // // // // // // // // // //               ${SAMPLE_SKILLS.map(s => `<span class="grid-skill">${s}</span>`).join("")}
// // // // // // // // // // // // //             </div>
// // // // // // // // // // // // //           </div>
// // // // // // // // // // // // //           <div class="grid-education">
// // // // // // // // // // // // //             <div class="grid-section-title">Education</div>
// // // // // // // // // // // // //             <div class="grid-degree">${SAMPLE_EDUCATION.degree}</div>
// // // // // // // // // // // // //             <div class="grid-school">${SAMPLE_EDUCATION.school}, ${SAMPLE_EDUCATION.year}</div>
// // // // // // // // // // // // //           </div>
// // // // // // // // // // // // //         </div>
// // // // // // // // // // // // //         <div class="grid-main">
// // // // // // // // // // // // //           <div class="grid-header">
// // // // // // // // // // // // //             <h1 class="grid-name">${name}</h1>
// // // // // // // // // // // // //             <div class="grid-title">${title}</div>
// // // // // // // // // // // // //             <div class="grid-summary">${summary}</div>
// // // // // // // // // // // // //           </div>
// // // // // // // // // // // // //           <div class="grid-experience">
// // // // // // // // // // // // //             <div class="grid-section-title">Experience</div>
// // // // // // // // // // // // //             ${experienceHtml.replace(/exp-item/g, 'grid-exp-item').replace(/exp-header/g, 'grid-exp-header')}
// // // // // // // // // // // // //           </div>
// // // // // // // // // // // // //         </div>
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //     // Return early with special CSS
// // // // // // // // // // // // //     return generateFullHTML(templateId, accentColor, headerBg, name, title, contacts, summary, experienceHtml, educationHtml, skillsHtml, certHtml, headerHtml, "", true);
// // // // // // // // // // // // //   }
  
// // // // // // // // // // // // //   if (templateId === "modern" || templateId === "sidebarlight") {
// // // // // // // // // // // // //     const initial = name.charAt(0).toUpperCase();
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="two-column">
// // // // // // // // // // // // //         <div class="sidebar" style="background: #${templateId === "modern" ? headerBg : accentColor}">
// // // // // // // // // // // // //           <div class="avatar">${initial}</div>
// // // // // // // // // // // // //           <div class="sidebar-name">${name}</div>
// // // // // // // // // // // // //           ${title ? `<div class="sidebar-title">${title}</div>` : ""}
// // // // // // // // // // // // //           <div class="sidebar-contact-title">Contact</div>
// // // // // // // // // // // // //           ${contacts.map(c => `<div class="sidebar-contact-item">${c}</div>`).join("")}
// // // // // // // // // // // // //           <div class="sidebar-skills-title">Skills</div>
// // // // // // // // // // // // //           ${SAMPLE_SKILLS.slice(0, 5).map((s, i) => `
// // // // // // // // // // // // //             <div class="sidebar-skill">
// // // // // // // // // // // // //               <div class="sidebar-skill-name">${s}</div>
// // // // // // // // // // // // //               <div class="sidebar-skill-bar"><div class="sidebar-skill-fill" style="width: ${85 - i * 8}%"></div></div>
// // // // // // // // // // // // //             </div>
// // // // // // // // // // // // //           `).join("")}
// // // // // // // // // // // // //         </div>
// // // // // // // // // // // // //         <div class="main-content">
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //     mainClose = `</div></div>`;
// // // // // // // // // // // // //   } else if (isDarkHeader) {
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="dark-header" style="background: #${headerBg};">
// // // // // // // // // // // // //         <div class="dark-name">${name}</div>
// // // // // // // // // // // // //         ${title ? `<div class="dark-title">${title}</div>` : ""}
// // // // // // // // // // // // //         <div class="dark-contact">${contacts.map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // //         ${templateId === "bold" ? `<div class="bold-accent-bar" style="background: #${accentColor};"></div>` : ""}
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //       <div class="dark-body">
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //     mainClose = `</div>`;
// // // // // // // // // // // // //   } else if (templateId === "horizontal") {
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="horizontal-header" style="background: #${accentColor};">
// // // // // // // // // // // // //         <h1 class="horizontal-name">${name}</h1>
// // // // // // // // // // // // //         <div class="horizontal-title">${title}</div>
// // // // // // // // // // // // //         <div class="horizontal-contact">${contacts.map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //       <div class="horizontal-body">
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //     mainClose = `</div>`;
// // // // // // // // // // // // //   } else if (templateId === "dual_accent") {
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="dual-header" style="background: linear-gradient(135deg, #${accentColor}, #${accentColor}80);">
// // // // // // // // // // // // //         <h1 class="dual-name">${name}</h1>
// // // // // // // // // // // // //         <div class="dual-title">${title}</div>
// // // // // // // // // // // // //         <div class="dual-contact">${contacts.map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //       <div class="dual-body">
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //     mainClose = `</div>`;
// // // // // // // // // // // // //   } else if (templateId === "minimal_luxe") {
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="luxe-header">
// // // // // // // // // // // // //         <h1 class="luxe-name">${name}</h1>
// // // // // // // // // // // // //         <div class="luxe-title">${title}</div>
// // // // // // // // // // // // //         <div class="luxe-accent" style="background: #${accentColor};"></div>
// // // // // // // // // // // // //         <div class="luxe-contact">${contacts.slice(0, 3).map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //   } else if (templateId === "spaced_clean") {
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="spaced-header">
// // // // // // // // // // // // //         <h1 class="spaced-name">${name}</h1>
// // // // // // // // // // // // //         <div class="spaced-title">${title}</div>
// // // // // // // // // // // // //         <div class="spaced-contact">${contacts.slice(0, 3).map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // //         <div class="spaced-divider"></div>
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //       <div class="spaced-body">
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //     mainClose = `</div>`;
// // // // // // // // // // // // //   } else if (templateId === "focused") {
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="focused-header" style="background: #${headerBg}; border-bottom-color: #${accentColor};">
// // // // // // // // // // // // //         <h1 class="focused-name">${name}</h1>
// // // // // // // // // // // // //         <div class="focused-title">${title}</div>
// // // // // // // // // // // // //         <div class="focused-contact">${contacts.slice(0, 3).map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //       <div class="focused-body">
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //     mainClose = `</div>`;
// // // // // // // // // // // // //   } else if (templateId === "ats_optimized") {
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="ats-header">
// // // // // // // // // // // // //         <h1 class="ats-name">${name}</h1>
// // // // // // // // // // // // //         <div class="ats-title">${title}</div>
// // // // // // // // // // // // //         <div class="ats-contact">${contacts.map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // //         <div class="ats-accent" style="background: #${accentColor};"></div>
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //   } else if (templateId === "border_accent") {
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="border-header">
// // // // // // // // // // // // //         <h1 class="border-name">${name}</h1>
// // // // // // // // // // // // //         <div class="border-title">${title}</div>
// // // // // // // // // // // // //         <div class="border-contact">${contacts.slice(0, 3).map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //   } else if (templateId === "timeline") {
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="timeline-header">
// // // // // // // // // // // // //         <h1 class="timeline-name">${name}</h1>
// // // // // // // // // // // // //         <div class="timeline-title">${title}</div>
// // // // // // // // // // // // //         <div class="timeline-contact">${contacts.slice(0, 3).map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //   } else if (templateId === "elevated_classic") {
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="elevated-header">
// // // // // // // // // // // // //         <h1 class="elevated-name">${name}</h1>
// // // // // // // // // // // // //         <div class="elevated-title">${title}</div>
// // // // // // // // // // // // //         <div class="elevated-contact">${contacts.slice(0, 3).map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // //         <div class="elevated-divider" style="background: #${accentColor};"></div>
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //       <div class="elevated-body">
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //     mainClose = `</div>`;
// // // // // // // // // // // // //   } else {
// // // // // // // // // // // // //     // Standard header
// // // // // // // // // // // // //     headerHtml = `
// // // // // // // // // // // // //       <div class="standard-header" style="border-bottom-color: #${accentColor};">
// // // // // // // // // // // // //         <h1 class="standard-name">${name}</h1>
// // // // // // // // // // // // //         ${title && !isMinimal ? `<div class="standard-title">${title}</div>` : ""}
// // // // // // // // // // // // //         ${isMinimal ? `<div class="minimal-accent" style="background: #${accentColor};"></div>` : ""}
// // // // // // // // // // // // //         <div class="standard-contact">${contacts.map(c => `<span>${c}</span>`).join("")}</div>
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //   }
  
// // // // // // // // // // // // //   function renderSection(sectionTitle, content) {
// // // // // // // // // // // // //     if (!content || content === "") return "";
// // // // // // // // // // // // //     return `
// // // // // // // // // // // // //       <div class="section">
// // // // // // // // // // // // //         <div class="${sectionClass}" style="color: #${accentColor};">${sectionTitle}</div>
// // // // // // // // // // // // //         <div class="section-content">${content}</div>
// // // // // // // // // // // // //       </div>
// // // // // // // // // // // // //     `;
// // // // // // // // // // // // //   }
  
// // // // // // // // // // // // //   return generateFullHTML(templateId, accentColor, headerBg, name, title, contacts, summary, experienceHtml, educationHtml, skillsHtml, certHtml, headerHtml + renderSection("Professional Summary", summary ? `<p>${summary}</p>` : "") + renderSection("Work Experience", experienceHtml) + renderSection("Education", educationHtml) + renderSection("Skills", skillsHtml) + renderSection("Certifications", certHtml) + mainClose, mainClose ? "" : renderSection("Professional Summary", summary ? `<p>${summary}</p>` : "") + renderSection("Work Experience", experienceHtml) + renderSection("Education", educationHtml) + renderSection("Skills", skillsHtml) + renderSection("Certifications", certHtml), false);
// // // // // // // // // // // // // }

// // // // // // // // // // // // // // Sample data for previews
// // // // // // // // // // // // // const SAMPLE_SKILLS = ["React", "Node.js", "Python", "SQL", "Agile", "Figma", "Data Analysis"];
// // // // // // // // // // // // // const SAMPLE_EDUCATION = { degree: "B.S. Computer Science", school: "MIT", year: "2015" };

// // // // // // // // // // // // // function generateFullHTML(templateId, accentColor, headerBg, name, title, contacts, summary, experienceHtml, educationHtml, skillsHtml, certHtml, bodyContent, isGrid, customCSS = "") {
// // // // // // // // // // // // //   let additionalCSS = "";
  
// // // // // // // // // // // // //   // Common CSS for all templates
// // // // // // // // // // // // //   const commonCSS = `
// // // // // // // // // // // // //     * { margin: 0; padding: 0; box-sizing: border-box; }
// // // // // // // // // // // // //     body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.5; color: #1a202c; background: #e8e8e8; }
// // // // // // // // // // // // //     .resume { max-width: 850px; margin: 20px auto; background: white; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
// // // // // // // // // // // // //     .section { margin-bottom: 24px; padding: 0 40px; }
// // // // // // // // // // // // //     .section-content { margin-top: 12px; }
// // // // // // // // // // // // //     .section-underlined { font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em; border-bottom: 1.5px solid; padding-bottom: 4px; margin-bottom: 12px; }
// // // // // // // // // // // // //     .section-filled { font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em; border-left: 3px solid; padding: 6px 12px; margin-bottom: 12px; border-radius: 0 6px 6px 0; background: #${accentColor}18; }
// // // // // // // // // // // // //     .section-mono { font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em; border-left: 3px solid; padding: 6px 12px; margin-bottom: 12px; border-radius: 0 6px 6px 0; background: #${accentColor}18; font-family: 'Courier New', monospace; }
// // // // // // // // // // // // //     .section-simple { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 12px; }
// // // // // // // // // // // // //     .section-horizontal { font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.15em; margin-bottom: 12px; }
// // // // // // // // // // // // //     .section-border { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.1em; border-left: 3px solid; padding-left: 12px; margin-bottom: 12px; }
// // // // // // // // // // // // //     .section-timeline { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.2em; margin-bottom: 12px; }
// // // // // // // // // // // // //     .section-dual { font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em; background: #${accentColor}10; display: inline-block; padding: 4px 12px; border-radius: 20px; margin-bottom: 12px; }
// // // // // // // // // // // // //     .section-minimal { font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.2em; color: #94a3b8; margin-bottom: 12px; }
// // // // // // // // // // // // //     .section-grid { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.1em; border-bottom: 1px solid; padding-bottom: 4px; display: inline-block; margin-bottom: 12px; }
// // // // // // // // // // // // //     .section-elevated { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.1em; border-bottom: 1px solid; padding-bottom: 4px; margin-bottom: 12px; }
// // // // // // // // // // // // //     .section-spaced { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.2em; margin-bottom: 16px; }
// // // // // // // // // // // // //     .section-focused { font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.15em; border-bottom: 2px solid; padding-bottom: 4px; display: inline-block; margin-bottom: 12px; }
// // // // // // // // // // // // //     .exp-item { margin-bottom: 20px; }
// // // // // // // // // // // // //     .exp-header { display: flex; justify-content: space-between; flex-wrap: wrap; margin-bottom: 5px; }
// // // // // // // // // // // // //     .exp-date { font-size: 12px; color: #666; }
// // // // // // // // // // // // //     .exp-company { font-size: 12px; color: #555; margin-bottom: 8px; }
// // // // // // // // // // // // //     .exp-bullets { margin: 0 0 0 20px; padding: 0; }
// // // // // // // // // // // // //     .exp-bullets li { margin-bottom: 5px; font-size: 13px; line-height: 1.5; }
// // // // // // // // // // // // //     .edu-item { margin-bottom: 15px; }
// // // // // // // // // // // // //     .edu-header { display: flex; justify-content: space-between; flex-wrap: wrap; }
// // // // // // // // // // // // //     .edu-year { font-size: 12px; color: #666; }
// // // // // // // // // // // // //     .edu-school { font-size: 13px; color: #555; }
// // // // // // // // // // // // //     .edu-gpa { font-size: 12px; color: #666; }
// // // // // // // // // // // // //     p { margin: 0 0 8px 0; }
// // // // // // // // // // // // //     .cert-list { margin: 0 0 0 20px; padding: 0; }
// // // // // // // // // // // // //     .cert-list li { margin-bottom: 5px; }
// // // // // // // // // // // // //     .standard-header { border-bottom: 2px solid; padding: 30px 40px 20px; text-align: center; margin-bottom: 24px; }
// // // // // // // // // // // // //     .standard-name { font-size: 28px; font-weight: 700; margin-bottom: 5px; }
// // // // // // // // // // // // //     .standard-title { font-size: 14px; color: #4a5568; margin-bottom: 10px; }
// // // // // // // // // // // // //     .standard-contact { display: flex; flex-wrap: wrap; justify-content: center; gap: 16px; font-size: 12px; color: #718096; margin-top: 12px; }
// // // // // // // // // // // // //     .minimal-accent { width: 40px; height: 3px; margin: 10px auto 12px; }
// // // // // // // // // // // // //     .dark-header { padding: 30px 40px; color: #fff; }
// // // // // // // // // // // // //     .dark-name { font-size: 36px; font-weight: 900; letter-spacing: -1px; margin-bottom: 8px; }
// // // // // // // // // // // // //     .dark-title { font-size: 14px; opacity: 0.8; margin-bottom: 15px; }
// // // // // // // // // // // // //     .dark-contact { display: flex; flex-wrap: wrap; gap: 20px; font-size: 12px; opacity: 0.7; }
// // // // // // // // // // // // //     .dark-body { padding: 30px 40px; background: #fff; }
// // // // // // // // // // // // //     .bold-accent-bar { width: 60px; height: 4px; margin-top: 16px; }
// // // // // // // // // // // // //     .two-column { display: flex; }
// // // // // // // // // // // // //     .sidebar { width: 30%; padding: 30px 20px; color: #fff; }
// // // // // // // // // // // // //     .avatar { width: 70px; height: 70px; border-radius: 50%; background: rgba(255,255,255,0.15); display: flex; align-items: center; justify-content: center; margin-bottom: 20px; font-size: 28px; font-weight: bold; }
// // // // // // // // // // // // //     .sidebar-name { font-size: 18px; font-weight: 800; margin-bottom: 8px; }
// // // // // // // // // // // // //     .sidebar-title { font-size: 11px; opacity: 0.8; margin-bottom: 25px; }
// // // // // // // // // // // // //     .sidebar-contact-title { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; margin: 16px 0 8px; opacity: 0.6; }
// // // // // // // // // // // // //     .sidebar-contact-item { font-size: 10px; opacity: 0.8; margin-bottom: 6px; }
// // // // // // // // // // // // //     .sidebar-skills-title { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; margin: 16px 0 8px; opacity: 0.6; }
// // // // // // // // // // // // //     .sidebar-skill { margin-bottom: 12px; }
// // // // // // // // // // // // //     .sidebar-skill-name { font-size: 10px; margin-bottom: 4px; }
// // // // // // // // // // // // //     .sidebar-skill-bar { height: 4px; background: rgba(255,255,255,0.2); border-radius: 2px; }
// // // // // // // // // // // // //     .sidebar-skill-fill { height: 100%; background: rgba(255,255,255,0.6); border-radius: 2px; }
// // // // // // // // // // // // //     .main-content { width: 70%; padding: 30px 25px; background: #fff; }
// // // // // // // // // // // // //     .horizontal-header { padding: 24px 40px; text-align: center; color: #fff; }
// // // // // // // // // // // // //     .horizontal-name { font-size: 28px; font-weight: 700; margin-bottom: 8px; }
// // // // // // // // // // // // //     .horizontal-title { font-size: 13px; opacity: 0.85; margin-bottom: 12px; }
// // // // // // // // // // // // //     .horizontal-contact { display: flex; justify-content: center; flex-wrap: wrap; gap: 20px; font-size: 11px; opacity: 0.75; }
// // // // // // // // // // // // //     .horizontal-body { padding: 28px 40px; }
// // // // // // // // // // // // //     .dual-header { padding: 30px 40px; text-align: center; color: #fff; }
// // // // // // // // // // // // //     .dual-name { font-size: 28px; font-weight: 700; margin-bottom: 8px; }
// // // // // // // // // // // // //     .dual-title { font-size: 13px; opacity: 0.85; margin-bottom: 12px; }
// // // // // // // // // // // // //     .dual-contact { display: flex; justify-content: center; flex-wrap: wrap; gap: 20px; font-size: 11px; opacity: 0.75; }
// // // // // // // // // // // // //     .dual-body { padding: 28px 40px; }
// // // // // // // // // // // // //     .luxe-header { text-align: center; padding: 40px 40px 30px; }
// // // // // // // // // // // // //     .luxe-name { font-size: 36px; font-weight: 300; letter-spacing: -1px; margin-bottom: 12px; }
// // // // // // // // // // // // //     .luxe-title { font-size: 14px; color: #64748b; margin-bottom: 16px; }
// // // // // // // // // // // // //     .luxe-accent { width: 50px; height: 2px; margin: 0 auto 20px; }
// // // // // // // // // // // // //     .luxe-contact { display: flex; justify-content: center; flex-wrap: wrap; gap: 24px; font-size: 11px; color: #94a3b8; }
// // // // // // // // // // // // //     .spaced-header { text-align: center; padding: 35px 40px 25px; }
// // // // // // // // // // // // //     .spaced-name { font-size: 34px; font-weight: 600; letter-spacing: -0.5px; margin-bottom: 12px; }
// // // // // // // // // // // // //     .spaced-title { font-size: 14px; color: #64748b; margin-bottom: 16px; }
// // // // // // // // // // // // //     .spaced-contact { display: flex; justify-content: center; flex-wrap: wrap; gap: 24px; font-size: 11px; color: #94a3b8; }
// // // // // // // // // // // // //     .spaced-divider { height: 1px; background: #e2e8f0; margin-top: 20px; }
// // // // // // // // // // // // //     .spaced-body { padding: 20px 45px 45px; }
// // // // // // // // // // // // //     .focused-header { padding: 35px 40px; border-bottom: 3px solid; }
// // // // // // // // // // // // //     .focused-name { font-size: 38px; font-weight: 800; letter-spacing: -1px; margin-bottom: 10px; }
// // // // // // // // // // // // //     .focused-title { font-size: 14px; color: #64748b; margin-bottom: 16px; }
// // // // // // // // // // // // //     .focused-contact { display: flex; justify-content: center; flex-wrap: wrap; gap: 24px; font-size: 11px; color: #94a3b8; }
// // // // // // // // // // // // //     .focused-body { padding: 30px 40px; }
// // // // // // // // // // // // //     .ats-header { text-align: center; padding: 30px 40px 20px; }
// // // // // // // // // // // // //     .ats-name { font-size: 28px; font-weight: 700; margin-bottom: 8px; }
// // // // // // // // // // // // //     .ats-title { font-size: 14px; color: #4a5568; margin-bottom: 12px; }
// // // // // // // // // // // // //     .ats-contact { display: flex; justify-content: center; flex-wrap: wrap; gap: 16px; font-size: 11px; color: #718096; margin-bottom: 16px; }
// // // // // // // // // // // // //     .ats-accent { width: 50px; height: 2px; margin: 0 auto; }
// // // // // // // // // // // // //     .border-header { text-align: center; padding: 30px 40px 20px; border-bottom: 1px solid #e2e8f0; margin-bottom: 10px; }
// // // // // // // // // // // // //     .border-name { font-size: 32px; font-weight: 300; letter-spacing: -0.5px; margin-bottom: 8px; }
// // // // // // // // // // // // //     .border-title { font-size: 14px; color: #4a5568; margin-bottom: 12px; }
// // // // // // // // // // // // //     .border-contact { display: flex; justify-content: center; flex-wrap: wrap; gap: 20px; font-size: 11px; color: #718096; }
// // // // // // // // // // // // //     .timeline-header { text-align: center; padding: 30px 40px 20px; border-bottom: 1px solid #e2e8f0; margin-bottom: 10px; }
// // // // // // // // // // // // //     .timeline-name { font-size: 32px; font-weight: 300; letter-spacing: -0.5px; margin-bottom: 8px; }
// // // // // // // // // // // // //     .timeline-title { font-size: 14px; color: ${accentColor === "0f172a" ? "#2563eb" : "#" + accentColor}; font-weight: 500; margin-bottom: 12px; }
// // // // // // // // // // // // //     .timeline-contact { display: flex; justify-content: center; flex-wrap: wrap; gap: 20px; font-size: 11px; color: #718096; }
// // // // // // // // // // // // //     .elevated-header { text-align: center; padding: 35px 40px 25px; }
// // // // // // // // // // // // //     .elevated-name { font-size: 32px; font-weight: 700; letter-spacing: -0.3px; margin-bottom: 8px; font-family: Georgia, 'Times New Roman', serif; }
// // // // // // // // // // // // //     .elevated-title { font-size: 13px; color: #4a5568; margin-bottom: 12px; font-style: italic; }
// // // // // // // // // // // // //     .elevated-contact { display: flex; justify-content: center; flex-wrap: wrap; gap: 20px; font-size: 11px; color: #718096; }
// // // // // // // // // // // // //     .elevated-divider { width: 60px; height: 2px; margin: 20px auto 0; }
// // // // // // // // // // // // //     .elevated-body { padding: 20px 40px 40px; font-family: Georgia, 'Times New Roman', serif; }
// // // // // // // // // // // // //     .grid-container { display: flex; min-height: 500px; }
// // // // // // // // // // // // //     .grid-sidebar { width: 35%; background: #${accentColor}08; padding: 24px 20px; }
// // // // // // // // // // // // //     .grid-main { flex: 1; padding: 24px 24px; }
// // // // // // // // // // // // //     .grid-section-title { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.1em; color: #${accentColor}; margin-bottom: 12px; }
// // // // // // // // // // // // //     .grid-contact-item { font-size: 10px; color: #475569; margin-bottom: 8px; }
// // // // // // // // // // // // //     .grid-skills-list { display: flex; flex-wrap: wrap; gap: 6px; }
// // // // // // // // // // // // //     .grid-skill { font-size: 9px; background: #${accentColor}15; color: #${accentColor}; padding: 3px 8px; border-radius: 3px; }
// // // // // // // // // // // // //     .grid-degree { font-size: 11px; font-weight: 600; margin-bottom: 2px; }
// // // // // // // // // // // // //     .grid-school { font-size: 10px; color: #64748b; }
// // // // // // // // // // // // //     .grid-header { margin-bottom: 20px; }
// // // // // // // // // // // // //     .grid-name { font-size: 24px; font-weight: 700; margin-bottom: 6px; }
// // // // // // // // // // // // //     .grid-title { font-size: 12px; color: #${accentColor}; font-weight: 600; margin-bottom: 12px; }
// // // // // // // // // // // // //     .grid-summary { font-size: 11px; color: #475569; line-height: 1.5; }
// // // // // // // // // // // // //     .grid-exp-item { margin-bottom: 16px; }
// // // // // // // // // // // // //     .grid-exp-header { display: flex; justify-content: space-between; margin-bottom: 4px; }
// // // // // // // // // // // // //     .grid-exp-header strong { font-size: 11px; }
// // // // // // // // // // // // //     .grid-exp-header span { font-size: 9px; color: #64748b; }
// // // // // // // // // // // // //     @media print {
// // // // // // // // // // // // //       body { background: white; padding: 0; margin: 0; }
// // // // // // // // // // // // //       .resume { margin: 0; box-shadow: none; }
// // // // // // // // // // // // //       .dark-header, .sidebar, .horizontal-header, .dual-header, .focused-header { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
// // // // // // // // // // // // //       @page { size: A4; margin: 0.5in; }
// // // // // // // // // // // // //     }
// // // // // // // // // // // // //   `;
  
// // // // // // // // // // // // //   if (isGrid) {
// // // // // // // // // // // // //     return `<!DOCTYPE html>
// // // // // // // // // // // // // <html><head><meta charset="UTF-8"><title>${name} - Resume</title><style>${commonCSS}</style></head>
// // // // // // // // // // // // // <body><div class="resume">${bodyContent}</div></body></html>`;
// // // // // // // // // // // // //   }
  
// // // // // // // // // // // // //   return `<!DOCTYPE html>
// // // // // // // // // // // // // <html><head><meta charset="UTF-8"><title>${name} - Resume</title><style>${commonCSS}${additionalCSS}</style></head>
// // // // // // // // // // // // // <body><div class="resume">${bodyContent}</div></body></html>`;
// // // // // // // // // // // // // }

// // // // // // // // // // // // // // Export functions
// // // // // // // // // // // // // export function downloadResumeAsPDF(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // //   const html = generateResumeHTML(resume, templateId);
// // // // // // // // // // // // //   const blob = new Blob([html], { type: "text/html" });
// // // // // // // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // // // // // // //   const printWindow = window.open(url, "_blank");
// // // // // // // // // // // // //   if (!printWindow) {
// // // // // // // // // // // // //     const a = document.createElement("a");
// // // // // // // // // // // // //     a.href = url;
// // // // // // // // // // // // //     a.download = (fileName || "resume").replace(/\.pdf$/i, "") + ".html";
// // // // // // // // // // // // //     document.body.appendChild(a);
// // // // // // // // // // // // //     a.click();
// // // // // // // // // // // // //     document.body.removeChild(a);
// // // // // // // // // // // // //     URL.revokeObjectURL(url);
// // // // // // // // // // // // //     return;
// // // // // // // // // // // // //   }
// // // // // // // // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 1000);
// // // // // // // // // // // // // }

// // // // // // // // // // // // // export function downloadResumeAsWord(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // //   const html = generateResumeHTML(resume, templateId);
// // // // // // // // // // // // //   const wordHtml = `<!DOCTYPE html>
// // // // // // // // // // // // // <html><head><meta charset="UTF-8"><meta name="ProgId" content="Word.Document"><title>${escapeHtml(resume.name || "Resume")} - Resume</title>
// // // // // // // // // // // // // <style>body{font-family:'Calibri',Arial,sans-serif;margin:1in auto;max-width:8.5in;}</style>
// // // // // // // // // // // // // </head><body>${html.replace(/<!DOCTYPE html>[\s\S]*?<body[^>]*>/, "").replace(/<\/body>[\s\S]*$/, "")}</body></html>`;
// // // // // // // // // // // // //   const blob = new Blob([wordHtml], { type: "application/msword" });
// // // // // // // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // // // // // // //   const a = document.createElement("a");
// // // // // // // // // // // // //   a.href = url;
// // // // // // // // // // // // //   a.download = (fileName || "resume").replace(/\.(doc|docx)$/i, "") + ".doc";
// // // // // // // // // // // // //   document.body.appendChild(a);
// // // // // // // // // // // // //   a.click();
// // // // // // // // // // // // //   document.body.removeChild(a);
// // // // // // // // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 100);
// // // // // // // // // // // // // }

// // // // // // // // // // // // // export function downloadATSResume(resume, fileName, templateId = "classic") {
// // // // // // // // // // // // //   const html = generateResumeHTML(resume, templateId);
// // // // // // // // // // // // //   const blob = new Blob([html], { type: "text/html" });
// // // // // // // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // // // // // // //   const a = document.createElement("a");
// // // // // // // // // // // // //   a.href = url;
// // // // // // // // // // // // //   a.download = (fileName || "resume").replace(/\.html$/i, "") + ".html";
// // // // // // // // // // // // //   document.body.appendChild(a);
// // // // // // // // // // // // //   a.click();
// // // // // // // // // // // // //   document.body.removeChild(a);
// // // // // // // // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 100);
// // // // // // // // // // // // // }

// // // // // // // // // // // // // src/utils/generateResumeDoc.js
// // // // // // // // // // // // // Single source of truth for all resume downloads
// // // // // // // // // // // // // HTML generator mirrors ResumeGeneratorPage.jsx ResumePreview exactly

// // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // SUPPORTED DOWNLOAD TEMPLATES
// // // // // // // // // // // // // These 5 templates are fully supported for download
// // // // // // // // // // // // // They match the React preview in ResumeGeneratorPage.jsx exactly
// // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // const DOWNLOAD_TEMPLATES = {
// // // // // // // // // // // //   classic: {
// // // // // // // // // // // //     name: "Classic ATS",
// // // // // // // // // // // //     accent: "#2563eb",
// // // // // // // // // // // //     header: "#1e293b",
// // // // // // // // // // // //   },
// // // // // // // // // // // //   executive: {
// // // // // // // // // // // //     name: "Executive",
// // // // // // // // // // // //     accent: "#334155",
// // // // // // // // // // // //     header: "#0f172a",
// // // // // // // // // // // //   },
// // // // // // // // // // // //   bold: {
// // // // // // // // // // // //     name: "Bold Impact",
// // // // // // // // // // // //     accent: "#1d4ed8",
// // // // // // // // // // // //     header: "#1e3a8a",
// // // // // // // // // // // //   },
// // // // // // // // // // // //   minimal: {
// // // // // // // // // // // //     name: "Minimal Clean",
// // // // // // // // // // // //     accent: "#059669",
// // // // // // // // // // // //     header: "#059669",
// // // // // // // // // // // //   },
// // // // // // // // // // // //   professional: {
// // // // // // // // // // // //     name: "Professional",
// // // // // // // // // // // //     accent: "#1e3a5f",
// // // // // // // // // // // //     header: "#1e3a5f",
// // // // // // // // // // // //   },
// // // // // // // // // // // // };

// // // // // // // // // // // // function getT(id) {
// // // // // // // // // // // //   return DOWNLOAD_TEMPLATES[id] || DOWNLOAD_TEMPLATES.classic;
// // // // // // // // // // // // }

// // // // // // // // // // // // function esc(s) {
// // // // // // // // // // // //   if (!s) return "";
// // // // // // // // // // // //   return String(s)
// // // // // // // // // // // //     .replace(/&/g,"&amp;").replace(/</g,"&lt;")
// // // // // // // // // // // //     .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// // // // // // // // // // // // }

// // // // // // // // // // // // function fmt(s, e) {
// // // // // // // // // // // //   if (!s && !e) return "";
// // // // // // // // // // // //   if (s && !e) return esc(s);
// // // // // // // // // // // //   if (!s && e) return esc(e);
// // // // // // // // // // // //   return `${esc(s)} &ndash; ${esc(e)}`;
// // // // // // // // // // // // }

// // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // CORE HTML BUILDER
// // // // // // // // // // // // // forWord=true → removes rgba, flexbox → uses table for sidebar
// // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // function buildResumeHTML(resume, templateId, opts = {}) {
// // // // // // // // // // // //   const { forWord = false, showHint = false } = opts;
// // // // // // // // // // // //   const t  = getT(templateId);
// // // // // // // // // // // //   const ac = t.accent;
// // // // // // // // // // // //   const hd = t.header;

// // // // // // // // // // // //   const nm   = esc(resume.name)  || "Your Name";
// // // // // // // // // // // //   const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
// // // // // // // // // // // //   const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean).map(esc);

// // // // // // // // // // // //   // ── Section title ──
// // // // // // // // // // // //   const isFilled = ["bold","professional","corporate"].includes(templateId);
// // // // // // // // // // // //   function secTitle(text) {
// // // // // // // // // // // //     if (isFilled) {
// // // // // // // // // // // //       return `<div style="background:${ac}18;border-left:3px solid ${ac};padding:6px 12px;
// // // // // // // // // // // //         margin-bottom:14px;border-radius:0 6px 6px 0;">
// // // // // // // // // // // //         <div style="font-size:11px;font-weight:800;text-transform:uppercase;
// // // // // // // // // // // //           letter-spacing:.1em;color:${ac};">${text}</div></div>`;
// // // // // // // // // // // //     }
// // // // // // // // // // // //     return `<div style="margin-bottom:14px;border-bottom:1.5px solid ${ac};padding-bottom:5px;">
// // // // // // // // // // // //       <div style="font-size:11px;font-weight:800;text-transform:uppercase;
// // // // // // // // // // // //         letter-spacing:.1em;color:${ac};">${text}</div></div>`;
// // // // // // // // // // // //   }

// // // // // // // // // // // //   // ── Experience ──
// // // // // // // // // // // //   const expHtml = (resume.experience||[]).map(exp => {
// // // // // // // // // // // //     const bullets = (exp.bullets||[]).map(b =>
// // // // // // // // // // // //       `<li style="font-size:13px;color:#374151;margin-bottom:6px;line-height:1.7;">${esc(b)}</li>`
// // // // // // // // // // // //     ).join("");
// // // // // // // // // // // //     return `<div style="margin-bottom:18px;">
// // // // // // // // // // // //       <div style="margin-bottom:4px;">
// // // // // // // // // // // //         <span style="font-weight:700;font-size:14px;color:#0f172a;">${esc(exp.title||"")}</span>
// // // // // // // // // // // //         <span style="color:#475569;font-size:13px;"> &mdash; ${esc(exp.company||"")}</span>
// // // // // // // // // // // //         ${exp.location?`<span style="color:#94a3b8;font-size:12px;"> | ${esc(exp.location)}</span>`:""}
// // // // // // // // // // // //       </div>
// // // // // // // // // // // //       <div style="font-size:12px;color:#64748b;font-style:italic;margin-bottom:7px;">
// // // // // // // // // // // //         ${fmt(exp.startDate,exp.endDate)}</div>
// // // // // // // // // // // //       <ul style="margin:0 0 0 20px;padding:0;">${bullets}</ul>
// // // // // // // // // // // //     </div>`;
// // // // // // // // // // // //   }).join("");

// // // // // // // // // // // //   // ── Education ──
// // // // // // // // // // // //   const eduHtml = (resume.education||[]).map(edu =>
// // // // // // // // // // // //     `<div style="margin-bottom:12px;">
// // // // // // // // // // // //       <span style="font-weight:600;font-size:14px;color:#0f172a;">${esc(edu.degree||"")}</span>
// // // // // // // // // // // //       <span style="color:#475569;font-size:13px;"> &mdash; ${esc(edu.school||"")}</span>
// // // // // // // // // // // //       ${edu.location?`<span style="color:#94a3b8;font-size:12px;"> | ${esc(edu.location)}</span>`:""}
// // // // // // // // // // // //       <div style="font-size:12px;color:#64748b;font-style:italic;margin-top:2px;">
// // // // // // // // // // // //         ${esc(edu.year||"")}${edu.gpa?` | GPA: ${esc(edu.gpa)}`:""}
// // // // // // // // // // // //       </div>
// // // // // // // // // // // //     </div>`
// // // // // // // // // // // //   ).join("");

// // // // // // // // // // // //   // ── Skills ──
// // // // // // // // // // // //   const sk = resume.skills||{};
// // // // // // // // // // // //   const skillsHtml = [
// // // // // // // // // // // //     sk.technical?.length ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // // // // // //       <strong>Technical:</strong> ${sk.technical.map(esc).join(", ")}</p>` : "",
// // // // // // // // // // // //     sk.tools?.length     ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // // // // // //       <strong>Tools:</strong> ${sk.tools.map(esc).join(", ")}</p>` : "",
// // // // // // // // // // // //     sk.soft?.length      ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // // // // // //       <strong>Soft Skills:</strong> ${sk.soft.map(esc).join(", ")}</p>` : "",
// // // // // // // // // // // //   ].join("");

// // // // // // // // // // // //   // ── Certifications ──
// // // // // // // // // // // //   const certHtml = (resume.certifications||[]).length
// // // // // // // // // // // //     ? `<ul style="margin:0 0 0 20px;padding:0;">${(resume.certifications).map(c=>
// // // // // // // // // // // //         `<li style="font-size:13px;color:#374151;margin-bottom:6px;line-height:1.7;">${esc(c)}</li>`
// // // // // // // // // // // //       ).join("")}</ul>` : "";

// // // // // // // // // // // //   // ── Main content sections ──
// // // // // // // // // // // //   function section(title, body) {
// // // // // // // // // // // //     if (!body?.trim()) return "";
// // // // // // // // // // // //     return `<div style="margin-bottom:24px;">${secTitle(title)}${body}</div>`;
// // // // // // // // // // // //   }
// // // // // // // // // // // //   const mainSections = `
// // // // // // // // // // // //     ${resume.summary ? section("Professional Summary",
// // // // // // // // // // // //       `<p style="font-size:13px;line-height:1.8;color:#374151;">${esc(resume.summary)}</p>`) : ""}
// // // // // // // // // // // //     ${expHtml  ? section("Work Experience", expHtml)  : ""}
// // // // // // // // // // // //     ${eduHtml  ? section("Education",       eduHtml)  : ""}
// // // // // // // // // // // //     ${skillsHtml ? section("Skills",        skillsHtml) : ""}
// // // // // // // // // // // //     ${certHtml ? section("Certifications",  certHtml) : ""}`;

// // // // // // // // // // // //   // ── Print hint (PDF/HTML only) ──
// // // // // // // // // // // //   const hint = showHint ? `
// // // // // // // // // // // //     <div class="no-print" style="background:#e8f0fe;border:1px solid #1a73e8;border-radius:8px;
// // // // // // // // // // // //       padding:12px 18px;margin-bottom:20px;text-align:center;font-size:13px;color:#1a73e8;
// // // // // // // // // // // //       font-family:Arial,sans-serif;">
// // // // // // // // // // // //       📄 <strong>Save as PDF:</strong> Ctrl+P &rarr; destination = "Save as PDF" &rarr;
// // // // // // // // // // // //       margins = "None" &rarr; enable "Background graphics" &rarr; Save
// // // // // // // // // // // //     </div>` : "";

// // // // // // // // // // // //   // ── Print / page CSS ──
// // // // // // // // // // // //   const printCSS = forWord
// // // // // // // // // // // //     ? `@page { size:A4; margin:.65in; }`
// // // // // // // // // // // //     : `@media print {
// // // // // // // // // // // //         .no-print { display:none!important; }
// // // // // // // // // // // //         body { margin:0; padding:0; background:#fff; }
// // // // // // // // // // // //         .page { box-shadow:none!important; }
// // // // // // // // // // // //         @page { size:A4; margin:0; }
// // // // // // // // // // // //       }
// // // // // // // // // // // //       -webkit-print-color-adjust: exact;
// // // // // // // // // // // //       print-color-adjust: exact;`;

// // // // // // // // // // // //   // ── Build body per template ──
// // // // // // // // // // // //   let body = "";

// // // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // // //   // CLASSIC
// // // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // // //   if (templateId === "classic") {
// // // // // // // // // // // //     body = `
// // // // // // // // // // // //       <div style="padding:32px 40px;">
// // // // // // // // // // // //         <div style="text-align:center;padding-bottom:20px;margin-bottom:24px;
// // // // // // // // // // // //           border-bottom:2px solid ${ac};">
// // // // // // // // // // // //           <h1 style="font-size:26px;font-weight:700;color:#0f172a;margin:0 0 8px;
// // // // // // // // // // // //             font-family:Georgia,'Times New Roman',serif;">${nm}</h1>
// // // // // // // // // // // //           <div style="display:${forWord?"block":"flex"};justify-content:center;
// // // // // // // // // // // //             flex-wrap:wrap;gap:16px;font-size:13px;color:#475569;margin-top:8px;">
// // // // // // // // // // // //             ${ctcs.map(c => forWord
// // // // // // // // // // // //               ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // // // // // //               : `<span>${c}</span>`).join("")}
// // // // // // // // // // // //           </div>
// // // // // // // // // // // //         </div>
// // // // // // // // // // // //         ${mainSections}
// // // // // // // // // // // //       </div>`;
// // // // // // // // // // // //   }

// // // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // // //   // EXECUTIVE
// // // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // // //   else if (templateId === "executive") {
// // // // // // // // // // // //     body = `
// // // // // // // // // // // //       <div style="background:${hd};padding:30px 40px 26px;color:#fff;">
// // // // // // // // // // // //         <h1 style="font-size:28px;font-weight:700;color:#fff;text-transform:uppercase;
// // // // // // // // // // // //           letter-spacing:.06em;margin:0 0 10px;
// // // // // // // // // // // //           font-family:Georgia,'Times New Roman',serif;">${nm}</h1>
// // // // // // // // // // // //         <div style="height:2px;background:rgba(255,255,255,.3);margin-bottom:4px;"></div>
// // // // // // // // // // // //         <div style="height:1px;background:rgba(255,255,255,.1);margin-bottom:14px;"></div>
// // // // // // // // // // // //         <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:20px;
// // // // // // // // // // // //           font-size:12px;color:rgba(255,255,255,.65);">
// // // // // // // // // // // //           ${ctcs.map(c => forWord
// // // // // // // // // // // //             ? `<span style="margin-right:18px;">${c}</span>`
// // // // // // // // // // // //             : `<span>${c}</span>`).join("")}
// // // // // // // // // // // //         </div>
// // // // // // // // // // // //       </div>
// // // // // // // // // // // //       <div style="padding:26px 40px;">${mainSections}</div>`;
// // // // // // // // // // // //   }

// // // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // // //   // BOLD
// // // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // // //   else if (templateId === "bold") {
// // // // // // // // // // // //     body = `
// // // // // // // // // // // //       <div style="background:${hd};padding:28px 30px 24px;">
// // // // // // // // // // // //         <h1 style="font-size:34px;font-weight:900;color:#fff;letter-spacing:-.03em;
// // // // // // // // // // // //           line-height:1;margin:0 0 2px;">${nm}</h1>
// // // // // // // // // // // //         <div style="width:52px;height:4px;background:${ac};border-radius:2px;
// // // // // // // // // // // //           margin:12px 0 12px;"></div>
// // // // // // // // // // // //         <div style="font-size:12px;color:rgba(255,255,255,.75);text-transform:uppercase;
// // // // // // // // // // // //           letter-spacing:.1em;margin-bottom:12px;">${ttl}</div>
// // // // // // // // // // // //         <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:18px;
// // // // // // // // // // // //           font-size:12px;color:rgba(255,255,255,.55);">
// // // // // // // // // // // //           ${ctcs.map(c => forWord
// // // // // // // // // // // //             ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // // // // // //             : `<span>${c}</span>`).join("")}
// // // // // // // // // // // //         </div>
// // // // // // // // // // // //       </div>
// // // // // // // // // // // //       <div style="padding:22px 30px;">${mainSections}</div>`;
// // // // // // // // // // // //   }

// // // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // // //   // MINIMAL
// // // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // // //   else if (templateId === "minimal") {
// // // // // // // // // // // //     body = `
// // // // // // // // // // // //       <div style="padding:32px 40px;">
// // // // // // // // // // // //         <div style="padding-bottom:18px;margin-bottom:22px;border-bottom:2.5px solid ${ac};">
// // // // // // // // // // // //           <h1 style="font-size:28px;font-weight:300;color:#0f172a;letter-spacing:-.02em;
// // // // // // // // // // // //             margin:0 0 6px;">${nm}</h1>
// // // // // // // // // // // //           <div style="width:32px;height:3px;background:${ac};border-radius:2px;
// // // // // // // // // // // //             margin-bottom:12px;"></div>
// // // // // // // // // // // //           <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:18px;
// // // // // // // // // // // //             font-size:13px;color:#64748b;">
// // // // // // // // // // // //             ${ctcs.map(c => forWord
// // // // // // // // // // // //               ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // // // // // //               : `<span>${c}</span>`).join("")}
// // // // // // // // // // // //           </div>
// // // // // // // // // // // //         </div>
// // // // // // // // // // // //         ${mainSections}
// // // // // // // // // // // //       </div>`;
// // // // // // // // // // // //   }

// // // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // // //   // PROFESSIONAL
// // // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // // //   else if (templateId === "professional") {
// // // // // // // // // // // //     body = `
// // // // // // // // // // // //       <div style="background:${hd};padding:26px 32px 20px;">
// // // // // // // // // // // //         <div style="display:${forWord?"block":"flex"};justify-content:space-between;
// // // // // // // // // // // //           align-items:flex-end;flex-wrap:wrap;gap:12px;">
// // // // // // // // // // // //           <div>
// // // // // // // // // // // //             <h1 style="font-size:26px;font-weight:700;color:#fff;margin:0 0 5px;">${nm}</h1>
// // // // // // // // // // // //             <div style="font-size:12px;color:${ac}cc;letter-spacing:.1em;
// // // // // // // // // // // //               text-transform:uppercase;">${ttl}</div>
// // // // // // // // // // // //           </div>
// // // // // // // // // // // //           <div style="${forWord?"":"text-align:right;"}">
// // // // // // // // // // // //             ${ctcs.slice(0,2).map(c =>
// // // // // // // // // // // //               `<div style="font-size:11px;color:rgba(255,255,255,.6);margin-bottom:3px;
// // // // // // // // // // // //                 ${forWord?"":"text-align:right;"}">${c}</div>`).join("")}
// // // // // // // // // // // //           </div>
// // // // // // // // // // // //         </div>
// // // // // // // // // // // //         <div style="height:2px;background:${ac};margin-top:16px;border-radius:1px;"></div>
// // // // // // // // // // // //       </div>
// // // // // // // // // // // //       <div style="padding:20px 32px;">
// // // // // // // // // // // //         ${ctcs.length > 2 ? `<div style="font-size:12px;color:#64748b;margin-bottom:18px;
// // // // // // // // // // // //           padding-bottom:14px;border-bottom:1px solid #f1f5f9;">
// // // // // // // // // // // //           ${ctcs.slice(2).map(c=>`<span style="margin-right:16px;">${c}</span>`).join("")}
// // // // // // // // // // // //         </div>` : ""}
// // // // // // // // // // // //         ${mainSections}
// // // // // // // // // // // //       </div>`;
// // // // // // // // // // // //   }

// // // // // // // // // // // //   // fallback
// // // // // // // // // // // //   else {
// // // // // // // // // // // //     body = `<div style="padding:32px 40px;">${mainSections}</div>`;
// // // // // // // // // // // //   }

// // // // // // // // // // // //   // ── Assemble full HTML ──
// // // // // // // // // // // //   const doctype = forWord
// // // // // // // // // // // //     ? `<!DOCTYPE html>
// // // // // // // // // // // // <html xmlns:o="urn:schemas-microsoft-com:office:office"
// // // // // // // // // // // //       xmlns:w="urn:schemas-microsoft-com:office:word"
// // // // // // // // // // // //       xmlns="http://www.w3.org/TR/REC-html40">`
// // // // // // // // // // // //     : `<!DOCTYPE html><html lang="en">`;

// // // // // // // // // // // //   return `${doctype}
// // // // // // // // // // // // <head>
// // // // // // // // // // // //   <meta charset="UTF-8">
// // // // // // // // // // // //   <title>${nm} &mdash; Resume</title>
// // // // // // // // // // // //   ${forWord ? `<!--[if gte mso 9]><xml>
// // // // // // // // // // // //     <w:WordDocument><w:View>Print</w:View><w:Zoom>100</w:Zoom>
// // // // // // // // // // // //     <w:DoNotOptimizeForBrowser/></w:WordDocument></xml><![endif]-->` : ""}
// // // // // // // // // // // //   <style>
// // // // // // // // // // // //     *,*::before,*::after { box-sizing:border-box; margin:0; padding:0; }
// // // // // // // // // // // //     body {
// // // // // // // // // // // //       font-family: Arial, Helvetica, sans-serif;
// // // // // // // // // // // //       font-size: 14px;
// // // // // // // // // // // //       line-height: 1.5;
// // // // // // // // // // // //       color: #1a202c;
// // // // // // // // // // // //       background: #fff;
// // // // // // // // // // // //       ${forWord ? "" : "-webkit-print-color-adjust:exact;print-color-adjust:exact;"}
// // // // // // // // // // // //     }
// // // // // // // // // // // //     .page {
// // // // // // // // // // // //       max-width: 850px;
// // // // // // // // // // // //       margin: 0 auto;
// // // // // // // // // // // //       background: #fff;
// // // // // // // // // // // //       ${forWord ? "" : "box-shadow:0 2px 12px rgba(0,0,0,.1);"}
// // // // // // // // // // // //     }
// // // // // // // // // // // //     ul { list-style: disc; }
// // // // // // // // // // // //     li { line-height: 1.7; }
// // // // // // // // // // // //     p  { margin-bottom: 6px; }
// // // // // // // // // // // //     h1,h2,h3 { line-height: 1.2; }
// // // // // // // // // // // //     ${printCSS}
// // // // // // // // // // // //   </style>
// // // // // // // // // // // // </head>
// // // // // // // // // // // // <body>
// // // // // // // // // // // //   ${hint}
// // // // // // // // // // // //   <div class="page">${body}</div>
// // // // // // // // // // // // </body>
// // // // // // // // // // // // </html>`;
// // // // // // // // // // // // }

// // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // HELPER — trigger file download
// // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // function dl(blob, name) {
// // // // // // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // // // // // //   const a   = Object.assign(document.createElement("a"), { href:url, download:name });
// // // // // // // // // // // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // // // // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 1000);
// // // // // // // // // // // // }

// // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // PDF — html2canvas + jsPDF (silent, no print dialog)
// // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // async function loadScript(src) {
// // // // // // // // // // // //   if (document.querySelector(`script[src="${src}"]`)?.dataset.loaded) return;
// // // // // // // // // // // //   return new Promise((res, rej) => {
// // // // // // // // // // // //     const s = Object.assign(document.createElement("script"), { src });
// // // // // // // // // // // //     s.onload = () => { s.dataset.loaded = "1"; res(); };
// // // // // // // // // // // //     s.onerror = rej;
// // // // // // // // // // // //     document.head.appendChild(s);
// // // // // // // // // // // //   });
// // // // // // // // // // // // }

// // // // // // // // // // // // export async function downloadResumeAsPDF(resume, fileName, templateId) {
// // // // // // // // // // // //   const t    = getT(templateId);
// // // // // // // // // // // //   const html = buildResumeHTML(resume, templateId, { showHint:false });
// // // // // // // // // // // //   const name = (fileName||"resume").replace(/\.pdf$/i,"");

// // // // // // // // // // // //   try {
// // // // // // // // // // // //     await loadScript("https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js");
// // // // // // // // // // // //     await loadScript("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js");

// // // // // // // // // // // //     // Render HTML in a hidden iframe to get exact layout
// // // // // // // // // // // //     const iframe = document.createElement("iframe");
// // // // // // // // // // // //     iframe.style.cssText = "position:fixed;left:-9999px;top:-9999px;width:850px;height:1200px;border:0;";
// // // // // // // // // // // //     document.body.appendChild(iframe);
// // // // // // // // // // // //     iframe.contentDocument.open();
// // // // // // // // // // // //     iframe.contentDocument.write(html);
// // // // // // // // // // // //     iframe.contentDocument.close();

// // // // // // // // // // // //     await new Promise(r => setTimeout(r, 600)); // wait for render

// // // // // // // // // // // //     const el = iframe.contentDocument.querySelector(".page");
// // // // // // // // // // // //     const canvas = await iframe.contentWindow.html2canvas(el, {
// // // // // // // // // // // //       scale: 2,
// // // // // // // // // // // //       useCORS: true,
// // // // // // // // // // // //       allowTaint: true,
// // // // // // // // // // // //       backgroundColor: "#ffffff",
// // // // // // // // // // // //       logging: false,
// // // // // // // // // // // //     });
// // // // // // // // // // // //     document.body.removeChild(iframe);

// // // // // // // // // // // //     const { jsPDF } = iframe.contentWindow?.jspdf || window.jspdf;
// // // // // // // // // // // //     const A4W = 210, A4H = 297;
// // // // // // // // // // // //     const imgW = A4W;
// // // // // // // // // // // //     const imgH = (canvas.height * A4W) / canvas.width;
// // // // // // // // // // // //     const pdf  = new jsPDF({ orientation:"portrait", unit:"mm", format:"a4" });

// // // // // // // // // // // //     let y = 0;
// // // // // // // // // // // //     const imgData = canvas.toDataURL("image/jpeg", 0.97);
// // // // // // // // // // // //     while (y < imgH) {
// // // // // // // // // // // //       if (y > 0) pdf.addPage();
// // // // // // // // // // // //       pdf.addImage(imgData, "JPEG", 0, -y, imgW, imgH);
// // // // // // // // // // // //       y += A4H;
// // // // // // // // // // // //     }
// // // // // // // // // // // //     pdf.save(`${name}.pdf`);

// // // // // // // // // // // //   } catch (err) {
// // // // // // // // // // // //     console.error("PDF error — falling back to HTML:", err);
// // // // // // // // // // // //     // Fallback: open in new tab
// // // // // // // // // // // //     const win = window.open("","_blank");
// // // // // // // // // // // //     if (win) {
// // // // // // // // // // // //       win.document.write(buildResumeHTML(resume, templateId, { showHint:true }));
// // // // // // // // // // // //       win.document.close(); win.focus();
// // // // // // // // // // // //       setTimeout(() => win.print(), 800);
// // // // // // // // // // // //     }
// // // // // // // // // // // //   }
// // // // // // // // // // // // }

// // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // WORD — Word-safe HTML, direct .doc download
// // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // export function downloadResumeAsWord(resume, fileName, templateId) {
// // // // // // // // // // // //   const html = buildResumeHTML(resume, templateId, { forWord:true });
// // // // // // // // // // // //   dl(new Blob(["\ufeff", html], { type:"application/msword;charset=utf-8" }),
// // // // // // // // // // // //     (fileName||"resume").replace(/\.(doc|docx|html?)$/i,"") + ".doc");
// // // // // // // // // // // // }

// // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // // HTML — full HTML file, opens in browser
// // // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // export function downloadATSResume(resume, fileName, templateId) {
// // // // // // // // // // // //   const html = buildResumeHTML(resume, templateId, { showHint:true });
// // // // // // // // // // // //   dl(new Blob([html], { type:"text/html;charset=utf-8" }),
// // // // // // // // // // // //     (fileName||"resume").replace(/\.html?$/i,"") + ".html");
// // // // // // // // // // // // }

// // // // // // // // // // // // src/utils/generateResumeDoc.js
// // // // // // // // // // // // Single source of truth for all resume downloads
// // // // // // // // // // // // HTML generator mirrors ResumeGeneratorPage.jsx ResumePreview exactly

// // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // DOWNLOAD TEMPLATES — colors MUST match servicesConfig.js exactly
// // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // const DOWNLOAD_TEMPLATES = {
// // // // // // // // // // //   classic: {
// // // // // // // // // // //     name:   "Classic ATS",
// // // // // // // // // // //     accent: "#2563eb",
// // // // // // // // // // //     header: "#1e293b",
// // // // // // // // // // //   },
// // // // // // // // // // //   executive: {
// // // // // // // // // // //     name:   "Executive",
// // // // // // // // // // //     accent: "#334155",
// // // // // // // // // // //     header: "#0f172a",
// // // // // // // // // // //   },
// // // // // // // // // // //   bold: {
// // // // // // // // // // //     name:   "Bold Impact",
// // // // // // // // // // //     accent: "#1d4ed8",
// // // // // // // // // // //     header: "#1e3a8a",
// // // // // // // // // // //   },
// // // // // // // // // // //   minimal: {
// // // // // // // // // // //     name:   "Minimal Clean",
// // // // // // // // // // //     accent: "#059669",
// // // // // // // // // // //     header: "#059669",
// // // // // // // // // // //   },
// // // // // // // // // // //   professional: {
// // // // // // // // // // //     name:   "Professional",
// // // // // // // // // // //     accent: "#1e3a5f",
// // // // // // // // // // //     header: "#1e3a5f",
// // // // // // // // // // //   },
// // // // // // // // // // // };

// // // // // // // // // // // function getT(id) {
// // // // // // // // // // //   return DOWNLOAD_TEMPLATES[id] || DOWNLOAD_TEMPLATES.classic;
// // // // // // // // // // // }

// // // // // // // // // // // function esc(s) {
// // // // // // // // // // //   if (!s) return "";
// // // // // // // // // // //   return String(s)
// // // // // // // // // // //     .replace(/&/g,"&amp;").replace(/</g,"&lt;")
// // // // // // // // // // //     .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// // // // // // // // // // // }

// // // // // // // // // // // function fmt(s, e) {
// // // // // // // // // // //   if (!s && !e) return "";
// // // // // // // // // // //   if (s && !e) return esc(s);
// // // // // // // // // // //   if (!s && e) return esc(e);
// // // // // // // // // // //   return `${esc(s)} &ndash; ${esc(e)}`;
// // // // // // // // // // // }

// // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // CORE HTML BUILDER
// // // // // // // // // // // // forWord=true → removes rgba, flexbox → uses table for sidebar
// // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // function buildResumeHTML(resume, templateId, opts = {}) {
// // // // // // // // // // //   const { forWord = false, showHint = false } = opts;
// // // // // // // // // // //   const t  = getT(templateId);
// // // // // // // // // // //   const ac = t.accent;
// // // // // // // // // // //   const hd = t.header;

// // // // // // // // // // //   const nm   = esc(resume.name)  || "Your Name";
// // // // // // // // // // //   const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
// // // // // // // // // // //   const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean).map(esc);

// // // // // // // // // // //   // ── Section title — must match SectionTitle in ResumeGeneratorPage.jsx ──
// // // // // // // // // // //   const isFilled = ["bold","professional","corporate"].includes(templateId);
// // // // // // // // // // //   function secTitle(text) {
// // // // // // // // // // //     if (isFilled) {
// // // // // // // // // // //       return `<div style="background:${ac}10;border-left:3px solid ${ac};padding:6px 12px;
// // // // // // // // // // //         margin-bottom:14px;border-radius:0 6px 6px 0;">
// // // // // // // // // // //         <div style="font-size:11px;font-weight:800;text-transform:uppercase;
// // // // // // // // // // //           letter-spacing:.1em;color:${ac};">${text}</div></div>`;
// // // // // // // // // // //     }
// // // // // // // // // // //     // classic, executive, minimal — underline
// // // // // // // // // // //     return `<div style="margin-bottom:14px;border-bottom:1.5px solid ${ac};padding-bottom:5px;">
// // // // // // // // // // //       <div style="font-size:11px;font-weight:800;text-transform:uppercase;
// // // // // // // // // // //         letter-spacing:.1em;color:${ac};">${text}</div></div>`;
// // // // // // // // // // //   }

// // // // // // // // // // //   // ── Experience ──
// // // // // // // // // // //   const expHtml = (resume.experience||[]).map(exp => {
// // // // // // // // // // //     const bullets = (exp.bullets||[]).map(b =>
// // // // // // // // // // //       `<li style="font-size:13px;color:#374151;margin-bottom:6px;line-height:1.7;">${esc(b)}</li>`
// // // // // // // // // // //     ).join("");
// // // // // // // // // // //     return `<div style="margin-bottom:18px;">
// // // // // // // // // // //       <div style="margin-bottom:4px;">
// // // // // // // // // // //         <span style="font-weight:700;font-size:14px;color:#0f172a;">${esc(exp.title||"")}</span>
// // // // // // // // // // //         <span style="color:#475569;font-size:13px;"> &mdash; ${esc(exp.company||"")}</span>
// // // // // // // // // // //         ${exp.location?`<span style="color:#94a3b8;font-size:12px;"> | ${esc(exp.location)}</span>`:""}
// // // // // // // // // // //       </div>
// // // // // // // // // // //       <div style="font-size:12px;color:#64748b;font-style:italic;margin-bottom:7px;">
// // // // // // // // // // //         ${fmt(exp.startDate,exp.endDate)}</div>
// // // // // // // // // // //       <ul style="margin:0 0 0 20px;padding:0;">${bullets}</ul>
// // // // // // // // // // //     </div>`;
// // // // // // // // // // //   }).join("");

// // // // // // // // // // //   // ── Education ──
// // // // // // // // // // //   const eduHtml = (resume.education||[]).map(edu =>
// // // // // // // // // // //     `<div style="margin-bottom:12px;">
// // // // // // // // // // //       <span style="font-weight:600;font-size:14px;color:#0f172a;">${esc(edu.degree||"")}</span>
// // // // // // // // // // //       <span style="color:#475569;font-size:13px;"> &mdash; ${esc(edu.school||"")}</span>
// // // // // // // // // // //       ${edu.location?`<span style="color:#94a3b8;font-size:12px;"> | ${esc(edu.location)}</span>`:""}
// // // // // // // // // // //       <div style="font-size:12px;color:#64748b;font-style:italic;margin-top:2px;">
// // // // // // // // // // //         ${esc(edu.year||"")}${edu.gpa?` | GPA: ${esc(edu.gpa)}`:""}
// // // // // // // // // // //       </div>
// // // // // // // // // // //     </div>`
// // // // // // // // // // //   ).join("");

// // // // // // // // // // //   // ── Skills ──
// // // // // // // // // // //   const sk = resume.skills||{};
// // // // // // // // // // //   const skillsHtml = [
// // // // // // // // // // //     sk.technical?.length ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // // // // //       <strong>Technical:</strong> ${sk.technical.map(esc).join(", ")}</p>` : "",
// // // // // // // // // // //     sk.tools?.length     ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // // // // //       <strong>Tools:</strong> ${sk.tools.map(esc).join(", ")}</p>` : "",
// // // // // // // // // // //     sk.soft?.length      ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // // // // //       <strong>Soft Skills:</strong> ${sk.soft.map(esc).join(", ")}</p>` : "",
// // // // // // // // // // //   ].join("");

// // // // // // // // // // //   // ── Certifications ──
// // // // // // // // // // //   const certHtml = (resume.certifications||[]).length
// // // // // // // // // // //     ? `<ul style="margin:0 0 0 20px;padding:0;">${(resume.certifications).map(c=>
// // // // // // // // // // //         `<li style="font-size:13px;color:#374151;margin-bottom:6px;line-height:1.7;">${esc(c)}</li>`
// // // // // // // // // // //       ).join("")}</ul>` : "";

// // // // // // // // // // //   // ── Main content sections ──
// // // // // // // // // // //   function section(title, body) {
// // // // // // // // // // //     if (!body?.trim()) return "";
// // // // // // // // // // //     return `<div style="margin-bottom:24px;">${secTitle(title)}${body}</div>`;
// // // // // // // // // // //   }
// // // // // // // // // // //   const mainSections = `
// // // // // // // // // // //     ${resume.summary ? section("Professional Summary",
// // // // // // // // // // //       `<p style="font-size:13px;line-height:1.8;color:#374151;">${esc(resume.summary)}</p>`) : ""}
// // // // // // // // // // //     ${expHtml  ? section("Work Experience", expHtml)  : ""}
// // // // // // // // // // //     ${eduHtml  ? section("Education",       eduHtml)  : ""}
// // // // // // // // // // //     ${skillsHtml ? section("Skills",        skillsHtml) : ""}
// // // // // // // // // // //     ${certHtml ? section("Certifications",  certHtml) : ""}`;

// // // // // // // // // // //   // ── Print hint (PDF/HTML only) ──
// // // // // // // // // // //   const hint = showHint ? `
// // // // // // // // // // //     <div class="no-print" style="background:#e8f0fe;border:1px solid #1a73e8;border-radius:8px;
// // // // // // // // // // //       padding:12px 18px;margin-bottom:20px;text-align:center;font-size:13px;color:#1a73e8;
// // // // // // // // // // //       font-family:Arial,sans-serif;">
// // // // // // // // // // //       📄 <strong>Save as PDF:</strong> Ctrl+P &rarr; destination = "Save as PDF" &rarr;
// // // // // // // // // // //       margins = "None" &rarr; enable "Background graphics" &rarr; Save
// // // // // // // // // // //     </div>` : "";

// // // // // // // // // // //   // ── Print / page CSS ──
// // // // // // // // // // //   const printCSS = forWord
// // // // // // // // // // //     ? `@page { size:A4; margin:.65in; }`
// // // // // // // // // // //     : `@media print {
// // // // // // // // // // //         .no-print { display:none!important; }
// // // // // // // // // // //         body { margin:0; padding:0; background:#fff; }
// // // // // // // // // // //         .page { box-shadow:none!important; }
// // // // // // // // // // //         @page { size:A4; margin:0; }
// // // // // // // // // // //       }
// // // // // // // // // // //       -webkit-print-color-adjust: exact;
// // // // // // // // // // //       print-color-adjust: exact;`;

// // // // // // // // // // //   // ── Build body per template ──
// // // // // // // // // // //   let body = "";

// // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // //   // CLASSIC
// // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // //   if (templateId === "classic") {
// // // // // // // // // // //     body = `
// // // // // // // // // // //       <div style="padding:32px 40px;">
// // // // // // // // // // //         <div style="text-align:center;padding-bottom:20px;margin-bottom:24px;
// // // // // // // // // // //           border-bottom:2px solid ${ac};">
// // // // // // // // // // //           <h1 style="font-size:26px;font-weight:700;color:#0f172a;margin:0 0 8px;
// // // // // // // // // // //             font-family:Georgia,'Times New Roman',serif;">${nm}</h1>
// // // // // // // // // // //           <div style="display:${forWord?"block":"flex"};justify-content:center;
// // // // // // // // // // //             flex-wrap:wrap;gap:16px;font-size:13px;color:#475569;margin-top:8px;">
// // // // // // // // // // //             ${ctcs.map(c => forWord
// // // // // // // // // // //               ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // // // // //               : `<span>${c}</span>`).join("")}
// // // // // // // // // // //           </div>
// // // // // // // // // // //         </div>
// // // // // // // // // // //         ${mainSections}
// // // // // // // // // // //       </div>`;
// // // // // // // // // // //   }

// // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // //   // EXECUTIVE
// // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // //   else if (templateId === "executive") {
// // // // // // // // // // //     body = `
// // // // // // // // // // //       <div style="background:${hd};padding:30px 40px 26px;color:#fff;">
// // // // // // // // // // //         <h1 style="font-size:28px;font-weight:700;color:#fff;text-transform:uppercase;
// // // // // // // // // // //           letter-spacing:.06em;margin:0 0 10px;
// // // // // // // // // // //           font-family:Georgia,'Times New Roman',serif;">${nm}</h1>
// // // // // // // // // // //         <div style="height:2px;background:rgba(255,255,255,.3);margin-bottom:4px;"></div>
// // // // // // // // // // //         <div style="height:1px;background:rgba(255,255,255,.1);margin-bottom:14px;"></div>
// // // // // // // // // // //         <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:20px;
// // // // // // // // // // //           font-size:12px;color:rgba(255,255,255,.65);">
// // // // // // // // // // //           ${ctcs.map(c => forWord
// // // // // // // // // // //             ? `<span style="margin-right:18px;">${c}</span>`
// // // // // // // // // // //             : `<span>${c}</span>`).join("")}
// // // // // // // // // // //         </div>
// // // // // // // // // // //       </div>
// // // // // // // // // // //       <div style="padding:26px 40px;">${mainSections}</div>`;
// // // // // // // // // // //   }

// // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // //   // BOLD
// // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // //   else if (templateId === "bold") {
// // // // // // // // // // //     body = `
// // // // // // // // // // //       <div style="background:${hd};padding:28px 30px 24px;">
// // // // // // // // // // //         <h1 style="font-size:34px;font-weight:900;color:#fff;letter-spacing:-.03em;
// // // // // // // // // // //           line-height:1;margin:0 0 2px;">${nm}</h1>
// // // // // // // // // // //         <div style="width:52px;height:4px;background:${ac};border-radius:2px;
// // // // // // // // // // //           margin:12px 0 12px;"></div>
// // // // // // // // // // //         <div style="font-size:12px;color:rgba(255,255,255,.75);text-transform:uppercase;
// // // // // // // // // // //           letter-spacing:.1em;margin-bottom:12px;">${ttl}</div>
// // // // // // // // // // //         <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:18px;
// // // // // // // // // // //           font-size:12px;color:rgba(255,255,255,.55);">
// // // // // // // // // // //           ${ctcs.map(c => forWord
// // // // // // // // // // //             ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // // // // //             : `<span>${c}</span>`).join("")}
// // // // // // // // // // //         </div>
// // // // // // // // // // //       </div>
// // // // // // // // // // //       <div style="padding:22px 30px;">${mainSections}</div>`;
// // // // // // // // // // //   }

// // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // //   // MINIMAL
// // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // //   else if (templateId === "minimal") {
// // // // // // // // // // //     body = `
// // // // // // // // // // //       <div style="padding:32px 40px;">
// // // // // // // // // // //         <div style="padding-bottom:18px;margin-bottom:22px;border-bottom:2.5px solid ${ac};">
// // // // // // // // // // //           <h1 style="font-size:28px;font-weight:300;color:#0f172a;letter-spacing:-.02em;
// // // // // // // // // // //             margin:0 0 6px;">${nm}</h1>
// // // // // // // // // // //           <div style="width:32px;height:3px;background:${ac};border-radius:2px;
// // // // // // // // // // //             margin-bottom:12px;"></div>
// // // // // // // // // // //           <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:18px;
// // // // // // // // // // //             font-size:13px;color:#64748b;">
// // // // // // // // // // //             ${ctcs.map(c => forWord
// // // // // // // // // // //               ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // // // // //               : `<span>${c}</span>`).join("")}
// // // // // // // // // // //           </div>
// // // // // // // // // // //         </div>
// // // // // // // // // // //         ${mainSections}
// // // // // // // // // // //       </div>`;
// // // // // // // // // // //   }

// // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // //   // PROFESSIONAL
// // // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // // //   else if (templateId === "professional") {
// // // // // // // // // // //     body = `
// // // // // // // // // // //       <div style="background:${hd};padding:26px 32px 20px;">
// // // // // // // // // // //         <div style="display:${forWord?"block":"flex"};justify-content:space-between;
// // // // // // // // // // //           align-items:flex-end;flex-wrap:wrap;gap:12px;">
// // // // // // // // // // //           <div>
// // // // // // // // // // //             <h1 style="font-size:26px;font-weight:700;color:#fff;margin:0 0 5px;">${nm}</h1>
// // // // // // // // // // //             <div style="font-size:12px;color:${ac}cc;letter-spacing:.1em;
// // // // // // // // // // //               text-transform:uppercase;">${ttl}</div>
// // // // // // // // // // //           </div>
// // // // // // // // // // //           <div style="${forWord?"":"text-align:right;"}">
// // // // // // // // // // //             ${ctcs.slice(0,2).map(c =>
// // // // // // // // // // //               `<div style="font-size:11px;color:rgba(255,255,255,.6);margin-bottom:3px;
// // // // // // // // // // //                 ${forWord?"":"text-align:right;"}">${c}</div>`).join("")}
// // // // // // // // // // //           </div>
// // // // // // // // // // //         </div>
// // // // // // // // // // //         <div style="height:2px;background:${ac};margin-top:16px;border-radius:1px;"></div>
// // // // // // // // // // //       </div>
// // // // // // // // // // //       <div style="padding:20px 32px;">
// // // // // // // // // // //         ${ctcs.length > 2 ? `<div style="font-size:12px;color:#64748b;margin-bottom:18px;
// // // // // // // // // // //           padding-bottom:14px;border-bottom:1px solid #f1f5f9;">
// // // // // // // // // // //           ${ctcs.slice(2).map(c=>`<span style="margin-right:16px;">${c}</span>`).join("")}
// // // // // // // // // // //         </div>` : ""}
// // // // // // // // // // //         ${mainSections}
// // // // // // // // // // //       </div>`;
// // // // // // // // // // //   }

// // // // // // // // // // //   // fallback
// // // // // // // // // // //   else {
// // // // // // // // // // //     body = `<div style="padding:32px 40px;">${mainSections}</div>`;
// // // // // // // // // // //   }

// // // // // // // // // // //   // ── Assemble full HTML ──
// // // // // // // // // // //   const doctype = forWord
// // // // // // // // // // //     ? `<!DOCTYPE html>
// // // // // // // // // // // <html xmlns:o="urn:schemas-microsoft-com:office:office"
// // // // // // // // // // //       xmlns:w="urn:schemas-microsoft-com:office:word"
// // // // // // // // // // //       xmlns="http://www.w3.org/TR/REC-html40">`
// // // // // // // // // // //     : `<!DOCTYPE html><html lang="en">`;

// // // // // // // // // // //   return `${doctype}
// // // // // // // // // // // <head>
// // // // // // // // // // //   <meta charset="UTF-8">
// // // // // // // // // // //   <title>${nm} &mdash; Resume</title>
// // // // // // // // // // //   ${forWord ? `<!--[if gte mso 9]><xml>
// // // // // // // // // // //     <w:WordDocument><w:View>Print</w:View><w:Zoom>100</w:Zoom>
// // // // // // // // // // //     <w:DoNotOptimizeForBrowser/></w:WordDocument></xml><![endif]-->` : ""}
// // // // // // // // // // //   <style>
// // // // // // // // // // //     *,*::before,*::after { box-sizing:border-box; margin:0; padding:0; }
// // // // // // // // // // //     body {
// // // // // // // // // // //       font-family: Arial, Helvetica, sans-serif;
// // // // // // // // // // //       font-size: 14px;
// // // // // // // // // // //       line-height: 1.5;
// // // // // // // // // // //       color: #1a202c;
// // // // // // // // // // //       background: #fff;
// // // // // // // // // // //       ${forWord ? "" : "-webkit-print-color-adjust:exact;print-color-adjust:exact;"}
// // // // // // // // // // //     }
// // // // // // // // // // //     .page {
// // // // // // // // // // //       max-width: 850px;
// // // // // // // // // // //       margin: 0 auto;
// // // // // // // // // // //       background: #fff;
// // // // // // // // // // //       ${forWord ? "" : "box-shadow:0 2px 12px rgba(0,0,0,.1);"}
// // // // // // // // // // //     }
// // // // // // // // // // //     ul { list-style: disc; }
// // // // // // // // // // //     li { line-height: 1.7; }
// // // // // // // // // // //     p  { margin-bottom: 6px; }
// // // // // // // // // // //     h1,h2,h3 { line-height: 1.2; }
// // // // // // // // // // //     ${printCSS}
// // // // // // // // // // //   </style>
// // // // // // // // // // // </head>
// // // // // // // // // // // <body>
// // // // // // // // // // //   ${hint}
// // // // // // // // // // //   <div class="page">${body}</div>
// // // // // // // // // // // </body>
// // // // // // // // // // // </html>`;
// // // // // // // // // // // }

// // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // HELPER — trigger file download
// // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // function dl(blob, name) {
// // // // // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // // // // //   const a   = Object.assign(document.createElement("a"), { href: url, download: name });
// // // // // // // // // // //   document.body.appendChild(a);
// // // // // // // // // // //   a.click();
// // // // // // // // // // //   document.body.removeChild(a);
// // // // // // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 2000);
// // // // // // // // // // // }

// // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // PDF — opens styled HTML in new tab, auto-triggers print dialog
// // // // // // // // // // // // User presses Ctrl+P → Save as PDF → gets exact match to screen
// // // // // // // // // // // // No CDN libraries, no canvas, works 100% reliably
// // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // export function downloadResumeAsPDF(resume, fileName, templateId, previewElement) {
// // // // // // // // // // //   const name = (fileName || "resume").replace(/\.(pdf|html?)$/i, "");



// // // // // // // // // // //   const resumeBodyHTML = buildResumeHTML(resume, templateId, { showHint: false })
// // // // // // // // // // //     .replace(/<!DOCTYPE html>[\s\S]*?<body[^>]*>/i, "")
// // // // // // // // // // //     .replace(/<\/body>[\s\S]*$/i, "")
// // // // // // // // // // //     .trim();

// // // // // // // // // // //   const html = `<!DOCTYPE html>
// // // // // // // // // // // <html lang="en">
// // // // // // // // // // // <head>
// // // // // // // // // // //   <meta charset="UTF-8">
// // // // // // // // // // //   <title>${resume.name || "Resume"}</title>
// // // // // // // // // // //   <style>
// // // // // // // // // // //     *, *::before, *::after { box-sizing: border-box; }
// // // // // // // // // // //     html, body {
// // // // // // // // // // //       margin: 0; padding: 0;
// // // // // // // // // // //       background: #f0f0f0;
// // // // // // // // // // //       font-family: Arial, Helvetica, sans-serif;
// // // // // // // // // // //       -webkit-print-color-adjust: exact;
// // // // // // // // // // //       print-color-adjust: exact;
// // // // // // // // // // //     }
// // // // // // // // // // //     /* Screen: show as paper page with shadow */
// // // // // // // // // // //     .resume-sheet {
// // // // // // // // // // //       max-width: 794px;        /* A4 width in px at 96dpi */
// // // // // // // // // // //       margin: 20px auto 40px;
// // // // // // // // // // //       background: #fff;
// // // // // // // // // // //       box-shadow: 0 4px 20px rgba(0,0,0,0.15);
// // // // // // // // // // //       overflow: hidden;
// // // // // // // // // // //       word-break: break-word;
// // // // // // // // // // //       word-wrap: break-word;
// // // // // // // // // // //     }
// // // // // // // // // // //     /* Print: full page, no background, proper margins */
// // // // // // // // // // //     @media print {
// // // // // // // // // // //       html, body { background: #fff; }
// // // // // // // // // // //       .no-print  { display: none !important; }
// // // // // // // // // // //       .resume-sheet {
// // // // // // // // // // //         max-width: 100%;
// // // // // // // // // // //         width: 100%;
// // // // // // // // // // //         margin: 0;
// // // // // // // // // // //         box-shadow: none;
// // // // // // // // // // //         -webkit-print-color-adjust: exact;
// // // // // // // // // // //         print-color-adjust: exact;
// // // // // // // // // // //       }
// // // // // // // // // // //       @page { size: A4; margin: 15mm 15mm 15mm 15mm; }
// // // // // // // // // // //     }
// // // // // // // // // // //   </style>
// // // // // // // // // // // </head>
// // // // // // // // // // // <body>
// // // // // // // // // // //   <div class="no-print" style="background:#1d4ed8;color:#fff;padding:12px 20px;
// // // // // // // // // // //     text-align:center;font-size:13px;font-family:Arial,sans-serif;
// // // // // // // // // // //     position:sticky;top:0;z-index:999;line-height:1.8;">
// // // // // // // // // // //     📄 <strong>Step 1:</strong> Press
// // // // // // // // // // //     <kbd style="background:rgba(255,255,255,0.25);padding:2px 8px;border-radius:4px;font-size:12px;">Ctrl+P</kbd>
// // // // // // // // // // //     &nbsp;→&nbsp; <strong>Step 2:</strong> Destination = <strong>"Save as PDF"</strong>
// // // // // // // // // // //     &nbsp;→&nbsp; <strong>Step 3:</strong> Enable <strong>"Background graphics"</strong>
// // // // // // // // // // //     &nbsp;→&nbsp; <strong>Save</strong>
// // // // // // // // // // //   </div>
// // // // // // // // // // //   <div class="resume-sheet">
// // // // // // // // // // //     ${resumeBodyHTML}
// // // // // // // // // // //   </div>
// // // // // // // // // // // </body>
// // // // // // // // // // // </html>`;

// // // // // // // // // // //   const win = window.open("", "_blank");
// // // // // // // // // // //   if (!win) {
// // // // // // // // // // //     // Popup blocked — download as HTML fallback
// // // // // // // // // // //     dl(new Blob([html], { type: "text/html;charset=utf-8" }), `${name}.html`);
// // // // // // // // // // //     return;
// // // // // // // // // // //   }
// // // // // // // // // // //   win.document.open();
// // // // // // // // // // //   win.document.write(html);
// // // // // // // // // // //   win.document.close();
// // // // // // // // // // //   win.focus();
// // // // // // // // // // //   setTimeout(() => {
// // // // // // // // // // //     try { win.print(); } catch (e) { /* user can Ctrl+P manually */ }
// // // // // // // // // // //   }, 800);
// // // // // // // // // // // }

// // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // WORD — saves as .doc using text/html MIME
// // // // // // // // // // // // Word opens HTML files natively — reliable cross-browser
// // // // // // // // // // // // (application/msword MIME is blocked by modern browsers)
// // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // export function downloadResumeAsWord(resume, fileName, templateId) {
// // // // // // // // // // //   const html = buildResumeHTML(resume, templateId, { forWord: true });
// // // // // // // // // // //   // Use text/plain MIME — most reliable for triggering download
// // // // // // // // // // //   // The .doc extension tells Word to open it natively
// // // // // // // // // // //   dl(
// // // // // // // // // // //     new Blob(["\ufeff", html], { type: "text/plain;charset=utf-8" }),
// // // // // // // // // // //     (fileName || "resume").replace(/\.(doc|docx|html?)$/i, "") + ".doc"
// // // // // // // // // // //   );
// // // // // // // // // // // }

// // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // // HTML — saves as .html, opens in browser
// // // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // export function downloadATSResume(resume, fileName, templateId) {
// // // // // // // // // // //   const html = buildResumeHTML(resume, templateId, { showHint: true });
// // // // // // // // // // //   dl(
// // // // // // // // // // //     new Blob([html], { type: "text/html;charset=utf-8" }),
// // // // // // // // // // //     (fileName || "resume").replace(/\.html?$/i, "") + ".html"
// // // // // // // // // // //   );
// // // // // // // // // // // }

// // // // // // // // // // // src/utils/generateResumeDoc.js
// // // // // // // // // // // Single source of truth for all resume downloads
// // // // // // // // // // // HTML generator mirrors ResumeGeneratorPage.jsx ResumePreview exactly

// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // DOWNLOAD TEMPLATES — colors MUST match servicesConfig.js exactly
// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // const DOWNLOAD_TEMPLATES = {
// // // // // // // // // //   classic: {
// // // // // // // // // //     name:   "Classic ATS",
// // // // // // // // // //     accent: "#2563eb",
// // // // // // // // // //     header: "#1e293b",
// // // // // // // // // //   },
// // // // // // // // // //   executive: {
// // // // // // // // // //     name:   "Executive",
// // // // // // // // // //     accent: "#334155",
// // // // // // // // // //     header: "#0f172a",
// // // // // // // // // //   },
// // // // // // // // // //   bold: {
// // // // // // // // // //     name:   "Bold Impact",
// // // // // // // // // //     accent: "#1d4ed8",
// // // // // // // // // //     header: "#1e3a8a",
// // // // // // // // // //   },
// // // // // // // // // //   minimal: {
// // // // // // // // // //     name:   "Minimal Clean",
// // // // // // // // // //     accent: "#059669",
// // // // // // // // // //     header: "#059669",
// // // // // // // // // //   },
// // // // // // // // // //   professional: {
// // // // // // // // // //     name:   "Professional",
// // // // // // // // // //     accent: "#1e3a5f",
// // // // // // // // // //     header: "#1e3a5f",
// // // // // // // // // //   },
// // // // // // // // // // };

// // // // // // // // // // function getT(id) {
// // // // // // // // // //   return DOWNLOAD_TEMPLATES[id] || DOWNLOAD_TEMPLATES.classic;
// // // // // // // // // // }

// // // // // // // // // // function esc(s) {
// // // // // // // // // //   if (!s) return "";
// // // // // // // // // //   return String(s)
// // // // // // // // // //     .replace(/&/g,"&amp;").replace(/</g,"&lt;")
// // // // // // // // // //     .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// // // // // // // // // // }

// // // // // // // // // // function fmt(s, e) {
// // // // // // // // // //   if (!s && !e) return "";
// // // // // // // // // //   if (s && !e) return esc(s);
// // // // // // // // // //   if (!s && e) return esc(e);
// // // // // // // // // //   return `${esc(s)} &ndash; ${esc(e)}`;
// // // // // // // // // // }

// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // CORE HTML BUILDER
// // // // // // // // // // // forWord=true → removes rgba, flexbox → uses table for sidebar
// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // function buildResumeHTML(resume, templateId, opts = {}) {
// // // // // // // // // //   const { forWord = false, showHint = false } = opts;
// // // // // // // // // //   const t  = getT(templateId);
// // // // // // // // // //   const ac = t.accent;
// // // // // // // // // //   const hd = t.header;

// // // // // // // // // //   const nm   = esc(resume.name)  || "Your Name";
// // // // // // // // // //   const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
// // // // // // // // // //   const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean).map(esc);

// // // // // // // // // //   // ── Section title — must match SectionTitle in ResumeGeneratorPage.jsx ──
// // // // // // // // // //   const isFilled = ["bold","professional","corporate"].includes(templateId);
// // // // // // // // // //   function secTitle(text) {
// // // // // // // // // //     if (isFilled) {
// // // // // // // // // //       return `<div style="background:${ac}10;border-left:3px solid ${ac};padding:6px 12px;
// // // // // // // // // //         margin-bottom:14px;border-radius:0 6px 6px 0;">
// // // // // // // // // //         <div style="font-size:11px;font-weight:800;text-transform:uppercase;
// // // // // // // // // //           letter-spacing:.1em;color:${ac};">${text}</div></div>`;
// // // // // // // // // //     }
// // // // // // // // // //     // classic, executive, minimal — underline
// // // // // // // // // //     return `<div style="margin-bottom:14px;border-bottom:1.5px solid ${ac};padding-bottom:5px;">
// // // // // // // // // //       <div style="font-size:11px;font-weight:800;text-transform:uppercase;
// // // // // // // // // //         letter-spacing:.1em;color:${ac};">${text}</div></div>`;
// // // // // // // // // //   }

// // // // // // // // // //   // ── Experience ──
// // // // // // // // // //   const expHtml = (resume.experience||[]).map(exp => {
// // // // // // // // // //     const bullets = (exp.bullets||[]).map(b =>
// // // // // // // // // //       `<li style="font-size:13px;color:#374151;margin-bottom:6px;line-height:1.7;">${esc(b)}</li>`
// // // // // // // // // //     ).join("");
// // // // // // // // // //     return `<div style="margin-bottom:18px;">
// // // // // // // // // //       <div style="margin-bottom:4px;">
// // // // // // // // // //         <span style="font-weight:700;font-size:14px;color:#0f172a;">${esc(exp.title||"")}</span>
// // // // // // // // // //         <span style="color:#475569;font-size:13px;"> &mdash; ${esc(exp.company||"")}</span>
// // // // // // // // // //         ${exp.location?`<span style="color:#94a3b8;font-size:12px;"> | ${esc(exp.location)}</span>`:""}
// // // // // // // // // //       </div>
// // // // // // // // // //       <div style="font-size:12px;color:#64748b;font-style:italic;margin-bottom:7px;">
// // // // // // // // // //         ${fmt(exp.startDate,exp.endDate)}</div>
// // // // // // // // // //       <ul style="margin:0 0 0 20px;padding:0;">${bullets}</ul>
// // // // // // // // // //     </div>`;
// // // // // // // // // //   }).join("");

// // // // // // // // // //   // ── Education ──
// // // // // // // // // //   const eduHtml = (resume.education||[]).map(edu =>
// // // // // // // // // //     `<div style="margin-bottom:12px;">
// // // // // // // // // //       <span style="font-weight:600;font-size:14px;color:#0f172a;">${esc(edu.degree||"")}</span>
// // // // // // // // // //       <span style="color:#475569;font-size:13px;"> &mdash; ${esc(edu.school||"")}</span>
// // // // // // // // // //       ${edu.location?`<span style="color:#94a3b8;font-size:12px;"> | ${esc(edu.location)}</span>`:""}
// // // // // // // // // //       <div style="font-size:12px;color:#64748b;font-style:italic;margin-top:2px;">
// // // // // // // // // //         ${esc(edu.year||"")}${edu.gpa?` | GPA: ${esc(edu.gpa)}`:""}
// // // // // // // // // //       </div>
// // // // // // // // // //     </div>`
// // // // // // // // // //   ).join("");

// // // // // // // // // //   // ── Skills ──
// // // // // // // // // //   const sk = resume.skills||{};
// // // // // // // // // //   const skillsHtml = [
// // // // // // // // // //     sk.technical?.length ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // // // //       <strong>Technical:</strong> ${sk.technical.map(esc).join(", ")}</p>` : "",
// // // // // // // // // //     sk.tools?.length     ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // // // //       <strong>Tools:</strong> ${sk.tools.map(esc).join(", ")}</p>` : "",
// // // // // // // // // //     sk.soft?.length      ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // // // //       <strong>Soft Skills:</strong> ${sk.soft.map(esc).join(", ")}</p>` : "",
// // // // // // // // // //   ].join("");

// // // // // // // // // //   // ── Certifications ──
// // // // // // // // // //   const certHtml = (resume.certifications||[]).length
// // // // // // // // // //     ? `<ul style="margin:0 0 0 20px;padding:0;">${(resume.certifications).map(c=>
// // // // // // // // // //         `<li style="font-size:13px;color:#374151;margin-bottom:6px;line-height:1.7;">${esc(c)}</li>`
// // // // // // // // // //       ).join("")}</ul>` : "";

// // // // // // // // // //   // ── Main content sections ──
// // // // // // // // // //   function section(title, body) {
// // // // // // // // // //     if (!body?.trim()) return "";
// // // // // // // // // //     return `<div style="margin-bottom:24px;">${secTitle(title)}${body}</div>`;
// // // // // // // // // //   }
// // // // // // // // // //   const mainSections = `
// // // // // // // // // //     ${resume.summary ? section("Professional Summary",
// // // // // // // // // //       `<p style="font-size:13px;line-height:1.8;color:#374151;">${esc(resume.summary)}</p>`) : ""}
// // // // // // // // // //     ${expHtml  ? section("Work Experience", expHtml)  : ""}
// // // // // // // // // //     ${eduHtml  ? section("Education",       eduHtml)  : ""}
// // // // // // // // // //     ${skillsHtml ? section("Skills",        skillsHtml) : ""}
// // // // // // // // // //     ${certHtml ? section("Certifications",  certHtml) : ""}`;

// // // // // // // // // //   // ── Print hint (PDF/HTML only) ──
// // // // // // // // // //   const hint = showHint ? `
// // // // // // // // // //     <div class="no-print" style="background:#e8f0fe;border:1px solid #1a73e8;border-radius:8px;
// // // // // // // // // //       padding:12px 18px;margin-bottom:20px;text-align:center;font-size:13px;color:#1a73e8;
// // // // // // // // // //       font-family:Arial,sans-serif;">
// // // // // // // // // //       📄 <strong>Save as PDF:</strong> Ctrl+P &rarr; destination = "Save as PDF" &rarr;
// // // // // // // // // //       margins = "None" &rarr; enable "Background graphics" &rarr; Save
// // // // // // // // // //     </div>` : "";

// // // // // // // // // //   // ── Print / page CSS ──
// // // // // // // // // //   const printCSS = forWord
// // // // // // // // // //     ? `@page { size:A4; margin:.65in; }`
// // // // // // // // // //     : `@media print {
// // // // // // // // // //         .no-print { display:none!important; }
// // // // // // // // // //         body { margin:0; padding:0; background:#fff; }
// // // // // // // // // //         .page { box-shadow:none!important; }
// // // // // // // // // //         @page { size:A4; margin:0; }
// // // // // // // // // //       }
// // // // // // // // // //       -webkit-print-color-adjust: exact;
// // // // // // // // // //       print-color-adjust: exact;`;

// // // // // // // // // //   // ── Build body per template ──
// // // // // // // // // //   let body = "";

// // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // //   // CLASSIC
// // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // //   if (templateId === "classic") {
// // // // // // // // // //     body = `
// // // // // // // // // //       <div style="padding:32px 40px;">
// // // // // // // // // //         <div style="text-align:center;padding-bottom:20px;margin-bottom:24px;
// // // // // // // // // //           border-bottom:2px solid ${ac};">
// // // // // // // // // //           <h1 style="font-size:26px;font-weight:700;color:#0f172a;margin:0 0 8px;
// // // // // // // // // //             font-family:Georgia,'Times New Roman',serif;">${nm}</h1>
// // // // // // // // // //           <div style="display:${forWord?"block":"flex"};justify-content:center;
// // // // // // // // // //             flex-wrap:wrap;gap:16px;font-size:13px;color:#475569;margin-top:8px;">
// // // // // // // // // //             ${ctcs.map(c => forWord
// // // // // // // // // //               ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // // // //               : `<span>${c}</span>`).join("")}
// // // // // // // // // //           </div>
// // // // // // // // // //         </div>
// // // // // // // // // //         ${mainSections}
// // // // // // // // // //       </div>`;
// // // // // // // // // //   }

// // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // //   // EXECUTIVE
// // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // //   else if (templateId === "executive") {
// // // // // // // // // //     body = `
// // // // // // // // // //       <div style="background:${hd};padding:30px 40px 26px;color:#fff;">
// // // // // // // // // //         <h1 style="font-size:28px;font-weight:700;color:#fff;text-transform:uppercase;
// // // // // // // // // //           letter-spacing:.06em;margin:0 0 10px;
// // // // // // // // // //           font-family:Georgia,'Times New Roman',serif;">${nm}</h1>
// // // // // // // // // //         <div style="height:2px;background:rgba(255,255,255,.3);margin-bottom:4px;"></div>
// // // // // // // // // //         <div style="height:1px;background:rgba(255,255,255,.1);margin-bottom:14px;"></div>
// // // // // // // // // //         <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:20px;
// // // // // // // // // //           font-size:12px;color:rgba(255,255,255,.65);">
// // // // // // // // // //           ${ctcs.map(c => forWord
// // // // // // // // // //             ? `<span style="margin-right:18px;">${c}</span>`
// // // // // // // // // //             : `<span>${c}</span>`).join("")}
// // // // // // // // // //         </div>
// // // // // // // // // //       </div>
// // // // // // // // // //       <div style="padding:26px 40px;">${mainSections}</div>`;
// // // // // // // // // //   }

// // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // //   // BOLD
// // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // //   else if (templateId === "bold") {
// // // // // // // // // //     body = `
// // // // // // // // // //       <div style="background:${hd};padding:28px 30px 24px;">
// // // // // // // // // //         <h1 style="font-size:34px;font-weight:900;color:#fff;letter-spacing:-.03em;
// // // // // // // // // //           line-height:1;margin:0 0 2px;">${nm}</h1>
// // // // // // // // // //         <div style="width:52px;height:4px;background:${ac};border-radius:2px;
// // // // // // // // // //           margin:12px 0 12px;"></div>
// // // // // // // // // //         <div style="font-size:12px;color:rgba(255,255,255,.75);text-transform:uppercase;
// // // // // // // // // //           letter-spacing:.1em;margin-bottom:12px;">${ttl}</div>
// // // // // // // // // //         <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:18px;
// // // // // // // // // //           font-size:12px;color:rgba(255,255,255,.55);">
// // // // // // // // // //           ${ctcs.map(c => forWord
// // // // // // // // // //             ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // // // //             : `<span>${c}</span>`).join("")}
// // // // // // // // // //         </div>
// // // // // // // // // //       </div>
// // // // // // // // // //       <div style="padding:22px 30px;">${mainSections}</div>`;
// // // // // // // // // //   }

// // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // //   // MINIMAL
// // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // //   else if (templateId === "minimal") {
// // // // // // // // // //     body = `
// // // // // // // // // //       <div style="padding:32px 40px;">
// // // // // // // // // //         <div style="padding-bottom:18px;margin-bottom:22px;border-bottom:2.5px solid ${ac};">
// // // // // // // // // //           <h1 style="font-size:28px;font-weight:300;color:#0f172a;letter-spacing:-.02em;
// // // // // // // // // //             margin:0 0 6px;">${nm}</h1>
// // // // // // // // // //           <div style="width:32px;height:3px;background:${ac};border-radius:2px;
// // // // // // // // // //             margin-bottom:12px;"></div>
// // // // // // // // // //           <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:18px;
// // // // // // // // // //             font-size:13px;color:#64748b;">
// // // // // // // // // //             ${ctcs.map(c => forWord
// // // // // // // // // //               ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // // // //               : `<span>${c}</span>`).join("")}
// // // // // // // // // //           </div>
// // // // // // // // // //         </div>
// // // // // // // // // //         ${mainSections}
// // // // // // // // // //       </div>`;
// // // // // // // // // //   }

// // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // //   // PROFESSIONAL
// // // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // // //   else if (templateId === "professional") {
// // // // // // // // // //     body = `
// // // // // // // // // //       <div style="background:${hd};padding:26px 32px 20px;">
// // // // // // // // // //         <div style="display:${forWord?"block":"flex"};justify-content:space-between;
// // // // // // // // // //           align-items:flex-end;flex-wrap:wrap;gap:12px;">
// // // // // // // // // //           <div>
// // // // // // // // // //             <h1 style="font-size:26px;font-weight:700;color:#fff;margin:0 0 5px;">${nm}</h1>
// // // // // // // // // //             <div style="font-size:12px;color:${ac}cc;letter-spacing:.1em;
// // // // // // // // // //               text-transform:uppercase;">${ttl}</div>
// // // // // // // // // //           </div>
// // // // // // // // // //           <div style="${forWord?"":"text-align:right;"}">
// // // // // // // // // //             ${ctcs.slice(0,2).map(c =>
// // // // // // // // // //               `<div style="font-size:11px;color:rgba(255,255,255,.6);margin-bottom:3px;
// // // // // // // // // //                 ${forWord?"":"text-align:right;"}">${c}</div>`).join("")}
// // // // // // // // // //           </div>
// // // // // // // // // //         </div>
// // // // // // // // // //         <div style="height:2px;background:${ac};margin-top:16px;border-radius:1px;"></div>
// // // // // // // // // //       </div>
// // // // // // // // // //       <div style="padding:20px 32px;">
// // // // // // // // // //         ${ctcs.length > 2 ? `<div style="font-size:12px;color:#64748b;margin-bottom:18px;
// // // // // // // // // //           padding-bottom:14px;border-bottom:1px solid #f1f5f9;">
// // // // // // // // // //           ${ctcs.slice(2).map(c=>`<span style="margin-right:16px;">${c}</span>`).join("")}
// // // // // // // // // //         </div>` : ""}
// // // // // // // // // //         ${mainSections}
// // // // // // // // // //       </div>`;
// // // // // // // // // //   }

// // // // // // // // // //   // fallback
// // // // // // // // // //   else {
// // // // // // // // // //     body = `<div style="padding:32px 40px;">${mainSections}</div>`;
// // // // // // // // // //   }

// // // // // // // // // //   // ── Assemble full HTML ──
// // // // // // // // // //   const doctype = forWord
// // // // // // // // // //     ? `<!DOCTYPE html>
// // // // // // // // // // <html xmlns:o="urn:schemas-microsoft-com:office:office"
// // // // // // // // // //       xmlns:w="urn:schemas-microsoft-com:office:word"
// // // // // // // // // //       xmlns="http://www.w3.org/TR/REC-html40">`
// // // // // // // // // //     : `<!DOCTYPE html><html lang="en">`;

// // // // // // // // // //   return `${doctype}
// // // // // // // // // // <head>
// // // // // // // // // //   <meta charset="UTF-8">
// // // // // // // // // //   <title>${nm} &mdash; Resume</title>
// // // // // // // // // //   ${forWord ? `<!--[if gte mso 9]><xml>
// // // // // // // // // //     <w:WordDocument><w:View>Print</w:View><w:Zoom>100</w:Zoom>
// // // // // // // // // //     <w:DoNotOptimizeForBrowser/></w:WordDocument></xml><![endif]-->` : ""}
// // // // // // // // // //   <style>
// // // // // // // // // //     *,*::before,*::after { box-sizing:border-box; margin:0; padding:0; }
// // // // // // // // // //     body {
// // // // // // // // // //       font-family: Arial, Helvetica, sans-serif;
// // // // // // // // // //       font-size: 14px;
// // // // // // // // // //       line-height: 1.5;
// // // // // // // // // //       color: #1a202c;
// // // // // // // // // //       background: #fff;
// // // // // // // // // //       ${forWord ? "" : "-webkit-print-color-adjust:exact;print-color-adjust:exact;"}
// // // // // // // // // //     }
// // // // // // // // // //     .page {
// // // // // // // // // //       max-width: 850px;
// // // // // // // // // //       margin: 0 auto;
// // // // // // // // // //       background: #fff;
// // // // // // // // // //       ${forWord ? "" : "box-shadow:0 2px 12px rgba(0,0,0,.1);"}
// // // // // // // // // //     }
// // // // // // // // // //     ul { list-style: disc; }
// // // // // // // // // //     li { line-height: 1.7; }
// // // // // // // // // //     p  { margin-bottom: 6px; }
// // // // // // // // // //     h1,h2,h3 { line-height: 1.2; }
// // // // // // // // // //     ${printCSS}
// // // // // // // // // //   </style>
// // // // // // // // // // </head>
// // // // // // // // // // <body>
// // // // // // // // // //   ${hint}
// // // // // // // // // //   <div class="page">${body}</div>
// // // // // // // // // // </body>
// // // // // // // // // // </html>`;
// // // // // // // // // // }

// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // HELPER — trigger file download
// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // function dl(blob, name) {
// // // // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // // // //   const a   = Object.assign(document.createElement("a"), { href: url, download: name });
// // // // // // // // // //   document.body.appendChild(a);
// // // // // // // // // //   a.click();
// // // // // // // // // //   document.body.removeChild(a);
// // // // // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 2000);
// // // // // // // // // // }

// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // PDF — opens styled HTML in new tab, auto-triggers print dialog
// // // // // // // // // // // User presses Ctrl+P → Save as PDF → gets exact match to screen
// // // // // // // // // // // No CDN libraries, no canvas, works 100% reliably
// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // PDF — silent download using html2canvas + jsPDF
// // // // // // // // // // // No print dialog. Renders the live React preview
// // // // // // // // // // // directly to a PDF file and downloads it silently.
// // // // // // // // // // // Requires: npm install html2canvas jspdf
// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // export async function downloadResumeAsPDF(resume, fileName, templateId, previewElement) {
// // // // // // // // // //   const name = (fileName || "resume").replace(/\.(pdf|html?)$/i, "");

// // // // // // // // // //   try {
// // // // // // // // // //     // Dynamic import — only loads when user clicks Download PDF
// // // // // // // // // //     const html2canvas = (await import("html2canvas")).default;
// // // // // // // // // //     const { jsPDF }   = await import("jspdf");

// // // // // // // // // //     // Get the element to capture — use live React preview if available,
// // // // // // // // // //     // otherwise render our HTML into a hidden off-screen div
// // // // // // // // // //     let captureEl = previewElement;
// // // // // // // // // //     let tempDiv   = null;

// // // // // // // // // //     if (!captureEl) {
// // // // // // // // // //       tempDiv = document.createElement("div");
// // // // // // // // // //       tempDiv.style.cssText = "position:fixed;left:-9999px;top:0;width:794px;background:#fff;z-index:-1;pointer-events:none;";
// // // // // // // // // //       const bodyHTML = buildResumeHTML(resume, templateId, { showHint: false })
// // // // // // // // // //         .replace(/<!DOCTYPE html>[\s\S]*?<body[^>]*>/i, "")
// // // // // // // // // //         .replace(/<\/body>[\s\S]*$/i, "")
// // // // // // // // // //         .trim();
// // // // // // // // // //       tempDiv.innerHTML = `<div style="max-width:794px;overflow:hidden;word-break:break-word;">${bodyHTML}</div>`;
// // // // // // // // // //       document.body.appendChild(tempDiv);
// // // // // // // // // //       captureEl = tempDiv.firstChild;
// // // // // // // // // //       await new Promise(r => setTimeout(r, 500)); // let styles paint
// // // // // // // // // //     }

// // // // // // // // // //     // Capture the element as a high-res canvas
// // // // // // // // // //     const canvas = await html2canvas(captureEl, {
// // // // // // // // // //       scale:           2,          // 2× = crisp text on retina
// // // // // // // // // //       useCORS:         true,
// // // // // // // // // //       allowTaint:      true,
// // // // // // // // // //       backgroundColor: "#ffffff",
// // // // // // // // // //       logging:         false,
// // // // // // // // // //       imageTimeout:    0,
// // // // // // // // // //       onclone: (clonedDoc) => {
// // // // // // // // // //         // Remove SAMPLE watermark from the clone
// // // // // // // // // //         clonedDoc.querySelectorAll('[style*="SAMPLE"]')
// // // // // // // // // //           .forEach(el => el.remove());
// // // // // // // // // //         // Remove no-print elements
// // // // // // // // // //         clonedDoc.querySelectorAll('.no-print')
// // // // // // // // // //           .forEach(el => el.remove());
// // // // // // // // // //       },
// // // // // // // // // //     });

// // // // // // // // // //     if (tempDiv) document.body.removeChild(tempDiv);

// // // // // // // // // //     // Convert canvas to A4 PDF, multi-page if resume is long
// // // // // // // // // //     const A4_W_MM = 210;
// // // // // // // // // //     const A4_H_MM = 297;
// // // // // // // // // //     const imgW    = A4_W_MM;
// // // // // // // // // //     const imgH    = (canvas.height * A4_W_MM) / canvas.width;
// // // // // // // // // //     const pdf     = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
// // // // // // // // // //     const imgData = canvas.toDataURL("image/jpeg", 0.97);

// // // // // // // // // //     let posY = 0;
// // // // // // // // // //     while (posY < imgH) {
// // // // // // // // // //       if (posY > 0) pdf.addPage();
// // // // // // // // // //       pdf.addImage(imgData, "JPEG", 0, -posY, imgW, imgH);
// // // // // // // // // //       posY += A4_H_MM;
// // // // // // // // // //     }

// // // // // // // // // //     pdf.save(`${name}.pdf`);

// // // // // // // // // //   } catch (err) {
// // // // // // // // // //     console.error("PDF generation failed:", err);
// // // // // // // // // //     // Fallback: download as HTML with print instructions
// // // // // // // // // //     const html = buildResumeHTML(resume, templateId, { showHint: true });
// // // // // // // // // //     dl(new Blob([html], { type: "text/html;charset=utf-8" }), `${name}.html`);
// // // // // // // // // //     alert("PDF download failed. An HTML file was downloaded instead — open it in Chrome and press Ctrl+P → Save as PDF.");
// // // // // // // // // //   }
// // // // // // // // // // }

// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // WORD — saves as .doc using text/html MIME
// // // // // // // // // // // Word opens HTML files natively — reliable cross-browser
// // // // // // // // // // // (application/msword MIME is blocked by modern browsers)
// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // export function downloadResumeAsWord(resume, fileName, templateId) {
// // // // // // // // // //   const html = buildResumeHTML(resume, templateId, { forWord: true });
// // // // // // // // // //   // Use text/plain MIME — most reliable for triggering download
// // // // // // // // // //   // The .doc extension tells Word to open it natively
// // // // // // // // // //   dl(
// // // // // // // // // //     new Blob(["\ufeff", html], { type: "text/plain;charset=utf-8" }),
// // // // // // // // // //     (fileName || "resume").replace(/\.(doc|docx|html?)$/i, "") + ".doc"
// // // // // // // // // //   );
// // // // // // // // // // }

// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // // HTML — saves as .html, opens in browser
// // // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // export function downloadATSResume(resume, fileName, templateId) {
// // // // // // // // // //   const html = buildResumeHTML(resume, templateId, { showHint: true });
// // // // // // // // // //   dl(
// // // // // // // // // //     new Blob([html], { type: "text/html;charset=utf-8" }),
// // // // // // // // // //     (fileName || "resume").replace(/\.html?$/i, "") + ".html"
// // // // // // // // // //   );
// // // // // // // // // // }

// // // // // // // // // // src/utils/generateResumeDoc.js
// // // // // // // // // // Single source of truth for all resume downloads
// // // // // // // // // // HTML generator mirrors ResumeGeneratorPage.jsx ResumePreview exactly

// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // DOWNLOAD TEMPLATES — colors MUST match servicesConfig.js exactly
// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // const DOWNLOAD_TEMPLATES = {
// // // // // // // // //   classic: {
// // // // // // // // //     name:   "Classic ATS",
// // // // // // // // //     accent: "#2563eb",
// // // // // // // // //     header: "#1e293b",
// // // // // // // // //   },
// // // // // // // // //   executive: {
// // // // // // // // //     name:   "Executive",
// // // // // // // // //     accent: "#334155",
// // // // // // // // //     header: "#0f172a",
// // // // // // // // //   },
// // // // // // // // //   bold: {
// // // // // // // // //     name:   "Bold Impact",
// // // // // // // // //     accent: "#1d4ed8",
// // // // // // // // //     header: "#1e3a8a",
// // // // // // // // //   },
// // // // // // // // //   minimal: {
// // // // // // // // //     name:   "Minimal Clean",
// // // // // // // // //     accent: "#059669",
// // // // // // // // //     header: "#059669",
// // // // // // // // //   },
// // // // // // // // //   professional: {
// // // // // // // // //     name:   "Professional",
// // // // // // // // //     accent: "#1e3a5f",
// // // // // // // // //     header: "#1e3a5f",
// // // // // // // // //   },
// // // // // // // // // };

// // // // // // // // // function getT(id) {
// // // // // // // // //   return DOWNLOAD_TEMPLATES[id] || DOWNLOAD_TEMPLATES.classic;
// // // // // // // // // }

// // // // // // // // // function esc(s) {
// // // // // // // // //   if (!s) return "";
// // // // // // // // //   return String(s)
// // // // // // // // //     .replace(/&/g,"&amp;").replace(/</g,"&lt;")
// // // // // // // // //     .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// // // // // // // // // }

// // // // // // // // // function fmt(s, e) {
// // // // // // // // //   if (!s && !e) return "";
// // // // // // // // //   if (s && !e) return esc(s);
// // // // // // // // //   if (!s && e) return esc(e);
// // // // // // // // //   return `${esc(s)} &ndash; ${esc(e)}`;
// // // // // // // // // }

// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // CORE HTML BUILDER
// // // // // // // // // // forWord=true → removes rgba, flexbox → uses table for sidebar
// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // function buildResumeHTML(resume, templateId, opts = {}) {
// // // // // // // // //   const { forWord = false, showHint = false } = opts;
// // // // // // // // //   const t  = getT(templateId);
// // // // // // // // //   const ac = t.accent;
// // // // // // // // //   const hd = t.header;

// // // // // // // // //   const nm   = esc(resume.name)  || "Your Name";
// // // // // // // // //   const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
// // // // // // // // //   const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean).map(esc);

// // // // // // // // //   // ── Section title — must match SectionTitle in ResumeGeneratorPage.jsx ──
// // // // // // // // //   const isFilled = ["bold","professional","corporate"].includes(templateId);
// // // // // // // // //   function secTitle(text) {
// // // // // // // // //     if (isFilled) {
// // // // // // // // //       return `<div style="background:${ac}10;border-left:3px solid ${ac};padding:6px 12px;
// // // // // // // // //         margin-bottom:14px;border-radius:0 6px 6px 0;">
// // // // // // // // //         <div style="font-size:11px;font-weight:800;text-transform:uppercase;
// // // // // // // // //           letter-spacing:.1em;color:${ac};">${text}</div></div>`;
// // // // // // // // //     }
// // // // // // // // //     // classic, executive, minimal — underline
// // // // // // // // //     return `<div style="margin-bottom:14px;border-bottom:1.5px solid ${ac};padding-bottom:5px;">
// // // // // // // // //       <div style="font-size:11px;font-weight:800;text-transform:uppercase;
// // // // // // // // //         letter-spacing:.1em;color:${ac};">${text}</div></div>`;
// // // // // // // // //   }

// // // // // // // // //   // ── Experience ──
// // // // // // // // //   const expHtml = (resume.experience||[]).map(exp => {
// // // // // // // // //     const bullets = (exp.bullets||[]).map(b =>
// // // // // // // // //       `<li style="font-size:13px;color:#374151;margin-bottom:6px;line-height:1.7;">${esc(b)}</li>`
// // // // // // // // //     ).join("");
// // // // // // // // //     return `<div style="margin-bottom:18px;">
// // // // // // // // //       <div style="margin-bottom:4px;">
// // // // // // // // //         <span style="font-weight:700;font-size:14px;color:#0f172a;">${esc(exp.title||"")}</span>
// // // // // // // // //         <span style="color:#475569;font-size:13px;"> &mdash; ${esc(exp.company||"")}</span>
// // // // // // // // //         ${exp.location?`<span style="color:#94a3b8;font-size:12px;"> | ${esc(exp.location)}</span>`:""}
// // // // // // // // //       </div>
// // // // // // // // //       <div style="font-size:12px;color:#64748b;font-style:italic;margin-bottom:7px;">
// // // // // // // // //         ${fmt(exp.startDate,exp.endDate)}</div>
// // // // // // // // //       <ul style="margin:0 0 0 20px;padding:0;">${bullets}</ul>
// // // // // // // // //     </div>`;
// // // // // // // // //   }).join("");

// // // // // // // // //   // ── Education ──
// // // // // // // // //   const eduHtml = (resume.education||[]).map(edu =>
// // // // // // // // //     `<div style="margin-bottom:12px;">
// // // // // // // // //       <span style="font-weight:600;font-size:14px;color:#0f172a;">${esc(edu.degree||"")}</span>
// // // // // // // // //       <span style="color:#475569;font-size:13px;"> &mdash; ${esc(edu.school||"")}</span>
// // // // // // // // //       ${edu.location?`<span style="color:#94a3b8;font-size:12px;"> | ${esc(edu.location)}</span>`:""}
// // // // // // // // //       <div style="font-size:12px;color:#64748b;font-style:italic;margin-top:2px;">
// // // // // // // // //         ${esc(edu.year||"")}${edu.gpa?` | GPA: ${esc(edu.gpa)}`:""}
// // // // // // // // //       </div>
// // // // // // // // //     </div>`
// // // // // // // // //   ).join("");

// // // // // // // // //   // ── Skills ──
// // // // // // // // //   const sk = resume.skills||{};
// // // // // // // // //   const skillsHtml = [
// // // // // // // // //     sk.technical?.length ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // // //       <strong>Technical:</strong> ${sk.technical.map(esc).join(", ")}</p>` : "",
// // // // // // // // //     sk.tools?.length     ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // // //       <strong>Tools:</strong> ${sk.tools.map(esc).join(", ")}</p>` : "",
// // // // // // // // //     sk.soft?.length      ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // // //       <strong>Soft Skills:</strong> ${sk.soft.map(esc).join(", ")}</p>` : "",
// // // // // // // // //   ].join("");

// // // // // // // // //   // ── Certifications ──
// // // // // // // // //   const certHtml = (resume.certifications||[]).length
// // // // // // // // //     ? `<ul style="margin:0 0 0 20px;padding:0;">${(resume.certifications).map(c=>
// // // // // // // // //         `<li style="font-size:13px;color:#374151;margin-bottom:6px;line-height:1.7;">${esc(c)}</li>`
// // // // // // // // //       ).join("")}</ul>` : "";

// // // // // // // // //   // ── Main content sections ──
// // // // // // // // //   function section(title, body) {
// // // // // // // // //     if (!body?.trim()) return "";
// // // // // // // // //     return `<div style="margin-bottom:24px;">${secTitle(title)}${body}</div>`;
// // // // // // // // //   }
// // // // // // // // //   const mainSections = `
// // // // // // // // //     ${resume.summary ? section("Professional Summary",
// // // // // // // // //       `<p style="font-size:13px;line-height:1.8;color:#374151;">${esc(resume.summary)}</p>`) : ""}
// // // // // // // // //     ${expHtml  ? section("Work Experience", expHtml)  : ""}
// // // // // // // // //     ${eduHtml  ? section("Education",       eduHtml)  : ""}
// // // // // // // // //     ${skillsHtml ? section("Skills",        skillsHtml) : ""}
// // // // // // // // //     ${certHtml ? section("Certifications",  certHtml) : ""}`;

// // // // // // // // //   // ── Print hint (PDF/HTML only) ──
// // // // // // // // //   const hint = showHint ? `
// // // // // // // // //     <div class="no-print" style="background:#e8f0fe;border:1px solid #1a73e8;border-radius:8px;
// // // // // // // // //       padding:12px 18px;margin-bottom:20px;text-align:center;font-size:13px;color:#1a73e8;
// // // // // // // // //       font-family:Arial,sans-serif;">
// // // // // // // // //       📄 <strong>Save as PDF:</strong> Ctrl+P &rarr; destination = "Save as PDF" &rarr;
// // // // // // // // //       margins = "None" &rarr; enable "Background graphics" &rarr; Save
// // // // // // // // //     </div>` : "";

// // // // // // // // //   // ── Print / page CSS ──
// // // // // // // // //   const printCSS = forWord
// // // // // // // // //     ? `@page { size:A4; margin:.65in; }`
// // // // // // // // //     : `@media print {
// // // // // // // // //         .no-print { display:none!important; }
// // // // // // // // //         body { margin:0; padding:0; background:#fff; }
// // // // // // // // //         .page { box-shadow:none!important; }
// // // // // // // // //         @page { size:A4; margin:0; }
// // // // // // // // //       }
// // // // // // // // //       -webkit-print-color-adjust: exact;
// // // // // // // // //       print-color-adjust: exact;`;

// // // // // // // // //   // ── Build body per template ──
// // // // // // // // //   let body = "";

// // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // //   // CLASSIC
// // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // //   if (templateId === "classic") {
// // // // // // // // //     body = `
// // // // // // // // //       <div style="padding:32px 40px;">
// // // // // // // // //         <div style="text-align:center;padding-bottom:20px;margin-bottom:24px;
// // // // // // // // //           border-bottom:2px solid ${ac};">
// // // // // // // // //           <h1 style="font-size:26px;font-weight:700;color:#0f172a;margin:0 0 8px;
// // // // // // // // //             font-family:Georgia,'Times New Roman',serif;">${nm}</h1>
// // // // // // // // //           <div style="display:${forWord?"block":"flex"};justify-content:center;
// // // // // // // // //             flex-wrap:wrap;gap:16px;font-size:13px;color:#475569;margin-top:8px;">
// // // // // // // // //             ${ctcs.map(c => forWord
// // // // // // // // //               ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // // //               : `<span>${c}</span>`).join("")}
// // // // // // // // //           </div>
// // // // // // // // //         </div>
// // // // // // // // //         ${mainSections}
// // // // // // // // //       </div>`;
// // // // // // // // //   }

// // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // //   // EXECUTIVE
// // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // //   else if (templateId === "executive") {
// // // // // // // // //     body = `
// // // // // // // // //       <div style="background:${hd};padding:30px 40px 26px;color:#fff;">
// // // // // // // // //         <h1 style="font-size:28px;font-weight:700;color:#fff;text-transform:uppercase;
// // // // // // // // //           letter-spacing:.06em;margin:0 0 10px;
// // // // // // // // //           font-family:Georgia,'Times New Roman',serif;">${nm}</h1>
// // // // // // // // //         <div style="height:2px;background:rgba(255,255,255,.3);margin-bottom:4px;"></div>
// // // // // // // // //         <div style="height:1px;background:rgba(255,255,255,.1);margin-bottom:14px;"></div>
// // // // // // // // //         <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:20px;
// // // // // // // // //           font-size:12px;color:rgba(255,255,255,.65);">
// // // // // // // // //           ${ctcs.map(c => forWord
// // // // // // // // //             ? `<span style="margin-right:18px;">${c}</span>`
// // // // // // // // //             : `<span>${c}</span>`).join("")}
// // // // // // // // //         </div>
// // // // // // // // //       </div>
// // // // // // // // //       <div style="padding:26px 40px;">${mainSections}</div>`;
// // // // // // // // //   }

// // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // //   // BOLD
// // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // //   else if (templateId === "bold") {
// // // // // // // // //     body = `
// // // // // // // // //       <div style="background:${hd};padding:28px 30px 24px;">
// // // // // // // // //         <h1 style="font-size:34px;font-weight:900;color:#fff;letter-spacing:-.03em;
// // // // // // // // //           line-height:1;margin:0 0 2px;">${nm}</h1>
// // // // // // // // //         <div style="width:52px;height:4px;background:${ac};border-radius:2px;
// // // // // // // // //           margin:12px 0 12px;"></div>
// // // // // // // // //         <div style="font-size:12px;color:rgba(255,255,255,.75);text-transform:uppercase;
// // // // // // // // //           letter-spacing:.1em;margin-bottom:12px;">${ttl}</div>
// // // // // // // // //         <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:18px;
// // // // // // // // //           font-size:12px;color:rgba(255,255,255,.55);">
// // // // // // // // //           ${ctcs.map(c => forWord
// // // // // // // // //             ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // // //             : `<span>${c}</span>`).join("")}
// // // // // // // // //         </div>
// // // // // // // // //       </div>
// // // // // // // // //       <div style="padding:22px 30px;">${mainSections}</div>`;
// // // // // // // // //   }

// // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // //   // MINIMAL
// // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // //   else if (templateId === "minimal") {
// // // // // // // // //     body = `
// // // // // // // // //       <div style="padding:32px 40px;">
// // // // // // // // //         <div style="padding-bottom:18px;margin-bottom:22px;border-bottom:2.5px solid ${ac};">
// // // // // // // // //           <h1 style="font-size:28px;font-weight:300;color:#0f172a;letter-spacing:-.02em;
// // // // // // // // //             margin:0 0 6px;">${nm}</h1>
// // // // // // // // //           <div style="width:32px;height:3px;background:${ac};border-radius:2px;
// // // // // // // // //             margin-bottom:12px;"></div>
// // // // // // // // //           <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:18px;
// // // // // // // // //             font-size:13px;color:#64748b;">
// // // // // // // // //             ${ctcs.map(c => forWord
// // // // // // // // //               ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // // //               : `<span>${c}</span>`).join("")}
// // // // // // // // //           </div>
// // // // // // // // //         </div>
// // // // // // // // //         ${mainSections}
// // // // // // // // //       </div>`;
// // // // // // // // //   }

// // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // //   // PROFESSIONAL
// // // // // // // // //   // ──────────────────────────────────────────
// // // // // // // // //   else if (templateId === "professional") {
// // // // // // // // //     body = `
// // // // // // // // //       <div style="background:${hd};padding:26px 32px 20px;">
// // // // // // // // //         <div style="display:${forWord?"block":"flex"};justify-content:space-between;
// // // // // // // // //           align-items:flex-end;flex-wrap:wrap;gap:12px;">
// // // // // // // // //           <div>
// // // // // // // // //             <h1 style="font-size:26px;font-weight:700;color:#fff;margin:0 0 5px;">${nm}</h1>
// // // // // // // // //             <div style="font-size:12px;color:${ac}cc;letter-spacing:.1em;
// // // // // // // // //               text-transform:uppercase;">${ttl}</div>
// // // // // // // // //           </div>
// // // // // // // // //           <div style="${forWord?"":"text-align:right;"}">
// // // // // // // // //             ${ctcs.slice(0,2).map(c =>
// // // // // // // // //               `<div style="font-size:11px;color:rgba(255,255,255,.6);margin-bottom:3px;
// // // // // // // // //                 ${forWord?"":"text-align:right;"}">${c}</div>`).join("")}
// // // // // // // // //           </div>
// // // // // // // // //         </div>
// // // // // // // // //         <div style="height:2px;background:${ac};margin-top:16px;border-radius:1px;"></div>
// // // // // // // // //       </div>
// // // // // // // // //       <div style="padding:20px 32px;">
// // // // // // // // //         ${ctcs.length > 2 ? `<div style="font-size:12px;color:#64748b;margin-bottom:18px;
// // // // // // // // //           padding-bottom:14px;border-bottom:1px solid #f1f5f9;">
// // // // // // // // //           ${ctcs.slice(2).map(c=>`<span style="margin-right:16px;">${c}</span>`).join("")}
// // // // // // // // //         </div>` : ""}
// // // // // // // // //         ${mainSections}
// // // // // // // // //       </div>`;
// // // // // // // // //   }

// // // // // // // // //   // fallback
// // // // // // // // //   else {
// // // // // // // // //     body = `<div style="padding:32px 40px;">${mainSections}</div>`;
// // // // // // // // //   }

// // // // // // // // //   // ── Assemble full HTML ──
// // // // // // // // //   const doctype = forWord
// // // // // // // // //     ? `<!DOCTYPE html>
// // // // // // // // // <html xmlns:o="urn:schemas-microsoft-com:office:office"
// // // // // // // // //       xmlns:w="urn:schemas-microsoft-com:office:word"
// // // // // // // // //       xmlns="http://www.w3.org/TR/REC-html40">`
// // // // // // // // //     : `<!DOCTYPE html><html lang="en">`;

// // // // // // // // //   return `${doctype}
// // // // // // // // // <head>
// // // // // // // // //   <meta charset="UTF-8">
// // // // // // // // //   <title>${nm} &mdash; Resume</title>
// // // // // // // // //   ${forWord ? `<!--[if gte mso 9]><xml>
// // // // // // // // //     <w:WordDocument><w:View>Print</w:View><w:Zoom>100</w:Zoom>
// // // // // // // // //     <w:DoNotOptimizeForBrowser/></w:WordDocument></xml><![endif]-->` : ""}
// // // // // // // // //   <style>
// // // // // // // // //     *,*::before,*::after { box-sizing:border-box; margin:0; padding:0; }
// // // // // // // // //     body {
// // // // // // // // //       font-family: Arial, Helvetica, sans-serif;
// // // // // // // // //       font-size: 14px;
// // // // // // // // //       line-height: 1.5;
// // // // // // // // //       color: #1a202c;
// // // // // // // // //       background: #fff;
// // // // // // // // //       ${forWord ? "" : "-webkit-print-color-adjust:exact;print-color-adjust:exact;"}
// // // // // // // // //     }
// // // // // // // // //     .page {
// // // // // // // // //       max-width: 794px;
// // // // // // // // //       width: 794px;
// // // // // // // // //       margin: 0 auto;
// // // // // // // // //       background: #fff;
// // // // // // // // //       overflow: hidden;
// // // // // // // // //       word-break: break-word;
// // // // // // // // //       word-wrap: break-word;
// // // // // // // // //       ${forWord ? "" : "box-shadow:0 2px 12px rgba(0,0,0,.1);"}
// // // // // // // // //     }
// // // // // // // // //     /* Prevent any element from exceeding page width */
// // // // // // // // //     .page * {
// // // // // // // // //       max-width: 100%;
// // // // // // // // //     }
// // // // // // // // //     /* Flex containers must wrap */
// // // // // // // // //     .page div[style*="display:flex"],
// // // // // // // // //     .page div[style*="display: flex"] {
// // // // // // // // //       flex-wrap: wrap;
// // // // // // // // //     }
// // // // // // // // //     ul { list-style: disc; }
// // // // // // // // //     li { line-height: 1.7; }
// // // // // // // // //     p  { margin-bottom: 6px; }
// // // // // // // // //     h1,h2,h3 { line-height: 1.2; }
// // // // // // // // //     ${printCSS}
// // // // // // // // //   </style>
// // // // // // // // // </head>
// // // // // // // // // <body>
// // // // // // // // //   ${hint}
// // // // // // // // //   <div class="page">${body}</div>
// // // // // // // // // </body>
// // // // // // // // // </html>`;
// // // // // // // // // }

// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // HELPER — trigger file download
// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // function dl(blob, name) {
// // // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // // //   const a   = Object.assign(document.createElement("a"), { href: url, download: name });
// // // // // // // // //   document.body.appendChild(a);
// // // // // // // // //   a.click();
// // // // // // // // //   document.body.removeChild(a);
// // // // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 2000);
// // // // // // // // // }

// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // PDF — opens styled HTML in new tab, auto-triggers print dialog
// // // // // // // // // // User presses Ctrl+P → Save as PDF → gets exact match to screen
// // // // // // // // // // No CDN libraries, no canvas, works 100% reliably
// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // PDF — silent download using html2canvas + jsPDF
// // // // // // // // // // No print dialog. Renders the live React preview
// // // // // // // // // // directly to a PDF file and downloads it silently.
// // // // // // // // // // Requires: npm install html2canvas jspdf
// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // export async function downloadResumeAsPDF(resume, fileName, templateId, previewElement) {
// // // // // // // // //   const name = (fileName || "resume").replace(/\.(pdf|html?)$/i, "");

// // // // // // // // //   try {
// // // // // // // // //     const html2canvas = (await import("html2canvas")).default;
// // // // // // // // //     const { jsPDF }   = await import("jspdf");

// // // // // // // // //     // Always render from our HTML at exact 794px (A4 width)
// // // // // // // // //     // Never capture the live React preview — it varies by screen width
// // // // // // // // //     // and causes content to overflow A4 boundaries
// // // // // // // // //     const tempDiv = document.createElement("div");
// // // // // // // // //     tempDiv.style.cssText = [
// // // // // // // // //       "position:fixed",
// // // // // // // // //       "left:-9999px",
// // // // // // // // //       "top:0",
// // // // // // // // //       "width:794px",       // exact A4 width at 96dpi
// // // // // // // // //       "background:#fff",
// // // // // // // // //       "z-index:-9999",
// // // // // // // // //       "pointer-events:none",
// // // // // // // // //       "overflow:hidden",
// // // // // // // // //     ].join(";");

// // // // // // // // //     // Build the full HTML and inject just the body content
// // // // // // // // //     const fullHTML = buildResumeHTML(resume, templateId, { showHint: false, forWord: false });
// // // // // // // // //     const bodyMatch = fullHTML.match(/<body[^>]*>([\s\S]*)<\/body>/i);
// // // // // // // // //     tempDiv.innerHTML = bodyMatch ? bodyMatch[1] : fullHTML;

// // // // // // // // //     document.body.appendChild(tempDiv);

// // // // // // // // //     // Target the .page div for capture
// // // // // // // // //     const captureEl = tempDiv.querySelector(".page") || tempDiv;

// // // // // // // // //     // Wait for fonts and styles to render
// // // // // // // // //     await new Promise(r => setTimeout(r, 600));

// // // // // // // // //     const canvas = await html2canvas(captureEl, {
// // // // // // // // //       scale:           2,
// // // // // // // // //       useCORS:         true,
// // // // // // // // //       allowTaint:      true,
// // // // // // // // //       backgroundColor: "#ffffff",
// // // // // // // // //       logging:         false,
// // // // // // // // //       width:           794,
// // // // // // // // //       windowWidth:     794,
// // // // // // // // //       imageTimeout:    0,
// // // // // // // // //       onclone: (clonedDoc) => {
// // // // // // // // //         clonedDoc.querySelectorAll('[style*="SAMPLE"]').forEach(el => el.remove());
// // // // // // // // //         clonedDoc.querySelectorAll('.no-print').forEach(el => el.remove());
// // // // // // // // //         // Force all elements to respect width
// // // // // // // // //         const style = clonedDoc.createElement("style");
// // // // // // // // //         style.textContent = `* { max-width: 100%; word-break: break-word; } .page { width: 794px !important; overflow: hidden !important; }`;
// // // // // // // // //         clonedDoc.head.appendChild(style);
// // // // // // // // //       },
// // // // // // // // //     });

// // // // // // // // //     document.body.removeChild(tempDiv);

// // // // // // // // //     // Convert to A4 PDF
// // // // // // // // //     const A4_W = 210;
// // // // // // // // //     const A4_H = 297;
// // // // // // // // //     const imgW = A4_W;
// // // // // // // // //     const imgH = (canvas.height * A4_W) / canvas.width;
// // // // // // // // //     const pdf  = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
// // // // // // // // //     const img  = canvas.toDataURL("image/jpeg", 0.97);

// // // // // // // // //     let posY = 0;
// // // // // // // // //     while (posY < imgH) {
// // // // // // // // //       if (posY > 0) pdf.addPage();
// // // // // // // // //       pdf.addImage(img, "JPEG", 0, -posY, imgW, imgH);
// // // // // // // // //       posY += A4_H;
// // // // // // // // //     }

// // // // // // // // //     pdf.save(`${name}.pdf`);

// // // // // // // // //   } catch (err) {
// // // // // // // // //     console.error("PDF generation failed:", err);
// // // // // // // // //     const html = buildResumeHTML(resume, templateId, { showHint: true });
// // // // // // // // //     dl(new Blob([html], { type: "text/html;charset=utf-8" }), `${name}.html`);
// // // // // // // // //     alert("PDF download failed. An HTML file was saved instead — open it in Chrome and press Ctrl+P → Save as PDF.");
// // // // // // // // //   }
// // // // // // // // // }

// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // WORD — saves as .doc using text/html MIME
// // // // // // // // // // Word opens HTML files natively — reliable cross-browser
// // // // // // // // // // (application/msword MIME is blocked by modern browsers)
// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // export function downloadResumeAsWord(resume, fileName, templateId) {
// // // // // // // // //   const html = buildResumeHTML(resume, templateId, { forWord: true });
// // // // // // // // //   // Use text/plain MIME — most reliable for triggering download
// // // // // // // // //   // The .doc extension tells Word to open it natively
// // // // // // // // //   dl(
// // // // // // // // //     new Blob(["\ufeff", html], { type: "text/plain;charset=utf-8" }),
// // // // // // // // //     (fileName || "resume").replace(/\.(doc|docx|html?)$/i, "") + ".doc"
// // // // // // // // //   );
// // // // // // // // // }

// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // // HTML — saves as .html, opens in browser
// // // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // export function downloadATSResume(resume, fileName, templateId) {
// // // // // // // // //   const html = buildResumeHTML(resume, templateId, { showHint: true });
// // // // // // // // //   dl(
// // // // // // // // //     new Blob([html], { type: "text/html;charset=utf-8" }),
// // // // // // // // //     (fileName || "resume").replace(/\.html?$/i, "") + ".html"
// // // // // // // // //   );
// // // // // // // // // }

// // // // // // // // // src/utils/generateResumeDoc.js
// // // // // // // // // Single source of truth for all resume downloads
// // // // // // // // // HTML generator mirrors ResumeGeneratorPage.jsx ResumePreview exactly

// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // DOWNLOAD TEMPLATES — colors MUST match servicesConfig.js exactly
// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // const DOWNLOAD_TEMPLATES = {
// // // // // // // //   classic: {
// // // // // // // //     name:   "Classic ATS",
// // // // // // // //     accent: "#2563eb",
// // // // // // // //     header: "#1e293b",
// // // // // // // //   },
// // // // // // // //   executive: {
// // // // // // // //     name:   "Executive",
// // // // // // // //     accent: "#334155",
// // // // // // // //     header: "#0f172a",
// // // // // // // //   },
// // // // // // // //   bold: {
// // // // // // // //     name:   "Bold Impact",
// // // // // // // //     accent: "#1d4ed8",
// // // // // // // //     header: "#1e3a8a",
// // // // // // // //   },
// // // // // // // //   minimal: {
// // // // // // // //     name:   "Minimal Clean",
// // // // // // // //     accent: "#059669",
// // // // // // // //     header: "#059669",
// // // // // // // //   },
// // // // // // // //   professional: {
// // // // // // // //     name:   "Professional",
// // // // // // // //     accent: "#1e3a5f",
// // // // // // // //     header: "#1e3a5f",
// // // // // // // //   },
// // // // // // // // };

// // // // // // // // function getT(id) {
// // // // // // // //   return DOWNLOAD_TEMPLATES[id] || DOWNLOAD_TEMPLATES.classic;
// // // // // // // // }

// // // // // // // // function esc(s) {
// // // // // // // //   if (!s) return "";
// // // // // // // //   return String(s)
// // // // // // // //     .replace(/&/g,"&amp;").replace(/</g,"&lt;")
// // // // // // // //     .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// // // // // // // // }

// // // // // // // // function fmt(s, e) {
// // // // // // // //   if (!s && !e) return "";
// // // // // // // //   if (s && !e) return esc(s);
// // // // // // // //   if (!s && e) return esc(e);
// // // // // // // //   return `${esc(s)} &ndash; ${esc(e)}`;
// // // // // // // // }

// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // CORE HTML BUILDER — exported for screen preview use
// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // export function buildResumeHTML(resume, templateId, opts = {}) {
// // // // // // // //   const { forWord = false, showHint = false } = opts;
// // // // // // // //   const t  = getT(templateId);
// // // // // // // //   const ac = t.accent;
// // // // // // // //   const hd = t.header;

// // // // // // // //   const nm   = esc(resume.name)  || "Your Name";
// // // // // // // //   const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
// // // // // // // //   const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean).map(esc);

// // // // // // // //   // ── Section title — must match SectionTitle in ResumeGeneratorPage.jsx ──
// // // // // // // //   const isFilled = ["bold","professional","corporate"].includes(templateId);
// // // // // // // //   function secTitle(text) {
// // // // // // // //     if (isFilled) {
// // // // // // // //       return `<div style="background:${ac}10;border-left:3px solid ${ac};padding:6px 12px;
// // // // // // // //         margin-bottom:14px;border-radius:0 6px 6px 0;">
// // // // // // // //         <div style="font-size:11px;font-weight:800;text-transform:uppercase;
// // // // // // // //           letter-spacing:.1em;color:${ac};">${text}</div></div>`;
// // // // // // // //     }
// // // // // // // //     // classic, executive, minimal — underline
// // // // // // // //     return `<div style="margin-bottom:14px;border-bottom:1.5px solid ${ac};padding-bottom:5px;">
// // // // // // // //       <div style="font-size:11px;font-weight:800;text-transform:uppercase;
// // // // // // // //         letter-spacing:.1em;color:${ac};">${text}</div></div>`;
// // // // // // // //   }

// // // // // // // //   // ── Experience ──
// // // // // // // //   const expHtml = (resume.experience||[]).map(exp => {
// // // // // // // //     const bullets = (exp.bullets||[]).map(b =>
// // // // // // // //       `<li style="font-size:13px;color:#374151;margin-bottom:6px;line-height:1.7;">${esc(b)}</li>`
// // // // // // // //     ).join("");
// // // // // // // //     return `<div style="margin-bottom:18px;">
// // // // // // // //       <div style="margin-bottom:4px;">
// // // // // // // //         <span style="font-weight:700;font-size:14px;color:#0f172a;">${esc(exp.title||"")}</span>
// // // // // // // //         <span style="color:#475569;font-size:13px;"> &mdash; ${esc(exp.company||"")}</span>
// // // // // // // //         ${exp.location?`<span style="color:#94a3b8;font-size:12px;"> | ${esc(exp.location)}</span>`:""}
// // // // // // // //       </div>
// // // // // // // //       <div style="font-size:12px;color:#64748b;font-style:italic;margin-bottom:7px;">
// // // // // // // //         ${fmt(exp.startDate,exp.endDate)}</div>
// // // // // // // //       <ul style="margin:0 0 0 20px;padding:0;">${bullets}</ul>
// // // // // // // //     </div>`;
// // // // // // // //   }).join("");

// // // // // // // //   // ── Education ──
// // // // // // // //   const eduHtml = (resume.education||[]).map(edu =>
// // // // // // // //     `<div style="margin-bottom:12px;">
// // // // // // // //       <span style="font-weight:600;font-size:14px;color:#0f172a;">${esc(edu.degree||"")}</span>
// // // // // // // //       <span style="color:#475569;font-size:13px;"> &mdash; ${esc(edu.school||"")}</span>
// // // // // // // //       ${edu.location?`<span style="color:#94a3b8;font-size:12px;"> | ${esc(edu.location)}</span>`:""}
// // // // // // // //       <div style="font-size:12px;color:#64748b;font-style:italic;margin-top:2px;">
// // // // // // // //         ${esc(edu.year||"")}${edu.gpa?` | GPA: ${esc(edu.gpa)}`:""}
// // // // // // // //       </div>
// // // // // // // //     </div>`
// // // // // // // //   ).join("");

// // // // // // // //   // ── Skills ──
// // // // // // // //   const sk = resume.skills||{};
// // // // // // // //   const skillsHtml = [
// // // // // // // //     sk.technical?.length ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // //       <strong>Technical:</strong> ${sk.technical.map(esc).join(", ")}</p>` : "",
// // // // // // // //     sk.tools?.length     ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // //       <strong>Tools:</strong> ${sk.tools.map(esc).join(", ")}</p>` : "",
// // // // // // // //     sk.soft?.length      ? `<p style="font-size:13px;margin-bottom:7px;color:#374151;line-height:1.6;">
// // // // // // // //       <strong>Soft Skills:</strong> ${sk.soft.map(esc).join(", ")}</p>` : "",
// // // // // // // //   ].join("");

// // // // // // // //   // ── Certifications ──
// // // // // // // //   const certHtml = (resume.certifications||[]).length
// // // // // // // //     ? `<ul style="margin:0 0 0 20px;padding:0;">${(resume.certifications).map(c=>
// // // // // // // //         `<li style="font-size:13px;color:#374151;margin-bottom:6px;line-height:1.7;">${esc(c)}</li>`
// // // // // // // //       ).join("")}</ul>` : "";

// // // // // // // //   // ── Main content sections ──
// // // // // // // //   function section(title, body) {
// // // // // // // //     if (!body?.trim()) return "";
// // // // // // // //     return `<div style="margin-bottom:24px;">${secTitle(title)}${body}</div>`;
// // // // // // // //   }
// // // // // // // //   const mainSections = `
// // // // // // // //     ${resume.summary ? section("Professional Summary",
// // // // // // // //       `<p style="font-size:13px;line-height:1.8;color:#374151;">${esc(resume.summary)}</p>`) : ""}
// // // // // // // //     ${expHtml  ? section("Work Experience", expHtml)  : ""}
// // // // // // // //     ${eduHtml  ? section("Education",       eduHtml)  : ""}
// // // // // // // //     ${skillsHtml ? section("Skills",        skillsHtml) : ""}
// // // // // // // //     ${certHtml ? section("Certifications",  certHtml) : ""}`;

// // // // // // // //   // ── Print hint (PDF/HTML only) ──
// // // // // // // //   const hint = showHint ? `
// // // // // // // //     <div class="no-print" style="background:#e8f0fe;border:1px solid #1a73e8;border-radius:8px;
// // // // // // // //       padding:12px 18px;margin-bottom:20px;text-align:center;font-size:13px;color:#1a73e8;
// // // // // // // //       font-family:Arial,sans-serif;">
// // // // // // // //       📄 <strong>Save as PDF:</strong> Ctrl+P &rarr; destination = "Save as PDF" &rarr;
// // // // // // // //       margins = "None" &rarr; enable "Background graphics" &rarr; Save
// // // // // // // //     </div>` : "";

// // // // // // // //   // ── Print / page CSS ──
// // // // // // // //   const printCSS = forWord
// // // // // // // //     ? `@page { size:A4; margin:.65in; }`
// // // // // // // //     : `@media print {
// // // // // // // //         .no-print { display:none!important; }
// // // // // // // //         body { margin:0; padding:0; background:#fff; }
// // // // // // // //         .page { box-shadow:none!important; }
// // // // // // // //         @page { size:A4; margin:0; }
// // // // // // // //       }
// // // // // // // //       -webkit-print-color-adjust: exact;
// // // // // // // //       print-color-adjust: exact;`;

// // // // // // // //   // ── Build body per template ──
// // // // // // // //   let body = "";

// // // // // // // //   // ──────────────────────────────────────────
// // // // // // // //   // CLASSIC
// // // // // // // //   // ──────────────────────────────────────────
// // // // // // // //   if (templateId === "classic") {
// // // // // // // //     body = `
// // // // // // // //       <div style="padding:32px 40px;">
// // // // // // // //         <div style="text-align:center;padding-bottom:20px;margin-bottom:24px;
// // // // // // // //           border-bottom:2px solid ${ac};">
// // // // // // // //           <h1 style="font-size:26px;font-weight:700;color:#0f172a;margin:0 0 8px;
// // // // // // // //             font-family:Georgia,'Times New Roman',serif;">${nm}</h1>
// // // // // // // //           <div style="display:${forWord?"block":"flex"};justify-content:center;
// // // // // // // //             flex-wrap:wrap;gap:16px;font-size:13px;color:#475569;margin-top:8px;">
// // // // // // // //             ${ctcs.map(c => forWord
// // // // // // // //               ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // //               : `<span>${c}</span>`).join("")}
// // // // // // // //           </div>
// // // // // // // //         </div>
// // // // // // // //         ${mainSections}
// // // // // // // //       </div>`;
// // // // // // // //   }

// // // // // // // //   // ──────────────────────────────────────────
// // // // // // // //   // EXECUTIVE
// // // // // // // //   // ──────────────────────────────────────────
// // // // // // // //   else if (templateId === "executive") {
// // // // // // // //     body = `
// // // // // // // //       <div style="background:${hd};padding:30px 40px 26px;color:#fff;">
// // // // // // // //         <h1 style="font-size:28px;font-weight:700;color:#fff;text-transform:uppercase;
// // // // // // // //           letter-spacing:.06em;margin:0 0 10px;
// // // // // // // //           font-family:Georgia,'Times New Roman',serif;">${nm}</h1>
// // // // // // // //         <div style="height:2px;background:rgba(255,255,255,.3);margin-bottom:4px;"></div>
// // // // // // // //         <div style="height:1px;background:rgba(255,255,255,.1);margin-bottom:14px;"></div>
// // // // // // // //         <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:20px;
// // // // // // // //           font-size:12px;color:rgba(255,255,255,.65);">
// // // // // // // //           ${ctcs.map(c => forWord
// // // // // // // //             ? `<span style="margin-right:18px;">${c}</span>`
// // // // // // // //             : `<span>${c}</span>`).join("")}
// // // // // // // //         </div>
// // // // // // // //       </div>
// // // // // // // //       <div style="padding:26px 40px;">${mainSections}</div>`;
// // // // // // // //   }

// // // // // // // //   // ──────────────────────────────────────────
// // // // // // // //   // BOLD
// // // // // // // //   // ──────────────────────────────────────────
// // // // // // // //   else if (templateId === "bold") {
// // // // // // // //     body = `
// // // // // // // //       <div style="background:${hd};padding:28px 30px 24px;">
// // // // // // // //         <h1 style="font-size:34px;font-weight:900;color:#fff;letter-spacing:-.03em;
// // // // // // // //           line-height:1;margin:0 0 2px;">${nm}</h1>
// // // // // // // //         <div style="width:52px;height:4px;background:${ac};border-radius:2px;
// // // // // // // //           margin:12px 0 12px;"></div>
// // // // // // // //         <div style="font-size:12px;color:rgba(255,255,255,.75);text-transform:uppercase;
// // // // // // // //           letter-spacing:.1em;margin-bottom:12px;">${ttl}</div>
// // // // // // // //         <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:18px;
// // // // // // // //           font-size:12px;color:rgba(255,255,255,.55);">
// // // // // // // //           ${ctcs.map(c => forWord
// // // // // // // //             ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // //             : `<span>${c}</span>`).join("")}
// // // // // // // //         </div>
// // // // // // // //       </div>
// // // // // // // //       <div style="padding:22px 30px;">${mainSections}</div>`;
// // // // // // // //   }

// // // // // // // //   // ──────────────────────────────────────────
// // // // // // // //   // MINIMAL
// // // // // // // //   // ──────────────────────────────────────────
// // // // // // // //   else if (templateId === "minimal") {
// // // // // // // //     body = `
// // // // // // // //       <div style="padding:32px 40px;">
// // // // // // // //         <div style="padding-bottom:18px;margin-bottom:22px;border-bottom:2.5px solid ${ac};">
// // // // // // // //           <h1 style="font-size:28px;font-weight:300;color:#0f172a;letter-spacing:-.02em;
// // // // // // // //             margin:0 0 6px;">${nm}</h1>
// // // // // // // //           <div style="width:32px;height:3px;background:${ac};border-radius:2px;
// // // // // // // //             margin-bottom:12px;"></div>
// // // // // // // //           <div style="display:${forWord?"block":"flex"};flex-wrap:wrap;gap:18px;
// // // // // // // //             font-size:13px;color:#64748b;">
// // // // // // // //             ${ctcs.map(c => forWord
// // // // // // // //               ? `<span style="margin-right:16px;">${c}</span>`
// // // // // // // //               : `<span>${c}</span>`).join("")}
// // // // // // // //           </div>
// // // // // // // //         </div>
// // // // // // // //         ${mainSections}
// // // // // // // //       </div>`;
// // // // // // // //   }

// // // // // // // //   // ──────────────────────────────────────────
// // // // // // // //   // PROFESSIONAL
// // // // // // // //   // ──────────────────────────────────────────
// // // // // // // //   else if (templateId === "professional") {
// // // // // // // //     body = `
// // // // // // // //       <div style="background:${hd};padding:26px 32px 20px;">
// // // // // // // //         <div style="display:${forWord?"block":"flex"};justify-content:space-between;
// // // // // // // //           align-items:flex-end;flex-wrap:wrap;gap:12px;">
// // // // // // // //           <div>
// // // // // // // //             <h1 style="font-size:26px;font-weight:700;color:#fff;margin:0 0 5px;">${nm}</h1>
// // // // // // // //             <div style="font-size:12px;color:${ac}cc;letter-spacing:.1em;
// // // // // // // //               text-transform:uppercase;">${ttl}</div>
// // // // // // // //           </div>
// // // // // // // //           <div style="${forWord?"":"text-align:right;"}">
// // // // // // // //             ${ctcs.slice(0,2).map(c =>
// // // // // // // //               `<div style="font-size:11px;color:rgba(255,255,255,.6);margin-bottom:3px;
// // // // // // // //                 ${forWord?"":"text-align:right;"}">${c}</div>`).join("")}
// // // // // // // //           </div>
// // // // // // // //         </div>
// // // // // // // //         <div style="height:2px;background:${ac};margin-top:16px;border-radius:1px;"></div>
// // // // // // // //       </div>
// // // // // // // //       <div style="padding:20px 32px;">
// // // // // // // //         ${ctcs.length > 2 ? `<div style="font-size:12px;color:#64748b;margin-bottom:18px;
// // // // // // // //           padding-bottom:14px;border-bottom:1px solid #f1f5f9;">
// // // // // // // //           ${ctcs.slice(2).map(c=>`<span style="margin-right:16px;">${c}</span>`).join("")}
// // // // // // // //         </div>` : ""}
// // // // // // // //         ${mainSections}
// // // // // // // //       </div>`;
// // // // // // // //   }

// // // // // // // //   // fallback
// // // // // // // //   else {
// // // // // // // //     body = `<div style="padding:32px 40px;">${mainSections}</div>`;
// // // // // // // //   }

// // // // // // // //   // ── Assemble full HTML ──
// // // // // // // //   const doctype = forWord
// // // // // // // //     ? `<!DOCTYPE html>
// // // // // // // // <html xmlns:o="urn:schemas-microsoft-com:office:office"
// // // // // // // //       xmlns:w="urn:schemas-microsoft-com:office:word"
// // // // // // // //       xmlns="http://www.w3.org/TR/REC-html40">`
// // // // // // // //     : `<!DOCTYPE html><html lang="en">`;

// // // // // // // //   return `${doctype}
// // // // // // // // <head>
// // // // // // // //   <meta charset="UTF-8">
// // // // // // // //   <title>${nm} &mdash; Resume</title>
// // // // // // // //   ${forWord ? `<!--[if gte mso 9]><xml>
// // // // // // // //     <w:WordDocument><w:View>Print</w:View><w:Zoom>100</w:Zoom>
// // // // // // // //     <w:DoNotOptimizeForBrowser/></w:WordDocument></xml><![endif]-->` : ""}
// // // // // // // //   <style>
// // // // // // // //     *,*::before,*::after { box-sizing:border-box; margin:0; padding:0; }
// // // // // // // //     body {
// // // // // // // //       font-family: Arial, Helvetica, sans-serif;
// // // // // // // //       font-size: 14px;
// // // // // // // //       line-height: 1.5;
// // // // // // // //       color: #1a202c;
// // // // // // // //       background: #fff;
// // // // // // // //       ${forWord ? "" : "-webkit-print-color-adjust:exact;print-color-adjust:exact;"}
// // // // // // // //     }
// // // // // // // //     .page {
// // // // // // // //       max-width: 794px;
// // // // // // // //       width: 794px;
// // // // // // // //       margin: 0 auto;
// // // // // // // //       background: #fff;
// // // // // // // //       overflow: hidden;
// // // // // // // //       word-break: break-word;
// // // // // // // //       word-wrap: break-word;
// // // // // // // //       ${forWord ? "" : "box-shadow:0 2px 12px rgba(0,0,0,.1);"}
// // // // // // // //     }
// // // // // // // //     /* Prevent any element from exceeding page width */
// // // // // // // //     .page * {
// // // // // // // //       max-width: 100%;
// // // // // // // //     }
// // // // // // // //     /* Flex containers must wrap */
// // // // // // // //     .page div[style*="display:flex"],
// // // // // // // //     .page div[style*="display: flex"] {
// // // // // // // //       flex-wrap: wrap;
// // // // // // // //     }
// // // // // // // //     ul { list-style: disc; }
// // // // // // // //     li { line-height: 1.7; }
// // // // // // // //     p  { margin-bottom: 6px; }
// // // // // // // //     h1,h2,h3 { line-height: 1.2; }
// // // // // // // //     ${printCSS}
// // // // // // // //   </style>
// // // // // // // // </head>
// // // // // // // // <body>
// // // // // // // //   ${hint}
// // // // // // // //   <div class="page">${body}</div>
// // // // // // // // </body>
// // // // // // // // </html>`;
// // // // // // // // }

// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // HELPER — trigger file download
// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // function dl(blob, name) {
// // // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // // //   const a   = Object.assign(document.createElement("a"), { href: url, download: name });
// // // // // // // //   document.body.appendChild(a);
// // // // // // // //   a.click();
// // // // // // // //   document.body.removeChild(a);
// // // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 2000);
// // // // // // // // }

// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // PDF — opens styled HTML in new tab, auto-triggers print dialog
// // // // // // // // // User presses Ctrl+P → Save as PDF → gets exact match to screen
// // // // // // // // // No CDN libraries, no canvas, works 100% reliably
// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // PDF — silent download using html2canvas + jsPDF
// // // // // // // // // No print dialog. Renders the live React preview
// // // // // // // // // directly to a PDF file and downloads it silently.
// // // // // // // // // Requires: npm install html2canvas jspdf
// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // export async function downloadResumeAsPDF(resume, fileName, templateId, previewElement) {
// // // // // // // //   const name = (fileName || "resume").replace(/\.(pdf|html?)$/i, "");

// // // // // // // //   try {
// // // // // // // //     const html2canvas = (await import("html2canvas")).default;
// // // // // // // //     const { jsPDF }   = await import("jspdf");

// // // // // // // //     // Always render from our HTML at exact 794px (A4 width)
// // // // // // // //     // Never capture the live React preview — it varies by screen width
// // // // // // // //     // and causes content to overflow A4 boundaries
// // // // // // // //     const tempDiv = document.createElement("div");
// // // // // // // //     tempDiv.style.cssText = [
// // // // // // // //       "position:fixed",
// // // // // // // //       "left:-9999px",
// // // // // // // //       "top:0",
// // // // // // // //       "width:794px",       // exact A4 width at 96dpi
// // // // // // // //       "background:#fff",
// // // // // // // //       "z-index:-9999",
// // // // // // // //       "pointer-events:none",
// // // // // // // //       "overflow:hidden",
// // // // // // // //     ].join(";");

// // // // // // // //     // Build the full HTML and inject just the body content
// // // // // // // //     const fullHTML = buildResumeHTML(resume, templateId, { showHint: false, forWord: false });
// // // // // // // //     const bodyMatch = fullHTML.match(/<body[^>]*>([\s\S]*)<\/body>/i);
// // // // // // // //     tempDiv.innerHTML = bodyMatch ? bodyMatch[1] : fullHTML;

// // // // // // // //     document.body.appendChild(tempDiv);

// // // // // // // //     // Target the .page div for capture
// // // // // // // //     const captureEl = tempDiv.querySelector(".page") || tempDiv;

// // // // // // // //     // Wait for fonts and styles to render
// // // // // // // //     await new Promise(r => setTimeout(r, 600));

// // // // // // // //     const canvas = await html2canvas(captureEl, {
// // // // // // // //       scale:           2,
// // // // // // // //       useCORS:         true,
// // // // // // // //       allowTaint:      true,
// // // // // // // //       backgroundColor: "#ffffff",
// // // // // // // //       logging:         false,
// // // // // // // //       width:           794,
// // // // // // // //       windowWidth:     794,
// // // // // // // //       imageTimeout:    0,
// // // // // // // //       onclone: (clonedDoc) => {
// // // // // // // //         clonedDoc.querySelectorAll('[style*="SAMPLE"]').forEach(el => el.remove());
// // // // // // // //         clonedDoc.querySelectorAll('.no-print').forEach(el => el.remove());
// // // // // // // //         // Force all elements to respect width
// // // // // // // //         const style = clonedDoc.createElement("style");
// // // // // // // //         style.textContent = `* { max-width: 100%; word-break: break-word; } .page { width: 794px !important; overflow: hidden !important; }`;
// // // // // // // //         clonedDoc.head.appendChild(style);
// // // // // // // //       },
// // // // // // // //     });

// // // // // // // //     document.body.removeChild(tempDiv);

// // // // // // // //     // Convert to A4 PDF
// // // // // // // //     const A4_W = 210;
// // // // // // // //     const A4_H = 297;
// // // // // // // //     const imgW = A4_W;
// // // // // // // //     const imgH = (canvas.height * A4_W) / canvas.width;
// // // // // // // //     const pdf  = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
// // // // // // // //     const img  = canvas.toDataURL("image/jpeg", 0.97);

// // // // // // // //     let posY = 0;
// // // // // // // //     while (posY < imgH) {
// // // // // // // //       if (posY > 0) pdf.addPage();
// // // // // // // //       pdf.addImage(img, "JPEG", 0, -posY, imgW, imgH);
// // // // // // // //       posY += A4_H;
// // // // // // // //     }

// // // // // // // //     pdf.save(`${name}.pdf`);

// // // // // // // //   } catch (err) {
// // // // // // // //     console.error("PDF generation failed:", err);
// // // // // // // //     const html = buildResumeHTML(resume, templateId, { showHint: true });
// // // // // // // //     dl(new Blob([html], { type: "text/html;charset=utf-8" }), `${name}.html`);
// // // // // // // //     alert("PDF download failed. An HTML file was saved instead — open it in Chrome and press Ctrl+P → Save as PDF.");
// // // // // // // //   }
// // // // // // // // }

// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // WORD — saves as .doc using text/html MIME
// // // // // // // // // Word opens HTML files natively — reliable cross-browser
// // // // // // // // // (application/msword MIME is blocked by modern browsers)
// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // export function downloadResumeAsWord(resume, fileName, templateId) {
// // // // // // // //   const html = buildResumeHTML(resume, templateId, { forWord: true });
// // // // // // // //   // Use text/plain MIME — most reliable for triggering download
// // // // // // // //   // The .doc extension tells Word to open it natively
// // // // // // // //   dl(
// // // // // // // //     new Blob(["\ufeff", html], { type: "text/plain;charset=utf-8" }),
// // // // // // // //     (fileName || "resume").replace(/\.(doc|docx|html?)$/i, "") + ".doc"
// // // // // // // //   );
// // // // // // // // }

// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // // HTML — saves as .html, opens in browser
// // // // // // // // // ─────────────────────────────────────────────
// // // // // // // // export function downloadATSResume(resume, fileName, templateId) {
// // // // // // // //   const html = buildResumeHTML(resume, templateId, { showHint: true });
// // // // // // // //   dl(
// // // // // // // //     new Blob([html], { type: "text/html;charset=utf-8" }),
// // // // // // // //     (fileName || "resume").replace(/\.html?$/i, "") + ".html"
// // // // // // // //   );
// // // // // // // // }

// // // // // // // //--New code below
// // // // // // // // generateResumeDoc.js — Professional ATS Resume Templates
// // // // // // // // Harvard/Columbia career-center standard layouts

// // // // // // // const TEMPLATES = {
// // // // // // //   classic: {
// // // // // // //     name:"Classic ATS", accent:"#2563eb", header:"#1e293b",
// // // // // // //     font:"'Georgia','Times New Roman',serif",
// // // // // // //   },
// // // // // // //   executive: {
// // // // // // //     name:"Executive",   accent:"#1e293b", header:"#0f172a",
// // // // // // //     font:"'Georgia','Times New Roman',serif",
// // // // // // //   },
// // // // // // //   bold: {
// // // // // // //     name:"Bold Impact", accent:"#1d4ed8", header:"#1e3a8a",
// // // // // // //     font:"'Arial','Helvetica',sans-serif",
// // // // // // //   },
// // // // // // //   minimal: {
// // // // // // //     name:"Minimal Clean", accent:"#047857", header:"#047857",
// // // // // // //     font:"'Arial','Helvetica',sans-serif",
// // // // // // //   },
// // // // // // //   professional: {
// // // // // // //     name:"Professional", accent:"#0f172a", header:"#1e3a5f",
// // // // // // //     font:"'Arial','Helvetica',sans-serif",
// // // // // // //   },
// // // // // // // };

// // // // // // // function getT(id) { return TEMPLATES[id] || TEMPLATES.classic; }

// // // // // // // function esc(s) {
// // // // // // //   if (!s) return "";
// // // // // // //   return String(s)
// // // // // // //     .replace(/&/g,"&amp;").replace(/</g,"&lt;")
// // // // // // //     .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// // // // // // // }

// // // // // // // function fmt(s, e) {
// // // // // // //   if (!s && !e) return "";
// // // // // // //   if (s && !e)  return esc(s);
// // // // // // //   if (!s && e)  return esc(e);
// // // // // // //   return `${esc(s)} &ndash; ${esc(e)}`;
// // // // // // // }

// // // // // // // // ─────────────────────────────────────────────
// // // // // // // export function buildResumeHTML(resume, templateId, opts = {}) {
// // // // // // //   const { forWord = false, showHint = false } = opts;
// // // // // // //   const t  = getT(templateId);
// // // // // // //   const ac = t.accent;
// // // // // // //   const hd = t.header;
// // // // // // //   const ff = t.font;

// // // // // // //   const nm   = esc(resume.name || "Your Name");
// // // // // // //   const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
// // // // // // //   const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin]
// // // // // // //                  .filter(Boolean).map(esc);

// // // // // // //   // ── Google Fonts ──
// // // // // // //   const gf = forWord ? "" : `<link rel="preconnect" href="https://fonts.googleapis.com">
// // // // // // // <link href="https://fonts.googleapis.com/css2?family=EB+Garamond:wght@400;500;600;700&family=Libre+Baskerville:wght@400;700&family=Inter:wght@300;400;500;600;700&family=Lato:wght@300;400;700;900&display=swap" rel="stylesheet">`;

// // // // // // //   // ── Shared content builders ──
// // // // // // //   const expHtml = (resume.experience||[]).map(exp => {
// // // // // // //     const bullets = (exp.bullets||[]).map(b =>
// // // // // // //       `<li>${esc(b)}</li>`
// // // // // // //     ).join("");
// // // // // // //     const dates = fmt(exp.startDate, exp.endDate);
// // // // // // //     return `
// // // // // // //     <div class="exp-block">
// // // // // // //       <div class="exp-header">
// // // // // // //         <div class="exp-left">
// // // // // // //           <span class="exp-title">${esc(exp.title||"")}</span>
// // // // // // //           <span class="exp-sep"> | </span>
// // // // // // //           <span class="exp-company">${esc(exp.company||"")}</span>
// // // // // // //           ${exp.location ? `<span class="exp-loc">&nbsp;&nbsp;${esc(exp.location)}</span>` : ""}
// // // // // // //         </div>
// // // // // // //         ${dates ? `<span class="exp-dates">${dates}</span>` : ""}
// // // // // // //       </div>
// // // // // // //       ${bullets ? `<ul class="bullets">${bullets}</ul>` : ""}
// // // // // // //     </div>`;
// // // // // // //   }).join("");

// // // // // // //   const eduHtml = (resume.education||[]).map(edu => `
// // // // // // //     <div class="edu-block">
// // // // // // //       <div class="exp-header">
// // // // // // //         <div class="exp-left">
// // // // // // //           <span class="exp-title">${esc(edu.degree||"")}</span>
// // // // // // //           <span class="exp-sep"> | </span>
// // // // // // //           <span class="exp-company">${esc(edu.school||"")}</span>
// // // // // // //           ${edu.location ? `<span class="exp-loc">&nbsp;&nbsp;${esc(edu.location)}</span>` : ""}
// // // // // // //         </div>
// // // // // // //         ${edu.year ? `<span class="exp-dates">${esc(edu.year)}${edu.gpa ? ` &nbsp;·&nbsp; GPA ${esc(edu.gpa)}` : ""}</span>` : ""}
// // // // // // //       </div>
// // // // // // //     </div>`
// // // // // // //   ).join("");

// // // // // // //   const sk = resume.skills || {};
// // // // // // //   const skillLines = [
// // // // // // //     sk.technical?.length ? `<div class="skill-line"><span class="skill-cat">Technical</span><span class="skill-vals">${sk.technical.map(esc).join(" &nbsp;·&nbsp; ")}</span></div>` : "",
// // // // // // //     sk.tools?.length     ? `<div class="skill-line"><span class="skill-cat">Tools &amp; Platforms</span><span class="skill-vals">${sk.tools.map(esc).join(" &nbsp;·&nbsp; ")}</span></div>` : "",
// // // // // // //     sk.soft?.length      ? `<div class="skill-line"><span class="skill-cat">Core Competencies</span><span class="skill-vals">${sk.soft.map(esc).join(" &nbsp;·&nbsp; ")}</span></div>` : "",
// // // // // // //   ].join("");

// // // // // // //   const certHtml = (resume.certifications||[]).length
// // // // // // //     ? `<div class="cert-list">${resume.certifications.map(c=>`<span class="cert-item">${esc(c)}</span>`).join("")}</div>` : "";

// // // // // // //   function sec(title, body) {
// // // // // // //     if (!body?.trim()) return "";
// // // // // // //     return `<div class="section"><div class="sec-title">${title}</div><div class="sec-body">${body}</div></div>`;
// // // // // // //   }

// // // // // // //   const sections = `
// // // // // // //     ${resume.summary ? sec("Professional Summary",`<p class="summary-text">${esc(resume.summary)}</p>`) : ""}
// // // // // // //     ${expHtml  ? sec("Work Experience",  expHtml)  : ""}
// // // // // // //     ${eduHtml  ? sec("Education",        eduHtml)  : ""}
// // // // // // //     ${skillLines ? sec("Skills",         skillLines) : ""}
// // // // // // //     ${certHtml ? sec("Certifications",   certHtml) : ""}`;

// // // // // // //   const hint = showHint ? `<div class="hint">📄 Ctrl+P → Save as PDF → enable "Background graphics" → Save</div>` : "";

// // // // // // //   // ════════════════════════════════════════════
// // // // // // //   // TEMPLATE CSS
// // // // // // //   // ════════════════════════════════════════════

// // // // // // //   // ── CLASSIC — Harvard style, centered, serif ──
// // // // // // //   const classicCSS = `
// // // // // // //     body { font-family: 'EB Garamond','Georgia',serif; font-size:14.5px; line-height:1.55; color:#1a1a1a; background:#fff; }
// // // // // // //     .page { max-width:794px; width:794px; margin:0 auto; background:#fff; padding:44px 52px 40px; }
// // // // // // //     .header { text-align:center; margin-bottom:14px; }
// // // // // // //     .header-name { font-family:'EB Garamond','Georgia',serif; font-size:32px; font-weight:700; letter-spacing:.5px; color:#000; line-height:1.1; margin-bottom:6px; }
// // // // // // //     .header-title { font-size:14px; color:#444; font-style:italic; margin-bottom:8px; }
// // // // // // //     .header-contact { display:flex; justify-content:center; flex-wrap:wrap; gap:4px 0; font-size:12.5px; color:#333; }
// // // // // // //     .ctc-sep { margin:0 8px; color:#999; }
// // // // // // //     .divider { border:none; border-top:2px solid #000; margin:12px 0 18px; }
// // // // // // //     .section { margin-bottom:18px; }
// // // // // // //     .sec-title { font-family:'EB Garamond','Georgia',serif; font-size:15px; font-weight:700; text-transform:uppercase; letter-spacing:1.5px; color:#000; border-bottom:1px solid #000; padding-bottom:3px; margin-bottom:9px; }
// // // // // // //     .sec-body { }
// // // // // // //     .summary-text { font-size:13.5px; line-height:1.65; color:#222; margin:0; }
// // // // // // //     .exp-block { margin-bottom:12px; }
// // // // // // //     .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:4px; }
// // // // // // //     .exp-left { flex:1; }
// // // // // // //     .exp-title { font-weight:700; font-size:14px; color:#000; }
// // // // // // //     .exp-sep { color:#666; font-weight:400; }
// // // // // // //     .exp-company { font-size:14px; color:#333; font-style:italic; }
// // // // // // //     .exp-loc { font-size:12.5px; color:#666; }
// // // // // // //     .exp-dates { font-size:12.5px; color:#333; white-space:nowrap; font-style:italic; }
// // // // // // //     .edu-block { margin-bottom:8px; }
// // // // // // //     .bullets { margin:4px 0 0 18px; padding:0; list-style:disc; }
// // // // // // //     .bullets li { font-size:13px; color:#222; margin-bottom:3px; line-height:1.55; padding-left:3px; }
// // // // // // //     .skill-line { display:flex; gap:10px; margin-bottom:5px; font-size:13px; }
// // // // // // //     .skill-cat { font-weight:700; color:#000; min-width:130px; flex-shrink:0; }
// // // // // // //     .skill-vals { color:#333; line-height:1.5; }
// // // // // // //     .cert-list { display:flex; flex-wrap:wrap; gap:6px; }
// // // // // // //     .cert-item { font-size:13px; color:#333; }
// // // // // // //     .cert-item:not(:last-child)::after { content:" ·"; color:#999; margin-left:4px; }
// // // // // // //     .hint { background:#eff6ff; border:1px solid #bfdbfe; border-radius:6px; padding:10px 16px; margin-bottom:16px; text-align:center; font-size:12px; color:#1d4ed8; font-family:Arial,sans-serif; }
// // // // // // //     @media print { .hint { display:none; } body { background:#fff; } .page { padding:32px 40px; box-shadow:none; } @page { size:A4; margin:0; } }
// // // // // // //     -webkit-print-color-adjust:exact; print-color-adjust:exact;`;

// // // // // // //   // ── EXECUTIVE — dark header bar, clean white body ──
// // // // // // //   const executiveCSS = `
// // // // // // //     body { font-family: 'Libre Baskerville','Georgia',serif; font-size:13.5px; line-height:1.55; color:#1a1a1a; background:#fff; }
// // // // // // //     .page { max-width:794px; width:794px; margin:0 auto; background:#fff; overflow:hidden; }
// // // // // // //     .header { background:#0f172a; padding:30px 44px 24px; }
// // // // // // //     .header-name { font-family:'Libre Baskerville','Georgia',serif; font-size:28px; font-weight:700; color:#fff; letter-spacing:.8px; text-transform:uppercase; margin-bottom:5px; }
// // // // // // //     .header-title { font-size:12px; color:rgba(255,255,255,.55); text-transform:uppercase; letter-spacing:2px; margin-bottom:14px; font-family:'Lato','Arial',sans-serif; font-weight:300; }
// // // // // // //     .header-rule { border:none; border-top:1px solid rgba(255,255,255,.2); margin-bottom:12px; }
// // // // // // //     .header-contact { display:flex; flex-wrap:wrap; gap:4px 24px; font-size:12px; color:rgba(255,255,255,.6); font-family:'Lato','Arial',sans-serif; }
// // // // // // //     .body-pad { padding:26px 44px 36px; }
// // // // // // //     .section { margin-bottom:18px; }
// // // // // // //     .sec-title { font-family:'Lato','Arial',sans-serif; font-size:10.5px; font-weight:700; text-transform:uppercase; letter-spacing:2px; color:#0f172a; border-bottom:2px solid #0f172a; padding-bottom:4px; margin-bottom:10px; }
// // // // // // //     .sec-body { }
// // // // // // //     .summary-text { font-size:13px; line-height:1.7; color:#333; margin:0; }
// // // // // // //     .exp-block { margin-bottom:13px; }
// // // // // // //     .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:4px; }
// // // // // // //     .exp-left { flex:1; }
// // // // // // //     .exp-title { font-weight:700; font-size:13.5px; color:#0f172a; }
// // // // // // //     .exp-sep { color:#999; }
// // // // // // //     .exp-company { font-size:13px; color:#444; }
// // // // // // //     .exp-loc { font-size:12px; color:#888; }
// // // // // // //     .exp-dates { font-size:12px; color:#555; white-space:nowrap; font-style:italic; font-family:'Lato','Arial',sans-serif; }
// // // // // // //     .edu-block { margin-bottom:8px; }
// // // // // // //     .bullets { margin:5px 0 0 18px; padding:0; list-style:disc; }
// // // // // // //     .bullets li { font-size:12.5px; color:#333; margin-bottom:4px; line-height:1.55; }
// // // // // // //     .skill-line { display:flex; gap:10px; margin-bottom:5px; font-size:12.5px; font-family:'Lato','Arial',sans-serif; }
// // // // // // //     .skill-cat { font-weight:700; color:#0f172a; min-width:135px; flex-shrink:0; }
// // // // // // //     .skill-vals { color:#444; line-height:1.5; }
// // // // // // //     .cert-list { display:flex; flex-wrap:wrap; gap:6px; font-family:'Lato','Arial',sans-serif; }
// // // // // // //     .cert-item { font-size:12.5px; color:#444; }
// // // // // // //     .cert-item:not(:last-child)::after { content:" ·"; color:#bbb; margin-left:4px; }
// // // // // // //     .hint { background:#f8fafc; border:1px solid #e2e8f0; border-radius:6px; padding:10px 16px; margin:0 44px 12px; text-align:center; font-size:12px; color:#475569; font-family:Arial,sans-serif; }
// // // // // // //     @media print { .hint { display:none; } body { background:#fff; } .page { box-shadow:none; } @page { size:A4; margin:0; } }
// // // // // // //     -webkit-print-color-adjust:exact; print-color-adjust:exact;`;

// // // // // // //   // ── BOLD — strong left accent bar, modern sans-serif ──
// // // // // // //   const boldCSS = `
// // // // // // //     body { font-family: 'Lato','Arial',sans-serif; font-size:13.5px; line-height:1.55; color:#1a1a1a; background:#fff; }
// // // // // // //     .page { max-width:794px; width:794px; margin:0 auto; background:#fff; overflow:hidden; }
// // // // // // //     .header { background:#1e3a8a; padding:28px 40px 22px; position:relative; }
// // // // // // //     .header::after { content:""; position:absolute; bottom:0; left:0; right:0; height:4px; background:#1d4ed8; }
// // // // // // //     .header-name { font-family:'Lato','Arial',sans-serif; font-size:34px; font-weight:900; color:#fff; letter-spacing:-.5px; line-height:1.05; margin-bottom:4px; }
// // // // // // //     .header-title { font-size:12px; color:rgba(255,255,255,.65); text-transform:uppercase; letter-spacing:2.5px; margin-bottom:14px; font-weight:400; }
// // // // // // //     .header-contact { display:flex; flex-wrap:wrap; gap:4px 20px; font-size:12px; color:rgba(255,255,255,.55); }
// // // // // // //     .body-pad { padding:24px 40px 36px; }
// // // // // // //     .section { margin-bottom:18px; }
// // // // // // //     .sec-title { font-size:10px; font-weight:900; text-transform:uppercase; letter-spacing:2.5px; color:#1d4ed8; padding-bottom:6px; border-bottom:2px solid #1d4ed8; margin-bottom:10px; }
// // // // // // //     .sec-body { }
// // // // // // //     .summary-text { font-size:13px; line-height:1.7; color:#333; margin:0; }
// // // // // // //     .exp-block { margin-bottom:13px; border-left:2px solid #e2e8f0; padding-left:12px; }
// // // // // // //     .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:4px; }
// // // // // // //     .exp-left { flex:1; }
// // // // // // //     .exp-title { font-weight:700; font-size:14px; color:#0f172a; }
// // // // // // //     .exp-sep { color:#cbd5e1; }
// // // // // // //     .exp-company { font-size:13px; color:#475569; font-weight:600; }
// // // // // // //     .exp-loc { font-size:12px; color:#94a3b8; }
// // // // // // //     .exp-dates { font-size:12px; color:#64748b; white-space:nowrap; font-style:italic; }
// // // // // // //     .edu-block { margin-bottom:8px; border-left:2px solid #e2e8f0; padding-left:12px; }
// // // // // // //     .bullets { margin:5px 0 0 16px; padding:0; list-style:disc; }
// // // // // // //     .bullets li { font-size:12.5px; color:#374151; margin-bottom:4px; line-height:1.55; }
// // // // // // //     .skill-line { display:flex; gap:10px; margin-bottom:6px; font-size:12.5px; }
// // // // // // //     .skill-cat { font-weight:700; color:#0f172a; min-width:130px; flex-shrink:0; }
// // // // // // //     .skill-vals { color:#475569; line-height:1.5; }
// // // // // // //     .cert-list { display:flex; flex-wrap:wrap; gap:6px; }
// // // // // // //     .cert-item { font-size:12.5px; color:#475569; }
// // // // // // //     .cert-item:not(:last-child)::after { content:" ·"; color:#cbd5e1; margin-left:4px; }
// // // // // // //     .hint { background:#eff6ff; border:1px solid #bfdbfe; border-radius:6px; padding:10px 16px; margin:0 40px 12px; text-align:center; font-size:12px; color:#1d4ed8; }
// // // // // // //     @media print { .hint { display:none; } body { background:#fff; } .page { box-shadow:none; } @page { size:A4; margin:0; } }
// // // // // // //     -webkit-print-color-adjust:exact; print-color-adjust:exact;`;

// // // // // // //   // ── MINIMAL — clean white, thin green accents, left-aligned ──
// // // // // // //   const minimalCSS = `
// // // // // // //     body { font-family: 'Inter','Arial',sans-serif; font-size:13.5px; line-height:1.6; color:#1a1a1a; background:#fff; }
// // // // // // //     .page { max-width:794px; width:794px; margin:0 auto; background:#fff; padding:44px 52px 40px; }
// // // // // // //     .header { margin-bottom:24px; border-bottom:1px solid #e5e7eb; padding-bottom:20px; }
// // // // // // //     .header-name { font-family:'Inter','Arial',sans-serif; font-size:30px; font-weight:600; color:#111; letter-spacing:-.5px; margin-bottom:4px; }
// // // // // // //     .header-title { font-size:14px; color:#047857; font-weight:500; margin-bottom:12px; }
// // // // // // //     .header-contact { display:flex; flex-wrap:wrap; gap:4px 0; font-size:12.5px; color:#555; }
// // // // // // //     .ctc-sep { margin:0 10px; color:#d1d5db; }
// // // // // // //     .section { margin-bottom:18px; }
// // // // // // //     .sec-title { font-size:10px; font-weight:600; text-transform:uppercase; letter-spacing:2px; color:#047857; margin-bottom:8px; padding-bottom:4px; border-bottom:1px solid #d1fae5; }
// // // // // // //     .sec-body { }
// // // // // // //     .summary-text { font-size:13px; line-height:1.7; color:#374141; margin:0; }
// // // // // // //     .exp-block { margin-bottom:14px; }
// // // // // // //     .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:4px; }
// // // // // // //     .exp-left { flex:1; }
// // // // // // //     .exp-title { font-weight:600; font-size:13.5px; color:#111; }
// // // // // // //     .exp-sep { color:#d1d5db; margin:0 4px; }
// // // // // // //     .exp-company { font-size:13px; color:#374151; }
// // // // // // //     .exp-loc { font-size:12px; color:#9ca3af; }
// // // // // // //     .exp-dates { font-size:12px; color:#6b7280; white-space:nowrap; }
// // // // // // //     .edu-block { margin-bottom:8px; }
// // // // // // //     .bullets { margin:5px 0 0 16px; padding:0; list-style:none; }
// // // // // // //     .bullets li { font-size:13px; color:#374151; margin-bottom:3px; line-height:1.55; padding-left:10px; position:relative; }
// // // // // // //     .bullets li::before { content:"–"; position:absolute; left:0; color:#047857; }
// // // // // // //     .skill-line { display:flex; gap:10px; margin-bottom:5px; font-size:13px; }
// // // // // // //     .skill-cat { font-weight:600; color:#111; min-width:130px; flex-shrink:0; }
// // // // // // //     .skill-vals { color:#374151; line-height:1.5; }
// // // // // // //     .cert-list { display:flex; flex-wrap:wrap; gap:6px; }
// // // // // // //     .cert-item { font-size:13px; color:#374151; }
// // // // // // //     .cert-item:not(:last-child)::after { content:" ·"; color:#9ca3af; margin-left:4px; }
// // // // // // //     .hint { background:#f0fdf4; border:1px solid #bbf7d0; border-radius:6px; padding:10px 16px; margin-bottom:16px; text-align:center; font-size:12px; color:#047857; font-family:Arial,sans-serif; }
// // // // // // //     @media print { .hint { display:none; } body { background:#fff; } .page { padding:32px 40px; box-shadow:none; } @page { size:A4; margin:0; } }
// // // // // // //     -webkit-print-color-adjust:exact; print-color-adjust:exact;`;

// // // // // // //   // ── PROFESSIONAL — dark navy header split-layout, corporate ──
// // // // // // //   const professionalCSS = `
// // // // // // //     body { font-family: 'Lato','Arial',sans-serif; font-size:13.5px; line-height:1.55; color:#1a1a1a; background:#fff; }
// // // // // // //     .page { max-width:794px; width:794px; margin:0 auto; background:#fff; overflow:hidden; }
// // // // // // //     .header { background:#1e3a5f; padding:24px 40px 20px; }
// // // // // // //     .header-top { display:flex; justify-content:space-between; align-items:flex-start; gap:16px; margin-bottom:12px; }
// // // // // // //     .header-left .header-name { font-family:'Lato','Arial',sans-serif; font-size:26px; font-weight:700; color:#fff; letter-spacing:.2px; margin-bottom:4px; }
// // // // // // //     .header-left .header-title { font-size:11.5px; color:rgba(255,255,255,.55); text-transform:uppercase; letter-spacing:1.5px; font-weight:300; }
// // // // // // //     .header-right { text-align:right; padding-top:4px; }
// // // // // // //     .header-right .ctc-line { font-size:12px; color:rgba(255,255,255,.6); margin-bottom:3px; }
// // // // // // //     .header-rule { border:none; border-top:1px solid rgba(255,255,255,.15); margin-bottom:0; }
// // // // // // //     .body-pad { padding:22px 40px 36px; }
// // // // // // //     .section { margin-bottom:18px; }
// // // // // // //     .sec-title { font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:2px; color:#1e3a5f; background:#f0f4f8; padding:5px 10px; margin-bottom:10px; border-left:3px solid #1e3a5f; }
// // // // // // //     .sec-body { }
// // // // // // //     .summary-text { font-size:13px; line-height:1.7; color:#333; margin:0; }
// // // // // // //     .exp-block { margin-bottom:13px; }
// // // // // // //     .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:4px; }
// // // // // // //     .exp-left { flex:1; }
// // // // // // //     .exp-title { font-weight:700; font-size:13.5px; color:#0f172a; }
// // // // // // //     .exp-sep { color:#cbd5e1; margin:0 3px; }
// // // // // // //     .exp-company { font-size:13px; color:#374151; font-weight:600; }
// // // // // // //     .exp-loc { font-size:12px; color:#94a3b8; }
// // // // // // //     .exp-dates { font-size:12px; color:#64748b; white-space:nowrap; font-style:italic; }
// // // // // // //     .edu-block { margin-bottom:8px; }
// // // // // // //     .bullets { margin:5px 0 0 18px; padding:0; list-style:square; }
// // // // // // //     .bullets li { font-size:12.5px; color:#374151; margin-bottom:4px; line-height:1.55; }
// // // // // // //     .bullets li::marker { color:#1e3a5f; }
// // // // // // //     .skill-line { display:flex; gap:10px; margin-bottom:6px; font-size:12.5px; }
// // // // // // //     .skill-cat { font-weight:700; color:#1e3a5f; min-width:130px; flex-shrink:0; }
// // // // // // //     .skill-vals { color:#374151; line-height:1.5; }
// // // // // // //     .cert-list { display:flex; flex-wrap:wrap; gap:6px; }
// // // // // // //     .cert-item { font-size:12.5px; color:#374151; }
// // // // // // //     .cert-item:not(:last-child)::after { content:" ·"; color:#cbd5e1; margin-left:4px; }
// // // // // // //     .hint { background:#f0f4f8; border:1px solid #cbd5e1; border-radius:6px; padding:10px 16px; margin:0 40px 12px; text-align:center; font-size:12px; color:#1e3a5f; }
// // // // // // //     @media print { .hint { display:none; } body { background:#fff; } .page { box-shadow:none; } @page { size:A4; margin:0; } }
// // // // // // //     -webkit-print-color-adjust:exact; print-color-adjust:exact;`;

// // // // // // //   const cssMap = { classic:classicCSS, executive:executiveCSS, bold:boldCSS, minimal:minimalCSS, professional:professionalCSS };
// // // // // // //   const css = cssMap[templateId] || classicCSS;

// // // // // // //   // ── Build header HTML per template ──
// // // // // // //   let headerHTML = "";
// // // // // // //   let wrapOpen   = "";
// // // // // // //   let wrapClose  = "";

// // // // // // //   const ctcLine = forWord
// // // // // // //     ? ctcs.map(c=>`<span>${c}</span>`).join(" &nbsp;|&nbsp; ")
// // // // // // //     : ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");

// // // // // // //   if (templateId === "classic") {
// // // // // // //     headerHTML = `
// // // // // // //       <div class="header">
// // // // // // //         <div class="header-name">${nm}</div>
// // // // // // //         ${ttl ? `<div class="header-title">${ttl}</div>` : ""}
// // // // // // //         <div class="header-contact">${ctcLine}</div>
// // // // // // //       </div>
// // // // // // //       <hr class="divider">`;
// // // // // // //   }
// // // // // // //   else if (templateId === "executive") {
// // // // // // //     headerHTML = `<div class="header">
// // // // // // //       <div class="header-name">${nm}</div>
// // // // // // //       ${ttl ? `<div class="header-title">${ttl}</div>` : ""}
// // // // // // //       <hr class="header-rule">
// // // // // // //       <div class="header-contact">${ctcs.join(" &nbsp;&nbsp;·&nbsp;&nbsp; ")}</div>
// // // // // // //     </div>`;
// // // // // // //     wrapOpen  = `<div class="body-pad">`;
// // // // // // //     wrapClose = `</div>`;
// // // // // // //   }
// // // // // // //   else if (templateId === "bold") {
// // // // // // //     headerHTML = `<div class="header">
// // // // // // //       <div class="header-name">${nm}</div>
// // // // // // //       ${ttl ? `<div class="header-title">${ttl}</div>` : ""}
// // // // // // //       <div class="header-contact">${ctcs.join(" &nbsp;·&nbsp; ")}</div>
// // // // // // //     </div>`;
// // // // // // //     wrapOpen  = `<div class="body-pad">`;
// // // // // // //     wrapClose = `</div>`;
// // // // // // //   }
// // // // // // //   else if (templateId === "minimal") {
// // // // // // //     headerHTML = `
// // // // // // //       <div class="header">
// // // // // // //         <div class="header-name">${nm}</div>
// // // // // // //         ${ttl ? `<div class="header-title">${ttl}</div>` : ""}
// // // // // // //         <div class="header-contact">${ctcLine}</div>
// // // // // // //       </div>`;
// // // // // // //   }
// // // // // // //   else if (templateId === "professional") {
// // // // // // //     const ctcRight = ctcs.slice(0,3).map(c=>`<div class="ctc-line">${c}</div>`).join("");
// // // // // // //     const ctcExtra = ctcs.slice(3);
// // // // // // //     headerHTML = `<div class="header">
// // // // // // //       <div class="header-top">
// // // // // // //         <div class="header-left">
// // // // // // //           <div class="header-name">${nm}</div>
// // // // // // //           ${ttl ? `<div class="header-title">${ttl}</div>` : ""}
// // // // // // //         </div>
// // // // // // //         <div class="header-right">${ctcRight}</div>
// // // // // // //       </div>
// // // // // // //       ${ctcExtra.length ? `<div style="font-size:11.5px;color:rgba(255,255,255,.5);padding-top:6px;">${ctcExtra.join(" &nbsp;·&nbsp; ")}</div>` : ""}
// // // // // // //       <hr class="header-rule">
// // // // // // //     </div>`;
// // // // // // //     wrapOpen  = `<div class="body-pad">`;
// // // // // // //     wrapClose = `</div>`;
// // // // // // //   }

// // // // // // //   // ── Print CSS ──
// // // // // // //   const printCSS = forWord ? `@page { size:A4; margin:.7in; }` : "";

// // // // // // //   // ── Word CSS (simplified, no colors) ──
// // // // // // //   const wordCSS = `
// // // // // // //     body { font-family:Arial,Helvetica,sans-serif; font-size:14px; line-height:1.5; color:#000; }
// // // // // // //     .page { max-width:794px; margin:0 auto; padding:36px 44px; }
// // // // // // //     .header-name { font-size:26px; font-weight:700; margin-bottom:4px; }
// // // // // // //     .header-title { font-size:13px; color:#444; margin-bottom:8px; }
// // // // // // //     .header-contact { font-size:12px; color:#333; margin-bottom:12px; }
// // // // // // //     .divider { border-top:1px solid #000; margin:10px 0 14px; }
// // // // // // //     .sec-title { font-size:12px; font-weight:700; text-transform:uppercase; letter-spacing:1px; border-bottom:1px solid #000; padding-bottom:3px; margin:14px 0 8px; }
// // // // // // //     .exp-header { display:block; margin-bottom:3px; }
// // // // // // //     .exp-title { font-weight:700; font-size:13px; }
// // // // // // //     .exp-company { font-size:13px; color:#333; }
// // // // // // //     .exp-dates { font-size:12px; color:#555; display:block; }
// // // // // // //     .bullets { margin:4px 0 0 18px; padding:0; list-style:disc; }
// // // // // // //     .bullets li { font-size:13px; margin-bottom:3px; }
// // // // // // //     .skill-line { display:block; margin-bottom:4px; font-size:13px; }
// // // // // // //     .skill-cat { font-weight:700; }
// // // // // // //     @page { size:A4; margin:.7in; }`;

// // // // // // //   return `<!DOCTYPE html>
// // // // // // // <html lang="en">
// // // // // // // <head>
// // // // // // //   <meta charset="UTF-8">
// // // // // // //   <title>${nm} &mdash; Resume</title>
// // // // // // //   ${gf}
// // // // // // //   <style>
// // // // // // //     *,*::before,*::after { box-sizing:border-box; margin:0; padding:0; }
// // // // // // //     ${forWord ? wordCSS : css}
// // // // // // //     .page * { max-width:100%; }
// // // // // // //     ul.bullets { overflow:hidden; }
// // // // // // //     li { word-break:break-word; }
// // // // // // //     ${printCSS}
// // // // // // //   </style>
// // // // // // // </head>
// // // // // // // <body>
// // // // // // //   ${hint}
// // // // // // //   <div class="page">
// // // // // // //     ${headerHTML}
// // // // // // //     ${wrapOpen}
// // // // // // //     ${sections}
// // // // // // //     ${wrapClose}
// // // // // // //   </div>
// // // // // // // </body>
// // // // // // // </html>`;
// // // // // // // }

// // // // // // // // ─────────────────────────────────────────────
// // // // // // // // HELPERS
// // // // // // // // ─────────────────────────────────────────────
// // // // // // // function dl(blob, name) {
// // // // // // //   const url = URL.createObjectURL(blob);
// // // // // // //   const a   = Object.assign(document.createElement("a"), { href:url, download:name });
// // // // // // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // // // //   setTimeout(() => URL.revokeObjectURL(url), 2000);
// // // // // // // }

// // // // // // // export async function downloadResumeAsPDF(resume, fileName, templateId) {
// // // // // // //   const name = (fileName||"resume").replace(/\.(pdf|html?)$/i,"");
// // // // // // //   try {
// // // // // // //     const html2canvas = (await import("html2canvas")).default;
// // // // // // //     const { jsPDF }   = await import("jspdf");

// // // // // // //     const tempDiv = document.createElement("div");
// // // // // // //     tempDiv.style.cssText = "position:fixed;left:-9999px;top:0;width:794px;background:#fff;z-index:-9999;pointer-events:none;overflow:hidden;";
// // // // // // //     const full = buildResumeHTML(resume, templateId, { showHint:false });
// // // // // // //     const m    = full.match(/<body[^>]*>([\s\S]*)<\/body>/i);
// // // // // // //     tempDiv.innerHTML = m ? m[1] : full;
// // // // // // //     document.body.appendChild(tempDiv);

// // // // // // //     const captureEl = tempDiv.querySelector(".page") || tempDiv;
// // // // // // //     await new Promise(r => setTimeout(r, 800));

// // // // // // //     const canvas = await html2canvas(captureEl, {
// // // // // // //       scale: 2, useCORS: true, allowTaint: true,
// // // // // // //       backgroundColor: "#ffffff", logging: false,
// // // // // // //       width: 794, windowWidth: 794, imageTimeout: 0,
// // // // // // //       onclone: doc => {
// // // // // // //         const s = doc.createElement("style");
// // // // // // //         s.textContent = `* { max-width:100%; word-break:break-word; } .page { width:794px!important; overflow:hidden!important; } .hint { display:none!important; }`;
// // // // // // //         doc.head.appendChild(s);
// // // // // // //       },
// // // // // // //     });
// // // // // // //     document.body.removeChild(tempDiv);

// // // // // // //     const A4W = 210, A4H = 297;
// // // // // // //     const imgW = A4W, imgH = (canvas.height * A4W) / canvas.width;
// // // // // // //     const pdf  = new jsPDF({ orientation:"portrait", unit:"mm", format:"a4" });
// // // // // // //     const img  = canvas.toDataURL("image/jpeg", 0.97);
// // // // // // //     let y = 0;
// // // // // // //     while (y < imgH) {
// // // // // // //       if (y > 0) pdf.addPage();
// // // // // // //       pdf.addImage(img, "JPEG", 0, -y, imgW, imgH);
// // // // // // //       y += A4H;
// // // // // // //     }
// // // // // // //     pdf.save(`${name}.pdf`);
// // // // // // //   } catch (err) {
// // // // // // //     console.error("PDF failed:", err);
// // // // // // //     dl(new Blob([buildResumeHTML(resume, templateId, { showHint:true })],
// // // // // // //       { type:"text/html;charset=utf-8" }), `${name}.html`);
// // // // // // //     alert("PDF failed — HTML downloaded. Open in Chrome → Ctrl+P → Save as PDF.");
// // // // // // //   }
// // // // // // // }

// // // // // // // export function downloadResumeAsWord(resume, fileName, templateId) {
// // // // // // //   dl(new Blob(["\ufeff", buildResumeHTML(resume, templateId, { forWord:true })],
// // // // // // //     { type:"text/plain;charset=utf-8" }),
// // // // // // //     (fileName||"resume").replace(/\.(doc|docx|html?)$/i,"") + ".doc");
// // // // // // // }

// // // // // // // export function downloadATSResume(resume, fileName, templateId) {
// // // // // // //   dl(new Blob([buildResumeHTML(resume, templateId, { showHint:true })],
// // // // // // //     { type:"text/html;charset=utf-8" }),
// // // // // // //     (fileName||"resume").replace(/\.html?$/i,"") + ".html");
// // // // // // // }

// // // // // // // above is new, below is aLSO NEW 
// // // // // // // generateResumeDoc.js
// // // // // // // PDF:  Opens styled HTML in new tab → user saves as PDF (100% accurate)
// // // // // // // Word: Downloads styled HTML as .doc — Word opens it with full template styling
// // // // // // // HTML: Full styled file for browser viewing

// // // // // // const TEMPLATES = {
// // // // // //   classic:      { name:"Classic ATS",    accent:"#2563eb", header:"#1e293b" },
// // // // // //   executive:    { name:"Executive",      accent:"#334155", header:"#0f172a" },
// // // // // //   bold:         { name:"Bold Impact",    accent:"#1d4ed8", header:"#1e3a8a" },
// // // // // //   minimal:      { name:"Minimal Clean",  accent:"#047857", header:"#047857" },
// // // // // //   professional: { name:"Professional",   accent:"#1e3a5f", header:"#1e3a5f" },
// // // // // // };

// // // // // // function getT(id) { return TEMPLATES[id] || TEMPLATES.classic; }

// // // // // // function esc(s) {
// // // // // //   if (!s) return "";
// // // // // //   return String(s)
// // // // // //     .replace(/&/g,"&amp;").replace(/</g,"&lt;")
// // // // // //     .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// // // // // // }
// // // // // // function fmt(s, e) {
// // // // // //   if (!s && !e) return "";
// // // // // //   if (s && !e)  return esc(s);
// // // // // //   if (!s && e)  return esc(e);
// // // // // //   return `${esc(s)} &ndash; ${esc(e)}`;
// // // // // // }

// // // // // // // ─────────────────────────────────────────────
// // // // // // // CORE HTML BUILDER — single source of truth
// // // // // // // Same HTML used for screen preview, PDF, Word, HTML download
// // // // // // // Uses system fonts — no CDN, renders everywhere
// // // // // // // ─────────────────────────────────────────────
// // // // // // export function buildResumeHTML(resume, templateId, opts = {}) {
// // // // // //   const { forWord = false, showHint = false, forPrint = false } = opts;
// // // // // //   const t  = getT(templateId);
// // // // // //   const ac = t.accent;
// // // // // //   const hd = t.header;

// // // // // //   const nm   = esc(resume.name  || "Your Name");
// // // // // //   const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
// // // // // //   const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin]
// // // // // //                  .filter(Boolean).map(esc);

// // // // // //   // ── Content builders ──
// // // // // //   const expHtml = (resume.experience||[]).map(exp => {
// // // // // //     const bullets = (exp.bullets||[]).map(b=>`<li>${esc(b)}</li>`).join("");
// // // // // //     const dates   = fmt(exp.startDate, exp.endDate);
// // // // // //     return `<div class="exp-block">
// // // // // //       <div class="exp-header">
// // // // // //         <div class="exp-left">
// // // // // //           <span class="exp-title">${esc(exp.title||"")}</span>
// // // // // //           <span class="exp-sep"> | </span>
// // // // // //           <span class="exp-company">${esc(exp.company||"")}</span>
// // // // // //           ${exp.location?`<span class="exp-loc">, ${esc(exp.location)}</span>`:""}
// // // // // //         </div>
// // // // // //         ${dates?`<span class="exp-dates">${dates}</span>`:""}
// // // // // //       </div>
// // // // // //       ${bullets?`<ul class="bullets">${bullets}</ul>`:""}
// // // // // //     </div>`;
// // // // // //   }).join("");

// // // // // //   const eduHtml = (resume.education||[]).map(edu=>
// // // // // //     `<div class="edu-block">
// // // // // //       <div class="exp-header">
// // // // // //         <div class="exp-left">
// // // // // //           <span class="exp-title">${esc(edu.degree||"")}</span>
// // // // // //           <span class="exp-sep"> | </span>
// // // // // //           <span class="exp-company">${esc(edu.school||"")}</span>
// // // // // //           ${edu.location?`<span class="exp-loc">, ${esc(edu.location)}</span>`:""}
// // // // // //         </div>
// // // // // //         ${edu.year?`<span class="exp-dates">${esc(edu.year)}${edu.gpa?` · GPA ${esc(edu.gpa)}`:""}</span>`:""}
// // // // // //       </div>
// // // // // //     </div>`
// // // // // //   ).join("");

// // // // // //   const sk = resume.skills||{};
// // // // // //   const skillLines = [
// // // // // //     sk.technical?.length?`<div class="skill-line"><span class="skill-cat">Technical Skills</span><span class="skill-vals">${sk.technical.map(esc).join(" · ")}</span></div>`:"",
// // // // // //     sk.tools?.length?`<div class="skill-line"><span class="skill-cat">Tools &amp; Platforms</span><span class="skill-vals">${sk.tools.map(esc).join(" · ")}</span></div>`:"",
// // // // // //     sk.soft?.length?`<div class="skill-line"><span class="skill-cat">Core Competencies</span><span class="skill-vals">${sk.soft.map(esc).join(" · ")}</span></div>`:"",
// // // // // //   ].join("");

// // // // // //   const certHtml = (resume.certifications||[]).length
// // // // // //     ? `<p class="cert-text">${resume.certifications.map(esc).join(" · ")}</p>` : "";

// // // // // //   function sec(title, body) {
// // // // // //     if (!body?.trim()) return "";
// // // // // //     return `<div class="section"><div class="sec-title">${title}</div><div class="sec-body">${body}</div></div>`;
// // // // // //   }
// // // // // //   const sections = [
// // // // // //     resume.summary ? sec("Professional Summary",`<p class="summary-text">${esc(resume.summary)}</p>`):"",
// // // // // //     expHtml  ? sec("Work Experience", expHtml) :"",
// // // // // //     eduHtml  ? sec("Education",       eduHtml) :"",
// // // // // //     skillLines?sec("Skills",          skillLines):"",
// // // // // //     certHtml ? sec("Certifications",  certHtml) :"",
// // // // // //   ].join("");

// // // // // //   // ── Print/save banner ──
// // // // // //   const hint = (showHint || forPrint) ? `
// // // // // //     <div class="hint no-print">
// // // // // //       <strong>Save as PDF:</strong> Ctrl+P (or Cmd+P) →
// // // // // //       Destination = <strong>Save as PDF</strong> →
// // // // // //       Margins = <strong>None</strong> →
// // // // // //       ✅ Enable <strong>Background graphics</strong> → Save
// // // // // //     </div>` : "";

// // // // // //   // ════════════════════════════════════════════
// // // // // //   // TEMPLATE CSS — all system fonts, no CDN
// // // // // //   // ════════════════════════════════════════════
// // // // // //   const BASE = `
// // // // // //     *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
// // // // // //     body { background:#f5f5f5; -webkit-print-color-adjust:exact !important; print-color-adjust:exact !important; }
// // // // // //     .page { max-width:794px; width:794px; margin:0 auto; background:#fff; }
// // // // // //     .page * { max-width:100%; }
// // // // // //     ul.bullets { overflow:hidden; }
// // // // // //     li { word-break:break-word; }
// // // // // //     .no-print { display:block; }
// // // // // //     @media print {
// // // // // //       body { background:#fff; margin:0; padding:0; }
// // // // // //       .no-print { display:none !important; }
// // // // // //       .page { box-shadow:none; width:100%; max-width:100%; }
// // // // // //       @page { size:A4; margin:0; }
// // // // // //       -webkit-print-color-adjust: exact !important;
// // // // // //       print-color-adjust: exact !important;
// // // // // //     }`;

// // // // // //   const TEMPLATES_CSS = {
// // // // // //     classic: `
// // // // // //       body { font-family:Georgia,"Times New Roman",serif; font-size:13.5px; line-height:1.6; color:#111; }
// // // // // //       .page { padding:42px 52px 38px; }
// // // // // //       .hdr { text-align:center; padding-bottom:16px; margin-bottom:20px; border-bottom:2px solid ${ac}; }
// // // // // //       .hdr-name { font-size:30px; font-weight:700; color:#000; letter-spacing:.3px; margin-bottom:5px; }
// // // // // //       .hdr-title { font-size:13.5px; color:#444; font-style:italic; margin-bottom:9px; }
// // // // // //       .hdr-contact { font-size:12px; color:#333; }
// // // // // //       .ctc-sep { margin:0 8px; color:#aaa; }
// // // // // //       .section { margin-bottom:16px; }
// // // // // //       .sec-title { font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:1.8px; color:#000; border-bottom:1.5px solid #000; padding-bottom:3px; margin-bottom:9px; font-family:Georgia,"Times New Roman",serif; }
// // // // // //       .summary-text { font-size:13px; line-height:1.7; color:#222; margin:0; }
// // // // // //       .exp-block { margin-bottom:11px; }
// // // // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // // // //       .exp-left { flex:1; min-width:0; }
// // // // // //       .exp-title { font-weight:700; font-size:13.5px; color:#000; }
// // // // // //       .exp-sep { color:#999; }
// // // // // //       .exp-company { font-size:13px; color:#333; font-style:italic; }
// // // // // //       .exp-loc { font-size:12px; color:#666; }
// // // // // //       .exp-dates { font-size:12px; color:#444; white-space:nowrap; font-style:italic; padding-left:8px; flex-shrink:0; }
// // // // // //       .edu-block { margin-bottom:7px; }
// // // // // //       .bullets { margin:4px 0 0 20px; padding:0; list-style:disc; }
// // // // // //       .bullets li { font-size:12.5px; color:#222; margin-bottom:3px; line-height:1.55; }
// // // // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12.5px; }
// // // // // //       .skill-cat { font-weight:700; color:#000; min-width:140px; flex-shrink:0; }
// // // // // //       .skill-vals { color:#333; line-height:1.5; }
// // // // // //       .cert-text { font-size:12.5px; color:#333; line-height:1.6; margin:0; }`,

// // // // // //     executive: `
// // // // // //       body { font-family:Georgia,"Times New Roman",serif; font-size:13px; line-height:1.6; color:#1a1a1a; }
// // // // // //       .page { overflow:hidden; }
// // // // // //       .hdr { background:${hd} !important; padding:28px 44px 22px; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // // // // //       .hdr-name { font-size:26px; font-weight:700; color:#ffffff !important; text-transform:uppercase; letter-spacing:1.5px; margin-bottom:4px; }
// // // // // //       .hdr-title { font-size:11px; color:rgba(255,255,255,0.6) !important; text-transform:uppercase; letter-spacing:2.5px; font-family:Arial,Helvetica,sans-serif; margin-bottom:12px; }
// // // // // //       .hdr-rule { border:none; border-top:1px solid rgba(255,255,255,0.2); margin-bottom:10px; }
// // // // // //       .hdr-contact { font-size:11.5px; color:rgba(255,255,255,0.7) !important; font-family:Arial,Helvetica,sans-serif; }
// // // // // //       .ctc-sep { margin:0 12px; color:rgba(255,255,255,0.3); }
// // // // // //       .body-pad { padding:24px 44px 34px; }
// // // // // //       .section { margin-bottom:16px; }
// // // // // //       .sec-title { font-family:Arial,Helvetica,sans-serif; font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:2.5px; color:${hd} !important; border-bottom:2px solid ${hd} !important; padding-bottom:4px; margin-bottom:9px; }
// // // // // //       .summary-text { font-size:12.5px; line-height:1.7; color:#333; margin:0; }
// // // // // //       .exp-block { margin-bottom:12px; }
// // // // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // // // //       .exp-left { flex:1; min-width:0; }
// // // // // //       .exp-title { font-weight:700; font-size:13px; color:#0f172a; }
// // // // // //       .exp-sep { color:#aaa; }
// // // // // //       .exp-company { font-size:12.5px; color:#444; font-style:italic; }
// // // // // //       .exp-loc { font-size:12px; color:#888; }
// // // // // //       .exp-dates { font-size:11.5px; color:#555; white-space:nowrap; font-style:italic; font-family:Arial,Helvetica,sans-serif; padding-left:8px; flex-shrink:0; }
// // // // // //       .edu-block { margin-bottom:7px; }
// // // // // //       .bullets { margin:4px 0 0 18px; padding:0; list-style:disc; }
// // // // // //       .bullets li { font-size:12px; color:#333; margin-bottom:3px; line-height:1.55; }
// // // // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12px; font-family:Arial,Helvetica,sans-serif; }
// // // // // //       .skill-cat { font-weight:700; color:${hd} !important; min-width:140px; flex-shrink:0; }
// // // // // //       .skill-vals { color:#444; line-height:1.5; }
// // // // // //       .cert-text { font-size:12px; color:#444; line-height:1.6; margin:0; font-family:Arial,Helvetica,sans-serif; }`,

// // // // // //     bold: `
// // // // // //       body { font-family:Arial,Helvetica,sans-serif; font-size:13px; line-height:1.6; color:#1a1a1a; }
// // // // // //       .page { overflow:hidden; }
// // // // // //       .hdr { background:${hd} !important; padding:26px 38px 20px; border-bottom:4px solid ${ac} !important; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // // // // //       .hdr-name { font-size:32px; font-weight:900; color:#ffffff !important; letter-spacing:-.5px; line-height:1.05; margin-bottom:3px; }
// // // // // //       .hdr-title { font-size:11px; color:rgba(255,255,255,0.65) !important; text-transform:uppercase; letter-spacing:2.5px; margin-bottom:11px; }
// // // // // //       .hdr-contact { font-size:11.5px; color:rgba(255,255,255,0.6) !important; }
// // // // // //       .ctc-sep { margin:0 10px; color:rgba(255,255,255,0.3); }
// // // // // //       .body-pad { padding:22px 38px 34px; }
// // // // // //       .section { margin-bottom:16px; }
// // // // // //       .sec-title { font-size:9.5px; font-weight:900; text-transform:uppercase; letter-spacing:2.5px; color:${ac} !important; border-bottom:2px solid ${ac} !important; padding-bottom:5px; margin-bottom:9px; }
// // // // // //       .summary-text { font-size:12.5px; line-height:1.7; color:#333; margin:0; }
// // // // // //       .exp-block { margin-bottom:12px; padding-left:10px; border-left:2.5px solid #e2e8f0 !important; }
// // // // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // // // //       .exp-left { flex:1; min-width:0; }
// // // // // //       .exp-title { font-weight:700; font-size:13.5px; color:#0f172a; }
// // // // // //       .exp-sep { color:#cbd5e1; }
// // // // // //       .exp-company { font-size:12.5px; color:#475569; font-weight:600; }
// // // // // //       .exp-loc { font-size:12px; color:#94a3b8; }
// // // // // //       .exp-dates { font-size:11.5px; color:#64748b; white-space:nowrap; font-style:italic; padding-left:8px; flex-shrink:0; }
// // // // // //       .edu-block { margin-bottom:7px; padding-left:10px; border-left:2.5px solid #e2e8f0 !important; }
// // // // // //       .bullets { margin:4px 0 0 16px; padding:0; list-style:disc; }
// // // // // //       .bullets li { font-size:12px; color:#374151; margin-bottom:3px; line-height:1.55; }
// // // // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12px; }
// // // // // //       .skill-cat { font-weight:700; color:#0f172a; min-width:140px; flex-shrink:0; }
// // // // // //       .skill-vals { color:#475569; line-height:1.5; }
// // // // // //       .cert-text { font-size:12px; color:#475569; line-height:1.6; margin:0; }`,

// // // // // //     minimal: `
// // // // // //       body { font-family:Arial,Helvetica,sans-serif; font-size:13.5px; line-height:1.65; color:#1a1a1a; }
// // // // // //       .page { padding:44px 52px 38px; }
// // // // // //       .hdr { margin-bottom:22px; padding-bottom:16px; border-bottom:1px solid #e5e7eb; }
// // // // // //       .hdr-name { font-size:28px; font-weight:600; color:#111; letter-spacing:-.3px; margin-bottom:4px; }
// // // // // //       .hdr-title { font-size:13.5px; color:${ac} !important; font-weight:600; margin-bottom:10px; }
// // // // // //       .hdr-contact { font-size:12px; color:#555; }
// // // // // //       .ctc-sep { margin:0 10px; color:#d1d5db; }
// // // // // //       .section { margin-bottom:16px; }
// // // // // //       .sec-title { font-size:9.5px; font-weight:700; text-transform:uppercase; letter-spacing:2.5px; color:${ac} !important; border-bottom:1px solid ${ac}44 !important; padding-bottom:4px; margin-bottom:8px; }
// // // // // //       .summary-text { font-size:13px; line-height:1.7; color:#374151; margin:0; }
// // // // // //       .exp-block { margin-bottom:13px; }
// // // // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // // // //       .exp-left { flex:1; min-width:0; }
// // // // // //       .exp-title { font-weight:600; font-size:13.5px; color:#111; }
// // // // // //       .exp-sep { color:#d1d5db; margin:0 4px; }
// // // // // //       .exp-company { font-size:13px; color:#374151; }
// // // // // //       .exp-loc { font-size:12px; color:#9ca3af; }
// // // // // //       .exp-dates { font-size:12px; color:#6b7280; white-space:nowrap; padding-left:8px; flex-shrink:0; }
// // // // // //       .edu-block { margin-bottom:7px; }
// // // // // //       .bullets { margin:4px 0 0 0; padding:0; list-style:none; }
// // // // // //       .bullets li { font-size:12.5px; color:#374151; margin-bottom:3px; line-height:1.55; padding-left:14px; position:relative; }
// // // // // //       .bullets li::before { content:"–"; position:absolute; left:0; color:${ac}; }
// // // // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12.5px; }
// // // // // //       .skill-cat { font-weight:600; color:#111; min-width:140px; flex-shrink:0; }
// // // // // //       .skill-vals { color:#374151; line-height:1.5; }
// // // // // //       .cert-text { font-size:12.5px; color:#374151; line-height:1.6; margin:0; }`,

// // // // // //     professional: `
// // // // // //       body { font-family:Arial,Helvetica,sans-serif; font-size:13px; line-height:1.6; color:#1a1a1a; }
// // // // // //       .page { overflow:hidden; }
// // // // // //       .hdr { background:${hd} !important; padding:22px 38px 18px; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // // // // //       .hdr-top { display:flex; justify-content:space-between; align-items:flex-start; gap:16px; margin-bottom:10px; }
// // // // // //       .hdr-name { font-size:24px; font-weight:700; color:#ffffff !important; letter-spacing:.2px; margin-bottom:4px; }
// // // // // //       .hdr-title { font-size:10.5px; color:rgba(255,255,255,0.55) !important; text-transform:uppercase; letter-spacing:1.8px; }
// // // // // //       .hdr-right { text-align:right; padding-top:3px; }
// // // // // //       .ctc-line { font-size:11.5px; color:rgba(255,255,255,0.65) !important; margin-bottom:3px; }
// // // // // //       .hdr-rule { border:none; border-top:1px solid rgba(255,255,255,0.15); margin-top:0; }
// // // // // //       .body-pad { padding:20px 38px 32px; }
// // // // // //       .section { margin-bottom:16px; }
// // // // // //       .sec-title { font-size:9.5px; font-weight:700; text-transform:uppercase; letter-spacing:2px; color:${hd} !important; background:#f0f4f8 !important; padding:4px 10px; margin-bottom:9px; border-left:3px solid ${hd} !important; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // // // // //       .summary-text { font-size:12.5px; line-height:1.7; color:#333; margin:0; }
// // // // // //       .exp-block { margin-bottom:12px; }
// // // // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // // // //       .exp-left { flex:1; min-width:0; }
// // // // // //       .exp-title { font-weight:700; font-size:13px; color:#0f172a; }
// // // // // //       .exp-sep { color:#cbd5e1; margin:0 3px; }
// // // // // //       .exp-company { font-size:12.5px; color:#374151; font-weight:600; }
// // // // // //       .exp-loc { font-size:11.5px; color:#94a3b8; }
// // // // // //       .exp-dates { font-size:11.5px; color:#64748b; white-space:nowrap; font-style:italic; padding-left:8px; flex-shrink:0; }
// // // // // //       .edu-block { margin-bottom:7px; }
// // // // // //       .bullets { margin:4px 0 0 16px; padding:0; list-style:square; }
// // // // // //       .bullets li { font-size:12px; color:#374151; margin-bottom:3px; line-height:1.55; }
// // // // // //       .bullets li::marker { color:${hd} !important; }
// // // // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12px; }
// // // // // //       .skill-cat { font-weight:700; color:${hd} !important; min-width:140px; flex-shrink:0; }
// // // // // //       .skill-vals { color:#374151; line-height:1.5; }
// // // // // //       .cert-text { font-size:12px; color:#374151; line-height:1.6; margin:0; }`,
// // // // // //   };

// // // // // //   const css = TEMPLATES_CSS[templateId] || TEMPLATES_CSS.classic;

// // // // // //   // ── Hint box ──
// // // // // //   const hintBox = (showHint || forPrint) ? `
// // // // // //     <div class="hint no-print" style="background:#1d4ed8;color:#fff;padding:12px 20px;
// // // // // //       text-align:center;font-size:13px;font-family:Arial,sans-serif;line-height:1.8;">
// // // // // //       📄 <strong>Save as PDF:</strong>
// // // // // //       Press <kbd style="background:rgba(255,255,255,.2);padding:2px 8px;border-radius:3px;">Ctrl+P</kbd>
// // // // // //       → Destination = <strong>"Save as PDF"</strong>
// // // // // //       → Margins = <strong>None</strong>
// // // // // //       → ✅ <strong>Background graphics ON</strong>
// // // // // //       → Save
// // // // // //     </div>` : "";

// // // // // //   // ── Build header per template ──
// // // // // //   let headerHTML = "";
// // // // // //   let wrapOpen   = "";
// // // // // //   let wrapClose  = "";

// // // // // //   const ctcJoined = ctcs.map((c,i)=>
// // // // // //     i===0 ? c : `<span class="ctc-sep">|</span>${c}`
// // // // // //   ).join("");

// // // // // //   if (templateId === "classic") {
// // // // // //     headerHTML = `<div class="hdr">
// // // // // //       <div class="hdr-name">${nm}</div>
// // // // // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // // // //       <div class="hdr-contact">${ctcJoined}</div>
// // // // // //     </div>`;
// // // // // //   }
// // // // // //   else if (templateId === "executive") {
// // // // // //     headerHTML = `<div class="hdr">
// // // // // //       <div class="hdr-name">${nm}</div>
// // // // // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // // // //       <hr class="hdr-rule">
// // // // // //       <div class="hdr-contact">${ctcJoined}</div>
// // // // // //     </div>`;
// // // // // //     wrapOpen=`<div class="body-pad">`; wrapClose=`</div>`;
// // // // // //   }
// // // // // //   else if (templateId === "bold") {
// // // // // //     headerHTML = `<div class="hdr">
// // // // // //       <div class="hdr-name">${nm}</div>
// // // // // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // // // //       <div class="hdr-contact">${ctcJoined}</div>
// // // // // //     </div>`;
// // // // // //     wrapOpen=`<div class="body-pad">`; wrapClose=`</div>`;
// // // // // //   }
// // // // // //   else if (templateId === "minimal") {
// // // // // //     headerHTML = `<div class="hdr">
// // // // // //       <div class="hdr-name">${nm}</div>
// // // // // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // // // //       <div class="hdr-contact">${ctcJoined}</div>
// // // // // //     </div>`;
// // // // // //   }
// // // // // //   else if (templateId === "professional") {
// // // // // //     const ctcRight = ctcs.slice(0,3).map(c=>`<div class="ctc-line">${c}</div>`).join("");
// // // // // //     const ctcExtra = ctcs.slice(3).join(" · ");
// // // // // //     headerHTML = `<div class="hdr">
// // // // // //       <div class="hdr-top">
// // // // // //         <div>
// // // // // //           <div class="hdr-name">${nm}</div>
// // // // // //           ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // // // //         </div>
// // // // // //         <div class="hdr-right">${ctcRight}</div>
// // // // // //       </div>
// // // // // //       ${ctcExtra?`<div style="font-size:11px;color:rgba(255,255,255,.5);padding-bottom:8px;">${ctcExtra}</div>`:""}
// // // // // //       <hr class="hdr-rule">
// // // // // //     </div>`;
// // // // // //     wrapOpen=`<div class="body-pad">`; wrapClose=`</div>`;
// // // // // //   }

// // // // // //   return `<!DOCTYPE html>
// // // // // // <html lang="en">
// // // // // // <head>
// // // // // //   <meta charset="UTF-8">
// // // // // //   <title>${nm} — Resume</title>
// // // // // //   <style>
// // // // // //     ${BASE}
// // // // // //     ${css}
// // // // // //   </style>
// // // // // // </head>
// // // // // // <body>
// // // // // //   ${hintBox}
// // // // // //   <div class="page">
// // // // // //     ${headerHTML}
// // // // // //     ${wrapOpen}
// // // // // //     ${sections}
// // // // // //     ${wrapClose}
// // // // // //   </div>
// // // // // // </body>
// // // // // // </html>`;
// // // // // // }

// // // // // // // ─────────────────────────────────────────────
// // // // // // // HELPERS
// // // // // // // ─────────────────────────────────────────────
// // // // // // function dl(blob, name) {
// // // // // //   const url = URL.createObjectURL(blob);
// // // // // //   const a   = Object.assign(document.createElement("a"),{href:url,download:name});
// // // // // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // // //   setTimeout(()=>URL.revokeObjectURL(url),2000);
// // // // // // }

// // // // // // // ─────────────────────────────────────────────
// // // // // // // PDF — opens in new tab, user saves via Ctrl+P
// // // // // // // This is 100% accurate — browser renders exact styling
// // // // // // // No canvas/conversion artifacts — pure vector PDF
// // // // // // // ─────────────────────────────────────────────
// // // // // // export function downloadResumeAsPDF(resume, fileName, templateId) {
// // // // // //   const html = buildResumeHTML(resume, templateId, { forPrint: true });
// // // // // //   const win  = window.open("", "_blank");

// // // // // //   if (!win) {
// // // // // //     // Popup blocked — download as HTML fallback
// // // // // //     dl(new Blob([html],{type:"text/html;charset=utf-8"}),
// // // // // //       (fileName||"resume").replace(/\.(pdf|html?)$/i,"") + ".html");
// // // // // //     alert("Popup blocked by browser.\nAn HTML file was downloaded instead.\nOpen it in Chrome → Ctrl+P → Save as PDF.");
// // // // // //     return;
// // // // // //   }

// // // // // //   win.document.open();
// // // // // //   win.document.write(html);
// // // // // //   win.document.close();
// // // // // //   win.focus();

// // // // // //   // Auto-trigger print dialog after page renders
// // // // // //   setTimeout(() => {
// // // // // //     try { win.print(); } catch(e) { /* user can Ctrl+P manually */ }
// // // // // //   }, 800);
// // // // // // }

// // // // // // // ─────────────────────────────────────────────
// // // // // // // WORD — downloads styled HTML as .doc
// // // // // // // Word opens HTML files natively with full styling
// // // // // // // Same HTML as screen = same template design in Word
// // // // // // // ─────────────────────────────────────────────
// // // // // // export function downloadResumeAsWord(resume, fileName, templateId) {
// // // // // //   // Use same HTML but with Word-specific overrides
// // // // // //   const html = buildResumeHTML(resume, templateId, { showHint: false });

// // // // // //   // Inject Word-specific meta and simplify for Word rendering
// // // // // //   const wordHtml = html
// // // // // //     .replace('<html lang="en">', `<html xmlns:o="urn:schemas-microsoft-com:office:office"
// // // // // //       xmlns:w="urn:schemas-microsoft-com:office:word"
// // // // // //       xmlns="http://www.w3.org/TR/REC-html40">`)
// // // // // //     .replace('</head>', `<!--[if gte mso 9]><xml>
// // // // // //       <w:WordDocument><w:View>Print</w:View><w:Zoom>90</w:Zoom>
// // // // // //       <w:DoNotOptimizeForBrowser/></w:WordDocument></xml><![endif]-->
// // // // // //     <style>
// // // // // //       /* Word overrides — keeps structure, simplifies backgrounds */
// // // // // //       @page { size:A4; margin:.75in; }
// // // // // //       body { font-family:Calibri,Arial,sans-serif; font-size:11pt; background:#fff !important; }
// // // // // //       .page { width:auto !important; max-width:100% !important; padding:0 !important; overflow:visible !important; }
// // // // // //       .hdr { padding:16pt 0 12pt !important; }
// // // // // //       .body-pad { padding:0 !important; }
// // // // // //       .exp-header { display:block !important; }
// // // // // //       .exp-dates { display:block !important; font-style:italic; padding-left:0 !important; }
// // // // // //       .skill-line { display:block !important; margin-bottom:4pt !important; }
// // // // // //       .skill-cat { display:inline; }
// // // // // //       .skill-vals { display:inline; }
// // // // // //     </style>
// // // // // //     </head>`);

// // // // // //   dl(
// // // // // //     new Blob(["\ufeff", wordHtml], { type:"application/msword;charset=utf-8" }),
// // // // // //     (fileName||"resume").replace(/\.(doc|docx|html?)$/i,"") + ".doc"
// // // // // //   );
// // // // // // }

// // // // // // // ─────────────────────────────────────────────
// // // // // // // HTML — full styled file, opens in browser
// // // // // // // ─────────────────────────────────────────────
// // // // // // export function downloadATSResume(resume, fileName, templateId) {
// // // // // //   dl(
// // // // // //     new Blob([buildResumeHTML(resume, templateId, { showHint:true })],
// // // // // //       { type:"text/html;charset=utf-8" }),
// // // // // //     (fileName||"resume").replace(/\.html?$/i,"") + ".html"
// // // // // //   );
// // // // // // }

// // // // // // generateResumeDoc.js
// // // // // // PDF:  Opens styled HTML in new tab → user saves as PDF (100% accurate)
// // // // // // Word: Downloads styled HTML as .doc — Word opens it with full template styling
// // // // // // HTML: Full styled file for browser viewing

// // // // // const TEMPLATES = {
// // // // //   classic:      { name:"Classic ATS",    accent:"#2563eb", header:"#1e293b" },
// // // // //   executive:    { name:"Executive",      accent:"#334155", header:"#0f172a" },
// // // // //   bold:         { name:"Bold Impact",    accent:"#1d4ed8", header:"#1e3a8a" },
// // // // //   minimal:      { name:"Minimal Clean",  accent:"#047857", header:"#047857" },
// // // // //   professional: { name:"Professional",   accent:"#1e3a5f", header:"#1e3a5f" },
// // // // // };

// // // // // function getT(id) { return TEMPLATES[id] || TEMPLATES.classic; }

// // // // // function esc(s) {
// // // // //   if (!s) return "";
// // // // //   return String(s)
// // // // //     .replace(/&/g,"&amp;").replace(/</g,"&lt;")
// // // // //     .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// // // // // }
// // // // // function fmt(s, e) {
// // // // //   if (!s && !e) return "";
// // // // //   if (s && !e)  return esc(s);
// // // // //   if (!s && e)  return esc(e);
// // // // //   return `${esc(s)} &ndash; ${esc(e)}`;
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // CORE HTML BUILDER — single source of truth
// // // // // // Same HTML used for screen preview, PDF, Word, HTML download
// // // // // // Uses system fonts — no CDN, renders everywhere
// // // // // // ─────────────────────────────────────────────
// // // // // export function buildResumeHTML(resume, templateId, opts = {}) {
// // // // //   const { forWord = false, showHint = false, forPrint = false } = opts;
// // // // //   const t  = getT(templateId);
// // // // //   const ac = t.accent;
// // // // //   const hd = t.header;

// // // // //   const nm   = esc(resume.name  || "Your Name");
// // // // //   const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
// // // // //   const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin]
// // // // //                  .filter(Boolean).map(esc);

// // // // //   // ── Content builders ──
// // // // //   const expHtml = (resume.experience||[]).map(exp => {
// // // // //     const bullets = (exp.bullets||[]).map(b=>`<li>${esc(b)}</li>`).join("");
// // // // //     const dates   = fmt(exp.startDate, exp.endDate);
// // // // //     return `<div class="exp-block">
// // // // //       <div class="exp-header">
// // // // //         <div class="exp-left">
// // // // //           <span class="exp-title">${esc(exp.title||"")}</span>
// // // // //           <span class="exp-sep"> | </span>
// // // // //           <span class="exp-company">${esc(exp.company||"")}</span>
// // // // //           ${exp.location?`<span class="exp-loc">, ${esc(exp.location)}</span>`:""}
// // // // //         </div>
// // // // //         ${dates?`<span class="exp-dates">${dates}</span>`:""}
// // // // //       </div>
// // // // //       ${bullets?`<ul class="bullets">${bullets}</ul>`:""}
// // // // //     </div>`;
// // // // //   }).join("");

// // // // //   const eduHtml = (resume.education||[]).map(edu=>
// // // // //     `<div class="edu-block">
// // // // //       <div class="exp-header">
// // // // //         <div class="exp-left">
// // // // //           <span class="exp-title">${esc(edu.degree||"")}</span>
// // // // //           <span class="exp-sep"> | </span>
// // // // //           <span class="exp-company">${esc(edu.school||"")}</span>
// // // // //           ${edu.location?`<span class="exp-loc">, ${esc(edu.location)}</span>`:""}
// // // // //         </div>
// // // // //         ${edu.year?`<span class="exp-dates">${esc(edu.year)}${edu.gpa?` · GPA ${esc(edu.gpa)}`:""}</span>`:""}
// // // // //       </div>
// // // // //     </div>`
// // // // //   ).join("");

// // // // //   const sk = resume.skills||{};
// // // // //   const skillLines = [
// // // // //     sk.technical?.length?`<div class="skill-line"><span class="skill-cat">Technical Skills</span><span class="skill-vals">${sk.technical.map(esc).join(" · ")}</span></div>`:"",
// // // // //     sk.tools?.length?`<div class="skill-line"><span class="skill-cat">Tools &amp; Platforms</span><span class="skill-vals">${sk.tools.map(esc).join(" · ")}</span></div>`:"",
// // // // //     sk.soft?.length?`<div class="skill-line"><span class="skill-cat">Core Competencies</span><span class="skill-vals">${sk.soft.map(esc).join(" · ")}</span></div>`:"",
// // // // //   ].join("");

// // // // //   const certHtml = (resume.certifications||[]).length
// // // // //     ? `<p class="cert-text">${resume.certifications.map(esc).join(" · ")}</p>` : "";

// // // // //   function sec(title, body) {
// // // // //     if (!body?.trim()) return "";
// // // // //     return `<div class="section"><div class="sec-title">${title}</div><div class="sec-body">${body}</div></div>`;
// // // // //   }
// // // // //   const sections = [
// // // // //     resume.summary ? sec("Professional Summary",`<p class="summary-text">${esc(resume.summary)}</p>`):"",
// // // // //     expHtml  ? sec("Work Experience", expHtml) :"",
// // // // //     eduHtml  ? sec("Education",       eduHtml) :"",
// // // // //     skillLines?sec("Skills",          skillLines):"",
// // // // //     certHtml ? sec("Certifications",  certHtml) :"",
// // // // //   ].join("");

// // // // //   // ── Print/save banner ──
// // // // //   const hint = (showHint || forPrint) ? `
// // // // //     <div class="hint no-print">
// // // // //       <strong>Save as PDF:</strong> Ctrl+P (or Cmd+P) →
// // // // //       Destination = <strong>Save as PDF</strong> →
// // // // //       Margins = <strong>None</strong> →
// // // // //       ✅ Enable <strong>Background graphics</strong> → Save
// // // // //     </div>` : "";

// // // // //   // ════════════════════════════════════════════
// // // // //   // TEMPLATE CSS — all system fonts, no CDN
// // // // //   // ════════════════════════════════════════════
// // // // //   const BASE = `
// // // // //     *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
// // // // //     body { background:#f5f5f5; -webkit-print-color-adjust:exact !important; print-color-adjust:exact !important; }
// // // // //     .page { max-width:794px; width:794px; margin:0 auto; background:#fff; }
// // // // //     .page * { max-width:100%; }
// // // // //     ul.bullets { overflow:hidden; }
// // // // //     li { word-break:break-word; }
// // // // //     .no-print { display:block; }
// // // // //     @media print {
// // // // //       body { background:#fff; margin:0; padding:0; }
// // // // //       .no-print { display:none !important; }
// // // // //       .page { box-shadow:none; width:100%; max-width:100%; }
// // // // //       @page { size:A4; margin:0; }
// // // // //       -webkit-print-color-adjust: exact !important;
// // // // //       print-color-adjust: exact !important;
// // // // //     }`;

// // // // //   const TEMPLATES_CSS = {
// // // // //     classic: `
// // // // //       body { font-family:Georgia,"Times New Roman",serif; font-size:13.5px; line-height:1.6; color:#111; }
// // // // //       .page { padding:42px 52px 38px; }
// // // // //       .hdr { text-align:center; padding-bottom:16px; margin-bottom:20px; border-bottom:2px solid ${ac}; }
// // // // //       .hdr-name { font-size:30px; font-weight:700; color:#000; letter-spacing:.3px; margin-bottom:5px; }
// // // // //       .hdr-title { font-size:13.5px; color:#444; font-style:italic; margin-bottom:9px; }
// // // // //       .hdr-contact { font-size:12px; color:#333; }
// // // // //       .ctc-sep { margin:0 8px; color:#aaa; }
// // // // //       .section { margin-bottom:16px; }
// // // // //       .sec-title { font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:1.8px; color:#000; border-bottom:1.5px solid #000; padding-bottom:3px; margin-bottom:9px; font-family:Georgia,"Times New Roman",serif; }
// // // // //       .summary-text { font-size:13px; line-height:1.7; color:#222; margin:0; }
// // // // //       .exp-block { margin-bottom:11px; }
// // // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // // //       .exp-left { flex:1; min-width:0; }
// // // // //       .exp-title { font-weight:700; font-size:13.5px; color:#000; }
// // // // //       .exp-sep { color:#999; }
// // // // //       .exp-company { font-size:13px; color:#333; font-style:italic; }
// // // // //       .exp-loc { font-size:12px; color:#666; }
// // // // //       .exp-dates { font-size:12px; color:#444; white-space:nowrap; font-style:italic; padding-left:8px; flex-shrink:0; }
// // // // //       .edu-block { margin-bottom:7px; }
// // // // //       .bullets { margin:4px 0 0 20px; padding:0; list-style:disc; }
// // // // //       .bullets li { font-size:12.5px; color:#222; margin-bottom:3px; line-height:1.55; }
// // // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12.5px; }
// // // // //       .skill-cat { font-weight:700; color:#000; min-width:140px; flex-shrink:0; }
// // // // //       .skill-vals { color:#333; line-height:1.5; }
// // // // //       .cert-text { font-size:12.5px; color:#333; line-height:1.6; margin:0; }`,

// // // // //     executive: `
// // // // //       body { font-family:Georgia,"Times New Roman",serif; font-size:13px; line-height:1.6; color:#1a1a1a; }
// // // // //       .page { overflow:hidden; }
// // // // //       .hdr { background:${hd} !important; padding:28px 44px 22px; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // // // //       .hdr-name { font-size:26px; font-weight:700; color:#ffffff !important; text-transform:uppercase; letter-spacing:1.5px; margin-bottom:4px; }
// // // // //       .hdr-title { font-size:11px; color:rgba(255,255,255,0.6) !important; text-transform:uppercase; letter-spacing:2.5px; font-family:Arial,Helvetica,sans-serif; margin-bottom:12px; }
// // // // //       .hdr-rule { border:none; border-top:1px solid rgba(255,255,255,0.2); margin-bottom:10px; }
// // // // //       .hdr-contact { font-size:11.5px; color:rgba(255,255,255,0.7) !important; font-family:Arial,Helvetica,sans-serif; }
// // // // //       .ctc-sep { margin:0 12px; color:rgba(255,255,255,0.3); }
// // // // //       .body-pad { padding:24px 44px 34px; }
// // // // //       .section { margin-bottom:16px; }
// // // // //       .sec-title { font-family:Arial,Helvetica,sans-serif; font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:2.5px; color:${hd} !important; border-bottom:2px solid ${hd} !important; padding-bottom:4px; margin-bottom:9px; }
// // // // //       .summary-text { font-size:12.5px; line-height:1.7; color:#333; margin:0; }
// // // // //       .exp-block { margin-bottom:12px; }
// // // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // // //       .exp-left { flex:1; min-width:0; }
// // // // //       .exp-title { font-weight:700; font-size:13px; color:#0f172a; }
// // // // //       .exp-sep { color:#aaa; }
// // // // //       .exp-company { font-size:12.5px; color:#444; font-style:italic; }
// // // // //       .exp-loc { font-size:12px; color:#888; }
// // // // //       .exp-dates { font-size:11.5px; color:#555; white-space:nowrap; font-style:italic; font-family:Arial,Helvetica,sans-serif; padding-left:8px; flex-shrink:0; }
// // // // //       .edu-block { margin-bottom:7px; }
// // // // //       .bullets { margin:4px 0 0 18px; padding:0; list-style:disc; }
// // // // //       .bullets li { font-size:12px; color:#333; margin-bottom:3px; line-height:1.55; }
// // // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12px; font-family:Arial,Helvetica,sans-serif; }
// // // // //       .skill-cat { font-weight:700; color:${hd} !important; min-width:140px; flex-shrink:0; }
// // // // //       .skill-vals { color:#444; line-height:1.5; }
// // // // //       .cert-text { font-size:12px; color:#444; line-height:1.6; margin:0; font-family:Arial,Helvetica,sans-serif; }`,

// // // // //     bold: `
// // // // //       body { font-family:Arial,Helvetica,sans-serif; font-size:13px; line-height:1.6; color:#1a1a1a; }
// // // // //       .page { overflow:hidden; }
// // // // //       .hdr { background:${hd} !important; padding:26px 38px 20px; border-bottom:4px solid ${ac} !important; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // // // //       .hdr-name { font-size:32px; font-weight:900; color:#ffffff !important; letter-spacing:-.5px; line-height:1.05; margin-bottom:3px; }
// // // // //       .hdr-title { font-size:11px; color:rgba(255,255,255,0.65) !important; text-transform:uppercase; letter-spacing:2.5px; margin-bottom:11px; }
// // // // //       .hdr-contact { font-size:11.5px; color:rgba(255,255,255,0.6) !important; }
// // // // //       .ctc-sep { margin:0 10px; color:rgba(255,255,255,0.3); }
// // // // //       .body-pad { padding:22px 38px 34px; }
// // // // //       .section { margin-bottom:16px; }
// // // // //       .sec-title { font-size:9.5px; font-weight:900; text-transform:uppercase; letter-spacing:2.5px; color:${ac} !important; border-bottom:2px solid ${ac} !important; padding-bottom:5px; margin-bottom:9px; }
// // // // //       .summary-text { font-size:12.5px; line-height:1.7; color:#333; margin:0; }
// // // // //       .exp-block { margin-bottom:12px; padding-left:10px; border-left:2.5px solid #e2e8f0 !important; }
// // // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // // //       .exp-left { flex:1; min-width:0; }
// // // // //       .exp-title { font-weight:700; font-size:13.5px; color:#0f172a; }
// // // // //       .exp-sep { color:#cbd5e1; }
// // // // //       .exp-company { font-size:12.5px; color:#475569; font-weight:600; }
// // // // //       .exp-loc { font-size:12px; color:#94a3b8; }
// // // // //       .exp-dates { font-size:11.5px; color:#64748b; white-space:nowrap; font-style:italic; padding-left:8px; flex-shrink:0; }
// // // // //       .edu-block { margin-bottom:7px; padding-left:10px; border-left:2.5px solid #e2e8f0 !important; }
// // // // //       .bullets { margin:4px 0 0 16px; padding:0; list-style:disc; }
// // // // //       .bullets li { font-size:12px; color:#374151; margin-bottom:3px; line-height:1.55; }
// // // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12px; }
// // // // //       .skill-cat { font-weight:700; color:#0f172a; min-width:140px; flex-shrink:0; }
// // // // //       .skill-vals { color:#475569; line-height:1.5; }
// // // // //       .cert-text { font-size:12px; color:#475569; line-height:1.6; margin:0; }`,

// // // // //     minimal: `
// // // // //       body { font-family:Arial,Helvetica,sans-serif; font-size:13.5px; line-height:1.65; color:#1a1a1a; }
// // // // //       .page { padding:44px 52px 38px; }
// // // // //       .hdr { margin-bottom:22px; padding-bottom:16px; border-bottom:1px solid #e5e7eb; }
// // // // //       .hdr-name { font-size:28px; font-weight:600; color:#111; letter-spacing:-.3px; margin-bottom:4px; }
// // // // //       .hdr-title { font-size:13.5px; color:${ac} !important; font-weight:600; margin-bottom:10px; }
// // // // //       .hdr-contact { font-size:12px; color:#555; }
// // // // //       .ctc-sep { margin:0 10px; color:#d1d5db; }
// // // // //       .section { margin-bottom:16px; }
// // // // //       .sec-title { font-size:9.5px; font-weight:700; text-transform:uppercase; letter-spacing:2.5px; color:${ac} !important; border-bottom:1px solid ${ac}44 !important; padding-bottom:4px; margin-bottom:8px; }
// // // // //       .summary-text { font-size:13px; line-height:1.7; color:#374151; margin:0; }
// // // // //       .exp-block { margin-bottom:13px; }
// // // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // // //       .exp-left { flex:1; min-width:0; }
// // // // //       .exp-title { font-weight:600; font-size:13.5px; color:#111; }
// // // // //       .exp-sep { color:#d1d5db; margin:0 4px; }
// // // // //       .exp-company { font-size:13px; color:#374151; }
// // // // //       .exp-loc { font-size:12px; color:#9ca3af; }
// // // // //       .exp-dates { font-size:12px; color:#6b7280; white-space:nowrap; padding-left:8px; flex-shrink:0; }
// // // // //       .edu-block { margin-bottom:7px; }
// // // // //       .bullets { margin:4px 0 0 0; padding:0; list-style:none; }
// // // // //       .bullets li { font-size:12.5px; color:#374151; margin-bottom:3px; line-height:1.55; padding-left:14px; position:relative; }
// // // // //       .bullets li::before { content:"–"; position:absolute; left:0; color:${ac}; }
// // // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12.5px; }
// // // // //       .skill-cat { font-weight:600; color:#111; min-width:140px; flex-shrink:0; }
// // // // //       .skill-vals { color:#374151; line-height:1.5; }
// // // // //       .cert-text { font-size:12.5px; color:#374151; line-height:1.6; margin:0; }`,

// // // // //     professional: `
// // // // //       body { font-family:Arial,Helvetica,sans-serif; font-size:13px; line-height:1.6; color:#1a1a1a; }
// // // // //       .page { overflow:hidden; }
// // // // //       .hdr { background:${hd} !important; padding:22px 38px 18px; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // // // //       .hdr-top { display:flex; justify-content:space-between; align-items:flex-start; gap:16px; margin-bottom:10px; }
// // // // //       .hdr-name { font-size:24px; font-weight:700; color:#ffffff !important; letter-spacing:.2px; margin-bottom:4px; }
// // // // //       .hdr-title { font-size:10.5px; color:rgba(255,255,255,0.55) !important; text-transform:uppercase; letter-spacing:1.8px; }
// // // // //       .hdr-right { text-align:right; padding-top:3px; }
// // // // //       .ctc-line { font-size:11.5px; color:rgba(255,255,255,0.65) !important; margin-bottom:3px; }
// // // // //       .hdr-rule { border:none; border-top:1px solid rgba(255,255,255,0.15); margin-top:0; }
// // // // //       .body-pad { padding:20px 38px 32px; }
// // // // //       .section { margin-bottom:16px; }
// // // // //       .sec-title { font-size:9.5px; font-weight:700; text-transform:uppercase; letter-spacing:2px; color:${hd} !important; background:#f0f4f8 !important; padding:4px 10px; margin-bottom:9px; border-left:3px solid ${hd} !important; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // // // //       .summary-text { font-size:12.5px; line-height:1.7; color:#333; margin:0; }
// // // // //       .exp-block { margin-bottom:12px; }
// // // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // // //       .exp-left { flex:1; min-width:0; }
// // // // //       .exp-title { font-weight:700; font-size:13px; color:#0f172a; }
// // // // //       .exp-sep { color:#cbd5e1; margin:0 3px; }
// // // // //       .exp-company { font-size:12.5px; color:#374151; font-weight:600; }
// // // // //       .exp-loc { font-size:11.5px; color:#94a3b8; }
// // // // //       .exp-dates { font-size:11.5px; color:#64748b; white-space:nowrap; font-style:italic; padding-left:8px; flex-shrink:0; }
// // // // //       .edu-block { margin-bottom:7px; }
// // // // //       .bullets { margin:4px 0 0 16px; padding:0; list-style:square; }
// // // // //       .bullets li { font-size:12px; color:#374151; margin-bottom:3px; line-height:1.55; }
// // // // //       .bullets li::marker { color:${hd} !important; }
// // // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12px; }
// // // // //       .skill-cat { font-weight:700; color:${hd} !important; min-width:140px; flex-shrink:0; }
// // // // //       .skill-vals { color:#374151; line-height:1.5; }
// // // // //       .cert-text { font-size:12px; color:#374151; line-height:1.6; margin:0; }`,
// // // // //   };

// // // // //   const css = TEMPLATES_CSS[templateId] || TEMPLATES_CSS.classic;

// // // // //   // ── Hint box ──
// // // // //   const hintBox = (showHint || forPrint) ? `
// // // // //     <div class="hint no-print" style="background:#1d4ed8;color:#fff;padding:12px 20px;
// // // // //       text-align:center;font-size:13px;font-family:Arial,sans-serif;line-height:1.8;">
// // // // //       📄 <strong>Save as PDF:</strong>
// // // // //       Press <kbd style="background:rgba(255,255,255,.2);padding:2px 8px;border-radius:3px;">Ctrl+P</kbd>
// // // // //       → Destination = <strong>"Save as PDF"</strong>
// // // // //       → Margins = <strong>None</strong>
// // // // //       → ✅ <strong>Background graphics ON</strong>
// // // // //       → Save
// // // // //     </div>` : "";

// // // // //   // ── Build header per template ──
// // // // //   let headerHTML = "";
// // // // //   let wrapOpen   = "";
// // // // //   let wrapClose  = "";

// // // // //   const ctcJoined = ctcs.map((c,i)=>
// // // // //     i===0 ? c : `<span class="ctc-sep">|</span>${c}`
// // // // //   ).join("");

// // // // //   if (templateId === "classic") {
// // // // //     headerHTML = `<div class="hdr">
// // // // //       <div class="hdr-name">${nm}</div>
// // // // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // // //       <div class="hdr-contact">${ctcJoined}</div>
// // // // //     </div>`;
// // // // //   }
// // // // //   else if (templateId === "executive") {
// // // // //     headerHTML = `<div class="hdr">
// // // // //       <div class="hdr-name">${nm}</div>
// // // // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // // //       <hr class="hdr-rule">
// // // // //       <div class="hdr-contact">${ctcJoined}</div>
// // // // //     </div>`;
// // // // //     wrapOpen=`<div class="body-pad">`; wrapClose=`</div>`;
// // // // //   }
// // // // //   else if (templateId === "bold") {
// // // // //     headerHTML = `<div class="hdr">
// // // // //       <div class="hdr-name">${nm}</div>
// // // // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // // //       <div class="hdr-contact">${ctcJoined}</div>
// // // // //     </div>`;
// // // // //     wrapOpen=`<div class="body-pad">`; wrapClose=`</div>`;
// // // // //   }
// // // // //   else if (templateId === "minimal") {
// // // // //     headerHTML = `<div class="hdr">
// // // // //       <div class="hdr-name">${nm}</div>
// // // // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // // //       <div class="hdr-contact">${ctcJoined}</div>
// // // // //     </div>`;
// // // // //   }
// // // // //   else if (templateId === "professional") {
// // // // //     const ctcRight = ctcs.slice(0,3).map(c=>`<div class="ctc-line">${c}</div>`).join("");
// // // // //     const ctcExtra = ctcs.slice(3).join(" · ");
// // // // //     headerHTML = `<div class="hdr">
// // // // //       <div class="hdr-top">
// // // // //         <div>
// // // // //           <div class="hdr-name">${nm}</div>
// // // // //           ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // // //         </div>
// // // // //         <div class="hdr-right">${ctcRight}</div>
// // // // //       </div>
// // // // //       ${ctcExtra?`<div style="font-size:11px;color:rgba(255,255,255,.5);padding-bottom:8px;">${ctcExtra}</div>`:""}
// // // // //       <hr class="hdr-rule">
// // // // //     </div>`;
// // // // //     wrapOpen=`<div class="body-pad">`; wrapClose=`</div>`;
// // // // //   }

// // // // //   return `<!DOCTYPE html>
// // // // // <html lang="en">
// // // // // <head>
// // // // //   <meta charset="UTF-8">
// // // // //   <title>${nm} — Resume</title>
// // // // //   <style>
// // // // //     ${BASE}
// // // // //     ${css}
// // // // //   </style>
// // // // // </head>
// // // // // <body>
// // // // //   ${hintBox}
// // // // //   <div class="page">
// // // // //     ${headerHTML}
// // // // //     ${wrapOpen}
// // // // //     ${sections}
// // // // //     ${wrapClose}
// // // // //   </div>
// // // // // </body>
// // // // // </html>`;
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // HELPERS
// // // // // // ─────────────────────────────────────────────
// // // // // function dl(blob, name) {
// // // // //   const url = URL.createObjectURL(blob);
// // // // //   const a   = Object.assign(document.createElement("a"),{href:url,download:name});
// // // // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // // //   setTimeout(()=>URL.revokeObjectURL(url),2000);
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // PDF — server-side Puppeteer (silent download)
// // // // // // Falls back to new-tab print if server unavailable
// // // // // // ─────────────────────────────────────────────
// // // // // export async function downloadResumeAsPDF(resume, fileName, templateId) {
// // // // //   const name    = (fileName||"resume").replace(/\.(pdf|html?)$/i,"");
// // // // //   const html    = buildResumeHTML(resume, templateId, { forPrint: false });
// // // // //   const BACKEND = window.REACT_APP_BACKEND_URL ||
// // // // //                   process.env?.REACT_APP_BACKEND_URL ||
// // // // //                   "https://ats-app-795v.onrender.com";

// // // // //   try {
// // // // //     const res = await fetch(`${BACKEND}/generate-pdf`, {
// // // // //       method:  "POST",
// // // // //       headers: { "Content-Type": "application/json" },
// // // // //       body:    JSON.stringify({ html }),
// // // // //     });

// // // // //     if (!res.ok) throw new Error(`Server error ${res.status}`);

// // // // //     const blob = await res.blob();
// // // // //     const url  = URL.createObjectURL(blob);
// // // // //     const a    = Object.assign(document.createElement("a"),
// // // // //       { href: url, download: `${name}.pdf` });
// // // // //     document.body.appendChild(a);
// // // // //     a.click();
// // // // //     document.body.removeChild(a);
// // // // //     setTimeout(() => URL.revokeObjectURL(url), 2000);

// // // // //   } catch (err) {
// // // // //     console.warn("Server PDF failed, falling back to print:", err.message);
// // // // //     // Fallback: open in new tab with print instructions
// // // // //     _openPrintTab(html);
// // // // //   }
// // // // // }

// // // // // function _openPrintTab(html) {
// // // // //   const win = window.open("", "_blank");
// // // // //   if (!win) {
// // // // //     dl(new Blob([html],{type:"text/html;charset=utf-8"}),"resume.html");
// // // // //     alert("Popup blocked. HTML file downloaded — open in Chrome → Ctrl+P → Save as PDF.");
// // // // //     return;
// // // // //   }
// // // // //   win.document.open();
// // // // //   win.document.write(html);
// // // // //   win.document.close();
// // // // //   win.focus();
// // // // //   setTimeout(() => { try { win.print(); } catch(e) {} }, 800);
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // WORD — downloads styled HTML as .doc
// // // // // // Word opens HTML files natively with full styling
// // // // // // Same HTML as screen = same template design in Word
// // // // // // ─────────────────────────────────────────────
// // // // // export function downloadResumeAsWord(resume, fileName, templateId) {
// // // // //   // Use same HTML but with Word-specific overrides
// // // // //   const html = buildResumeHTML(resume, templateId, { showHint: false });

// // // // //   // Inject Word-specific meta and simplify for Word rendering
// // // // //   const wordHtml = html
// // // // //     .replace('<html lang="en">', `<html xmlns:o="urn:schemas-microsoft-com:office:office"
// // // // //       xmlns:w="urn:schemas-microsoft-com:office:word"
// // // // //       xmlns="http://www.w3.org/TR/REC-html40">`)
// // // // //     .replace('</head>', `<!--[if gte mso 9]><xml>
// // // // //       <w:WordDocument><w:View>Print</w:View><w:Zoom>90</w:Zoom>
// // // // //       <w:DoNotOptimizeForBrowser/></w:WordDocument></xml><![endif]-->
// // // // //     <style>
// // // // //       /* Word overrides — keeps structure, simplifies backgrounds */
// // // // //       @page { size:A4; margin:.75in; }
// // // // //       body { font-family:Calibri,Arial,sans-serif; font-size:11pt; background:#fff !important; }
// // // // //       .page { width:auto !important; max-width:100% !important; padding:0 !important; overflow:visible !important; }
// // // // //       .hdr { padding:16pt 0 12pt !important; }
// // // // //       .body-pad { padding:0 !important; }
// // // // //       .exp-header { display:block !important; }
// // // // //       .exp-dates { display:block !important; font-style:italic; padding-left:0 !important; }
// // // // //       .skill-line { display:block !important; margin-bottom:4pt !important; }
// // // // //       .skill-cat { display:inline; }
// // // // //       .skill-vals { display:inline; }
// // // // //     </style>
// // // // //     </head>`);

// // // // //   dl(
// // // // //     new Blob(["\ufeff", wordHtml], { type:"application/msword;charset=utf-8" }),
// // // // //     (fileName||"resume").replace(/\.(doc|docx|html?)$/i,"") + ".doc"
// // // // //   );
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // HTML — full styled file, opens in browser
// // // // // // ─────────────────────────────────────────────
// // // // // export function downloadATSResume(resume, fileName, templateId) {
// // // // //   dl(
// // // // //     new Blob([buildResumeHTML(resume, templateId, { showHint:true })],
// // // // //       { type:"text/html;charset=utf-8" }),
// // // // //     (fileName||"resume").replace(/\.html?$/i,"") + ".html"
// // // // //   );
// // // // // }

// // // // // generateResumeDoc.js
// // // // // PDF:  Opens styled HTML in new tab → user saves as PDF (100% accurate)
// // // // // Word: Downloads styled HTML as .doc — Word opens it with full template styling
// // // // // HTML: Full styled file for browser viewing

// // // // const TEMPLATES = {
// // // //   classic:      { name:"Classic ATS",    accent:"#2563eb", header:"#1e293b" },
// // // //   executive:    { name:"Executive",      accent:"#334155", header:"#0f172a" },
// // // //   bold:         { name:"Bold Impact",    accent:"#1d4ed8", header:"#1e3a8a" },
// // // //   minimal:      { name:"Minimal Clean",  accent:"#047857", header:"#047857" },
// // // //   professional: { name:"Professional",   accent:"#1e3a5f", header:"#1e3a5f" },
// // // // };

// // // // function getT(id) { return TEMPLATES[id] || TEMPLATES.classic; }

// // // // function esc(s) {
// // // //   if (!s) return "";
// // // //   return String(s)
// // // //     .replace(/&/g,"&amp;").replace(/</g,"&lt;")
// // // //     .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// // // // }
// // // // function fmt(s, e) {
// // // //   if (!s && !e) return "";
// // // //   if (s && !e)  return esc(s);
// // // //   if (!s && e)  return esc(e);
// // // //   return `${esc(s)} &ndash; ${esc(e)}`;
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // CORE HTML BUILDER — single source of truth
// // // // // Same HTML used for screen preview, PDF, Word, HTML download
// // // // // Uses system fonts — no CDN, renders everywhere
// // // // // ─────────────────────────────────────────────
// // // // export function buildResumeHTML(resume, templateId, opts = {}) {
// // // //   const { forWord = false, showHint = false, forPrint = false } = opts;
// // // //   const t  = getT(templateId);
// // // //   const ac = t.accent;
// // // //   const hd = t.header;

// // // //   const nm   = esc(resume.name  || "Your Name");
// // // //   const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
// // // //   const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin]
// // // //                  .filter(Boolean).map(esc);

// // // //   // ── Content builders ──
// // // //   const expHtml = (resume.experience||[]).map(exp => {
// // // //     const bullets = (exp.bullets||[]).map(b=>`<li>${esc(b)}</li>`).join("");
// // // //     const dates   = fmt(exp.startDate, exp.endDate);
// // // //     return `<div class="exp-block">
// // // //       <div class="exp-header">
// // // //         <div class="exp-left">
// // // //           <span class="exp-title">${esc(exp.title||"")}</span>
// // // //           <span class="exp-sep"> | </span>
// // // //           <span class="exp-company">${esc(exp.company||"")}</span>
// // // //           ${exp.location?`<span class="exp-loc">, ${esc(exp.location)}</span>`:""}
// // // //         </div>
// // // //         ${dates?`<span class="exp-dates">${dates}</span>`:""}
// // // //       </div>
// // // //       ${bullets?`<ul class="bullets">${bullets}</ul>`:""}
// // // //     </div>`;
// // // //   }).join("");

// // // //   const eduHtml = (resume.education||[]).map(edu=>
// // // //     `<div class="edu-block">
// // // //       <div class="exp-header">
// // // //         <div class="exp-left">
// // // //           <span class="exp-title">${esc(edu.degree||"")}</span>
// // // //           <span class="exp-sep"> | </span>
// // // //           <span class="exp-company">${esc(edu.school||"")}</span>
// // // //           ${edu.location?`<span class="exp-loc">, ${esc(edu.location)}</span>`:""}
// // // //         </div>
// // // //         ${edu.year?`<span class="exp-dates">${esc(edu.year)}${edu.gpa?` · GPA ${esc(edu.gpa)}`:""}</span>`:""}
// // // //       </div>
// // // //     </div>`
// // // //   ).join("");

// // // //   const sk = resume.skills||{};
// // // //   const skillLines = [
// // // //     sk.technical?.length?`<div class="skill-line"><span class="skill-cat">Technical Skills</span><span class="skill-vals">${sk.technical.map(esc).join(" · ")}</span></div>`:"",
// // // //     sk.tools?.length?`<div class="skill-line"><span class="skill-cat">Tools &amp; Platforms</span><span class="skill-vals">${sk.tools.map(esc).join(" · ")}</span></div>`:"",
// // // //     sk.soft?.length?`<div class="skill-line"><span class="skill-cat">Core Competencies</span><span class="skill-vals">${sk.soft.map(esc).join(" · ")}</span></div>`:"",
// // // //   ].join("");

// // // //   const certHtml = (resume.certifications||[]).length
// // // //     ? `<p class="cert-text">${resume.certifications.map(esc).join(" · ")}</p>` : "";

// // // //   function sec(title, body) {
// // // //     if (!body?.trim()) return "";
// // // //     return `<div class="section"><div class="sec-title">${title}</div><div class="sec-body">${body}</div></div>`;
// // // //   }
// // // //   const sections = [
// // // //     resume.summary ? sec("Professional Summary",`<p class="summary-text">${esc(resume.summary)}</p>`):"",
// // // //     expHtml  ? sec("Work Experience", expHtml) :"",
// // // //     eduHtml  ? sec("Education",       eduHtml) :"",
// // // //     skillLines?sec("Skills",          skillLines):"",
// // // //     certHtml ? sec("Certifications",  certHtml) :"",
// // // //   ].join("");

// // // //   // ── Print/save banner ──
// // // //   const hint = (showHint || forPrint) ? `
// // // //     <div class="hint no-print">
// // // //       <strong>Save as PDF:</strong> Ctrl+P (or Cmd+P) →
// // // //       Destination = <strong>Save as PDF</strong> →
// // // //       Margins = <strong>None</strong> →
// // // //       ✅ Enable <strong>Background graphics</strong> → Save
// // // //     </div>` : "";

// // // //   // ════════════════════════════════════════════
// // // //   // TEMPLATE CSS — all system fonts, no CDN
// // // //   // ════════════════════════════════════════════
// // // //   const BASE = `
// // // //     *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
// // // //     body { background:#f5f5f5; -webkit-print-color-adjust:exact !important; print-color-adjust:exact !important; }
// // // //     .page { max-width:794px; width:794px; margin:0 auto; background:#fff; }
// // // //     .page * { max-width:100%; }
// // // //     ul.bullets { overflow:hidden; }
// // // //     li { word-break:break-word; }
// // // //     .no-print { display:block; }
// // // //     @media print {
// // // //       body { background:#fff; margin:0; padding:0; }
// // // //       .no-print { display:none !important; }
// // // //       .page { box-shadow:none; width:100%; max-width:100%; }
// // // //       @page { size:A4; margin:0; }
// // // //       -webkit-print-color-adjust: exact !important;
// // // //       print-color-adjust: exact !important;
// // // //     }`;

// // // //   const TEMPLATES_CSS = {
// // // //     classic: `
// // // //       body { font-family:Georgia,"Times New Roman",serif; font-size:13.5px; line-height:1.6; color:#111; }
// // // //       .page { padding:42px 52px 38px; }
// // // //       .hdr { text-align:center; padding-bottom:16px; margin-bottom:20px; border-bottom:2px solid ${ac}; }
// // // //       .hdr-name { font-size:30px; font-weight:700; color:#000; letter-spacing:.3px; margin-bottom:5px; }
// // // //       .hdr-title { font-size:13.5px; color:#444; font-style:italic; margin-bottom:9px; }
// // // //       .hdr-contact { font-size:12px; color:#333; }
// // // //       .ctc-sep { margin:0 8px; color:#aaa; }
// // // //       .section { margin-bottom:16px; }
// // // //       .sec-title { font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:1.8px; color:#000; border-bottom:1.5px solid #000; padding-bottom:3px; margin-bottom:9px; font-family:Georgia,"Times New Roman",serif; }
// // // //       .summary-text { font-size:13px; line-height:1.7; color:#222; margin:0; }
// // // //       .exp-block { margin-bottom:11px; }
// // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // //       .exp-left { flex:1; min-width:0; }
// // // //       .exp-title { font-weight:700; font-size:13.5px; color:#000; }
// // // //       .exp-sep { color:#999; }
// // // //       .exp-company { font-size:13px; color:#333; font-style:italic; }
// // // //       .exp-loc { font-size:12px; color:#666; }
// // // //       .exp-dates { font-size:12px; color:#444; white-space:nowrap; font-style:italic; padding-left:8px; flex-shrink:0; }
// // // //       .edu-block { margin-bottom:7px; }
// // // //       .bullets { margin:4px 0 0 20px; padding:0; list-style:disc; }
// // // //       .bullets li { font-size:12.5px; color:#222; margin-bottom:3px; line-height:1.55; }
// // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12.5px; }
// // // //       .skill-cat { font-weight:700; color:#000; min-width:140px; flex-shrink:0; }
// // // //       .skill-vals { color:#333; line-height:1.5; }
// // // //       .cert-text { font-size:12.5px; color:#333; line-height:1.6; margin:0; }`,

// // // //     executive: `
// // // //       body { font-family:Georgia,"Times New Roman",serif; font-size:13px; line-height:1.6; color:#1a1a1a; }
// // // //       .page { overflow:hidden; }
// // // //       .hdr { background:${hd} !important; padding:28px 44px 22px; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // // //       .hdr-name { font-size:26px; font-weight:700; color:#ffffff !important; text-transform:uppercase; letter-spacing:1.5px; margin-bottom:4px; }
// // // //       .hdr-title { font-size:11px; color:rgba(255,255,255,0.6) !important; text-transform:uppercase; letter-spacing:2.5px; font-family:Arial,Helvetica,sans-serif; margin-bottom:12px; }
// // // //       .hdr-rule { border:none; border-top:1px solid rgba(255,255,255,0.2); margin-bottom:10px; }
// // // //       .hdr-contact { font-size:11.5px; color:rgba(255,255,255,0.7) !important; font-family:Arial,Helvetica,sans-serif; }
// // // //       .ctc-sep { margin:0 12px; color:rgba(255,255,255,0.3); }
// // // //       .body-pad { padding:24px 44px 34px; }
// // // //       .section { margin-bottom:16px; }
// // // //       .sec-title { font-family:Arial,Helvetica,sans-serif; font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:2.5px; color:${hd} !important; border-bottom:2px solid ${hd} !important; padding-bottom:4px; margin-bottom:9px; }
// // // //       .summary-text { font-size:12.5px; line-height:1.7; color:#333; margin:0; }
// // // //       .exp-block { margin-bottom:12px; }
// // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // //       .exp-left { flex:1; min-width:0; }
// // // //       .exp-title { font-weight:700; font-size:13px; color:#0f172a; }
// // // //       .exp-sep { color:#aaa; }
// // // //       .exp-company { font-size:12.5px; color:#444; font-style:italic; }
// // // //       .exp-loc { font-size:12px; color:#888; }
// // // //       .exp-dates { font-size:11.5px; color:#555; white-space:nowrap; font-style:italic; font-family:Arial,Helvetica,sans-serif; padding-left:8px; flex-shrink:0; }
// // // //       .edu-block { margin-bottom:7px; }
// // // //       .bullets { margin:4px 0 0 18px; padding:0; list-style:disc; }
// // // //       .bullets li { font-size:12px; color:#333; margin-bottom:3px; line-height:1.55; }
// // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12px; font-family:Arial,Helvetica,sans-serif; }
// // // //       .skill-cat { font-weight:700; color:${hd} !important; min-width:140px; flex-shrink:0; }
// // // //       .skill-vals { color:#444; line-height:1.5; }
// // // //       .cert-text { font-size:12px; color:#444; line-height:1.6; margin:0; font-family:Arial,Helvetica,sans-serif; }`,

// // // //     bold: `
// // // //       body { font-family:Arial,Helvetica,sans-serif; font-size:13px; line-height:1.6; color:#1a1a1a; }
// // // //       .page { overflow:hidden; }
// // // //       .hdr { background:${hd} !important; padding:26px 38px 20px; border-bottom:4px solid ${ac} !important; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // // //       .hdr-name { font-size:32px; font-weight:900; color:#ffffff !important; letter-spacing:-.5px; line-height:1.05; margin-bottom:3px; }
// // // //       .hdr-title { font-size:11px; color:rgba(255,255,255,0.65) !important; text-transform:uppercase; letter-spacing:2.5px; margin-bottom:11px; }
// // // //       .hdr-contact { font-size:11.5px; color:rgba(255,255,255,0.6) !important; }
// // // //       .ctc-sep { margin:0 10px; color:rgba(255,255,255,0.3); }
// // // //       .body-pad { padding:22px 38px 34px; }
// // // //       .section { margin-bottom:16px; }
// // // //       .sec-title { font-size:9.5px; font-weight:900; text-transform:uppercase; letter-spacing:2.5px; color:${ac} !important; border-bottom:2px solid ${ac} !important; padding-bottom:5px; margin-bottom:9px; }
// // // //       .summary-text { font-size:12.5px; line-height:1.7; color:#333; margin:0; }
// // // //       .exp-block { margin-bottom:12px; padding-left:10px; border-left:2.5px solid #e2e8f0 !important; }
// // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // //       .exp-left { flex:1; min-width:0; }
// // // //       .exp-title { font-weight:700; font-size:13.5px; color:#0f172a; }
// // // //       .exp-sep { color:#cbd5e1; }
// // // //       .exp-company { font-size:12.5px; color:#475569; font-weight:600; }
// // // //       .exp-loc { font-size:12px; color:#94a3b8; }
// // // //       .exp-dates { font-size:11.5px; color:#64748b; white-space:nowrap; font-style:italic; padding-left:8px; flex-shrink:0; }
// // // //       .edu-block { margin-bottom:7px; padding-left:10px; border-left:2.5px solid #e2e8f0 !important; }
// // // //       .bullets { margin:4px 0 0 16px; padding:0; list-style:disc; }
// // // //       .bullets li { font-size:12px; color:#374151; margin-bottom:3px; line-height:1.55; }
// // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12px; }
// // // //       .skill-cat { font-weight:700; color:#0f172a; min-width:140px; flex-shrink:0; }
// // // //       .skill-vals { color:#475569; line-height:1.5; }
// // // //       .cert-text { font-size:12px; color:#475569; line-height:1.6; margin:0; }`,

// // // //     minimal: `
// // // //       body { font-family:Arial,Helvetica,sans-serif; font-size:13.5px; line-height:1.65; color:#1a1a1a; }
// // // //       .page { padding:44px 52px 38px; }
// // // //       .hdr { margin-bottom:22px; padding-bottom:16px; border-bottom:1px solid #e5e7eb; }
// // // //       .hdr-name { font-size:28px; font-weight:600; color:#111; letter-spacing:-.3px; margin-bottom:4px; }
// // // //       .hdr-title { font-size:13.5px; color:${ac} !important; font-weight:600; margin-bottom:10px; }
// // // //       .hdr-contact { font-size:12px; color:#555; }
// // // //       .ctc-sep { margin:0 10px; color:#d1d5db; }
// // // //       .section { margin-bottom:16px; }
// // // //       .sec-title { font-size:9.5px; font-weight:700; text-transform:uppercase; letter-spacing:2.5px; color:${ac} !important; border-bottom:1px solid ${ac}44 !important; padding-bottom:4px; margin-bottom:8px; }
// // // //       .summary-text { font-size:13px; line-height:1.7; color:#374151; margin:0; }
// // // //       .exp-block { margin-bottom:13px; }
// // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // //       .exp-left { flex:1; min-width:0; }
// // // //       .exp-title { font-weight:600; font-size:13.5px; color:#111; }
// // // //       .exp-sep { color:#d1d5db; margin:0 4px; }
// // // //       .exp-company { font-size:13px; color:#374151; }
// // // //       .exp-loc { font-size:12px; color:#9ca3af; }
// // // //       .exp-dates { font-size:12px; color:#6b7280; white-space:nowrap; padding-left:8px; flex-shrink:0; }
// // // //       .edu-block { margin-bottom:7px; }
// // // //       .bullets { margin:4px 0 0 0; padding:0; list-style:none; }
// // // //       .bullets li { font-size:12.5px; color:#374151; margin-bottom:3px; line-height:1.55; padding-left:14px; position:relative; }
// // // //       .bullets li::before { content:"–"; position:absolute; left:0; color:${ac}; }
// // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12.5px; }
// // // //       .skill-cat { font-weight:600; color:#111; min-width:140px; flex-shrink:0; }
// // // //       .skill-vals { color:#374151; line-height:1.5; }
// // // //       .cert-text { font-size:12.5px; color:#374151; line-height:1.6; margin:0; }`,

// // // //     professional: `
// // // //       body { font-family:Arial,Helvetica,sans-serif; font-size:13px; line-height:1.6; color:#1a1a1a; }
// // // //       .page { overflow:hidden; }
// // // //       .hdr { background:${hd} !important; padding:22px 38px 18px; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // // //       .hdr-top { display:flex; justify-content:space-between; align-items:flex-start; gap:16px; margin-bottom:10px; }
// // // //       .hdr-name { font-size:24px; font-weight:700; color:#ffffff !important; letter-spacing:.2px; margin-bottom:4px; }
// // // //       .hdr-title { font-size:10.5px; color:rgba(255,255,255,0.55) !important; text-transform:uppercase; letter-spacing:1.8px; }
// // // //       .hdr-right { text-align:right; padding-top:3px; }
// // // //       .ctc-line { font-size:11.5px; color:rgba(255,255,255,0.65) !important; margin-bottom:3px; }
// // // //       .hdr-rule { border:none; border-top:1px solid rgba(255,255,255,0.15); margin-top:0; }
// // // //       .body-pad { padding:20px 38px 32px; }
// // // //       .section { margin-bottom:16px; }
// // // //       .sec-title { font-size:9.5px; font-weight:700; text-transform:uppercase; letter-spacing:2px; color:${hd} !important; background:#f0f4f8 !important; padding:4px 10px; margin-bottom:9px; border-left:3px solid ${hd} !important; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // // //       .summary-text { font-size:12.5px; line-height:1.7; color:#333; margin:0; }
// // // //       .exp-block { margin-bottom:12px; }
// // // //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // // //       .exp-left { flex:1; min-width:0; }
// // // //       .exp-title { font-weight:700; font-size:13px; color:#0f172a; }
// // // //       .exp-sep { color:#cbd5e1; margin:0 3px; }
// // // //       .exp-company { font-size:12.5px; color:#374151; font-weight:600; }
// // // //       .exp-loc { font-size:11.5px; color:#94a3b8; }
// // // //       .exp-dates { font-size:11.5px; color:#64748b; white-space:nowrap; font-style:italic; padding-left:8px; flex-shrink:0; }
// // // //       .edu-block { margin-bottom:7px; }
// // // //       .bullets { margin:4px 0 0 16px; padding:0; list-style:square; }
// // // //       .bullets li { font-size:12px; color:#374151; margin-bottom:3px; line-height:1.55; }
// // // //       .bullets li::marker { color:${hd} !important; }
// // // //       .skill-line { display:flex; gap:8px; margin-bottom:4px; font-size:12px; }
// // // //       .skill-cat { font-weight:700; color:${hd} !important; min-width:140px; flex-shrink:0; }
// // // //       .skill-vals { color:#374151; line-height:1.5; }
// // // //       .cert-text { font-size:12px; color:#374151; line-height:1.6; margin:0; }`,
// // // //   };

// // // //   const css = TEMPLATES_CSS[templateId] || TEMPLATES_CSS.classic;

// // // //   // ── Hint box ──
// // // //   const hintBox = (showHint || forPrint) ? `
// // // //     <div class="hint no-print" style="background:#1d4ed8;color:#fff;padding:12px 20px;
// // // //       text-align:center;font-size:13px;font-family:Arial,sans-serif;line-height:1.8;">
// // // //       📄 <strong>Save as PDF:</strong>
// // // //       Press <kbd style="background:rgba(255,255,255,.2);padding:2px 8px;border-radius:3px;">Ctrl+P</kbd>
// // // //       → Destination = <strong>"Save as PDF"</strong>
// // // //       → Margins = <strong>None</strong>
// // // //       → ✅ <strong>Background graphics ON</strong>
// // // //       → Save
// // // //     </div>` : "";

// // // //   // ── Build header per template ──
// // // //   let headerHTML = "";
// // // //   let wrapOpen   = "";
// // // //   let wrapClose  = "";

// // // //   const ctcJoined = ctcs.map((c,i)=>
// // // //     i===0 ? c : `<span class="ctc-sep">|</span>${c}`
// // // //   ).join("");

// // // //   if (templateId === "classic") {
// // // //     headerHTML = `<div class="hdr">
// // // //       <div class="hdr-name">${nm}</div>
// // // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // //       <div class="hdr-contact">${ctcJoined}</div>
// // // //     </div>`;
// // // //   }
// // // //   else if (templateId === "executive") {
// // // //     headerHTML = `<div class="hdr">
// // // //       <div class="hdr-name">${nm}</div>
// // // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // //       <hr class="hdr-rule">
// // // //       <div class="hdr-contact">${ctcJoined}</div>
// // // //     </div>`;
// // // //     wrapOpen=`<div class="body-pad">`; wrapClose=`</div>`;
// // // //   }
// // // //   else if (templateId === "bold") {
// // // //     headerHTML = `<div class="hdr">
// // // //       <div class="hdr-name">${nm}</div>
// // // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // //       <div class="hdr-contact">${ctcJoined}</div>
// // // //     </div>`;
// // // //     wrapOpen=`<div class="body-pad">`; wrapClose=`</div>`;
// // // //   }
// // // //   else if (templateId === "minimal") {
// // // //     headerHTML = `<div class="hdr">
// // // //       <div class="hdr-name">${nm}</div>
// // // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // //       <div class="hdr-contact">${ctcJoined}</div>
// // // //     </div>`;
// // // //   }
// // // //   else if (templateId === "professional") {
// // // //     const ctcRight = ctcs.slice(0,3).map(c=>`<div class="ctc-line">${c}</div>`).join("");
// // // //     const ctcExtra = ctcs.slice(3).join(" · ");
// // // //     headerHTML = `<div class="hdr">
// // // //       <div class="hdr-top">
// // // //         <div>
// // // //           <div class="hdr-name">${nm}</div>
// // // //           ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // // //         </div>
// // // //         <div class="hdr-right">${ctcRight}</div>
// // // //       </div>
// // // //       ${ctcExtra?`<div style="font-size:11px;color:rgba(255,255,255,.5);padding-bottom:8px;">${ctcExtra}</div>`:""}
// // // //       <hr class="hdr-rule">
// // // //     </div>`;
// // // //     wrapOpen=`<div class="body-pad">`; wrapClose=`</div>`;
// // // //   }

// // // //   return `<!DOCTYPE html>
// // // // <html lang="en">
// // // // <head>
// // // //   <meta charset="UTF-8">
// // // //   <title>${nm} — Resume</title>
// // // //   <style>
// // // //     ${BASE}
// // // //     ${css}
// // // //   </style>
// // // // </head>
// // // // <body>
// // // //   ${hintBox}
// // // //   <div class="page">
// // // //     ${headerHTML}
// // // //     ${wrapOpen}
// // // //     ${sections}
// // // //     ${wrapClose}
// // // //   </div>
// // // // </body>
// // // // </html>`;
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // HELPERS
// // // // // ─────────────────────────────────────────────
// // // // function dl(blob, name) {
// // // //   const url = URL.createObjectURL(blob);
// // // //   const a   = Object.assign(document.createElement("a"),{href:url,download:name});
// // // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // // //   setTimeout(()=>URL.revokeObjectURL(url),2000);
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // PDF — server-side Puppeteer (silent download)
// // // // // Falls back to new-tab print if server unavailable
// // // // // ─────────────────────────────────────────────
// // // // export async function downloadResumeAsPDF(resume, fileName, templateId) {
// // // //   const name    = (fileName||"resume").replace(/\.(pdf|html?)$/i,"");
// // // //   const html    = buildResumeHTML(resume, templateId, { forPrint: false });
// // // //   const BACKEND = window.REACT_APP_BACKEND_URL ||
// // // //                   process.env?.REACT_APP_BACKEND_URL ||
// // // //                   "https://ats-app-795v.onrender.com";

// // // //   try {
// // // //     const res = await fetch(`${BACKEND}/generate-pdf`, {
// // // //       method:  "POST",
// // // //       headers: { "Content-Type": "application/json" },
// // // //       body:    JSON.stringify({ html }),
// // // //     });

// // // //     if (!res.ok) throw new Error(`Server error ${res.status}`);

// // // //     const blob = await res.blob();
// // // //     const url  = URL.createObjectURL(blob);
// // // //     const a    = Object.assign(document.createElement("a"),
// // // //       { href: url, download: `${name}.pdf` });
// // // //     document.body.appendChild(a);
// // // //     a.click();
// // // //     document.body.removeChild(a);
// // // //     setTimeout(() => URL.revokeObjectURL(url), 2000);

// // // //   } catch (err) {
// // // //     console.warn("Server PDF failed, falling back to print:", err.message);
// // // //     // Fallback: open in new tab with print instructions
// // // //     _openPrintTab(html);
// // // //   }
// // // // }

// // // // function _openPrintTab(html) {
// // // //   const win = window.open("", "_blank");
// // // //   if (!win) {
// // // //     dl(new Blob([html],{type:"text/html;charset=utf-8"}),"resume.html");
// // // //     alert("Popup blocked. HTML file downloaded — open in Chrome → Ctrl+P → Save as PDF.");
// // // //     return;
// // // //   }
// // // //   win.document.open();
// // // //   win.document.write(html);
// // // //   win.document.close();
// // // //   win.focus();
// // // //   setTimeout(() => { try { win.print(); } catch(e) {} }, 800);
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // WORD — server-side docx generation (proper .docx)
// // // // // Falls back to HTML-based .doc if server unavailable
// // // // // ─────────────────────────────────────────────
// // // // export async function downloadResumeAsWord(resume, fileName, templateId) {
// // // //   const name    = (fileName||"resume").replace(/\.(doc|docx|html?)$/i,"");
// // // //   const BACKEND = window.REACT_APP_BACKEND_URL ||
// // // //                   "https://ats-app-795v.onrender.com";

// // // //   try {
// // // //     const res = await fetch(`${BACKEND}/generate-word`, {
// // // //       method:  "POST",
// // // //       headers: { "Content-Type": "application/json" },
// // // //       body:    JSON.stringify({ resume, templateId }),
// // // //     });

// // // //     if (!res.ok) throw new Error(`Server error ${res.status}`);

// // // //     const blob = await res.blob();
// // // //     const url  = URL.createObjectURL(blob);
// // // //     const a    = Object.assign(document.createElement("a"),
// // // //       { href: url, download: `${name}.docx` });
// // // //     document.body.appendChild(a);
// // // //     a.click();
// // // //     document.body.removeChild(a);
// // // //     setTimeout(() => URL.revokeObjectURL(url), 2000);

// // // //   } catch (err) {
// // // //     console.warn("Server Word failed, falling back to HTML .doc:", err.message);
// // // //     // Fallback — HTML-based .doc (opens in Word with basic styling)
// // // //     const html = buildResumeHTML(resume, templateId, { showHint: false });
// // // //     dl(new Blob(["\ufeff", html], { type:"text/plain;charset=utf-8" }),
// // // //       `${name}.doc`);
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // HTML — full styled file, opens in browser
// // // // // ─────────────────────────────────────────────
// // // // export function downloadATSResume(resume, fileName, templateId) {
// // // //   dl(
// // // //     new Blob([buildResumeHTML(resume, templateId, { showHint:true })],
// // // //       { type:"text/html;charset=utf-8" }),
// // // //     (fileName||"resume").replace(/\.html?$/i,"") + ".html"
// // // //   );
// // // // }

// // // // generateResumeDoc.js
// // // // Clean, professional ATS resume templates
// // // // No colored header bars — elegant typography only

// // // const TEMPLATES = {
// // //   classic: {
// // //     name:"Classic ATS", accent:"#2563eb", header:"#1e293b",
// // //     style:"classic",
// // //   },
// // //   executive: {
// // //     name:"Executive", accent:"#1e293b", header:"#0f172a",
// // //     style:"executive",
// // //   },
// // //   bold: {
// // //     name:"Bold Impact", accent:"#1d4ed8", header:"#1e3a8a",
// // //     style:"bold",
// // //   },
// // //   minimal: {
// // //     name:"Minimal Clean", accent:"#047857", header:"#047857",
// // //     style:"minimal",
// // //   },
// // //   professional: {
// // //     name:"Professional", accent:"#0f172a", header:"#1e3a5f",
// // //     style:"professional",
// // //   },
// // // };

// // // function getT(id) { return TEMPLATES[id] || TEMPLATES.classic; }

// // // function esc(s) {
// // //   if (!s) return "";
// // //   return String(s)
// // //     .replace(/&/g,"&amp;").replace(/</g,"&lt;")
// // //     .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// // // }
// // // function fmt(s, e) {
// // //   if (!s && !e) return "";
// // //   if (s && !e)  return esc(s);
// // //   if (!s && e)  return esc(e);
// // //   return `${esc(s)} &ndash; ${esc(e)}`;
// // // }

// // // // ─────────────────────────────────────────────
// // // // CORE HTML BUILDER
// // // // All templates: white background, clean typography
// // // // No colored bars — professional & ATS-safe
// // // // ─────────────────────────────────────────────
// // // export function buildResumeHTML(resume, templateId, opts = {}) {
// // //   const { showHint = false, forPrint = false } = opts;
// // //   const t  = getT(templateId);
// // //   const ac = t.accent;

// // //   const nm   = esc(resume.name  || "Your Name");
// // //   const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
// // //   const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin]
// // //                  .filter(Boolean).map(esc);

// // //   // ── Content builders ──
// // //   const expHtml = (resume.experience||[]).map(exp => {
// // //     const bullets = (exp.bullets||[]).map(b=>`<li>${esc(b)}</li>`).join("");
// // //     const dates   = fmt(exp.startDate, exp.endDate);
// // //     return `<div class="exp-block">
// // //       <div class="exp-row">
// // //         <div class="exp-left">
// // //           <span class="exp-title">${esc(exp.title||"")}</span>
// // //           <span class="exp-pipe"> | </span>
// // //           <span class="exp-company">${esc(exp.company||"")}</span>
// // //           ${exp.location?`<span class="exp-loc">, ${esc(exp.location)}</span>`:""}
// // //         </div>
// // //         ${dates?`<span class="exp-dates">${dates}</span>`:""}
// // //       </div>
// // //       ${bullets?`<ul class="bullets">${bullets}</ul>`:""}
// // //     </div>`;
// // //   }).join("");

// // //   const eduHtml = (resume.education||[]).map(edu=>
// // //     `<div class="edu-block">
// // //       <div class="exp-row">
// // //         <div class="exp-left">
// // //           <span class="exp-title">${esc(edu.degree||"")}</span>
// // //           <span class="exp-pipe"> | </span>
// // //           <span class="exp-company">${esc(edu.school||"")}</span>
// // //           ${edu.location?`<span class="exp-loc">, ${esc(edu.location)}</span>`:""}
// // //         </div>
// // //         ${edu.year?`<span class="exp-dates">${esc(edu.year)}${edu.gpa?` · GPA ${esc(edu.gpa)}`:""}</span>`:""}
// // //       </div>
// // //     </div>`
// // //   ).join("");

// // //   const sk = resume.skills||{};
// // //   const skillLines = [
// // //     sk.technical?.length?`<div class="skill-row"><span class="skill-cat">Technical Skills:</span> <span class="skill-val">${sk.technical.map(esc).join(" · ")}</span></div>`:"",
// // //     sk.tools?.length?`<div class="skill-row"><span class="skill-cat">Tools &amp; Platforms:</span> <span class="skill-val">${sk.tools.map(esc).join(" · ")}</span></div>`:"",
// // //     sk.soft?.length?`<div class="skill-row"><span class="skill-cat">Core Competencies:</span> <span class="skill-val">${sk.soft.map(esc).join(" · ")}</span></div>`:"",
// // //   ].join("");

// // //   const certHtml = (resume.certifications||[]).length
// // //     ? `<p class="cert-text">${resume.certifications.map(esc).join(" · ")}</p>` : "";

// // //   function sec(title, body) {
// // //     if (!body?.trim()) return "";
// // //     return `<div class="section">
// // //       <div class="sec-head"><span class="sec-title">${title}</span></div>
// // //       <div class="sec-body">${body}</div>
// // //     </div>`;
// // //   }

// // //   const sections = [
// // //     resume.summary ? sec("Professional Summary",`<p class="summary">${esc(resume.summary)}</p>`):"",
// // //     expHtml  ? sec("Work Experience", expHtml) :"",
// // //     eduHtml  ? sec("Education",       eduHtml) :"",
// // //     skillLines?sec("Skills",          skillLines):"",
// // //     certHtml ? sec("Certifications",  certHtml) :"",
// // //   ].join("");

// // //   // ── Template-specific styles ──
// // //   // ALL templates: white bg, no colored header bars
// // //   // Differences: font choice, name size, section title style, accent usage

// // //   const STYLES = {

// // //     // ── CLASSIC ATS ──
// // //     // Centered header, serif fonts, ruled section titles
// // //     // Harvard/Columbia career office standard
// // //     classic: `
// // //       body { font-family: Georgia,"Times New Roman",serif; font-size:13.5px; line-height:1.6; color:#111; }
// // //       .page { padding:44px 52px 38px; }
// // //       /* Header — centered, no background */
// // //       .hdr { text-align:center; margin-bottom:6px; }
// // //       .hdr-name { font-size:28px; font-weight:700; color:#000; letter-spacing:.5px; margin-bottom:5px; font-family:Georgia,"Times New Roman",serif; }
// // //       .hdr-title { font-size:13px; color:#444; font-style:italic; margin-bottom:10px; }
// // //       .hdr-contact { font-size:12px; color:#333; margin-bottom:0; }
// // //       .ctc-sep { margin:0 8px; color:#999; }
// // //       .hdr-divider { border:none; border-top:2px solid #000; margin:14px 0 18px; }
// // //       /* Sections */
// // //       .section { margin-bottom:16px; }
// // //       .sec-head { border-bottom:1px solid #000; margin-bottom:8px; padding-bottom:3px; }
// // //       .sec-title { font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:2px; color:#000; font-family:Georgia,"Times New Roman",serif; }
// // //       .summary { font-size:13px; line-height:1.7; color:#222; margin:0; }
// // //       /* Experience */
// // //       .exp-block { margin-bottom:12px; }
// // //       .exp-row { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // //       .exp-left { flex:1; min-width:0; }
// // //       .exp-title { font-weight:700; font-size:13.5px; color:#000; }
// // //       .exp-pipe { color:#999; }
// // //       .exp-company { font-size:13px; color:#333; font-style:italic; }
// // //       .exp-loc { font-size:12px; color:#666; }
// // //       .exp-dates { font-size:12px; color:#444; white-space:nowrap; font-style:italic; padding-left:12px; flex-shrink:0; }
// // //       .edu-block { margin-bottom:8px; }
// // //       .bullets { margin:5px 0 0 20px; padding:0; list-style:disc; }
// // //       .bullets li { font-size:13px; color:#222; margin-bottom:3px; line-height:1.55; }
// // //       /* Skills */
// // //       .skill-row { display:flex; gap:6px; margin-bottom:4px; font-size:13px; line-height:1.5; }
// // //       .skill-cat { font-weight:700; color:#000; white-space:nowrap; }
// // //       .skill-val { color:#333; }
// // //       .cert-text { font-size:13px; color:#333; margin:0; line-height:1.6; }`,

// // //     // ── EXECUTIVE ──
// // //     // Left-aligned, large name, double ruled divider, all-caps sections
// // //     executive: `
// // //       body { font-family: Georgia,"Times New Roman",serif; font-size:13px; line-height:1.6; color:#111; }
// // //       .page { padding:44px 52px 38px; }
// // //       .hdr { margin-bottom:0; }
// // //       .hdr-name { font-size:30px; font-weight:700; color:#000; letter-spacing:.3px; margin-bottom:4px; font-family:Georgia,"Times New Roman",serif; text-transform:uppercase; }
// // //       .hdr-title { font-size:12px; color:#555; text-transform:uppercase; letter-spacing:2px; margin-bottom:12px; font-family:Arial,Helvetica,sans-serif; }
// // //       .hdr-contact { font-size:12px; color:#444; margin-bottom:0; font-family:Arial,Helvetica,sans-serif; }
// // //       .ctc-sep { margin:0 10px; color:#bbb; }
// // //       .hdr-divider { border:none; border-top:3px double #000; margin:14px 0 18px; }
// // //       .section { margin-bottom:16px; }
// // //       .sec-head { border-bottom:1.5px solid #000; margin-bottom:9px; padding-bottom:3px; }
// // //       .sec-title { font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:2px; color:#000; font-family:Arial,Helvetica,sans-serif; }
// // //       .summary { font-size:13px; line-height:1.7; color:#222; margin:0; }
// // //       .exp-block { margin-bottom:12px; }
// // //       .exp-row { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // //       .exp-left { flex:1; min-width:0; }
// // //       .exp-title { font-weight:700; font-size:13px; color:#000; }
// // //       .exp-pipe { color:#bbb; }
// // //       .exp-company { font-size:13px; color:#333; }
// // //       .exp-loc { font-size:12px; color:#777; }
// // //       .exp-dates { font-size:12px; color:#555; white-space:nowrap; font-style:italic; padding-left:12px; flex-shrink:0; font-family:Arial,Helvetica,sans-serif; }
// // //       .edu-block { margin-bottom:8px; }
// // //       .bullets { margin:5px 0 0 20px; padding:0; list-style:disc; }
// // //       .bullets li { font-size:12.5px; color:#222; margin-bottom:3px; line-height:1.55; }
// // //       .skill-row { display:flex; gap:6px; margin-bottom:4px; font-size:12.5px; line-height:1.5; font-family:Arial,Helvetica,sans-serif; }
// // //       .skill-cat { font-weight:700; color:#000; white-space:nowrap; }
// // //       .skill-val { color:#333; }
// // //       .cert-text { font-size:12.5px; color:#333; margin:0; font-family:Arial,Helvetica,sans-serif; }`,

// // //     // ── BOLD ──
// // //     // Strong sans-serif, thick blue accent on section titles only
// // //     bold: `
// // //       body { font-family: Arial,Helvetica,sans-serif; font-size:13px; line-height:1.6; color:#111; }
// // //       .page { padding:42px 50px 36px; }
// // //       .hdr { margin-bottom:0; }
// // //       .hdr-name { font-size:32px; font-weight:900; color:#000; letter-spacing:-.5px; margin-bottom:4px; }
// // //       .hdr-title { font-size:12.5px; color:#374151; font-weight:500; margin-bottom:10px; }
// // //       .hdr-contact { font-size:12px; color:#444; }
// // //       .ctc-sep { margin:0 10px; color:#d1d5db; }
// // //       .hdr-divider { border:none; border-top:3px solid ${ac}; margin:14px 0 18px; }
// // //       .section { margin-bottom:16px; }
// // //       .sec-head { background:#f8fafc; padding:5px 10px; margin-bottom:9px; border-left:3px solid ${ac}; }
// // //       .sec-title { font-size:10.5px; font-weight:800; text-transform:uppercase; letter-spacing:2px; color:${ac}; }
// // //       .summary { font-size:13px; line-height:1.7; color:#333; margin:0; }
// // //       .exp-block { margin-bottom:13px; }
// // //       .exp-row { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // //       .exp-left { flex:1; min-width:0; }
// // //       .exp-title { font-weight:700; font-size:13.5px; color:#0f172a; }
// // //       .exp-pipe { color:#cbd5e1; }
// // //       .exp-company { font-size:13px; color:#374151; font-weight:600; }
// // //       .exp-loc { font-size:12px; color:#9ca3af; }
// // //       .exp-dates { font-size:12px; color:#6b7280; white-space:nowrap; font-style:italic; padding-left:12px; flex-shrink:0; }
// // //       .edu-block { margin-bottom:8px; }
// // //       .bullets { margin:5px 0 0 18px; padding:0; list-style:disc; }
// // //       .bullets li { font-size:12.5px; color:#374151; margin-bottom:3px; line-height:1.55; }
// // //       .skill-row { display:flex; gap:6px; margin-bottom:4px; font-size:12.5px; line-height:1.5; }
// // //       .skill-cat { font-weight:700; color:#0f172a; white-space:nowrap; }
// // //       .skill-val { color:#374151; }
// // //       .cert-text { font-size:12.5px; color:#374151; margin:0; }`,

// // //     // ── MINIMAL CLEAN ──
// // //     // Ultra clean, generous whitespace, green accent dots only
// // //     minimal: `
// // //       body { font-family: Arial,Helvetica,sans-serif; font-size:13.5px; line-height:1.7; color:#111; }
// // //       .page { padding:48px 56px 42px; }
// // //       .hdr { margin-bottom:0; }
// // //       .hdr-name { font-size:30px; font-weight:600; color:#111; letter-spacing:-.3px; margin-bottom:4px; }
// // //       .hdr-title { font-size:13.5px; color:${ac}; font-weight:500; margin-bottom:12px; }
// // //       .hdr-contact { font-size:12px; color:#555; }
// // //       .ctc-sep { margin:0 10px; color:#d1d5db; }
// // //       .hdr-divider { border:none; border-top:1px solid #e5e7eb; margin:16px 0 20px; }
// // //       .section { margin-bottom:18px; }
// // //       .sec-head { margin-bottom:8px; }
// // //       .sec-title { font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:3px; color:${ac}; }
// // //       .summary { font-size:13px; line-height:1.75; color:#374151; margin:0; }
// // //       .exp-block { margin-bottom:14px; }
// // //       .exp-row { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // //       .exp-left { flex:1; min-width:0; }
// // //       .exp-title { font-weight:600; font-size:13.5px; color:#111; }
// // //       .exp-pipe { color:#e5e7eb; margin:0 4px; }
// // //       .exp-company { font-size:13px; color:#374151; }
// // //       .exp-loc { font-size:12px; color:#9ca3af; }
// // //       .exp-dates { font-size:12px; color:#6b7280; white-space:nowrap; padding-left:12px; flex-shrink:0; }
// // //       .edu-block { margin-bottom:8px; }
// // //       .bullets { margin:5px 0 0 0; padding:0; list-style:none; }
// // //       .bullets li { font-size:13px; color:#374151; margin-bottom:4px; line-height:1.6; padding-left:16px; position:relative; }
// // //       .bullets li::before { content:"–"; position:absolute; left:0; color:${ac}; font-weight:600; }
// // //       .skill-row { display:flex; gap:6px; margin-bottom:5px; font-size:13px; line-height:1.5; }
// // //       .skill-cat { font-weight:600; color:#111; white-space:nowrap; }
// // //       .skill-val { color:#374151; }
// // //       .cert-text { font-size:13px; color:#374151; margin:0; }`,

// // //     // ── PROFESSIONAL ──
// // //     // Clean left-aligned, bold name, underline sections
// // //     professional: `
// // //       body { font-family: Arial,Helvetica,sans-serif; font-size:13px; line-height:1.6; color:#111; }
// // //       .page { padding:42px 52px 38px; }
// // //       .hdr { margin-bottom:0; }
// // //       .hdr-name { font-size:28px; font-weight:700; color:#000; margin-bottom:4px; }
// // //       .hdr-title { font-size:12.5px; color:#374151; font-weight:500; text-transform:uppercase; letter-spacing:1px; margin-bottom:10px; }
// // //       .hdr-contact { font-size:12px; color:#444; }
// // //       .ctc-sep { margin:0 10px; color:#d1d5db; }
// // //       .hdr-divider { border:none; border-top:2px solid #000; margin:14px 0 18px; }
// // //       .section { margin-bottom:16px; }
// // //       .sec-head { border-bottom:1px solid #000; margin-bottom:8px; padding-bottom:3px; }
// // //       .sec-title { font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:1.5px; color:#000; }
// // //       .summary { font-size:13px; line-height:1.7; color:#222; margin:0; }
// // //       .exp-block { margin-bottom:12px; }
// // //       .exp-row { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2px; margin-bottom:3px; }
// // //       .exp-left { flex:1; min-width:0; }
// // //       .exp-title { font-weight:700; font-size:13px; color:#000; }
// // //       .exp-pipe { color:#bbb; }
// // //       .exp-company { font-size:13px; color:#333; font-weight:600; }
// // //       .exp-loc { font-size:12px; color:#777; }
// // //       .exp-dates { font-size:12px; color:#555; white-space:nowrap; font-style:italic; padding-left:12px; flex-shrink:0; }
// // //       .edu-block { margin-bottom:8px; }
// // //       .bullets { margin:5px 0 0 20px; padding:0; list-style:disc; }
// // //       .bullets li { font-size:12.5px; color:#222; margin-bottom:3px; line-height:1.55; }
// // //       .skill-row { display:flex; gap:6px; margin-bottom:4px; font-size:12.5px; line-height:1.5; }
// // //       .skill-cat { font-weight:700; color:#000; white-space:nowrap; }
// // //       .skill-val { color:#333; }
// // //       .cert-text { font-size:12.5px; color:#333; margin:0; }`,
// // //   };

// // //   const css = STYLES[templateId] || STYLES.classic;

// // //   // ── Contact line ──
// // //   const ctcLine = ctcs.map((c,i) =>
// // //     i===0 ? c : `<span class="ctc-sep">|</span>${c}`
// // //   ).join("");

// // //   // ── All templates: white page, clean header ──
// // //   const headerHTML = `
// // //     <div class="hdr">
// // //       <div class="hdr-name">${nm}</div>
// // //       ${ttl?`<div class="hdr-title">${ttl}</div>`:""}
// // //       <div class="hdr-contact">${ctcLine}</div>
// // //     </div>
// // //     <hr class="hdr-divider">`;

// // //   // ── Print hint ──
// // //   const hintHTML = (showHint||forPrint) ? `
// // //     <div style="background:#1d4ed8;color:#fff;padding:11px 18px;text-align:center;
// // //       font-size:13px;font-family:Arial,sans-serif;line-height:1.8;" class="no-print">
// // //       📄 <strong>Ctrl+P</strong> → Destination = <strong>Save as PDF</strong>
// // //       → Margins = <strong>None</strong> → ✅ <strong>Background graphics ON</strong> → Save
// // //     </div>` : "";

// // //   return `<!DOCTYPE html>
// // // <html lang="en">
// // // <head>
// // //   <meta charset="UTF-8">
// // //   <title>${nm} — Resume</title>
// // //   <style>
// // //     *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
// // //     body { background:#f0f0f0; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// // //     .page { max-width:794px; width:794px; margin:0 auto; background:#fff; }
// // //     .page * { max-width:100%; }
// // //     ul.bullets { overflow:hidden; }
// // //     li { word-break:break-word; }
// // //     ${css}
// // //     @media print {
// // //       body { background:#fff; margin:0; padding:0; }
// // //       .no-print { display:none !important; }
// // //       .page { box-shadow:none; width:100%; max-width:100%; }
// // //       @page { size:A4; margin:0; }
// // //     }
// // //   </style>
// // // </head>
// // // <body>
// // //   ${hintHTML}
// // //   <div class="page">
// // //     ${headerHTML}
// // //     ${sections}
// // //   </div>
// // // </body>
// // // </html>`;
// // // }

// // // // ─────────────────────────────────────────────
// // // // HELPERS
// // // // ─────────────────────────────────────────────
// // // function dl(blob, name) {
// // //   const url = URL.createObjectURL(blob);
// // //   const a   = Object.assign(document.createElement("a"),{href:url,download:name});
// // //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // //   setTimeout(()=>URL.revokeObjectURL(url),2000);
// // // }

// // // // ─────────────────────────────────────────────
// // // // PDF — server-side Puppeteer (silent .pdf)
// // // // Falls back to new-tab print if unavailable
// // // // ─────────────────────────────────────────────
// // // export async function downloadResumeAsPDF(resume, fileName, templateId) {
// // //   const name    = (fileName||"resume").replace(/\.(pdf|html?)$/i,"");
// // //   const html    = buildResumeHTML(resume, templateId, { forPrint:false });
// // //   const BACKEND = window.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";

// // //   try {
// // //     const res = await fetch(`${BACKEND}/generate-pdf`, {
// // //       method:  "POST",
// // //       headers: { "Content-Type":"application/json" },
// // //       body:    JSON.stringify({ html }),
// // //     });
// // //     if (!res.ok) throw new Error(`Server error ${res.status}`);
// // //     const blob = await res.blob();
// // //     const url  = URL.createObjectURL(blob);
// // //     const a    = Object.assign(document.createElement("a"),{href:url,download:`${name}.pdf`});
// // //     document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // //     setTimeout(()=>URL.revokeObjectURL(url),2000);
// // //   } catch(err) {
// // //     console.warn("Server PDF unavailable, opening print tab:", err.message);
// // //     const win = window.open("","_blank");
// // //     if (!win) {
// // //       dl(new Blob([buildResumeHTML(resume,templateId,{showHint:true})],
// // //         {type:"text/html;charset=utf-8"}),`${name}.html`);
// // //       alert("Popup blocked — HTML downloaded. Open in Chrome → Ctrl+P → Save as PDF.");
// // //       return;
// // //     }
// // //     win.document.open();
// // //     win.document.write(buildResumeHTML(resume, templateId, {forPrint:true}));
// // //     win.document.close();
// // //     win.focus();
// // //     setTimeout(()=>{ try{win.print();}catch(e){} }, 800);
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // WORD — server-side docx (proper .docx)
// // // // Falls back to HTML .doc if unavailable
// // // // ─────────────────────────────────────────────
// // // export async function downloadResumeAsWord(resume, fileName, templateId) {
// // //   const name    = (fileName||"resume").replace(/\.(doc|docx|html?)$/i,"");
// // //   const BACKEND = window.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";

// // //   try {
// // //     const res = await fetch(`${BACKEND}/generate-word`, {
// // //       method:  "POST",
// // //       headers: { "Content-Type":"application/json" },
// // //       body:    JSON.stringify({ resume, templateId }),
// // //     });
// // //     if (!res.ok) throw new Error(`Server error ${res.status}`);
// // //     const blob = await res.blob();
// // //     const url  = URL.createObjectURL(blob);
// // //     const a    = Object.assign(document.createElement("a"),{href:url,download:`${name}.docx`});
// // //     document.body.appendChild(a); a.click(); document.body.removeChild(a);
// // //     setTimeout(()=>URL.revokeObjectURL(url),2000);
// // //   } catch(err) {
// // //     console.warn("Server Word unavailable, falling back:", err.message);
// // //     dl(new Blob(["\ufeff", buildResumeHTML(resume,templateId,{})],
// // //       {type:"text/plain;charset=utf-8"}),`${name}.doc`);
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // HTML — full styled file
// // // // ─────────────────────────────────────────────
// // // export function downloadATSResume(resume, fileName, templateId) {
// // //   dl(new Blob([buildResumeHTML(resume,templateId,{showHint:true})],
// // //     {type:"text/html;charset=utf-8"}),
// // //     (fileName||"resume").replace(/\.html?$/i,"")+".html");
// // // }

// // //Todays' New code
// // // generateResumeDoc.js — Professional ATS Resume Templates
// // // Designed to match Harvard/Columbia career office standards
// // // Clean, readable, professional — optimized for human AND ATS screening

// // const TEMPLATES = {
// //   classic:      { name:"Classic ATS",    accent:"#2563eb", header:"#1e293b" },
// //   executive:    { name:"Executive",      accent:"#1e293b", header:"#0f172a" },
// //   bold:         { name:"Bold Impact",    accent:"#1d4ed8", header:"#1e3a8a" },
// //   minimal:      { name:"Minimal Clean",  accent:"#047857", header:"#047857" },
// //   professional: { name:"Professional",   accent:"#0f172a", header:"#1e3a5f" },
// // };

// // function getT(id) { return TEMPLATES[id] || TEMPLATES.classic; }

// // function esc(s) {
// //   if (!s) return "";
// //   return String(s)
// //     .replace(/&/g,"&amp;").replace(/</g,"&lt;")
// //     .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// // }
// // function fmt(s, e) {
// //   if (!s && !e) return "";
// //   if (s && !e)  return esc(s);
// //   if (!s && e)  return esc(e);
// //   return `${esc(s)} &ndash; ${esc(e)}`;
// // }

// // // ─────────────────────────────────────────────────────────────
// // // CONTENT BUILDERS — shared across all templates
// // // ─────────────────────────────────────────────────────────────
// // function buildContent(resume, templateId) {
// //   const ac = getT(templateId).accent;

// //   const expHtml = (resume.experience||[]).map(exp => {
// //     const bullets = (exp.bullets||[]).map(b =>
// //       `<li>${esc(b)}</li>`
// //     ).join("");
// //     const dates = fmt(exp.startDate, exp.endDate);
// //     return `
// //     <div class="exp-block">
// //       <div class="exp-header">
// //         <div class="exp-meta">
// //           <span class="job-title">${esc(exp.title||"")}</span>
// //           <span class="company-sep"> &bull; </span>
// //           <span class="company">${esc(exp.company||"")}</span>
// //           ${exp.location ? `<span class="loc">, ${esc(exp.location)}</span>` : ""}
// //         </div>
// //         ${dates ? `<span class="dates">${dates}</span>` : ""}
// //       </div>
// //       ${bullets ? `<ul class="bullets">${bullets}</ul>` : ""}
// //     </div>`;
// //   }).join("");

// //   const eduHtml = (resume.education||[]).map(edu => `
// //     <div class="edu-block">
// //       <div class="exp-header">
// //         <div class="exp-meta">
// //           <span class="job-title">${esc(edu.degree||"")}</span>
// //           <span class="company-sep"> &bull; </span>
// //           <span class="company">${esc(edu.school||"")}</span>
// //           ${edu.location ? `<span class="loc">, ${esc(edu.location)}</span>` : ""}
// //         </div>
// //         ${edu.year ? `<span class="dates">${esc(edu.year)}${edu.gpa?` &nbsp;&bull;&nbsp; GPA: ${esc(edu.gpa)}`:""}</span>` : ""}
// //       </div>
// //     </div>`
// //   ).join("");

// //   const sk = resume.skills||{};
// //   const skillRows = [
// //     sk.technical?.length ? `<div class="skill-row"><span class="skill-label">Technical</span><span class="skill-items">${sk.technical.map(esc).join(", ")}</span></div>` : "",
// //     sk.tools?.length     ? `<div class="skill-row"><span class="skill-label">Tools &amp; Platforms</span><span class="skill-items">${sk.tools.map(esc).join(", ")}</span></div>` : "",
// //     sk.soft?.length      ? `<div class="skill-row"><span class="skill-label">Competencies</span><span class="skill-items">${sk.soft.map(esc).join(", ")}</span></div>` : "",
// //   ].join("");

// //   const certHtml = (resume.certifications||[]).length
// //     ? `<div class="cert-row">${resume.certifications.map(esc).join("&nbsp;&nbsp;|&nbsp;&nbsp;")}</div>` : "";

// //   return { expHtml, eduHtml, skillRows, certHtml };
// // }

// // function buildSections(content, resume) {
// //   const { expHtml, eduHtml, skillRows, certHtml } = content;
// //   const parts = [];
// //   if (resume.summary)    parts.push({ title:"Professional Summary", body:`<p class="summary">${esc(resume.summary)}</p>` });
// //   if (expHtml)           parts.push({ title:"Work Experience",       body:expHtml });
// //   if (eduHtml)           parts.push({ title:"Education",             body:eduHtml });
// //   if (skillRows)         parts.push({ title:"Skills",               body:skillRows });
// //   if (certHtml)          parts.push({ title:"Certifications",       body:certHtml });
// //   return parts;
// // }

// // // ─────────────────────────────────────────────────────────────
// // // EXPORT — main HTML builder
// // // ─────────────────────────────────────────────────────────────
// // export function buildResumeHTML(resume, templateId, opts = {}) {
// //   const { showHint = false, forPrint = false } = opts;
// //   const t  = getT(templateId);
// //   const ac = t.accent;
// //   const nm   = esc(resume.name  || "Your Name");
// //   const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
// //   const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean).map(esc);

// //   const content  = buildContent(resume, templateId);
// //   const sections = buildSections(content, resume);

// //   // ── Section renderer — style varies by template ──
// //   function renderSections(sections, sectionClass = "section") {
// //     return sections.map(s => `
// //       <div class="${sectionClass}">
// //         <div class="sec-head"><span class="sec-title">${s.title}</span></div>
// //         <div class="sec-body">${s.body}</div>
// //       </div>`
// //     ).join("");
// //   }

// //   // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// //   // TEMPLATE DEFINITIONS
// //   // Each template: unique typography, spacing, section style
// //   // ALL: white background, no colored bars, ATS-safe
// //   // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

// //   let pageCSS = "", headerHTML = "", bodyHTML = "";

// //   // ══════════════════════════════════════════════════════
// //   // CLASSIC ATS — Harvard style
// //   // Centered header • Garamond serif • Ruled sections
// //   // ══════════════════════════════════════════════════════
// //   if (templateId === "classic") {
// //     pageCSS = `
// //       body { font-family: Garamond,"Book Antiqua","Times New Roman",serif; font-size:11pt; line-height:1.5; color:#1a1a1a; }
// //       .page { padding:0.7in 0.75in; }
// //       /* Header */
// //       .hdr { text-align:center; margin-bottom:6pt; }
// //       .nm  { font-size:22pt; font-weight:700; letter-spacing:0.5pt; color:#000; margin-bottom:4pt; line-height:1.2; }
// //       .ttl { font-size:11pt; color:#444; font-style:italic; margin-bottom:6pt; }
// //       .ctc { font-size:9.5pt; color:#333; }
// //       .ctc-sep { margin:0 6pt; color:#aaa; }
// //       .rule { border:none; border-top:1.5pt solid #000; margin:8pt 0 10pt; }
// //       /* Sections */
// //       .section { margin-bottom:10pt; }
// //       .sec-head { border-bottom:0.75pt solid #000; margin-bottom:6pt; padding-bottom:2pt; }
// //       .sec-title { font-size:10pt; font-weight:700; text-transform:uppercase; letter-spacing:1.2pt; color:#000; }
// //       /* Content */
// //       .summary { font-size:10.5pt; line-height:1.55; color:#222; margin:0; }
// //       .exp-block { margin-bottom:8pt; }
// //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2pt; }
// //       .exp-meta { flex:1; }
// //       .job-title  { font-weight:700; font-size:10.5pt; color:#000; }
// //       .company-sep { color:#999; font-size:10pt; }
// //       .company { font-size:10.5pt; color:#333; font-style:italic; }
// //       .loc  { font-size:9.5pt; color:#666; }
// //       .dates { font-size:9.5pt; color:#444; font-style:italic; white-space:nowrap; padding-left:8pt; flex-shrink:0; }
// //       .edu-block { margin-bottom:5pt; }
// //       .bullets { margin:4pt 0 0 14pt; padding:0; list-style:disc; }
// //       .bullets li { font-size:10pt; color:#222; margin-bottom:2.5pt; line-height:1.45; }
// //       .skill-row { display:flex; gap:6pt; margin-bottom:3.5pt; font-size:10pt; }
// //       .skill-label { font-weight:700; color:#000; min-width:110pt; flex-shrink:0; }
// //       .skill-items { color:#333; line-height:1.5; }
// //       .cert-row { font-size:10pt; color:#333; line-height:1.6; }`;

// //     const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
// //     headerHTML = `
// //       <div class="hdr">
// //         <div class="nm">${nm}</div>
// //         ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
// //         <div class="ctc">${ctcLine}</div>
// //       </div>
// //       <hr class="rule">`;
// //     bodyHTML = renderSections(sections);
// //   }

// //   // ══════════════════════════════════════════════════════
// //   // EXECUTIVE — Conservative elegance
// //   // Left-aligned • Baskerville serif • Double-rule divider
// //   // Name prominent but not oversized
// //   // ══════════════════════════════════════════════════════
// //   else if (templateId === "executive") {
// //     pageCSS = `
// //       body { font-family: "Palatino Linotype","Palatino","Book Antiqua",Georgia,serif; font-size:11pt; line-height:1.5; color:#1a1a1a; }
// //       .page { padding:0.7in 0.75in; }
// //       .hdr { margin-bottom:0; }
// //       .nm  { font-size:20pt; font-weight:700; color:#000; letter-spacing:0.3pt; margin-bottom:3pt; }
// //       .ttl { font-size:10.5pt; color:#333; text-transform:uppercase; letter-spacing:1.5pt; margin-bottom:8pt; font-family:Arial,Helvetica,sans-serif; }
// //       .ctc { font-size:9.5pt; color:#444; margin-bottom:0; font-family:Arial,Helvetica,sans-serif; }
// //       .ctc-sep { margin:0 8pt; color:#bbb; }
// //       .rule { border:none; border-top:2pt double #1e293b; margin:10pt 0 12pt; }
// //       .section { margin-bottom:10pt; }
// //       .sec-head { border-bottom:0.75pt solid #1e293b; margin-bottom:6pt; padding-bottom:2pt; }
// //       .sec-title { font-size:9.5pt; font-weight:700; text-transform:uppercase; letter-spacing:1.5pt; color:#1e293b; font-family:Arial,Helvetica,sans-serif; }
// //       .summary { font-size:10.5pt; line-height:1.6; color:#222; margin:0; }
// //       .exp-block { margin-bottom:8pt; }
// //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2pt; }
// //       .exp-meta { flex:1; }
// //       .job-title  { font-weight:700; font-size:10.5pt; color:#000; }
// //       .company-sep { color:#bbb; }
// //       .company { font-size:10.5pt; color:#333; }
// //       .loc  { font-size:9.5pt; color:#777; }
// //       .dates { font-size:9.5pt; color:#555; font-style:italic; white-space:nowrap; padding-left:8pt; flex-shrink:0; font-family:Arial,Helvetica,sans-serif; }
// //       .edu-block { margin-bottom:5pt; }
// //       .bullets { margin:4pt 0 0 14pt; padding:0; list-style:disc; }
// //       .bullets li { font-size:10pt; color:#222; margin-bottom:2.5pt; line-height:1.45; }
// //       .skill-row { display:flex; gap:6pt; margin-bottom:3.5pt; font-size:10pt; font-family:Arial,Helvetica,sans-serif; }
// //       .skill-label { font-weight:700; color:#1e293b; min-width:110pt; flex-shrink:0; }
// //       .skill-items { color:#333; line-height:1.5; }
// //       .cert-row { font-size:10pt; color:#333; font-family:Arial,Helvetica,sans-serif; }`;

// //     const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
// //     headerHTML = `
// //       <div class="hdr">
// //         <div class="nm">${nm}</div>
// //         ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
// //         <div class="ctc">${ctcLine}</div>
// //       </div>
// //       <hr class="rule">`;
// //     bodyHTML = renderSections(sections);
// //   }

// //   // ══════════════════════════════════════════════════════
// //   // BOLD IMPACT — Modern & confident
// //   // Strong sans-serif • Blue accent rule • Clean layout
// //   // ══════════════════════════════════════════════════════
// //   else if (templateId === "bold") {
// //     pageCSS = `
// //       body { font-family: "Trebuchet MS",Arial,Helvetica,sans-serif; font-size:10.5pt; line-height:1.5; color:#1a1a1a; }
// //       .page { padding:0.65in 0.75in; }
// //       .hdr { margin-bottom:0; border-bottom:2.5pt solid ${ac}; padding-bottom:10pt; }
// //       .nm  { font-size:22pt; font-weight:700; color:#0f172a; letter-spacing:-0.3pt; margin-bottom:3pt; }
// //       .ttl { font-size:11pt; color:#374151; font-weight:600; margin-bottom:7pt; }
// //       .ctc { font-size:9.5pt; color:#555; }
// //       .ctc-sep { margin:0 8pt; color:#cbd5e1; }
// //       .rule { display:none; }
// //       .spacer { margin-bottom:12pt; }
// //       .section { margin-bottom:10pt; }
// //       .sec-head { margin-bottom:6pt; padding-bottom:3pt; border-bottom:1.5pt solid ${ac}; }
// //       .sec-title { font-size:9pt; font-weight:800; text-transform:uppercase; letter-spacing:2pt; color:${ac}; }
// //       .summary { font-size:10.5pt; line-height:1.6; color:#333; margin:0; }
// //       .exp-block { margin-bottom:9pt; }
// //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2pt; }
// //       .exp-meta { flex:1; }
// //       .job-title  { font-weight:700; font-size:11pt; color:#0f172a; }
// //       .company-sep { color:#cbd5e1; }
// //       .company { font-size:10.5pt; color:#374151; font-weight:600; }
// //       .loc  { font-size:9.5pt; color:#94a3b8; }
// //       .dates { font-size:9.5pt; color:#64748b; font-style:italic; white-space:nowrap; padding-left:8pt; flex-shrink:0; }
// //       .edu-block { margin-bottom:5pt; }
// //       .bullets { margin:4pt 0 0 14pt; padding:0; list-style:disc; }
// //       .bullets li { font-size:10pt; color:#374151; margin-bottom:3pt; line-height:1.5; }
// //       .bullets li::marker { color:${ac}; }
// //       .skill-row { display:flex; gap:6pt; margin-bottom:4pt; font-size:10pt; }
// //       .skill-label { font-weight:700; color:#0f172a; min-width:110pt; flex-shrink:0; }
// //       .skill-items { color:#374151; line-height:1.5; }
// //       .cert-row { font-size:10pt; color:#374151; }`;

// //     const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
// //     headerHTML = `
// //       <div class="hdr">
// //         <div class="nm">${nm}</div>
// //         ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
// //         <div class="ctc">${ctcLine}</div>
// //       </div>
// //       <div class="spacer"></div>`;
// //     bodyHTML = renderSections(sections);
// //   }

// //   // ══════════════════════════════════════════════════════
// //   // MINIMAL CLEAN — Modern minimalist
// //   // Light weight • Generous spacing • Green accents only
// //   // Looks great for tech, product, design roles
// //   // ══════════════════════════════════════════════════════
// //   else if (templateId === "minimal") {
// //     pageCSS = `
// //       body { font-family: "Gill Sans","Gill Sans MT",Calibri,Arial,sans-serif; font-size:10.5pt; line-height:1.6; color:#1a1a1a; }
// //       .page { padding:0.7in 0.8in; }
// //       .hdr { margin-bottom:0; padding-bottom:10pt; border-bottom:1pt solid #e5e7eb; }
// //       .nm  { font-size:21pt; font-weight:600; color:#111; letter-spacing:-0.2pt; margin-bottom:3pt; }
// //       .ttl { font-size:11pt; color:${ac}; font-weight:500; margin-bottom:8pt; }
// //       .ctc { font-size:9.5pt; color:#555; }
// //       .ctc-sep { margin:0 8pt; color:#d1d5db; }
// //       .rule { display:none; }
// //       .spacer { margin-bottom:12pt; }
// //       .section { margin-bottom:11pt; }
// //       .sec-head { margin-bottom:6pt; }
// //       .sec-title { font-size:8.5pt; font-weight:700; text-transform:uppercase; letter-spacing:2.5pt; color:${ac}; }
// //       .summary { font-size:10.5pt; line-height:1.65; color:#374151; margin:0; }
// //       .exp-block { margin-bottom:9pt; }
// //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2pt; }
// //       .exp-meta { flex:1; }
// //       .job-title  { font-weight:600; font-size:11pt; color:#111; }
// //       .company-sep { color:#e5e7eb; margin:0 4pt; }
// //       .company { font-size:10.5pt; color:#374151; }
// //       .loc  { font-size:9.5pt; color:#9ca3af; }
// //       .dates { font-size:9.5pt; color:#6b7280; white-space:nowrap; padding-left:8pt; flex-shrink:0; }
// //       .edu-block { margin-bottom:5pt; }
// //       .bullets { margin:4pt 0 0 0; padding:0; list-style:none; }
// //       .bullets li { font-size:10pt; color:#374151; margin-bottom:3pt; line-height:1.55; padding-left:12pt; position:relative; }
// //       .bullets li::before { content:"–"; position:absolute; left:0; color:${ac}; font-weight:600; }
// //       .skill-row { display:flex; gap:6pt; margin-bottom:4pt; font-size:10pt; }
// //       .skill-label { font-weight:600; color:#111; min-width:110pt; flex-shrink:0; }
// //       .skill-items { color:#374151; line-height:1.5; }
// //       .cert-row { font-size:10pt; color:#374151; }`;

// //     const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
// //     headerHTML = `
// //       <div class="hdr">
// //         <div class="nm">${nm}</div>
// //         ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
// //         <div class="ctc">${ctcLine}</div>
// //       </div>
// //       <div class="spacer"></div>`;
// //     bodyHTML = renderSections(sections);
// //   }

// //   // ══════════════════════════════════════════════════════
// //   // PROFESSIONAL — Corporate clean
// //   // Arial • Bold name • Underline sections • Timeless
// //   // Best for finance, banking, consulting, corporate
// //   // ══════════════════════════════════════════════════════
// //   else {  // professional
// //     pageCSS = `
// //       body { font-family: Arial,Helvetica,sans-serif; font-size:10.5pt; line-height:1.5; color:#1a1a1a; }
// //       .page { padding:0.65in 0.75in; }
// //       .hdr { margin-bottom:0; }
// //       .nm  { font-size:20pt; font-weight:700; color:#000; margin-bottom:3pt; }
// //       .ttl { font-size:10.5pt; color:#374151; margin-bottom:7pt; text-transform:uppercase; letter-spacing:0.8pt; font-size:10pt; }
// //       .ctc { font-size:9.5pt; color:#444; }
// //       .ctc-sep { margin:0 7pt; color:#d1d5db; }
// //       .rule { border:none; border-top:2pt solid #000; margin:9pt 0 11pt; }
// //       .section { margin-bottom:10pt; }
// //       .sec-head { border-bottom:1pt solid #000; margin-bottom:6pt; padding-bottom:2pt; }
// //       .sec-title { font-size:9.5pt; font-weight:700; text-transform:uppercase; letter-spacing:1pt; color:#000; }
// //       .summary { font-size:10.5pt; line-height:1.6; color:#222; margin:0; }
// //       .exp-block { margin-bottom:8pt; }
// //       .exp-header { display:flex; justify-content:space-between; align-items:baseline; flex-wrap:wrap; gap:2pt; }
// //       .exp-meta { flex:1; }
// //       .job-title  { font-weight:700; font-size:10.5pt; color:#000; }
// //       .company-sep { color:#bbb; }
// //       .company { font-size:10.5pt; color:#333; }
// //       .loc  { font-size:9.5pt; color:#777; }
// //       .dates { font-size:9.5pt; color:#555; font-style:italic; white-space:nowrap; padding-left:8pt; flex-shrink:0; }
// //       .edu-block { margin-bottom:5pt; }
// //       .bullets { margin:4pt 0 0 14pt; padding:0; list-style:disc; }
// //       .bullets li { font-size:10pt; color:#222; margin-bottom:2.5pt; line-height:1.45; }
// //       .skill-row { display:flex; gap:6pt; margin-bottom:3.5pt; font-size:10pt; }
// //       .skill-label { font-weight:700; color:#000; min-width:110pt; flex-shrink:0; }
// //       .skill-items { color:#333; line-height:1.5; }
// //       .cert-row { font-size:10pt; color:#333; }`;

// //     const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
// //     headerHTML = `
// //       <div class="hdr">
// //         <div class="nm">${nm}</div>
// //         ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
// //         <div class="ctc">${ctcLine}</div>
// //       </div>
// //       <hr class="rule">`;
// //     bodyHTML = renderSections(sections);
// //   }

// //   const hint = (showHint||forPrint) ? `
// //     <div style="background:#1d4ed8;color:#fff;padding:10px 18px;text-align:center;
// //       font-size:12px;font-family:Arial,sans-serif;line-height:1.8;" class="no-print">
// //       📄 Ctrl+P → <strong>Save as PDF</strong> → Margins: <strong>None</strong> → ✅ <strong>Background graphics</strong> → Save
// //     </div>` : "";

// //   return `<!DOCTYPE html>
// // <html lang="en">
// // <head>
// //   <meta charset="UTF-8">
// //   <title>${nm} — Resume</title>
// //   <style>
// //     *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
// //     body { background:#e8e8e8; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
// //     .page { max-width:794px; width:794px; margin:0 auto; background:#fff; }
// //     .page * { max-width:100%; }
// //     ul.bullets { overflow:hidden; }
// //     li { word-break:break-word; }
// //     ${pageCSS}
// //     @media print {
// //       body { background:#fff; margin:0; padding:0; }
// //       .no-print { display:none !important; }
// //       .page { box-shadow:none; width:100%; max-width:100%; }
// //       @page { size:A4; margin:0; }
// //     }
// //   </style>
// // </head>
// // <body>
// //   ${hint}
// //   <div class="page">
// //     ${headerHTML}
// //     ${bodyHTML}
// //   </div>
// // </body>
// // </html>`;
// // }

// // // ─────────────────────────────────────────────
// // function dl(blob, name) {
// //   const url = URL.createObjectURL(blob);
// //   const a   = Object.assign(document.createElement("a"),{href:url,download:name});
// //   document.body.appendChild(a); a.click(); document.body.removeChild(a);
// //   setTimeout(()=>URL.revokeObjectURL(url),2000);
// // }

// // export async function downloadResumeAsPDF(resume, fileName, templateId) {
// //   const name    = (fileName||"resume").replace(/\.(pdf|html?)$/i,"");
// //   const html    = buildResumeHTML(resume, templateId, { forPrint:false });
// //   const BACKEND = window.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";
// //   try {
// //     const res = await fetch(`${BACKEND}/generate-pdf`, {
// //       method:"POST", headers:{"Content-Type":"application/json"},
// //       body: JSON.stringify({ html }),
// //     });
// //     if (!res.ok) throw new Error(`${res.status}`);
// //     const blob = await res.blob();
// //     dl(blob, `${name}.pdf`);
// //   } catch(err) {
// //     console.warn("Server PDF unavailable:", err.message);
// //     const win = window.open("","_blank");
// //     if (!win) { dl(new Blob([buildResumeHTML(resume,templateId,{showHint:true})],{type:"text/html;charset=utf-8"}),`${name}.html`); return; }
// //     win.document.open(); win.document.write(buildResumeHTML(resume,templateId,{forPrint:true})); win.document.close();
// //     win.focus(); setTimeout(()=>{ try{win.print();}catch(e){} },800);
// //   }
// // }

// // export async function downloadResumeAsWord(resume, fileName, templateId) {
// //   const name    = (fileName||"resume").replace(/\.(doc|docx|html?)$/i,"");
// //   const BACKEND = window.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";
// //   try {
// //     const res = await fetch(`${BACKEND}/generate-word`, {
// //       method:"POST", headers:{"Content-Type":"application/json"},
// //       body: JSON.stringify({ resume, templateId }),
// //     });
// //     if (!res.ok) throw new Error(`${res.status}`);
// //     const blob = await res.blob();
// //     const url  = URL.createObjectURL(blob);
// //     const a    = Object.assign(document.createElement("a"),{href:url,download:`${name}.docx`});
// //     document.body.appendChild(a); a.click(); document.body.removeChild(a);
// //     setTimeout(()=>URL.revokeObjectURL(url),2000);
// //   } catch(err) {
// //     console.warn("Server Word unavailable:", err.message);
// //     dl(new Blob(["\ufeff",buildResumeHTML(resume,templateId,{})],{type:"text/plain;charset=utf-8"}),`${name}.doc`);
// //   }
// // }

// // export function downloadATSResume(resume, fileName, templateId) {
// //   dl(new Blob([buildResumeHTML(resume,templateId,{showHint:true})],{type:"text/html;charset=utf-8"}),
// //     (fileName||"resume").replace(/\.html?$/i,"")+".html");
// // }

// const TEMPLATES = {
//   classic:      { name:"Classic ATS",    accent:"#2563eb", header:"#1e293b" },
//   executive:    { name:"Executive",      accent:"#1e293b", header:"#0f172a" },
//   bold:         { name:"Bold Impact",    accent:"#1d4ed8", header:"#1e3a8a" },
//   minimal:      { name:"Minimal Clean",  accent:"#047857", header:"#047857" },
//   professional: { name:"Professional",   accent:"#0f172a", header:"#1e3a5f" },
// };

// function getT(id) { return TEMPLATES[id] || TEMPLATES.classic; }

// function esc(s) {
//   if (!s) return "";
//   return String(s)
//     .replace(/&/g,"&amp;").replace(/</g,"&lt;")
//     .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// }
// function fmt(s, e) {
//   if (!s && !e) return "";
//   if (s && !e)  return esc(s);
//   if (!s && e)  return esc(e);
//   return `${esc(s)} &ndash; ${esc(e)}`;
// }

// // ─────────────────────────────────────────────────────────────
// // CONTENT BUILDERS — shared across all templates
// // ─────────────────────────────────────────────────────────────
// function buildContent(resume, templateId) {
//   const ac = getT(templateId).accent;

//   const expHtml = (resume.experience||[]).map(exp => {
//     const bullets = (exp.bullets||[]).map(b =>
//       `<li>${esc(b)}</li>`
//     ).join("");
//     const dates = fmt(exp.startDate, exp.endDate);
//     return `
//     <div class="exp-block">
//       <div class="exp-header">
//         <div class="exp-meta">
//           <span class="job-title">${esc(exp.title||"")}</span>
//           <span class="company-sep"> &bull; </span>
//           <span class="company">${esc(exp.company||"")}</span>
//           ${exp.location ? `<span class="loc">, ${esc(exp.location)}</span>` : ""}
//         </div>
//         ${dates ? `<span class="dates">${dates}</span>` : ""}
//       </div>
//       ${bullets ? `<ul class="bullets">${bullets}</ul>` : ""}
//     </div>`;
//   }).join("");

//   const eduHtml = (resume.education||[]).map(edu => `
//     <div class="edu-block">
//       <div class="exp-header">
//         <div class="exp-meta">
//           <span class="job-title">${esc(edu.degree||"")}</span>
//           <span class="company-sep"> &bull; </span>
//           <span class="company">${esc(edu.school||"")}</span>
//           ${edu.location ? `<span class="loc">, ${esc(edu.location)}</span>` : ""}
//         </div>
//         ${edu.year ? `<span class="dates">${esc(edu.year)}${edu.gpa?` &nbsp;&bull;&nbsp; GPA: ${esc(edu.gpa)}`:""}</span>` : ""}
//       </div>
//     </div>`
//   ).join("");

//   const sk = resume.skills||{};
//   const skillRows = [
//     sk.technical?.length ? `<div class="skill-row"><span class="skill-label">Technical</span><span class="skill-items">${sk.technical.map(esc).join(", ")}</span></div>` : "",
//     sk.tools?.length     ? `<div class="skill-row"><span class="skill-label">Tools &amp; Platforms</span><span class="skill-items">${sk.tools.map(esc).join(", ")}</span></div>` : "",
//     sk.soft?.length      ? `<div class="skill-row"><span class="skill-label">Competencies</span><span class="skill-items">${sk.soft.map(esc).join(", ")}</span></div>` : "",
//   ].join("");

//   const certHtml = (resume.certifications||[]).length
//     ? `<div class="cert-row">${resume.certifications.map(esc).join("&nbsp;&nbsp;|&nbsp;&nbsp;")}</div>` : "";

//   return { expHtml, eduHtml, skillRows, certHtml };
// }

// function buildSections(content, resume) {
//   const { expHtml, eduHtml, skillRows, certHtml } = content;
//   const parts = [];
//   if (resume.summary)    parts.push({ title:"Professional Summary", body:`<p class="summary">${esc(resume.summary)}</p>` });
//   if (expHtml)           parts.push({ title:"Work Experience",       body:expHtml });
//   if (eduHtml)           parts.push({ title:"Education",             body:eduHtml });
//   if (skillRows)         parts.push({ title:"Skills",               body:skillRows });
//   if (certHtml)          parts.push({ title:"Certifications",       body:certHtml });
//   return parts;
// }

// // ─────────────────────────────────────────────────────────────
// // EXPORT — main HTML builder
// // ─────────────────────────────────────────────────────────────
// export function buildResumeHTML(resume, templateId, opts = {}) {
//   const { showHint = false, forPrint = false } = opts;
//   const t  = getT(templateId);
//   const ac = t.accent;
//   const nm   = esc(resume.name  || "Your Name");
//   const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
//   const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean).map(esc);

//   const content  = buildContent(resume, templateId);
//   const sections = buildSections(content, resume);

//   function renderSections(sections, sectionClass = "section") {
//     return sections.map(s => `
//       <div class="${sectionClass}">
//         <div class="sec-head"><span class="sec-title">${s.title}</span></div>
//         <div class="sec-body">${s.body}</div>
//       </div>`
//     ).join("");
//   }

//   let pageCSS = "", headerHTML = "", bodyHTML = "";

//   // ══════════════════════════════════════════════════════
//   // CLASSIC ATS — Harvard style (Most ATS-Friendly)
//   // Centered header • Clean serif • Ruled sections
//   // ══════════════════════════════════════════════════════
//   if (templateId === "classic") {
//     pageCSS = `
//       body { font-family: 'Times New Roman', Times, Georgia, serif; font-size: 11pt; line-height: 1.5; color: #000000; }
//       .page { padding: 0.7in 0.75in; max-width: 100%; margin: 0 auto; background: #fff; }
//       .hdr { text-align: center; margin-bottom: 6pt; }
//       .nm  { font-size: 22pt; font-weight: 700; letter-spacing: 0.5pt; color: #000; margin-bottom: 4pt; line-height: 1.2; }
//       .ttl { font-size: 11pt; color: #333; font-style: italic; margin-bottom: 6pt; }
//       .ctc { font-size: 9.5pt; color: #333; word-break: break-word; }
//       .ctc-sep { margin: 0 6pt; color: #666; }
//       .rule { border: none; border-top: 1.5pt solid #000; margin: 8pt 0 10pt; }
//       .section { margin-bottom: 10pt; }
//       .sec-head { border-bottom: 0.75pt solid #000; margin-bottom: 6pt; padding-bottom: 2pt; }
//       .sec-title { font-size: 10pt; font-weight: 700; text-transform: uppercase; letter-spacing: 1.2pt; color: #000; }
//       .summary { font-size: 10.5pt; line-height: 1.55; color: #222; margin: 0; }
//       .exp-block { margin-bottom: 8pt; }
//       .exp-header { display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 2pt; }
//       .exp-meta { flex: 1; }
//       .job-title  { font-weight: 700; font-size: 10.5pt; color: #000; }
//       .company-sep { color: #999; font-size: 10pt; }
//       .company { font-size: 10.5pt; color: #333; font-style: italic; }
//       .loc  { font-size: 9.5pt; color: #555; }
//       .dates { font-size: 9.5pt; color: #444; font-style: italic; white-space: nowrap; padding-left: 8pt; flex-shrink: 0; }
//       .edu-block { margin-bottom: 5pt; }
//       .bullets { margin: 4pt 0 0 14pt; padding: 0; list-style: disc; }
//       .bullets li { font-size: 10pt; color: #222; margin-bottom: 2.5pt; line-height: 1.45; }
//       .skill-row { display: flex; gap: 6pt; margin-bottom: 3.5pt; font-size: 10pt; }
//       .skill-label { font-weight: 700; color: #000; min-width: 110pt; flex-shrink: 0; }
//       .skill-items { color: #333; line-height: 1.5; }
//       .cert-row { font-size: 10pt; color: #333; line-height: 1.6; }`;

//     const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
//     headerHTML = `
//       <div class="hdr">
//         <div class="nm">${nm}</div>
//         ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
//         <div class="ctc">${ctcLine}</div>
//       </div>
//       <hr class="rule">`;
//     bodyHTML = renderSections(sections);
//   }

//   // ══════════════════════════════════════════════════════
//   // EXECUTIVE — Premium serif for senior roles
//   // Left-aligned • Elegant spacing • Double-rule divider
//   // ══════════════════════════════════════════════════════
//   else if (templateId === "executive") {
//     pageCSS = `
//       body { font-family: Georgia, 'Times New Roman', Palatino, serif; font-size: 11pt; line-height: 1.5; color: #1a1a1a; }
//       .page { padding: 0.7in 0.75in; }
//       .hdr { margin-bottom: 0; }
//       .nm  { font-size: 20pt; font-weight: 700; color: #000; letter-spacing: 0.3pt; margin-bottom: 3pt; }
//       .ttl { font-size: 10.5pt; color: #333; text-transform: uppercase; letter-spacing: 1.5pt; margin-bottom: 8pt; font-family: Arial, Helvetica, sans-serif; }
//       .ctc { font-size: 9.5pt; color: #444; margin-bottom: 0; font-family: Arial, Helvetica, sans-serif; word-break: break-word; }
//       .ctc-sep { margin: 0 8pt; color: #999; }
//       .rule { border: none; border-top: 2pt double #1e293b; margin: 10pt 0 12pt; }
//       .section { margin-bottom: 10pt; }
//       .sec-head { border-bottom: 0.75pt solid #1e293b; margin-bottom: 6pt; padding-bottom: 2pt; }
//       .sec-title { font-size: 9.5pt; font-weight: 700; text-transform: uppercase; letter-spacing: 1.5pt; color: #1e293b; font-family: Arial, Helvetica, sans-serif; }
//       .summary { font-size: 10.5pt; line-height: 1.6; color: #222; margin: 0; }
//       .exp-block { margin-bottom: 8pt; }
//       .exp-header { display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 2pt; }
//       .exp-meta { flex: 1; }
//       .job-title  { font-weight: 700; font-size: 10.5pt; color: #000; }
//       .company-sep { color: #bbb; }
//       .company { font-size: 10.5pt; color: #333; }
//       .loc  { font-size: 9.5pt; color: #777; }
//       .dates { font-size: 9.5pt; color: #555; font-style: italic; white-space: nowrap; padding-left: 8pt; flex-shrink: 0; font-family: Arial, Helvetica, sans-serif; }
//       .edu-block { margin-bottom: 5pt; }
//       .bullets { margin: 4pt 0 0 14pt; padding: 0; list-style: disc; }
//       .bullets li { font-size: 10pt; color: #222; margin-bottom: 2.5pt; line-height: 1.45; }
//       .skill-row { display: flex; gap: 6pt; margin-bottom: 3.5pt; font-size: 10pt; font-family: Arial, Helvetica, sans-serif; }
//       .skill-label { font-weight: 700; color: #1e293b; min-width: 110pt; flex-shrink: 0; }
//       .skill-items { color: #333; line-height: 1.5; }
//       .cert-row { font-size: 10pt; color: #333; font-family: Arial, Helvetica, sans-serif; }`;

//     const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
//     headerHTML = `
//       <div class="hdr">
//         <div class="nm">${nm}</div>
//         ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
//         <div class="ctc">${ctcLine}</div>
//       </div>
//       <hr class="rule">`;
//     bodyHTML = renderSections(sections);
//   }

//   // ══════════════════════════════════════════════════════
//   // BOLD IMPACT — Modern sans-serif for confident roles
//   // Clean lines • Accent rule • Strong typography
//   // ══════════════════════════════════════════════════════
//   else if (templateId === "bold") {
//     pageCSS = `
//       body { font-family: 'Segoe UI', 'Roboto', Arial, Helvetica, sans-serif; font-size: 10.5pt; line-height: 1.5; color: #1a1a1a; }
//       .page { padding: 0.65in 0.75in; }
//       .hdr { margin-bottom: 0; border-bottom: 2.5pt solid ${ac}; padding-bottom: 10pt; }
//       .nm  { font-size: 22pt; font-weight: 700; color: #0f172a; letter-spacing: -0.3pt; margin-bottom: 3pt; }
//       .ttl { font-size: 11pt; color: #374151; font-weight: 600; margin-bottom: 7pt; }
//       .ctc { font-size: 9.5pt; color: #555; word-break: break-word; }
//       .ctc-sep { margin: 0 8pt; color: #cbd5e1; }
//       .rule { display: none; }
//       .spacer { margin-bottom: 12pt; }
//       .section { margin-bottom: 10pt; }
//       .sec-head { margin-bottom: 6pt; padding-bottom: 3pt; border-bottom: 1.5pt solid ${ac}; }
//       .sec-title { font-size: 9pt; font-weight: 800; text-transform: uppercase; letter-spacing: 2pt; color: ${ac}; }
//       .summary { font-size: 10.5pt; line-height: 1.6; color: #333; margin: 0; }
//       .exp-block { margin-bottom: 9pt; }
//       .exp-header { display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 2pt; }
//       .exp-meta { flex: 1; }
//       .job-title  { font-weight: 700; font-size: 11pt; color: #0f172a; }
//       .company-sep { color: #cbd5e1; }
//       .company { font-size: 10.5pt; color: #374151; font-weight: 600; }
//       .loc  { font-size: 9.5pt; color: #94a3b8; }
//       .dates { font-size: 9.5pt; color: #64748b; font-style: italic; white-space: nowrap; padding-left: 8pt; flex-shrink: 0; }
//       .edu-block { margin-bottom: 5pt; }
//       .bullets { margin: 4pt 0 0 14pt; padding: 0; list-style: disc; }
//       .bullets li { font-size: 10pt; color: #374151; margin-bottom: 3pt; line-height: 1.5; }
//       .bullets li::marker { color: ${ac}; }
//       .skill-row { display: flex; gap: 6pt; margin-bottom: 4pt; font-size: 10pt; }
//       .skill-label { font-weight: 700; color: #0f172a; min-width: 110pt; flex-shrink: 0; }
//       .skill-items { color: #374151; line-height: 1.5; }
//       .cert-row { font-size: 10pt; color: #374151; }`;

//     const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
//     headerHTML = `
//       <div class="hdr">
//         <div class="nm">${nm}</div>
//         ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
//         <div class="ctc">${ctcLine}</div>
//       </div>
//       <div class="spacer"></div>`;
//     bodyHTML = renderSections(sections);
//   }

//   // ══════════════════════════════════════════════════════
//   // MINIMAL CLEAN — Modern minimalist sans-serif
//   // Light weight • Generous spacing • Clean aesthetics
//   // ══════════════════════════════════════════════════════
//   else if (templateId === "minimal") {
//     pageCSS = `
//       body { font-family: 'Inter', -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-size: 10.5pt; line-height: 1.6; color: #1a1a1a; }
//       .page { padding: 0.7in 0.8in; }
//       .hdr { margin-bottom: 0; padding-bottom: 10pt; border-bottom: 1pt solid #e5e7eb; }
//       .nm  { font-size: 21pt; font-weight: 600; color: #111; letter-spacing: -0.2pt; margin-bottom: 3pt; }
//       .ttl { font-size: 11pt; color: ${ac}; font-weight: 500; margin-bottom: 8pt; }
//       .ctc { font-size: 9.5pt; color: #555; word-break: break-word; }
//       .ctc-sep { margin: 0 8pt; color: #d1d5db; }
//       .rule { display: none; }
//       .spacer { margin-bottom: 12pt; }
//       .section { margin-bottom: 11pt; }
//       .sec-head { margin-bottom: 6pt; }
//       .sec-title { font-size: 8.5pt; font-weight: 700; text-transform: uppercase; letter-spacing: 2.5pt; color: ${ac}; }
//       .summary { font-size: 10.5pt; line-height: 1.65; color: #374151; margin: 0; }
//       .exp-block { margin-bottom: 9pt; }
//       .exp-header { display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 2pt; }
//       .exp-meta { flex: 1; }
//       .job-title  { font-weight: 600; font-size: 11pt; color: #111; }
//       .company-sep { color: #e5e7eb; margin: 0 4pt; }
//       .company { font-size: 10.5pt; color: #374151; }
//       .loc  { font-size: 9.5pt; color: #9ca3af; }
//       .dates { font-size: 9.5pt; color: #6b7280; white-space: nowrap; padding-left: 8pt; flex-shrink: 0; }
//       .edu-block { margin-bottom: 5pt; }
//       .bullets { margin: 4pt 0 0 0; padding: 0; list-style: none; }
//       .bullets li { font-size: 10pt; color: #374151; margin-bottom: 3pt; line-height: 1.55; padding-left: 12pt; position: relative; }
//       .bullets li::before { content: "–"; position: absolute; left: 0; color: ${ac}; font-weight: 600; }
//       .skill-row { display: flex; gap: 6pt; margin-bottom: 4pt; font-size: 10pt; }
//       .skill-label { font-weight: 600; color: #111; min-width: 110pt; flex-shrink: 0; }
//       .skill-items { color: #374151; line-height: 1.5; }
//       .cert-row { font-size: 10pt; color: #374151; }`;

//     const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
//     headerHTML = `
//       <div class="hdr">
//         <div class="nm">${nm}</div>
//         ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
//         <div class="ctc">${ctcLine}</div>
//       </div>
//       <div class="spacer"></div>`;
//     bodyHTML = renderSections(sections);
//   }

//   // ══════════════════════════════════════════════════════
//   // PROFESSIONAL — Corporate standard Arial
//   // Best for finance, banking, consulting, corporate
//   // ══════════════════════════════════════════════════════
//   else {  // professional
//     pageCSS = `
//       body { font-family: Arial, Helvetica, 'Noto Sans', sans-serif; font-size: 10.5pt; line-height: 1.5; color: #1a1a1a; }
//       .page { padding: 0.65in 0.75in; }
//       .hdr { margin-bottom: 0; }
//       .nm  { font-size: 20pt; font-weight: 700; color: #000; margin-bottom: 3pt; }
//       .ttl { font-size: 10.5pt; color: #374151; margin-bottom: 7pt; text-transform: uppercase; letter-spacing: 0.8pt; }
//       .ctc { font-size: 9.5pt; color: #444; word-break: break-word; }
//       .ctc-sep { margin: 0 7pt; color: #bbb; }
//       .rule { border: none; border-top: 2pt solid #000; margin: 9pt 0 11pt; }
//       .section { margin-bottom: 10pt; }
//       .sec-head { border-bottom: 1pt solid #000; margin-bottom: 6pt; padding-bottom: 2pt; }
//       .sec-title { font-size: 9.5pt; font-weight: 700; text-transform: uppercase; letter-spacing: 1pt; color: #000; }
//       .summary { font-size: 10.5pt; line-height: 1.6; color: #222; margin: 0; }
//       .exp-block { margin-bottom: 8pt; }
//       .exp-header { display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 2pt; }
//       .exp-meta { flex: 1; }
//       .job-title  { font-weight: 700; font-size: 10.5pt; color: #000; }
//       .company-sep { color: #bbb; }
//       .company { font-size: 10.5pt; color: #333; }
//       .loc  { font-size: 9.5pt; color: #777; }
//       .dates { font-size: 9.5pt; color: #555; font-style: italic; white-space: nowrap; padding-left: 8pt; flex-shrink: 0; }
//       .edu-block { margin-bottom: 5pt; }
//       .bullets { margin: 4pt 0 0 14pt; padding: 0; list-style: disc; }
//       .bullets li { font-size: 10pt; color: #222; margin-bottom: 2.5pt; line-height: 1.45; }
//       .skill-row { display: flex; gap: 6pt; margin-bottom: 3.5pt; font-size: 10pt; }
//       .skill-label { font-weight: 700; color: #000; min-width: 110pt; flex-shrink: 0; }
//       .skill-items { color: #333; line-height: 1.5; }
//       .cert-row { font-size: 10pt; color: #333; }`;

//     const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
//     headerHTML = `
//       <div class="hdr">
//         <div class="nm">${nm}</div>
//         ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
//         <div class="ctc">${ctcLine}</div>
//       </div>
//       <hr class="rule">`;
//     bodyHTML = renderSections(sections);
//   }

//   const hint = (showHint||forPrint) ? `
//     <div style="background:#1d4ed8;color:#fff;padding:10px 18px;text-align:center;
//       font-size:12px;font-family:Arial,sans-serif;line-height:1.8;" class="no-print">
//       📄 Ctrl+P → <strong>Save as PDF</strong> → Margins: <strong>None</strong> → ✅ <strong>Background graphics</strong> → Save
//     </div>` : "";

//   return `<!DOCTYPE html>
// <html lang="en">
// <head>
//   <meta charset="UTF-8">
//   <title>${nm} — Resume</title>
//   <style>
//     *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
//     body { background:#e8e8e8; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
//     .page { max-width:794px; width:794px; margin:0 auto; background:#fff; box-shadow:0 2px 10px rgba(0,0,0,0.05); }
//     .page * { max-width:100%; }
//     ul.bullets { overflow:hidden; }
//     li { word-break:break-word; }
//     ${pageCSS}
//     @media print {
//       body { background:#fff; margin:0; padding:0; }
//       .no-print { display:none !important; }
//       .page { box-shadow:none; width:100%; max-width:100%; margin:0; padding:0; }
//       @page { size:A4; margin:0; }
//     }
//   </style>
// </head>
// <body>
//   ${hint}
//   <div class="page">
//     ${headerHTML}
//     ${bodyHTML}
//   </div>
// </body>
// </html>`;
// }

// // ─────────────────────────────────────────────
// function dl(blob, name) {
//   const url = URL.createObjectURL(blob);
//   const a   = Object.assign(document.createElement("a"),{href:url,download:name});
//   document.body.appendChild(a); a.click(); document.body.removeChild(a);
//   setTimeout(()=>URL.revokeObjectURL(url),2000);
// }

// export async function downloadResumeAsPDF(resume, fileName, templateId) {
//   const name    = (fileName||"resume").replace(/\.(pdf|html?)$/i,"");
//   const html    = buildResumeHTML(resume, templateId, { forPrint:false });
//   const BACKEND = window.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";
//   try {
//     const res = await fetch(`${BACKEND}/generate-pdf`, {
//       method:"POST", headers:{"Content-Type":"application/json"},
//       body: JSON.stringify({ html }),
//     });
//     if (!res.ok) throw new Error(`${res.status}`);
//     const blob = await res.blob();
//     dl(blob, `${name}.pdf`);
//   } catch(err) {
//     console.warn("Server PDF unavailable:", err.message);
//     const win = window.open("","_blank");
//     if (!win) { dl(new Blob([buildResumeHTML(resume,templateId,{showHint:true})],{type:"text/html;charset=utf-8"}),`${name}.html`); return; }
//     win.document.open(); win.document.write(buildResumeHTML(resume,templateId,{forPrint:true})); win.document.close();
//     win.focus(); setTimeout(()=>{ try{win.print();}catch(e){} },800);
//   }
// }

// export async function downloadResumeAsWord(resume, fileName, templateId) {
//   const name    = (fileName||"resume").replace(/\.(doc|docx|html?)$/i,"");
//   const BACKEND = window.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";
//   try {
//     const res = await fetch(`${BACKEND}/generate-word`, {
//       method:"POST", headers:{"Content-Type":"application/json"},
//       body: JSON.stringify({ resume, templateId }),
//     });
//     if (!res.ok) throw new Error(`${res.status}`);
//     const blob = await res.blob();
//     const url  = URL.createObjectURL(blob);
//     const a    = Object.assign(document.createElement("a"),{href:url,download:`${name}.docx`});
//     document.body.appendChild(a); a.click(); document.body.removeChild(a);
//     setTimeout(()=>URL.revokeObjectURL(url),2000);
//   } catch(err) {
//     console.warn("Server Word unavailable:", err.message);
//     dl(new Blob(["\ufeff",buildResumeHTML(resume,templateId,{})],{type:"text/plain;charset=utf-8"}),`${name}.doc`);
//   }
// }

// export function downloadATSResume(resume, fileName, templateId) {
//   dl(new Blob([buildResumeHTML(resume,templateId,{showHint:true})],{type:"text/html;charset=utf-8"}),
//     (fileName||"resume").replace(/\.html?$/i,"")+".html");
// }

//new code updated
const TEMPLATES = {
  classic:      { name:"Classic ATS",    accent:"#2563eb", header:"#1e293b" },
  executive:    { name:"Executive",      accent:"#1e293b", header:"#0f172a" },
  bold:         { name:"Bold Impact",    accent:"#1d4ed8", header:"#1e3a8a" },
  minimal:      { name:"Minimal Clean",  accent:"#047857", header:"#047857" },
  professional: { name:"Professional",   accent:"#0f172a", header:"#1e3a5f" },
};

function getT(id) { return TEMPLATES[id] || TEMPLATES.classic; }

function esc(s) {
  if (!s) return "";
  return String(s)
    .replace(/&/g,"&amp;").replace(/</g,"&lt;")
    .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
}
function fmt(s, e) {
  if (!s && !e) return "";
  if (s && !e)  return esc(s);
  if (!s && e)  return esc(e);
  return `${esc(s)} &ndash; ${esc(e)}`;
}

// ─────────────────────────────────────────────────────────────
// CONTENT BUILDERS — shared across all templates
// ─────────────────────────────────────────────────────────────
function buildContent(resume, templateId) {
  // eslint-disable-next-line no-unused-vars
  const ac = getT(templateId).accent;

  const expHtml = (resume.experience||[]).map(exp => {
    const bullets = (exp.bullets||[]).map(b =>
      `<li>${esc(b)}</li>`
    ).join("");
    const dates = fmt(exp.startDate, exp.endDate);
    return `
    <div class="exp-block">
      <div class="exp-header">
        <div class="exp-meta">
          <span class="job-title">${esc(exp.title||"")}</span>
          <span class="company-sep"> &bull; </span>
          <span class="company">${esc(exp.company||"")}</span>
          ${exp.location ? `<span class="loc">, ${esc(exp.location)}</span>` : ""}
        </div>
        ${dates ? `<span class="dates">${dates}</span>` : ""}
      </div>
      ${bullets ? `<ul class="bullets">${bullets}</ul>` : ""}
    </div>`;
  }).join("");

  const eduHtml = (resume.education||[]).map(edu => `
    <div class="edu-block">
      <div class="exp-header">
        <div class="exp-meta">
          <span class="job-title">${esc(edu.degree||"")}</span>
          <span class="company-sep"> &bull; </span>
          <span class="company">${esc(edu.school||"")}</span>
          ${edu.location ? `<span class="loc">, ${esc(edu.location)}</span>` : ""}
        </div>
        ${edu.year ? `<span class="dates">${esc(edu.year)}${edu.gpa?` &nbsp;&bull;&nbsp; GPA: ${esc(edu.gpa)}`:""}</span>` : ""}
      </div>
    </div>`
  ).join("");

  const sk = resume.skills||{};
  const skillRows = [
    sk.technical?.length ? `<div class="skill-row"><span class="skill-label">Technical</span><span class="skill-items">${sk.technical.map(esc).join(", ")}</span></div>` : "",
    sk.tools?.length     ? `<div class="skill-row"><span class="skill-label">Tools &amp; Platforms</span><span class="skill-items">${sk.tools.map(esc).join(", ")}</span></div>` : "",
    sk.soft?.length      ? `<div class="skill-row"><span class="skill-label">Competencies</span><span class="skill-items">${sk.soft.map(esc).join(", ")}</span></div>` : "",
  ].join("");

  const certHtml = (resume.certifications||[]).length
    ? `<div class="cert-row">${resume.certifications.map(esc).join("&nbsp;&nbsp;|&nbsp;&nbsp;")}</div>` : "";

  return { expHtml, eduHtml, skillRows, certHtml };
}

function buildSections(content, resume) {
  const { expHtml, eduHtml, skillRows, certHtml } = content;
  const parts = [];
  if (resume.summary)    parts.push({ title:"Professional Summary", body:`<p class="summary">${esc(resume.summary)}</p>` });
  if (expHtml)           parts.push({ title:"Work Experience",       body:expHtml });
  if (eduHtml)           parts.push({ title:"Education",             body:eduHtml });
  if (skillRows)         parts.push({ title:"Skills",               body:skillRows });
  if (certHtml)          parts.push({ title:"Certifications",       body:certHtml });
  return parts;
}

// ─────────────────────────────────────────────────────────────
// EXPORT — main HTML builder
// ─────────────────────────────────────────────────────────────
export function buildResumeHTML(resume, templateId, opts = {}) {
  const { showHint = false, forPrint = false } = opts;
  const t  = getT(templateId);
  const ac = t.accent;
  const nm   = esc(resume.name  || "Your Name");
  const ttl  = esc(resume.title || resume.experience?.[0]?.title || "");
  const ctcs = [resume.email, resume.phone, resume.location, resume.linkedin].filter(Boolean).map(esc);

  const content  = buildContent(resume, templateId);
  const sections = buildSections(content, resume);

  function renderSections(sections, sectionClass = "section") {
    return sections.map(s => `
      <div class="${sectionClass}">
        <div class="sec-head"><span class="sec-title">${s.title}</span></div>
        <div class="sec-body">${s.body}</div>
      </div>`
    ).join("");
  }

  let pageCSS = "", headerHTML = "", bodyHTML = "";

  // ══════════════════════════════════════════════════════
  // CLASSIC ATS — Harvard style (Most ATS-Friendly)
  // Centered header • Clean serif • Ruled sections
  // ══════════════════════════════════════════════════════
  if (templateId === "classic") {
    pageCSS = `
      body { font-family: 'Times New Roman', Times, Georgia, serif; font-size: 11pt; line-height: 1.5; color: #000000; }
      .page { padding: 0.7in 0.75in; max-width: 100%; margin: 0 auto; background: #fff; }
      .hdr { text-align: center; margin-bottom: 6pt; }
      .nm  { font-size: 22pt; font-weight: 700; letter-spacing: 0.5pt; color: #000; margin-bottom: 4pt; line-height: 1.2; }
      .ttl { font-size: 11pt; color: #333; font-style: italic; margin-bottom: 6pt; }
      .ctc { font-size: 9.5pt; color: #333; word-break: break-word; }
      .ctc-sep { margin: 0 6pt; color: #666; }
      .rule { border: none; border-top: 1.5pt solid #000; margin: 8pt 0 10pt; }
      .section { margin-bottom: 10pt; }
      .sec-head { border-bottom: 0.75pt solid #000; margin-bottom: 6pt; padding-bottom: 2pt; }
      .sec-title { font-size: 10pt; font-weight: 700; text-transform: uppercase; letter-spacing: 1.2pt; color: #000; }
      .summary { font-size: 10.5pt; line-height: 1.55; color: #222; margin: 0; }
      .exp-block { margin-bottom: 8pt; }
      .exp-header { display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 2pt; }
      .exp-meta { flex: 1; }
      .job-title  { font-weight: 700; font-size: 10.5pt; color: #000; }
      .company-sep { color: #999; font-size: 10pt; }
      .company { font-size: 10.5pt; color: #333; font-style: italic; }
      .loc  { font-size: 9.5pt; color: #555; }
      .dates { font-size: 9.5pt; color: #444; font-style: italic; white-space: nowrap; padding-left: 8pt; flex-shrink: 0; }
      .edu-block { margin-bottom: 5pt; }
      .bullets { margin: 4pt 0 0 14pt; padding: 0; list-style: disc; }
      .bullets li { font-size: 10pt; color: #222; margin-bottom: 2.5pt; line-height: 1.45; }
      .skill-row { display: flex; gap: 6pt; margin-bottom: 3.5pt; font-size: 10pt; }
      .skill-label { font-weight: 700; color: #000; min-width: 110pt; flex-shrink: 0; }
      .skill-items { color: #333; line-height: 1.5; }
      .cert-row { font-size: 10pt; color: #333; line-height: 1.6; }`;

    const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
    headerHTML = `
      <div class="hdr">
        <div class="nm">${nm}</div>
        ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
        <div class="ctc">${ctcLine}</div>
      </div>
      <hr class="rule">`;
    bodyHTML = renderSections(sections);
  }

  // ══════════════════════════════════════════════════════
  // EXECUTIVE — Premium serif for senior roles
  // Left-aligned • Elegant spacing • Double-rule divider
  // ══════════════════════════════════════════════════════
  else if (templateId === "executive") {
    pageCSS = `
      body { font-family: Georgia, 'Times New Roman', Palatino, serif; font-size: 11pt; line-height: 1.5; color: #1a1a1a; }
      .page { padding: 0.7in 0.75in; }
      .hdr { margin-bottom: 0; }
      .nm  { font-size: 20pt; font-weight: 700; color: #000; letter-spacing: 0.3pt; margin-bottom: 3pt; }
      .ttl { font-size: 10.5pt; color: #333; text-transform: uppercase; letter-spacing: 1.5pt; margin-bottom: 8pt; font-family: Arial, Helvetica, sans-serif; }
      .ctc { font-size: 9.5pt; color: #444; margin-bottom: 0; font-family: Arial, Helvetica, sans-serif; word-break: break-word; }
      .ctc-sep { margin: 0 8pt; color: #999; }
      .rule { border: none; border-top: 2pt double #1e293b; margin: 10pt 0 12pt; }
      .section { margin-bottom: 10pt; }
      .sec-head { border-bottom: 0.75pt solid #1e293b; margin-bottom: 6pt; padding-bottom: 2pt; }
      .sec-title { font-size: 9.5pt; font-weight: 700; text-transform: uppercase; letter-spacing: 1.5pt; color: #1e293b; font-family: Arial, Helvetica, sans-serif; }
      .summary { font-size: 10.5pt; line-height: 1.6; color: #222; margin: 0; }
      .exp-block { margin-bottom: 8pt; }
      .exp-header { display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 2pt; }
      .exp-meta { flex: 1; }
      .job-title  { font-weight: 700; font-size: 10.5pt; color: #000; }
      .company-sep { color: #bbb; }
      .company { font-size: 10.5pt; color: #333; }
      .loc  { font-size: 9.5pt; color: #777; }
      .dates { font-size: 9.5pt; color: #555; font-style: italic; white-space: nowrap; padding-left: 8pt; flex-shrink: 0; font-family: Arial, Helvetica, sans-serif; }
      .edu-block { margin-bottom: 5pt; }
      .bullets { margin: 4pt 0 0 14pt; padding: 0; list-style: disc; }
      .bullets li { font-size: 10pt; color: #222; margin-bottom: 2.5pt; line-height: 1.45; }
      .skill-row { display: flex; gap: 6pt; margin-bottom: 3.5pt; font-size: 10pt; font-family: Arial, Helvetica, sans-serif; }
      .skill-label { font-weight: 700; color: #1e293b; min-width: 110pt; flex-shrink: 0; }
      .skill-items { color: #333; line-height: 1.5; }
      .cert-row { font-size: 10pt; color: #333; font-family: Arial, Helvetica, sans-serif; }`;

    const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
    headerHTML = `
      <div class="hdr">
        <div class="nm">${nm}</div>
        ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
        <div class="ctc">${ctcLine}</div>
      </div>
      <hr class="rule">`;
    bodyHTML = renderSections(sections);
  }

  // ══════════════════════════════════════════════════════
  // BOLD IMPACT — Modern sans-serif for confident roles
  // Clean lines • Accent rule • Strong typography
  // ══════════════════════════════════════════════════════
  else if (templateId === "bold") {
    pageCSS = `
      body { font-family: 'Segoe UI', 'Roboto', Arial, Helvetica, sans-serif; font-size: 10.5pt; line-height: 1.5; color: #1a1a1a; }
      .page { padding: 0.65in 0.75in; }
      .hdr { margin-bottom: 0; border-bottom: 2.5pt solid ${ac}; padding-bottom: 10pt; }
      .nm  { font-size: 22pt; font-weight: 700; color: #0f172a; letter-spacing: -0.3pt; margin-bottom: 3pt; }
      .ttl { font-size: 11pt; color: #374151; font-weight: 600; margin-bottom: 7pt; }
      .ctc { font-size: 9.5pt; color: #555; word-break: break-word; }
      .ctc-sep { margin: 0 8pt; color: #cbd5e1; }
      .rule { display: none; }
      .spacer { margin-bottom: 12pt; }
      .section { margin-bottom: 10pt; }
      .sec-head { margin-bottom: 6pt; padding-bottom: 3pt; border-bottom: 1.5pt solid ${ac}; }
      .sec-title { font-size: 9pt; font-weight: 800; text-transform: uppercase; letter-spacing: 2pt; color: ${ac}; }
      .summary { font-size: 10.5pt; line-height: 1.6; color: #333; margin: 0; }
      .exp-block { margin-bottom: 9pt; }
      .exp-header { display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 2pt; }
      .exp-meta { flex: 1; }
      .job-title  { font-weight: 700; font-size: 11pt; color: #0f172a; }
      .company-sep { color: #cbd5e1; }
      .company { font-size: 10.5pt; color: #374151; font-weight: 600; }
      .loc  { font-size: 9.5pt; color: #94a3b8; }
      .dates { font-size: 9.5pt; color: #64748b; font-style: italic; white-space: nowrap; padding-left: 8pt; flex-shrink: 0; }
      .edu-block { margin-bottom: 5pt; }
      .bullets { margin: 4pt 0 0 14pt; padding: 0; list-style: disc; }
      .bullets li { font-size: 10pt; color: #374151; margin-bottom: 3pt; line-height: 1.5; }
      .bullets li::marker { color: ${ac}; }
      .skill-row { display: flex; gap: 6pt; margin-bottom: 4pt; font-size: 10pt; }
      .skill-label { font-weight: 700; color: #0f172a; min-width: 110pt; flex-shrink: 0; }
      .skill-items { color: #374151; line-height: 1.5; }
      .cert-row { font-size: 10pt; color: #374151; }`;

    const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
    headerHTML = `
      <div class="hdr">
        <div class="nm">${nm}</div>
        ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
        <div class="ctc">${ctcLine}</div>
      </div>
      <div class="spacer"></div>`;
    bodyHTML = renderSections(sections);
  }

  // ══════════════════════════════════════════════════════
  // MINIMAL CLEAN — Modern minimalist sans-serif
  // Light weight • Generous spacing • Clean aesthetics
  // ══════════════════════════════════════════════════════
  else if (templateId === "minimal") {
    pageCSS = `
      body { font-family: 'Inter', -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-size: 10.5pt; line-height: 1.6; color: #1a1a1a; }
      .page { padding: 0.7in 0.8in; }
      .hdr { margin-bottom: 0; padding-bottom: 10pt; border-bottom: 1pt solid #e5e7eb; }
      .nm  { font-size: 21pt; font-weight: 600; color: #111; letter-spacing: -0.2pt; margin-bottom: 3pt; }
      .ttl { font-size: 11pt; color: ${ac}; font-weight: 500; margin-bottom: 8pt; }
      .ctc { font-size: 9.5pt; color: #555; word-break: break-word; }
      .ctc-sep { margin: 0 8pt; color: #d1d5db; }
      .rule { display: none; }
      .spacer { margin-bottom: 12pt; }
      .section { margin-bottom: 11pt; }
      .sec-head { margin-bottom: 6pt; }
      .sec-title { font-size: 8.5pt; font-weight: 700; text-transform: uppercase; letter-spacing: 2.5pt; color: ${ac}; }
      .summary { font-size: 10.5pt; line-height: 1.65; color: #374151; margin: 0; }
      .exp-block { margin-bottom: 9pt; }
      .exp-header { display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 2pt; }
      .exp-meta { flex: 1; }
      .job-title  { font-weight: 600; font-size: 11pt; color: #111; }
      .company-sep { color: #e5e7eb; margin: 0 4pt; }
      .company { font-size: 10.5pt; color: #374151; }
      .loc  { font-size: 9.5pt; color: #9ca3af; }
      .dates { font-size: 9.5pt; color: #6b7280; white-space: nowrap; padding-left: 8pt; flex-shrink: 0; }
      .edu-block { margin-bottom: 5pt; }
      .bullets { margin: 4pt 0 0 0; padding: 0; list-style: none; }
      .bullets li { font-size: 10pt; color: #374151; margin-bottom: 3pt; line-height: 1.55; padding-left: 12pt; position: relative; }
      .bullets li::before { content: "–"; position: absolute; left: 0; color: ${ac}; font-weight: 600; }
      .skill-row { display: flex; gap: 6pt; margin-bottom: 4pt; font-size: 10pt; }
      .skill-label { font-weight: 600; color: #111; min-width: 110pt; flex-shrink: 0; }
      .skill-items { color: #374151; line-height: 1.5; }
      .cert-row { font-size: 10pt; color: #374151; }`;

    const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
    headerHTML = `
      <div class="hdr">
        <div class="nm">${nm}</div>
        ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
        <div class="ctc">${ctcLine}</div>
      </div>
      <div class="spacer"></div>`;
    bodyHTML = renderSections(sections);
  }

  // ══════════════════════════════════════════════════════
  // PROFESSIONAL — Corporate standard Arial
  // Best for finance, banking, consulting, corporate
  // ══════════════════════════════════════════════════════
  else {  // professional
    pageCSS = `
      body { font-family: Arial, Helvetica, 'Noto Sans', sans-serif; font-size: 10.5pt; line-height: 1.5; color: #1a1a1a; }
      .page { padding: 0.65in 0.75in; }
      .hdr { margin-bottom: 0; }
      .nm  { font-size: 20pt; font-weight: 700; color: #000; margin-bottom: 3pt; }
      .ttl { font-size: 10.5pt; color: #374151; margin-bottom: 7pt; text-transform: uppercase; letter-spacing: 0.8pt; }
      .ctc { font-size: 9.5pt; color: #444; word-break: break-word; }
      .ctc-sep { margin: 0 7pt; color: #bbb; }
      .rule { border: none; border-top: 2pt solid #000; margin: 9pt 0 11pt; }
      .section { margin-bottom: 10pt; }
      .sec-head { border-bottom: 1pt solid #000; margin-bottom: 6pt; padding-bottom: 2pt; }
      .sec-title { font-size: 9.5pt; font-weight: 700; text-transform: uppercase; letter-spacing: 1pt; color: #000; }
      .summary { font-size: 10.5pt; line-height: 1.6; color: #222; margin: 0; }
      .exp-block { margin-bottom: 8pt; }
      .exp-header { display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 2pt; }
      .exp-meta { flex: 1; }
      .job-title  { font-weight: 700; font-size: 10.5pt; color: #000; }
      .company-sep { color: #bbb; }
      .company { font-size: 10.5pt; color: #333; }
      .loc  { font-size: 9.5pt; color: #777; }
      .dates { font-size: 9.5pt; color: #555; font-style: italic; white-space: nowrap; padding-left: 8pt; flex-shrink: 0; }
      .edu-block { margin-bottom: 5pt; }
      .bullets { margin: 4pt 0 0 14pt; padding: 0; list-style: disc; }
      .bullets li { font-size: 10pt; color: #222; margin-bottom: 2.5pt; line-height: 1.45; }
      .skill-row { display: flex; gap: 6pt; margin-bottom: 3.5pt; font-size: 10pt; }
      .skill-label { font-weight: 700; color: #000; min-width: 110pt; flex-shrink: 0; }
      .skill-items { color: #333; line-height: 1.5; }
      .cert-row { font-size: 10pt; color: #333; }`;

    const ctcLine = ctcs.map((c,i) => i===0 ? c : `<span class="ctc-sep">|</span>${c}`).join("");
    headerHTML = `
      <div class="hdr">
        <div class="nm">${nm}</div>
        ${ttl ? `<div class="ttl">${ttl}</div>` : ""}
        <div class="ctc">${ctcLine}</div>
      </div>
      <hr class="rule">`;
    bodyHTML = renderSections(sections);
  }

  const hint = (showHint||forPrint) ? `
    <div style="background:#1d4ed8;color:#fff;padding:10px 18px;text-align:center;
      font-size:12px;font-family:Arial,sans-serif;line-height:1.8;" class="no-print">
      📄 Ctrl+P → <strong>Save as PDF</strong> → Margins: <strong>None</strong> → ✅ <strong>Background graphics</strong> → Save
    </div>` : "";

  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>${nm} — Resume</title>
  <style>
    *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
    body { background:#e8e8e8; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
    .page { max-width:794px; width:794px; margin:0 auto; background:#fff; box-shadow:0 2px 10px rgba(0,0,0,0.05); }
    .page * { max-width:100%; }
    ul.bullets { overflow:hidden; }
    li { word-break:break-word; }
    ${pageCSS}
    @media print {
      body { background:#fff; margin:0; padding:0; }
      .no-print { display:none !important; }
      .page { box-shadow:none; width:100%; max-width:100%; margin:0; padding:0; }
      @page { size:A4; margin:0; }
    }
  </style>
</head>
<body>
  ${hint}
  <div class="page">
    ${headerHTML}
    ${bodyHTML}
  </div>
</body>
</html>`;
}

// ─────────────────────────────────────────────
function dl(blob, name) {
  const url = URL.createObjectURL(blob);
  const a   = Object.assign(document.createElement("a"),{href:url,download:name});
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  setTimeout(()=>URL.revokeObjectURL(url),2000);
}

export async function downloadResumeAsPDF(resume, fileName, templateId) {
  const name    = (fileName||"resume").replace(/\.(pdf|html?)$/i,"");
  const html    = buildResumeHTML(resume, templateId, { forPrint:false });
  const BACKEND = window.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";
  try {
    const res = await fetch(`${BACKEND}/generate-pdf`, {
      method:"POST", headers:{"Content-Type":"application/json"},
      body: JSON.stringify({ html }),
    });
    if (!res.ok) throw new Error(`${res.status}`);
    const blob = await res.blob();
    dl(blob, `${name}.pdf`);
  } catch(err) {
    console.warn("Server PDF unavailable:", err.message);
    const win = window.open("","_blank");
    if (!win) { dl(new Blob([buildResumeHTML(resume,templateId,{showHint:true})],{type:"text/html;charset=utf-8"}),`${name}.html`); return; }
    win.document.open(); win.document.write(buildResumeHTML(resume,templateId,{forPrint:true})); win.document.close();
    win.focus(); setTimeout(()=>{ try{win.print();}catch(e){} },800);
  }
}

export async function downloadResumeAsWord(resume, fileName, templateId) {
  const name = (fileName || "resume").replace(/\.(doc|docx|html?)$/i, "");
  const BACKEND = window.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";
  
  try {
    console.log("📤 Downloading Word document...");
    const response = await fetch(`${BACKEND}/generate-word`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ resume, templateId }),
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`${response.status}: ${errorText}`);
    }
    
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${name}.docx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 2000);
    console.log("✅ Word document downloaded successfully");
  } catch (err) {
    console.warn("Server Word unavailable:", err.message);
    // Fallback to HTML
    dl(new Blob(["\ufeff", buildResumeHTML(resume, templateId, {})], { type: "text/plain;charset=utf-8" }), `${name}.doc`);
  }
}
export function downloadATSResume(resume, fileName, templateId) {
  dl(new Blob([buildResumeHTML(resume,templateId,{showHint:true})],{type:"text/html;charset=utf-8"}),
    (fileName||"resume").replace(/\.html?$/i,"")+".html");
}